import merge from 'lodash/merge';
import isValid from 'date-fns/isValid';
import isExists from 'date-fns/isExists';
import ru from 'date-fns/locale/ru';
import parse from 'date-fns/parse';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import isEqual from 'date-fns/isEqual';
import format$2 from 'date-fns/format';
import set from 'date-fns/set';
import setMonth from 'date-fns/setMonth';
import setYear from 'date-fns/setYear';
import getDaysInMonth from 'date-fns/getDaysInMonth';
import startOfMonth from 'date-fns/startOfMonth';
import startOfWeek from 'date-fns/startOfWeek';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import isSameDay from 'date-fns/isSameDay';
import setDate from 'date-fns/setDate';
import orderBy from 'lodash/orderBy';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

/**
 * Parent's child extending
 *
 * @param {function | ErrorConstructor} parent  Parent constructor function
 * @param {function} child                      Child constructor function
 */
function extend$1(parent, child) {
  var _this = this;

  var originPrototype = child.prototype; // eslint-disable-next-line no-param-reassign

  child.prototype = Object.create(parent.prototype);
  Object.keys(originPrototype).forEach(function (key) {
    _newArrowCheck(this, _this);

    // eslint-disable-next-line no-param-reassign
    child.prototype[key] = originPrototype[key];
  }.bind(this));
  Object.defineProperty(child.prototype, 'constructor', {
    enumerable: false,
    value: child
  });
}
/**
 * Base framework error
 *
 * @param {string | Array} message
 * @constructor
 */


function FrameworkError(message) {
  this.message = "[UI Framework] ".concat(Array.isArray(message) ? message.join('. ') : message);
}
extend$1(Error, FrameworkError);
/**
 * Throws when function options is not value
 *
 * @param {string} option
 * @param {string[]?} allowedValues
 * @constructor
 */

function InvalidOptionValueError(option) {
  var allowedValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var messages = ["Invalid value given for option \"".concat(option, "\"")];

  if (allowedValues.length) {
    messages.push("Allowed values: ".concat(allowedValues.join(', ')));
  }

  FrameworkError.call(this, messages);
}
extend$1(FrameworkError, InvalidOptionValueError);
/**
 * Throws when child component used not inside of provider
 *
 * @param {string} parent
 * @param {string} child
 * @constructor
 */

function ComponentInjectionError(parent, child) {
  // eslint-disable-next-line max-len
  FrameworkError.call(this, "The child component \"".concat(child, "\" must be used inside of \"").concat(parent, "\" component"));
}
extend$1(FrameworkError, ComponentInjectionError);
/**
 * Throws error when method not implemented in child component
 *
 * @param {string} method
 * @param {string} component
 * @constructor
 */

function MethodNotImplemented(method) {
  var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var message = component ? " in component ".concat(component) : '';
  FrameworkError.call(this, "Method \"".concat(method, "\" must be implemented").concat(message));
}
extend$1(FrameworkError, MethodNotImplemented);
/**
 * Validator error
 *
 * @param {string} message
 * @constructor
 */

function ValidatorError(message) {
  FrameworkError.call(this, "[Validator] ".concat(message));
}
extend$1(FrameworkError, ValidatorError);

/**
 * Grid breakpoints values in pixels
 *
 * @type {Readonly<{xl: number, md: number, sm: number, lg: number}>}
 */
var gridBreakpoints = Object.freeze({
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1800
});
/**
 * Keyboard event codes
 *
 * @type {Object}
 */

var keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  del: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34
});
/**
 * Money currencies
 *
 * @type {Readonly<{usd: string, rub: string}>}
 */

var currencies = Object.freeze({
  rub: '₽',
  usd: '$',
  eur: '€'
});
/**
 * @type {string}
 */

var qaAttributeName = 'data-qa';
/**
 * Days of week
 *
 * @type {Readonly<Object<string, Object>>}
 */

var weekDays$1 = Object.freeze({
  1: {
    title: 'Понедельник',
    short: 'ПН'
  },
  2: {
    title: 'Вторник',
    short: 'ВТ'
  },
  3: {
    title: 'Среда',
    short: 'СР'
  },
  4: {
    title: 'Четверг',
    short: 'ЧТ'
  },
  5: {
    title: 'Пятница',
    short: 'ПТ'
  },
  6: {
    title: 'Суббота',
    short: 'СБ'
  },
  7: {
    title: 'Воскресенье',
    short: 'ВС'
  }
});
/**
 * @type {Readonly<Object<string, string>>}
 */

var months$1 = Object.freeze({
  1: 'Январь',
  2: 'Февраль',
  3: 'Март',
  4: 'Апрель',
  5: 'Май',
  6: 'Июнь',
  7: 'Июль',
  8: 'Август',
  9: 'Сентябрь',
  10: 'Октябрь',
  11: 'Ноябрь',
  12: 'Декабрь'
});
/**
 * @type {string}
 */

var dateFormat = 'dd.MM.yyyy';
/**
 * Close modes for uiNotification component and Notifications plugin
 *
 * @type {string[]}
 */

var notificationCloseModes = Object.freeze(['auto', 'manual']);
/**
 * Timeout (in ms) of closing for uiNotification component and Notifications plugin
 *
 * @type {number}
 */

var notificationCloseTime = 5000;
/**
 * Minimal timeout (in ms) of closing for uiNotification component and Notifications plugin
 *
 * @type {number}
 */

var notificationMinCloseTime = 1000;
/**
 * @type {Readonly<{popovers: string, dropdowns: string, modals: string, tooltips: string}>}
 */

var containers = Object.freeze({
  dropdowns: 'x6yzHnS3PmDg26JWSJJHQUtgRdYhwntYBHnpGe6f7KXJI0S58gvlQbsdGrE0XLam',
  modals: 'RfHXHpexES2k38rdkSjonNGrHF7RDbB7oqg50kdFLfh6R1kPcd1A1aaRKsCGUnE0',
  popovers: 'Yh0akL2qH8Zb5p4I9uGui8kflty6kO04iur1JtJQ3oeQAe9SZr2fIcfdsZZs0yMa',
  tooltips: 'zelWHWAD6qpbX2rtwRtYiV55kxLEERkvcDUmEpePHJrpgD6nTlFruGSBxyNL3wmP'
});

/**
 * @popperjs/core v2.11.2 - MIT License
 */

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
} // means it doesn't take into account transforms.


function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/


function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format$1(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];

function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format$1(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format$1(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
} // of the `<html>` and `<body>` rect bounds if horizontally scrollable


function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;

    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...


      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false


  return false;
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS$1 = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var passive = {
  passive: true
};

function effect$2(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name; // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step

  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};
var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
}; // and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$1(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$1,
  requires: ['computeStyles']
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};
var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};

function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};

function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules
var createPopper_1 = createPopper$1;

var _e = function e() {
  return (_e = Object.assign || function (e) {
    for (var t, r = 1, s = arguments.length; r < s; r++) {
      for (var a in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    t = {
  kebab: /-(\w)/g,
  styleProp: /:(.*)/,
  styleList: /;(?![^(]*\))/g
};

function r(e, t) {
  return t ? t.toUpperCase() : "";
}

function s(e) {
  for (var s, a = {}, c = 0, o = e.split(t.styleList); c < o.length; c++) {
    var n = o[c].split(t.styleProp),
        i = n[0],
        l = n[1];
    (i = i.trim()) && ("string" == typeof l && (l = l.trim()), a[(s = i, s.replace(t.kebab, r))] = l);
  }

  return a;
}

function a() {
  for (var t, r, a = {}, c = arguments.length; c--;) {
    for (var o = 0, n = Object.keys(arguments[c]); o < n.length; o++) {
      switch (t = n[o]) {
        case "class":
        case "style":
        case "directives":
          if (Array.isArray(a[t]) || (a[t] = []), "style" === t) {
            var i = void 0;
            i = Array.isArray(arguments[c].style) ? arguments[c].style : [arguments[c].style];

            for (var l = 0; l < i.length; l++) {
              var y = i[l];
              "string" == typeof y && (i[l] = s(y));
            }

            arguments[c].style = i;
          }

          a[t] = a[t].concat(arguments[c][t]);
          break;

        case "staticClass":
          if (!arguments[c][t]) break;
          void 0 === a[t] && (a[t] = ""), a[t] && (a[t] += " "), a[t] += arguments[c][t].trim();
          break;

        case "on":
        case "nativeOn":
          a[t] || (a[t] = {});

          for (var p = 0, f = Object.keys(arguments[c][t] || {}); p < f.length; p++) {
            r = f[p], a[t][r] ? a[t][r] = [].concat(a[t][r], arguments[c][t][r]) : a[t][r] = arguments[c][t][r];
          }

          break;

        case "attrs":
        case "props":
        case "domProps":
        case "scopedSlots":
        case "staticStyle":
        case "hook":
        case "transition":
          a[t] || (a[t] = {}), a[t] = _e({}, arguments[c][t], a[t]);
          break;

        case "slot":
        case "key":
        case "ref":
        case "tag":
        case "show":
        case "keepAlive":
        default:
          a[t] || (a[t] = arguments[c][t]);
      }
    }
  }

  return a;
}

var _this$14 = null;
/**
 * Make random hash with given length
 *
 * @param {number} length
 * @returns {string}
 */

var makeHash = function makeHash() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  _newArrowCheck(this, _this$14);

  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';

  for (var i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}.bind(null);
/**
 * Format string from kebab case to pascal case
 *
 * @param {string} kebab
 * @returns {string}
 */

var kebabToPascal = function kebabToPascal(kebab) {
  var _this2 = this;

  _newArrowCheck(this, _this$14);

  return kebab.split('-').reduce(function (acc, part) {
    _newArrowCheck(this, _this2);

    var firstLetter = part.charAt(0).toLocaleUpperCase();
    return acc + firstLetter + part.substr(1).toLocaleLowerCase();
  }.bind(this), '');
}.bind(null);
/**
 * Format string from kebab case to camel case
 *
 * @param {string} kebab
 * @return {string}
 */

var kebabToCamel = function kebabToCamel(kebab) {
  var _this3 = this;

  _newArrowCheck(this, _this$14);

  return Object.entries(kebab.split('-')).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        index = _ref2[0],
        part = _ref2[1];

    _newArrowCheck(this, _this3);

    if (Number(index) === 0) {
      return acc + part.toLocaleLowerCase();
    }

    var firstLetter = part.charAt(0).toLocaleUpperCase();
    return acc + firstLetter + part.substr(1).toLocaleLowerCase();
  }.bind(this), '');
}.bind(null);
/**
 * Get element view area
 *
 * @param {HTMLElement | Element} el
 * @return {{ y: {start: number, end: number}, x: {start: number, end: number} }}
 */

var viewArea = function viewArea(el) {
  _newArrowCheck(this, _this$14);

  var _el$getBoundingClient = el.getBoundingClientRect(),
      width = _el$getBoundingClient.width,
      height = _el$getBoundingClient.height;

  return {
    x: {
      start: el.scrollLeft,
      end: Math.floor(el.scrollLeft + width)
    },
    y: {
      start: el.scrollTop,
      end: Math.floor(el.scrollTop + height)
    }
  };
}.bind(null);
/**
 * @param {Element | Node} el
 * @param {number} x
 * @param {number} y
 */

var scrollTo = function scrollTo(el, x, y) {
  _newArrowCheck(this, _this$14);

  if (typeof el.scrollTo === 'function') {
    el.scrollTo(x, y);
    return;
  }

  Object.assign(el, {
    scrollTop: y,
    scrollLeft: x
  });
}.bind(null);
/**
 * Scroll by Y axis
 *
 * @param {HTMLElement | Element} el
 * @param {number} top
 */

var scrollTop = function scrollTop(el, top) {
  _newArrowCheck(this, _this$14);

  return scrollTo(el, el.scrollLeft, top);
}.bind(null);
/**
 * @param {Function} func
 * @param {number} delay
 * @return {Function}
 */

function throttle(func, delay) {
  if (typeof func !== 'function') {
    // eslint-disable-next-line max-len
    throw new FrameworkError("Invalid type for argument \"func\", expected \"function\" got \"".concat(_typeof(func), "\""));
  }

  if (typeof delay !== 'number') {
    // eslint-disable-next-line max-len
    throw new FrameworkError("Invalid type for argument \"delay\", expected \"number\" got \"".concat(_typeof(delay), "\""));
  }

  if (delay <= 0) {
    // eslint-disable-next-line max-len
    throw new FrameworkError("Invalid value for argument \"delay\", expected Number greater than 0 got \"".concat(delay, "\""));
  }

  var isThrottled = false;
  var lastArgs = [];
  var lastContext = null;
  return function wrapper() {
    var _this4 = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isThrottled) {
      lastArgs = args;
      lastContext = this;
      return;
    }

    func.apply(this, args);
    isThrottled = true;
    setTimeout(function () {
      _newArrowCheck(this, _this4);

      isThrottled = false;

      if (lastArgs.length > 0) {
        wrapper.apply(lastContext, lastArgs);
        lastArgs = [];
        lastContext = null;
      }
    }.bind(this), delay);
  };
}
/**
 * @param {Element | HTMLElement} activator
 * @param {Element | HTMLElement} popper
 * @param {string} position
 * @param {Object} options?
 * @return {Popper}
 */

var createPopper = function createPopper(activator, popper, position) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _newArrowCheck(this, _this$14);

  var opts = {
    placement: position,
    strategy: 'absolute',
    modifiers: [{
      name: 'preventOverflow',
      options: {
        boundary: 'window'
      }
    }]
  };
  merge(opts, options);
  return createPopper_1(activator, popper, opts);
}.bind(null);
/**
 * @param {string} value
 * @return {string}
 */

var escapeRegExp$1 = function escapeRegExp(value) {
  _newArrowCheck(this, _this$14);

  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}.bind(null);
/**
 * @param {string} searchString
 * @param {string[] | Object[] | Array<Object> | Array<string>} options
 * @param {string | null} field
 * @returns {array}
 */

var search = function search(searchString, options) {
  var _this5 = this;

  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  _newArrowCheck(this, _this$14);

  var str = searchString ? searchString.toLocaleLowerCase().trim() : '';

  var value = function value(row) {
    _newArrowCheck(this, _this5);

    return String(field ? row[field] : row || '').toLocaleLowerCase().trim();
  }.bind(this);

  return options.filter(function (row) {
    _newArrowCheck(this, _this5);

    return value(row).includes(str);
  }.bind(this)).sort(function (a, b) {
    _newArrowCheck(this, _this5);

    var aValue = value(a);
    var bValue = value(b);
    var compare = aValue.indexOf(str) - bValue.indexOf(str);
    return compare === 0 ? aValue.length - bValue.length : compare;
  }.bind(this));
}.bind(null);
/**
 * @param {number} value
 * @param {Array<string> | string[]} parts
 * @returns {string}
 */

var pluralize = function pluralize(value, parts) {
  _newArrowCheck(this, _this$14);

  var _parts = _slicedToArray(parts, 3),
      one = _parts[0],
      two = _parts[1],
      five = _parts[2];

  var n = Math.abs(value) % 100;

  if (n >= 5 && n <= 20) {
    return five;
  }

  n %= 10;

  if (n === 1) {
    return one;
  }

  if (n >= 2 && n <= 4) {
    return two;
  }

  return five;
}.bind(null);
/**
 * @param {*} v
 * @returns {boolean}
 */
// eslint-disable-next-line max-len

var isPlainObject = function isPlainObject(v) {
  _newArrowCheck(this, _this$14);

  return _typeof(v) === 'object' && v !== null && v.toString() === '[object Object]';
}.bind(null);
/**
 * @return {function(): number}
 */

function counter() {
  var count = 0;
  return function increment() {
    count += 1;
    return count;
  };
}
/**
 * @param {string} breakpoint
 * @return {boolean}
 */

(function mediaMin(breakpoint) {
  _newArrowCheck(this, _this$14);

  return gridBreakpoints[breakpoint] <= window.innerWidth;
}).bind(null);
/**
 * @param {string} breakpoint
 * @return {boolean}
 */

var mediaMax = function mediaMax(breakpoint) {
  _newArrowCheck(this, _this$14);

  return gridBreakpoints[breakpoint] - 1 >= window.innerWidth;
}.bind(null);
/**
 * @param {Element | Node} el
 */

var removeNode = function removeNode(el) {
  _newArrowCheck(this, _this$14);

  return 'remove' in el ? el.remove() : el.parentNode.removeChild(el);
}.bind(null);
/**
 * @param {string | Object | null | undefined} value
 * @return {Object<string, number | boolean>}
 */

var parseBreakpoints = function parseBreakpoints(value) {
  var _this6 = this;

  _newArrowCheck(this, _this$14);

  if (value === null || value === undefined) {
    return {};
  }

  if (typeof value === 'string') {
    return value.split(' ').map(function (v) {
      _newArrowCheck(this, _this6);

      if (v.includes('-')) {
        var i = v.indexOf('-');
        return [v.substr(0, i), v.substr(i + 1, v.length - (i + 1))];
      }

      return [v];
    }.bind(this)).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];

      _newArrowCheck(this, _this6);

      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, k, v === undefined ? true : v));
    }.bind(this), {});
  }

  return value;
}.bind(null);
/**
 * Run smooth animation when element property changes
 *
 * @param {Element | Node} el
 * @param {string} prop
 * @param {number} to
 * @param {Object?} options
 */

var animate = function animate(el, prop, to) {
  var _this7 = this;

  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _newArrowCheck(this, _this$14);

  if (!el) {
    return;
  }

  var _duration$unit$get$op = _objectSpread2({
    /**
     * Animation time
     *
     * @type {number}
     */
    duration: 1000,

    /**
     * Element's prop value unit
     *
     * @type {string | null}
     */
    unit: null,

    /**
     * Gets root node for animation
     *
     * @param {Element} node
     * @return {Element | CSSStyleDeclaration}
     */
    get: function get(node) {
      _newArrowCheck(this, _this7);

      return node;
    }.bind(this)
  }, options),
      duration = _duration$unit$get$op.duration,
      unit = _duration$unit$get$op.unit,
      get = _duration$unit$get$op.get;

  var start = Date.now();
  var node = get(el);
  var from = node[prop];

  if (from === to) {
    return;
  }

  var timer = setInterval(function () {
    _newArrowCheck(this, _this7);

    var step = Math.min(1, (Date.now() - start) / duration);
    node[prop] = from + step * (to - from) + unit;

    if (step === 1) {
      clearInterval(timer);
    }
  }.bind(this), 25);
}.bind(null);
/**
 * @param {Object} obj
 * @param {string} prop
 * @param {function} getter
 */

(function defineReadOnlyProperty(obj, prop, getter) {
  _newArrowCheck(this, _this$14);

  Object.defineProperty(obj, prop, {
    configurable: false,
    get: getter,
    set: function set() {
      throw new FrameworkError("Can't set readonly property \"".concat(prop, "\""));
    }
  });
}).bind(null);
/**
 * @return {boolean}
 */

var isTouchDevice = function isTouchDevice() {
  _newArrowCheck(this, _this$14);

  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}.bind(null);
/**
 * @param {Element | HTMLElement} el
 * @return {Element[] | HTMLElement[]}
 */

var _elementPath = function elementPath(el) {
  _newArrowCheck(this, _this$14);

  var parentElement = el.parentElement;

  if (!parentElement) {
    return [];
  }

  return [parentElement].concat(_toConsumableArray(_elementPath(parentElement)));
}.bind(null);
var closesParent = function closesParent(el, condition) {
  var _this8 = this;

  _newArrowCheck(this, _this$14);

  return _elementPath(el).find(function (parent) {
    _newArrowCheck(this, _this8);

    return condition(parent);
  }.bind(this)) || null;
}.bind(null);
/**
 * @param {Element | HTMLElement} el
 * @param {function(parent: Element | HTMLElement): boolean} condition
 * @return {boolean}
 */

(function isNotTransportable(el, condition) {
  var _this9 = this;

  _newArrowCheck(this, _this$14);

  return _elementPath(el).some(function (parent) {
    _newArrowCheck(this, _this9);

    return condition(parent);
  }.bind(this));
}).bind(null);
/**
 * @param {Element | HTMLElement} el
 * @param {Element | HTMLElement | string} destination
 * @param {string} fallback
 */

var transport = function transport(el, destination) {
  var _this10 = this;

  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#app';

  _newArrowCheck(this, _this$14);

  var transported = [function () {
    _newArrowCheck(this, _this10);

    return document.querySelector("#".concat(destination)).appendChild(el);
  }.bind(this), function () {
    _newArrowCheck(this, _this10);

    return document.querySelector(fallback).appendChild(el);
  }.bind(this), function () {
    _newArrowCheck(this, _this10);

    return document.body.appendChild(el);
  }.bind(this)].some(function (move) {
    _newArrowCheck(this, _this10);

    try {
      move();
      return true;
    } catch (e) {
      return false;
    }
  }.bind(this));

  if (!transported) {
    // eslint-disable-next-line no-console
    console.warn("[UI Framework] Element \"".concat(el.className, "\" not transported"));
  }

  return transported;
}.bind(null);
/**
 * @param {Element} el
 * @param {Element | HTMLElement | string} destination
 * @param {string} fallback
 */

var removeTransportedElement = function removeTransportedElement(el, destination) {
  var _this11 = this;

  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#app';

  _newArrowCheck(this, _this$14);

  [function () {
    _newArrowCheck(this, _this11);

    return document.querySelector("#".concat(destination));
  }.bind(this), function () {
    _newArrowCheck(this, _this11);

    return document.querySelector(fallback);
  }.bind(this), function () {
    _newArrowCheck(this, _this11);

    return document.body;
  }.bind(this)].forEach(function (get) {
    _newArrowCheck(this, _this11);

    try {
      var container = get();

      if (container && container.contains(el)) {
        removeNode(el);
      }
    } catch (e) {// do nothing
    }
  }.bind(this));
}.bind(null);
/**
 * @param {function} callback
 */

var onBrowserReady = function onBrowserReady(callback) {
  var _this12 = this;

  _newArrowCheck(this, _this$14);

  var _handler = function handler() {
    var _this13 = this;

    _newArrowCheck(this, _this12);

    requestAnimationFrame(function () {
      var _this14 = this;

      _newArrowCheck(this, _this13);

      requestAnimationFrame(function () {
        var _this15 = this;

        _newArrowCheck(this, _this14);

        requestAnimationFrame(function () {
          _newArrowCheck(this, _this15);

          document.removeEventListener('DOMContentLoaded', _handler);
          callback();
        }.bind(this));
      }.bind(this));
    }.bind(this));
  }.bind(this);

  document.addEventListener('DOMContentLoaded', _handler);
}.bind(null);
/**
 * Convert the size from bytes to a human readable value
 *
 * @param {number|string} bytes
 * @returns {string}
 */

var humanFileSize = function humanFileSize(bytes) {
  _newArrowCheck(this, _this$14);

  if (!Number(bytes)) {
    return '0 Б';
  }

  var i = Math.floor(Math.log(bytes) / Math.log(1024));
  var unit = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'][i];
  var size = i === 1 ? Math.round(bytes / Math.pow(1024, i)) : (bytes / Math.pow(1024, i)).toFixed(2) * 1;
  return "".concat(size, " ").concat(unit);
}.bind(null);

var defaultOptions$1 = {
  title: null,
  text: null,
  theme: null,
  close: 'auto',
  closeTime: notificationCloseTime
};
var increment$1 = counter();

var Notifications = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Notifications() {
    _classCallCheck(this, Notifications);

    this._items = [];
    this._max = 3;
    this._position = 'right';
    this._offset = '12px';
  }
  /**
   * @return {object}
   */


  _createClass(Notifications, [{
    key: "items",
    get: function get() {
      return this._items;
    }
    /**
     * @return {number}
     */

  }, {
    key: "max",
    get: function get() {
      return this._max;
    }
    /**
     * @return {string}
     */

  }, {
    key: "position",
    get: function get() {
      return this._position;
    }
    /**
     * @return {string}
     */

  }, {
    key: "offset",
    get: function get() {
      return this._offset;
    }
    /**
     * @param {Object?} options
     * @return {number}
     */

  }, {
    key: "create",
    value: function create() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var opts = _objectSpread2(_objectSpread2({}, defaultOptions$1), options);

      if (!opts.text && !opts.title) {
        // eslint-disable-next-line max-len
        throw new FrameworkError('Can\'t create notification, title and text options are not defined');
      }

      if (!notificationCloseModes.includes(opts.close)) {
        // eslint-disable-next-line max-len
        throw new FrameworkError("Invalid close mode given for notification, allowed values: ".concat(notificationCloseModes.join(', ')));
      }

      if (typeof opts.closeTime !== 'number' || opts.closeTime < notificationMinCloseTime) {
        // eslint-disable-next-line max-len
        throw new FrameworkError("Invalid close time given for notification, minimum value - ".concat(notificationMinCloseTime));
      }

      var id = increment$1();
      var count = this._items.length;

      var items = this._items.slice();

      if (this._max <= count && this._max > 0) {
        items.splice(this._max - 1, count - this._max + 1).forEach(function (item) {
          _newArrowCheck(this, _this);

          return this.destroy(item.id);
        }.bind(this));
      }

      items.unshift(_objectSpread2({
        id: id
      }, opts));
      this._items = _toConsumableArray(items);
      return id;
    }
    /**
     * @param {number} id
     */

  }, {
    key: "destroy",
    value: function destroy(id) {
      var _this2 = this;

      if (typeof id !== 'number') {
        throw new FrameworkError('Invalid notification id given');
      }

      this._items = this._items.filter(function (item) {
        _newArrowCheck(this, _this2);

        return item.id !== id;
      }.bind(this));
    }
    /**
     * @param {'left' | 'right'} value
     */

  }, {
    key: "setPosition",
    value: function setPosition(value) {
      var allowed = ['left', 'right'];

      if (!allowed.includes(value)) {
        throw new FrameworkError("Invalid position given, allowed values: ".concat(allowed.join(', ')));
      }

      this._position = value;
    }
    /**
     * @param {number} value
     */

  }, {
    key: "setMaxCount",
    value: function setMaxCount(value) {
      if (typeof value !== 'number') {
        throw new FrameworkError('Max count must be type of number');
      }

      if (value < 1) {
        throw new FrameworkError('Max count must be greater than 0');
      }

      this._max = value;
    }
    /**
     * @param {string} value
     */

  }, {
    key: "setOffsetTop",
    value: function setOffsetTop(value) {
      if (typeof value !== 'string') {
        throw new FrameworkError('Offset top must be type of string');
      }

      this._offset = value;
    }
  }]);

  return Notifications;
}();

var Breakpoints = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Breakpoints() {
    var _this = this;

    _classCallCheck(this, Breakpoints);

    _defineProperty(this, "_onResize", function () {
      _newArrowCheck(this, _this);

      clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(this._update, 200);
    }.bind(this));

    _defineProperty(this, "_update", function () {
      _newArrowCheck(this, _this);

      this._current = null;
      this._width = this._getClientWidth();
      var xs = this._width < this._all.sm;
      var sm = this._width < this._all.md && !xs;
      var md = this._width < this._all.lg && !(xs || sm);
      var lg = this._width < this._all.xl && !(md || sm || xs);
      var xl = this._width >= this._all.xl;

      switch (true) {
        case xs:
          this._current = 'xs';
          break;

        case sm:
          this._current = 'sm';
          break;

        case md:
          this._current = 'md';
          break;

        case lg:
          this._current = 'lg';
          break;

        case xl:
          this._current = 'xl';
          break;

        default:
          this._current = 'xs';
      }
    }.bind(this));

    this._current = null;
    this._width = null;
    this._all = gridBreakpoints;
    this._resizeTimeout = null;
    this._sortedList = Object.entries(_objectSpread2({}, gridBreakpoints)).sort(function (a, b) {
      _newArrowCheck(this, _this);

      return a[1] - b[1];
    }.bind(this)).map(function (item) {
      _newArrowCheck(this, _this);

      return item[0];
    }.bind(this));
  }
  /**
   * @return {string}
   */


  _createClass(Breakpoints, [{
    key: "current",
    get: function get() {
      return this._current;
    }
    /**
     * @return {number}
     */

  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
    /**
     * @return {object}
     */

  }, {
    key: "all",
    get: function get() {
      return this._all;
    }
  }, {
    key: "_getClientWidth",
    value: function _getClientWidth() {
      try {
        var _document$documentEle;

        return Math.max((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth, window.innerWidth || 0);
      } catch (error) {
        return 0;
      }
    }
  }, {
    key: "init",
    value: function init() {
      this._update();

      if (typeof window === 'undefined') return;
      window.addEventListener('resize', this._onResize);
    }
    /**
     * @param {string} from
     * @param {string} to
     * @return {boolean}
     */

  }, {
    key: "between",
    value: function between(from, to) {
      return this.min(from) && this.max(to);
    }
    /**
     * @param {string} breakpoint
     * @return {boolean}
     */

  }, {
    key: "min",
    value: function min(breakpoint) {
      if (!(breakpoint in this._all)) {
        // eslint-disable-next-line max-len
        throw new FrameworkError("\"".concat(breakpoint, "\" - \u0431\u0440\u0435\u0439\u043A\u043F\u043E\u0438\u043D\u0442 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442, \u0432\u044B\u0431\u0435\u0440\u0438 \u043E\u0434\u0438\u043D \u0438\u0437 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0431\u0440\u0435\u0439\u043A\u043F\u043E\u0438\u043D\u0442\u043E\u0432: ").concat(this._sortedList.join(', ')));
      }

      return this._width >= this._all[breakpoint];
    }
    /**
     * @param {string} breakpoint
     * @return {boolean}
     */

  }, {
    key: "max",
    value: function max(breakpoint) {
      var indexBreakpoint = this._sortedList.indexOf(breakpoint);

      if (!(breakpoint in this._all)) {
        // eslint-disable-next-line max-len
        throw new FrameworkError("\"".concat(breakpoint, "\" - \u0431\u0440\u0435\u0439\u043A\u043F\u043E\u0438\u043D\u0442 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442, \u0432\u044B\u0431\u0435\u0440\u0438 \u043E\u0434\u0438\u043D \u0438\u0437 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0431\u0440\u0435\u0439\u043A\u043F\u043E\u0438\u043D\u0442\u043E\u0432: ").concat(this._sortedList.join(', ')));
      }

      if (indexBreakpoint === this._sortedList.length - 1) {
        return true;
      }

      return this._width < this._all[this._sortedList[indexBreakpoint + 1]];
    }
  }]);

  return Breakpoints;
}();

var increment = counter();

var Modals = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Modals() {
    _classCallCheck(this, Modals);

    this._items = [];
    this._current = null;
  }
  /**
   * @return {object}
   */


  _createClass(Modals, [{
    key: "current",
    get: function get() {
      return this._current;
    }
    /**
     * @return {array}
     */

  }, {
    key: "items",
    get: function get() {
      return this._items;
    }
    /**
     * @return {object}
     */

  }, {
    key: "state",
    get: function get() {
      var _this = this;

      return this._items.reduce(function (acc, current) {
        _newArrowCheck(this, _this);

        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, current.id, current.opened));
      }.bind(this), {});
    }
    /**
     * @param {object} options
     * @return {number}
     */

  }, {
    key: "create",
    value: function create() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (typeof options.content !== 'string' && typeof options.content !== 'function') {
        throw new FrameworkError('Опция content должна быть строкой либо функцией');
      }

      var id = increment();

      var items = this._items.slice();

      items.unshift(_objectSpread2({
        id: id,
        opened: false
      }, options));
      this._items = _toConsumableArray(items);
      return id;
    }
    /**
     * @param {number} id
     */

  }, {
    key: "destroy",
    value: function destroy(id) {
      var _this2 = this;

      if (typeof id !== 'number') {
        throw new FrameworkError('Указан неправильный id модального окна');
      }

      this._items = this._items.filter(function (item) {
        _newArrowCheck(this, _this2);

        return item.id !== id;
      }.bind(this));
    }
    /**
     * @param {number} id
     */

  }, {
    key: "open",
    value: function open(id) {
      this.toggle(id, true);
    }
    /**
     * @param {number} id
     */

  }, {
    key: "close",
    value: function close(id) {
      this.toggle(id, false);
    }
    /**
     * @param {number} id
     * @param {?boolean} value
     */

  }, {
    key: "toggle",
    value: function toggle(id, value) {
      var _this3 = this;

      if (typeof id !== 'number') {
        throw new FrameworkError('Указан неправильный id модального окна');
      }

      var items = this._items.slice();

      var index = items.findIndex(function (item) {
        _newArrowCheck(this, _this3);

        return item.id === id;
      }.bind(this));
      items.splice(index, 1, _objectSpread2(_objectSpread2({}, items[index]), {}, {
        opened: typeof value === 'boolean' ? value : !items[index]
      }));
      this._items = items;
    }
  }]);

  return Modals;
}();

/* eslint-disable import/prefer-default-export */

var frameworkPlugins = /*#__PURE__*/Object.freeze({
  __proto__: null,
  notifications: Notifications,
  breakpoints: Breakpoints,
  modals: Modals
});

var uiFramework = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Object} options
   * @param {Vue} Vue
   */
  function uiFramework(options, Vue) {
    var _this = this;

    _classCallCheck(this, uiFramework);

    var plugins = options.plugins || [];

    if (!Array.isArray(plugins)) {
      throw new FrameworkError('Invalid plugins given');
    }

    this._appContainer = null;
    plugins.forEach(function (name) {
      _newArrowCheck(this, _this);

      if (!(name in frameworkPlugins)) {
        throw new FrameworkError("Plugin with given name \"".concat(name, "\" is not exists"));
      }

      this._registerPlugin(this, name, frameworkPlugins[name], Vue);
    }.bind(this));
  }
  /**
   * Current version of framework
   * @return {string}
   */


  _createClass(uiFramework, [{
    key: "$version",
    get: function get() {
      return "0.44.7";
    }
    /**
     * Current registered application container for framework
     * @return {Object | null}
     */

  }, {
    key: "$appContainer",
    get: function get() {
      return this._appContainer;
    }
    /**
     * @param {uiFramework} instance Framework instance
     * @param {string} name Plugin name
     * @param {function} plugin Plugin constructor function
     * @param {object} Vue
     */

  }, {
    key: "_registerPlugin",
    value: function _registerPlugin(instance, name, plugin, Vue) {
      var pluginName = name.startsWith('$') ? name : "$".concat(name); // eslint-disable-next-line no-param-reassign,new-cap

      instance[pluginName] = Vue.observable(new plugin(instance));

      if ('init' in instance[pluginName]) {
        instance[pluginName].init();
      }
    }
    /**
     * Register instance of uiApp component
     * @param {Vue} app
     */

  }, {
    key: "setAppContainer",
    value: function setAppContainer(app) {
      this._appContainer = app;
    }
  }]);

  return uiFramework;
}();

var plugin$4 = {
  installed: false,
  install: function install(Vue, options) {
    if (this.installed) {
      return;
    }

    this.installed = true; // eslint-disable-next-line no-param-reassign

    Vue.prototype.$ui = new uiFramework(options, Vue);
  }
};

var _this$13 = null;
/**
 * Generate component's name
 *
 * @param {string} name
 * @returns {string}
 */

var generateName = function generateName(name) {
  _newArrowCheck(this, _this$13);

  return name.startsWith('ui-') ? name : "ui-".concat(name);
}.bind(null);
/**
 * @param {Vue} Vue
 * @param {Object} component
 */

var _install = function install(Vue, component) {
  _newArrowCheck(this, _this$13);

  var name = generateName(component.name);
  var pascalName = kebabToPascal(name);
  Vue.component(name, component);
  Vue.component(pascalName, component);
}.bind(null);
/**
 * Generate plugin for component
 *
 * @param {object} component
 * @param {Array<Object>} additionalComponents
 * @returns {Object}
 */


var generatePlugin = function generatePlugin(component) {
  var additionalComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  _newArrowCheck(this, _this$13);

  Object.assign(component, {
    install: function install(Vue) {
      var _this2 = this;

      _install(Vue, component);

      additionalComponents.forEach(function (cmp) {
        _newArrowCheck(this, _this2);

        return _install(Vue, cmp);
      }.bind(this));
    }
  });
  return component;
}.bind(null);
/**
 * @param {string?} styleName
 * @return {function(string?) | string}
 */

function createStyle(styleName) {
  var style = styleName.startsWith('ui-') ? styleName : "ui-".concat(styleName);
  return function f() {
    var _this3 = this;

    for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    var result = styles.join('__');
    return function () {
      _newArrowCheck(this, _this3);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return args.length ? f.apply(null, [result].concat(args)) : result;
    }.bind(this);
  }(style);
}

var qaProperty = {
  qa: {
    type: String,
    default: null
  }
};
var Testable = {
  props: _objectSpread2({}, qaProperty),
  computed: {
    qaAttributes: function qaAttributes() {
      return _defineProperty({}, qaAttributeName, this.qa);
    }
  }
};

var _this$12 = null;
var factory$4 = function factory() {
  var _props,
      _this2 = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'label' : _ref$tag,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'label' : _ref$prop,
      _ref$slot = _ref.slot,
      slot = _ref$slot === void 0 ? 'default' : _ref$slot,
      _ref$hashLength = _ref.hashLength,
      hashLength = _ref$hashLength === void 0 ? 16 : _ref$hashLength;

  _newArrowCheck(this, _this$12);

  return {
    props: (_props = {}, _defineProperty(_props, prop, {
      type: String,
      default: null
    }), _defineProperty(_props, "required", {
      type: Boolean,
      default: false
    }), _defineProperty(_props, "requiredClass", {
      type: String,
      default: createStyle('label-marker')()
    }), _props),
    data: function data() {
      _newArrowCheck(this, _this2);

      return {
        labelHash: null
      };
    }.bind(this),
    computed: {
      hasLabel: function hasLabel() {
        return this[prop] || this.$slots[slot];
      },
      labelOptions: function labelOptions() {
        return {};
      },
      labelText: function labelText() {
        if (this.$slots[slot]) {
          return (this.$slots[slot][0].text || '').trim();
        }

        return this[prop];
      }
    },
    methods: {
      genLabel: function genLabel() {
        var content = this[prop] || this.$slots[slot] || null;

        if (!content) {
          return null;
        }

        return this.$createElement(tag, this.labelOptions, [content, this.genRequiredMarker()]);
      },
      genRequiredMarker: function genRequiredMarker() {
        if (!this.required) {
          return null;
        }

        return this.$createElement('span', {
          staticClass: this.requiredClass
        }, ['*']);
      }
    },
    beforeMount: function beforeMount() {
      this.labelHash = makeHash(hashLength);
    }
  };
}.bind(null);
var Labelable = factory$4();

var _this$11 = null;

/**
 * Validate route property value
 *
 * @param {string | { name: string, path: string }} route
 * @returns {boolean}
 */
var validateRoute = function validateRoute(route) {
  _newArrowCheck(this, _this$11);

  if (['string', 'undefined'].includes(_typeof(route))) {
    return true;
  }

  if (route === null) {
    return false;
  }

  return typeof route.name === 'string' || typeof route.path === 'string';
}.bind(null);
/**
 * Default mount tag
 *
 * @type {string}
 */


var defaultTag = 'a';
var Routable = {
  props: {
    tag: {
      type: String,
      default: undefined
    },
    href: {
      type: [String, Object],
      default: undefined,
      validator: function validator(value) {
        _newArrowCheck(this, _this$11);

        return validateRoute(value);
      }.bind(null)
    },
    to: {
      type: [String, Object],
      default: undefined,
      validator: function validator(value) {
        _newArrowCheck(this, _this$11);

        return validateRoute(value);
      }.bind(null)
    },

    /**
     * Use native Vue component for router links (router-link).
     * By default used Nuxt links (nuxt-link)
     */
    native: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: undefined
    },
    append: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    exact: {
      type: Boolean,
      default: false
    },
    exactActiveClass: {
      type: String,
      default: undefined
    },
    replace: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: undefined,
      validator: function validator(value) {
        _newArrowCheck(this, _this$11);

        return ['_blank', '_self', '_parent', '_top'].includes(value);
      }.bind(null)
    }
  },
  computed: {
    isLink: function isLink() {
      return this.href || this.to;
    }
  },
  methods: {
    click: function click(e) {
      this.$emit('click', e);
    },
    generateRouterLink: function generateRouterLink(classes) {
      var exact = this.exact;
      var tag;

      var data = _defineProperty({
        attrs: {
          disabled: this.disabled
        },
        class: classes,
        props: {}
      }, this.to ? 'nativeOn' : 'on', _objectSpread2(_objectSpread2({}, this.$listeners), {}, {
        click: this.click
      }));

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.native ? 'router-link' : 'nuxt-link';
        Object.assign(data.props, {
          exact: exact,
          to: this.to,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass || this.activeClass,
          append: this.append,
          replace: this.replace
        });
      } else {
        tag = this.href && defaultTag || this.tag || defaultTag;

        if (tag === defaultTag && this.href) {
          data.attrs.href = this.href;
        }
      }

      if (this.target) {
        data.attrs.target = this.target;
      }

      return {
        tag: tag,
        data: data
      };
    }
  }
};

var _this$10 = null;
var style$W = createStyle('loader');
var uiLoader$1 = {
  name: 'ui-loader',
  functional: true,
  model: {
    prop: 'loading',
    event: 'change'
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    loading: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$10);

        return ['primary', 'partner'].includes(v);
      }.bind(null)
    },
    color: {
      type: String,
      default: null
    }
  },
  render: function render(h, _ref) {
    var _this2 = this;

    var props = _ref.props,
        data = _ref.data;

    if (!props.loading) {
      return null;
    }

    var classes = function () {
      _newArrowCheck(this, _this2);

      if (props.color) {
        return {
          '-colorness': !!props.color
        };
      }

      return {
        '-primary': props.theme === 'primary',
        '-partner': props.theme === 'partner'
      };
    }.bind(this)();

    return h(props.tag, a(data, {
      staticClass: style$W(),
      class: classes,
      style: {
        '--loader-color': props.color
      }
    }), new Array(5).fill(h('span')));
  }
};

var uiLoader = generatePlugin(uiLoader$1);

var _this$$ = null;
var style$V = createStyle('icon');
var uiIcon$1 = {
  name: 'ui-icon',
  mixins: [Testable],
  props: {
    tag: {
      type: String,
      default: 'span',
      validator: function validator(value) {
        _newArrowCheck(this, _this$$);

        return ['span', 'i'].includes(value);
      }.bind(null)
    },
    name: {
      type: String,
      required: true
    },
    interactive: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      return {
        '-interactive': this.interactive && !this.disabled,
        '-active': this.active && !this.disabled,
        '-disabled': this.disabled
      };
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      if (!this.disabled) {
        this.$emit('click', e);
      }
    },
    genWrapper: function genWrapper(content) {
      var _this2 = this;

      return this.$createElement(this.tag, {
        staticClass: style$V(),
        class: this.classes,
        attrs: this.qaAttributes,
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this2);

            return this.clickHandler(e);
          }.bind(this)
        }
      }, content);
    },
    genSvg: function genSvg() {
      return this.$createElement('svg', {
        attrs: {
          width: 20,
          height: 20,
          viewBox: '0 0 20 20',
          xmlns: 'http://www.w3.org/2000/svg'
        }
      }, [this.$createElement('use', {
        attrs: {
          'xlink:href': "#".concat(this.name)
        }
      })]);
    }
  },
  render: function render() {
    return this.genWrapper([this.genSvg()]);
  }
};

var uiIcon = generatePlugin(uiIcon$1);

var _this$_ = null;
var breakpoints$4 = Object.keys(gridBreakpoints);
var style$U = createStyle('button');
var uiButton$1 = {
  name: 'ui-button',
  mixins: [Labelable, Routable, Testable],
  props: {
    tag: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        _newArrowCheck(this, _this$_);

        return ['button', 'div', 'a'].includes(value);
      }.bind(null)
    },
    type: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        _newArrowCheck(this, _this$_);

        return ['button', 'submit', 'reset'].includes(value);
      }.bind(null)
    },
    value: {
      type: [Number, String, Boolean, Object],
      default: null
    },
    theme: {
      type: String,
      default: null,
      validator: function validator(value) {
        _newArrowCheck(this, _this$_);

        return ['primary', 'secondary', 'disabled', 'partner'].includes(value);
      }.bind(null)
    },

    /**
     * @deprecated Use theme="secondary"
     */
    ghost: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        _newArrowCheck(this, _this$_);

        return ['normal', 'small'].includes(value);
      }.bind(null)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pending: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    stretch: {
      type: [Boolean, String],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$_);

        return typeof v === 'boolean' || breakpoints$4.includes(v);
      }.bind(null)
    },
    icon: {
      type: String,
      default: null
    },
    iconRight: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$_);

    return {
      hasContent: false
    };
  }.bind(null),
  computed: {
    classes: function classes() {
      var _objectSpread2$1,
          _this2 = this;

      return _objectSpread2((_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, style$U(), true), _defineProperty(_objectSpread2$1, '-primary', this.theme === 'primary'), _defineProperty(_objectSpread2$1, '-partner', this.theme === 'partner'), _defineProperty(_objectSpread2$1, '-disabled', this.theme === 'disabled' || this.disabled), _defineProperty(_objectSpread2$1, '-secondary', this.theme === 'secondary' || this.ghost), _defineProperty(_objectSpread2$1, '-normal', this.size === 'normal'), _defineProperty(_objectSpread2$1, '-icon-only', this.hasIcon && !this.hasLabel), _defineProperty(_objectSpread2$1, '-icon-right', this.hasIcon && this.iconRight && this.hasLabel), _defineProperty(_objectSpread2$1, '-icon-left', this.hasIcon && !this.iconRight && this.hasLabel), _defineProperty(_objectSpread2$1, '-stretch', this.stretch === true), _objectSpread2$1), breakpoints$4.reduce(function (acc, key) {
        _newArrowCheck(this, _this2);

        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "-stretch-".concat(key), this.stretch === key));
      }.bind(this), {}));
    },
    attributes: function attributes() {
      return {
        type: this.type,
        disabled: this.disabled,
        'aria-label': this.labelText
      };
    },
    isLoading: function isLoading() {
      return this.loading || this.pending;
    },
    hasIcon: function hasIcon() {
      return this.$slots.icon || this.$scopedSlots.icon || this.icon;
    }
  },
  methods: {
    click: function click(e) {
      this.$emit('click', e);
    },
    genIcon: function genIcon() {
      if (!this.icon) {
        return null;
      }

      return this.$createElement(uiIcon, {
        staticClass: style$U('icon')(),
        class: {
          '-hidden': this.isLoading
        },
        props: {
          name: this.icon
        },
        attrs: {
          'area-hidden': 'true'
        }
      });
    },
    genIconSlot: function genIconSlot() {
      if (this.$scopedSlots.icon) {
        return this.$scopedSlots.icon({
          classes: style$U('icon')()
        });
      }

      return this.$slots.icon || this.genIcon();
    },
    genLabel: function genLabel() {
      if (!this.hasLabel) {
        return null;
      }

      return this.$createElement('span', {
        staticClass: style$U('label')(),
        class: {
          '-hidden': this.isLoading
        }
      }, [this.label || this.$slots.default]);
    },
    genLoader: function genLoader() {
      return this.$createElement(uiLoader, {
        staticClass: style$U('loader')(),
        props: {
          loading: this.isLoading,
          color: this.theme === 'partner' ? '#fff' : null,
          theme: this.theme !== 'partner' ? this.theme : undefined
        }
      });
    }
  },
  render: function render(h) {
    var _this$generateRouterL = this.generateRouterLink(this.classes),
        tag = _this$generateRouterL.tag,
        data = _this$generateRouterL.data;

    return h(tag, a(data, {
      attrs: _objectSpread2(_objectSpread2({
        'data-group-item': ''
      }, tag === 'button' && this.attributes), this.qaAttributes)
    }), [!this.iconRight && this.genIconSlot(), this.genLabel(), this.iconRight && this.genIconSlot(), this.genLoader()]);
  }
};

var uiButton = generatePlugin(uiButton$1);

var _excluded$6 = ["click", "close"];

var _this$Z = null;
var style$T = createStyle('notification');
var uiNotification$1 = {
  name: 'ui-notification',
  mixins: [Testable],
  props: {
    theme: {
      type: String,
      default: null
    },
    close: {
      type: String,
      default: 'auto',
      validator: function validator(v) {
        _newArrowCheck(this, _this$Z);

        return notificationCloseModes.includes(v);
      }.bind(null)
    },
    closeTime: {
      type: [String, Number],
      default: notificationCloseTime,
      validator: function validator(v) {
        _newArrowCheck(this, _this$Z);

        return !Number.isNaN(parseInt(v, 10)) && v >= notificationMinCloseTime;
      }.bind(null)
    },
    closeLabel: {
      type: String,
      default: 'Закрыть'
    },
    action: {
      type: Object,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$Z);

        return isPlainObject(v);
      }.bind(null)
    }
  },
  computed: {
    classes: function classes() {
      return {
        '-warning': this.theme === 'warning',
        '-success': this.theme === 'success',
        '-danger': this.theme === 'danger'
      };
    }
  },
  watch: {
    close: function close(v) {
      (v === 'auto' ? this.startTimeout : this.stopTimeout)();
    }
  },
  methods: {
    startTimeout: function startTimeout() {
      var _this2 = this;

      this.$_closeTimeout = setTimeout(function () {
        _newArrowCheck(this, _this2);

        return this.closeHandler();
      }.bind(this), parseInt(this.closeTime, 10));
    },
    stopTimeout: function stopTimeout() {
      clearTimeout(this.$_closeTimeout);
      this.$_closeTimeout = undefined;
    },
    closeHandler: function closeHandler() {
      this.$emit('close');
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$T(),
        class: this.classes,
        attrs: this.qaAttributes
      }, content);
    },
    genText: function genText() {
      return this.$createElement('div', {
        staticClass: style$T('text')()
      }, [this.$createElement('div', {
        attrs: _defineProperty({}, qaAttributeName, this.qa ? "".concat(this.qa, "-text") : null)
      }, this.$slots.default)]);
    },
    genActions: function genActions(content) {
      var _this3 = this;

      if (content.filter(function (v) {
        _newArrowCheck(this, _this3);

        return v !== null;
      }.bind(this)).length === 0) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$T('actions')()
      }, content);
    },
    genClose: function genClose() {
      var _this4 = this;

      if (this.close !== 'manual') {
        return null;
      }

      return this.$createElement(uiButton, {
        staticClass: style$T('button')(),
        props: {
          ghost: true,
          label: this.closeLabel,
          qa: this.qa ? "".concat(this.qa, "-close-button") : null
        },
        on: {
          click: function click() {
            _newArrowCheck(this, _this4);

            this.closeHandler();
            this.stopTimeout();
          }.bind(this)
        }
      });
    },
    genAction: function genAction() {
      var _this5 = this;

      if (!this.action) {
        return null;
      }

      var _this$action = this.action,
          _this$action$click = _this$action.click,
          _click = _this$action$click === void 0 ? function () {
        _newArrowCheck(this, _this5);
      }.bind(this) : _this$action$click,
          _this$action$close = _this$action.close,
          close = _this$action$close === void 0 ? true : _this$action$close,
          props = _objectWithoutProperties(_this$action, _excluded$6);

      return this.$createElement(uiButton, {
        staticClass: style$T('button')(),
        props: _objectSpread2(_objectSpread2({
          qa: this.qa ? "".concat(this.qa, "-action-button") : null
        }, props), {}, {
          ghost: true
        }),
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this5);

            _click(e);

            if (close) {
              this.closeHandler();
            }
          }.bind(this)
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.close === 'auto') {
      this.startTimeout();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopTimeout();
  },
  render: function render() {
    return this.genWrapper([this.genText(), this.genActions([this.genAction(), this.genClose()])]);
  }
};

var uiNotification = generatePlugin(uiNotification$1);

var _excluded$5 = ["id", "text"];

var _this$Y = null;
var style$S = createStyle('notifications');
var uiNotificationsContainer$1 = {
  name: 'ui-notifications-container',
  props: {
    options: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$Y);

        return [];
      }.bind(null)
    },
    position: {
      type: String,
      default: 'right',
      validator: function validator(v) {
        _newArrowCheck(this, _this$Y);

        return ['left', 'right'].includes(v);
      }.bind(null)
    },
    offsetTop: {
      type: [String, Number],
      default: '12px'
    }
  },
  methods: {
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$S(),
        class: {
          '-left': this.position === 'left',
          '-right': this.position === 'right'
        },
        style: {
          top: this.offsetTop
        }
      }, content);
    },
    genTransition: function genTransition(content) {
      return this.$createElement('transition-group', {
        staticClass: style$S('wrapper')(),
        props: {
          tag: 'div',
          duration: 300,
          mode: 'out-in',
          enterClass: '-enter',
          enterToClass: '-enter-to',
          enterActiveClass: '-active',
          leaveClass: '-leave',
          leaveToClass: '-leave-to',
          leaveActiveClass: '-leave-active',
          moveClass: '-move'
        }
      }, content);
    },
    genOptions: function genOptions() {
      var _this2 = this;

      return this.$slots.default || this.options.map(function (_ref, index) {
        var _this3 = this;

        var _ref$id = _ref.id,
            id = _ref$id === void 0 ? null : _ref$id,
            text = _ref.text,
            props = _objectWithoutProperties(_ref, _excluded$5);

        _newArrowCheck(this, _this2);

        return this.$createElement(uiNotification, {
          key: id || index,
          props: props,
          on: {
            close: function close() {
              _newArrowCheck(this, _this3);

              return this.$emit('close', id || index, id ? 'id' : 'index');
            }.bind(this)
          }
        }, [text]);
      }.bind(this));
    }
  },
  render: function render() {
    return this.genWrapper([this.genTransition([this.genOptions()])]);
  }
};

var uiNotificationsContainer = generatePlugin(uiNotificationsContainer$1);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var bodyScrollLock = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    {
      factory(exports);
    }
  })(commonjsGlobal, function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      } else {
        return Array.from(arr);
      }
    } // Older browsers don't support event options, feature detect it.
    // Adopted and modified solution from Bohdan Didukh (2017)
    // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi


    var hasPassiveEvents = false;

    if (typeof window !== 'undefined') {
      var passiveTestOptions = {
        get passive() {
          hasPassiveEvents = true;
          return undefined;
        }

      };
      window.addEventListener('testPassive', null, passiveTestOptions);
      window.removeEventListener('testPassive', null, passiveTestOptions);
    }

    var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
    var locks = [];
    var documentListenerAdded = false;
    var initialClientY = -1;
    var previousBodyOverflowSetting = void 0;
    var previousBodyPaddingRight = void 0; // returns true if `el` should be allowed to receive touchmove events.

    var allowTouchMove = function allowTouchMove(el) {
      return locks.some(function (lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
          return true;
        }

        return false;
      });
    };

    var preventDefault = function preventDefault(rawEvent) {
      var e = rawEvent || window.event; // For the case whereby consumers adds a touchmove event listener to document.
      // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
      // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
      // the touchmove event on document will break.

      if (allowTouchMove(e.target)) {
        return true;
      } // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).


      if (e.touches.length > 1) return true;
      if (e.preventDefault) e.preventDefault();
      return false;
    };

    var setOverflowHidden = function setOverflowHidden(options) {
      // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
      // the responsiveness for some reason. Setting within a setTimeout fixes this.
      setTimeout(function () {
        // If previousBodyPaddingRight is already set, don't set it again.
        if (previousBodyPaddingRight === undefined) {
          var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;

          var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

          if (_reserveScrollBarGap && scrollBarGap > 0) {
            previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + 'px';
          }
        } // If previousBodyOverflowSetting is already set, don't set it again.


        if (previousBodyOverflowSetting === undefined) {
          previousBodyOverflowSetting = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
      });
    };

    var restoreOverflowSetting = function restoreOverflowSetting() {
      // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
      // the responsiveness for some reason. Setting within a setTimeout fixes this.
      setTimeout(function () {
        if (previousBodyPaddingRight !== undefined) {
          document.body.style.paddingRight = previousBodyPaddingRight; // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
          // can be set again.

          previousBodyPaddingRight = undefined;
        }

        if (previousBodyOverflowSetting !== undefined) {
          document.body.style.overflow = previousBodyOverflowSetting; // Restore previousBodyOverflowSetting to undefined
          // so setOverflowHidden knows it can be set again.

          previousBodyOverflowSetting = undefined;
        }
      });
    }; // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions


    var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
      return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
    };

    var handleScroll = function handleScroll(event, targetElement) {
      var clientY = event.targetTouches[0].clientY - initialClientY;

      if (allowTouchMove(event.target)) {
        return false;
      }

      if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll.
        return preventDefault(event);
      }

      if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
        // element is at the bottom of its scroll.
        return preventDefault(event);
      }

      event.stopPropagation();
      return true;
    };

    exports.disableBodyScroll = function disableBodyScroll(targetElement, options) {
      if (isIosDevice) {
        // targetElement must be provided, and disableBodyScroll must not have been
        // called on this targetElement before.
        if (!targetElement) {
          // eslint-disable-next-line no-console
          console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
          return;
        }

        if (targetElement && !locks.some(function (lock) {
          return lock.targetElement === targetElement;
        })) {
          var lock = {
            targetElement: targetElement,
            options: options || {}
          };
          locks = [].concat(_toConsumableArray(locks), [lock]);

          targetElement.ontouchstart = function (event) {
            if (event.targetTouches.length === 1) {
              // detect single touch.
              initialClientY = event.targetTouches[0].clientY;
            }
          };

          targetElement.ontouchmove = function (event) {
            if (event.targetTouches.length === 1) {
              // detect single touch.
              handleScroll(event, targetElement);
            }
          };

          if (!documentListenerAdded) {
            document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? {
              passive: false
            } : undefined);
            documentListenerAdded = true;
          }
        }
      } else {
        setOverflowHidden(options);
        var _lock = {
          targetElement: targetElement,
          options: options || {}
        };
        locks = [].concat(_toConsumableArray(locks), [_lock]);
      }
    };

    exports.clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
      if (isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        locks.forEach(function (lock) {
          lock.targetElement.ontouchstart = null;
          lock.targetElement.ontouchmove = null;
        });

        if (documentListenerAdded) {
          document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
            passive: false
          } : undefined);
          documentListenerAdded = false;
        }

        locks = []; // Reset initial clientY.

        initialClientY = -1;
      } else {
        restoreOverflowSetting();
        locks = [];
      }
    };

    exports.enableBodyScroll = function enableBodyScroll(targetElement) {
      if (isIosDevice) {
        if (!targetElement) {
          // eslint-disable-next-line no-console
          console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
          return;
        }

        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        locks = locks.filter(function (lock) {
          return lock.targetElement !== targetElement;
        });

        if (documentListenerAdded && locks.length === 0) {
          document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
            passive: false
          } : undefined);
          documentListenerAdded = false;
        }
      } else {
        locks = locks.filter(function (lock) {
          return lock.targetElement !== targetElement;
        });

        if (!locks.length) {
          restoreOverflowSetting();
        }
      }
    };
  });
});

var _this$X = null;
/**
 * Inject factory
 *
 * @param {string} namespace
 * @param {string?} child
 * @param {string?} parent
 * @returns {{ inject: {} }}
 */

var inject$1 = function inject(namespace, child, parent) {
  var _this2 = this;

  _newArrowCheck(this, _this$X);

  var implementation = child && parent ? {
    register: function register() {
      _newArrowCheck(this, _this2);

      throw new ComponentInjectionError(parent, child);
    }.bind(this),
    unregister: function unregister() {
      _newArrowCheck(this, _this2);

      throw new ComponentInjectionError(parent, child);
    }.bind(this)
  } : null;
  return {
    inject: _defineProperty({}, namespace, {
      default: implementation
    })
  };
}.bind(null);
/**
 * Provide factory
 *
 * @param {string} namespace
 * @returns {{ provide(): object, methods: { unregister: null, register: null } }}
 */

var provide$1 = function provide(namespace) {
  _newArrowCheck(this, _this$X);

  return {
    methods: {
      register: null,
      unregister: null
    },
    provide: function provide() {
      return _defineProperty({}, namespace, {
        register: this.register,
        unregister: this.unregister
      });
    }
  };
}.bind(null);

var _this$W = null;

var provide = function provide(layer) {
  _newArrowCheck(this, _this$W);

  return {
    methods: {
      provideLayer: function provideLayer(item) {
        if (item.layer === null) {
          Object.assign(item, {
            layer: layer + 1
          });
        }
      }
    },
    provide: function provide() {
      return {
        layerProvider: {
          provideLayer: this.provideLayer
        }
      };
    }
  };
}.bind(null);
var inject = {
  inject: {
    layerProvider: {
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$W);

    return {
      layer: null
    };
  }.bind(null),
  mounted: function mounted() {
    if (this.layerProvider) {
      this.layerProvider.provideLayer(this);
    }
  }
};

/**
 * @return {HTMLBodyElement}
 */

function container$1() {
  if (!document) {
    throw new FrameworkError('Can\'t execute this code on server side');
  }

  return document.querySelector('body');
}
/**
 * @param {HTMLElement} el
 * @param {number} x
 * @param {number} y
 * @return {boolean}
 */


function clickedInEl(el, x, y) {
  var rect = el.getBoundingClientRect();
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}
/**
 * @param {Event} e
 * @param {Array} elements
 * @return {boolean}
 */


function clickedInEls(e, elements) {
  var x = e.clientX,
      y = e.clientY; // eslint-disable-next-line no-restricted-syntax

  var _iterator = _createForOfIteratorHelper(elements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var el = _step.value;

      if (clickedInEl(el, x, y)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}
/**
 * @param {Event} e
 * @param {HTMLElement} el
 * @param {Object} binding
 */


function directive$1(e, el, binding) {
  var _this = this;

  // eslint-disable-next-line no-param-reassign
  binding.args = binding.args || {};

  var isActive = binding.args.closeConditional || function () {
    _newArrowCheck(this, _this);

    return false;
  }.bind(this);

  if (!e || isActive(e) === false) {
    return;
  }

  if ('isTrusted' in e && !e.isTrusted || 'pointerType' in e && !e.pointerType) {
    return;
  }

  var elements = (binding.args.include || function () {
    _newArrowCheck(this, _this);

    return [];
  }.bind(this))();

  elements.push(el);
  binding.value(e); // eslint-disable-next-line no-unused-expressions

  !clickedInEls(e, elements) && isActive(e) && binding.value(e);
}

var ClickOutside = {
  name: 'click-outside',
  inserted: function inserted(el, binding) {
    var _this2 = this;

    var onClick = function onClick(e) {
      _newArrowCheck(this, _this2);

      return directive$1(e, el, binding);
    }.bind(this);

    container$1().addEventListener('mousedown', onClick, true); // eslint-disable-next-line no-param-reassign,no-underscore-dangle

    el._clickOutside = onClick;
  },
  unbind: function unbind(el) {
    var app = container$1(); // eslint-disable-next-line no-param-reassign,no-underscore-dangle,no-unused-expressions

    app && app.removeEventListener('mousedown', el._clickOutside, true); // eslint-disable-next-line no-param-reassign,no-underscore-dangle

    delete el._clickOutside;
  }
};

var _this$V = null;

/**
 * Create mixin with given params
 *
 * @param {string} prop
 * @param {string} event
 * @return {object}
 */
var factory$3 = function factory() {
  var _this2 = this;

  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'opened';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'toggle';

  _newArrowCheck(this, _this$V);

  return {
    model: {
      prop: prop,
      event: event
    },
    props: _defineProperty({}, prop, {
      type: Boolean,
      default: false
    }),
    data: function data() {
      _newArrowCheck(this, _this2);

      return {
        isOpened: false,
        isClosed: true
      };
    }.bind(this),
    watch: _defineProperty({}, prop, 'handleModelChange'),
    methods: {
      open: function open() {
        this.isClosed = false;
        this.isOpened = true;
      },
      close: function close() {
        this.isClosed = true;
        this.isOpened = false;
      },
      toggle: function toggle() {
        this.$emit(event, this.isOpened);
      },
      handleModelChange: function handleModelChange(value) {
        value ? this.open() : this.close();
      }
    },
    mounted: function mounted() {
      if (this[prop]) {
        this.open();
      }
    }
  };
}.bind(null);
var Toggleable = factory$3();

var Transportable = {
  props: {
    disableTransporting: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Перемещает элемент в указанный контейнер
     *
     * @param {Element | HTMLElement} el
     * @param {string} container
     */
    transport: function transport$1(el, container) {
      if (this.disableTransporting) {
        return;
      }

      var destination = containers[container];

      if (destination) {
        transport(el, destination);
      }
    },

    /**
     * Удаляет элемент из указанного контейнера
     *
     * @param {Element | HTMLElement} el
     * @param {string} container
     */
    removeTransportedElement: function removeTransportedElement$1(el, container) {
      if (this.disableTransporting) {
        return;
      }

      var destination = containers[container];

      if (destination) {
        removeTransportedElement(el, destination);
      }
    }
  }
};

var uiOverlay$1 = {
  name: 'ui-overlay',
  mixins: [Toggleable, Transportable],
  props: {
    disableScrollLock: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    opened: 'toggleScroll'
  },
  methods: {
    toggleScroll: function toggleScroll(opened) {
      if (opened) {
        scrollTo(this.$el, 0, 0);
      }

      opened ? this.lockScroll() : this.unlockScroll();
    },
    lockScroll: function lockScroll() {
      var _this = this;

      if (!this.disableScrollLock) {
        bodyScrollLock.disableBodyScroll(this.$el, {
          // eslint-disable-next-line consistent-return
          allowTouchMove: function allowTouchMove(element) {
            _newArrowCheck(this, _this);

            var el = element;

            while (el && el !== document.body) {
              if (el.getAttribute('data-scroll-lock-ignore') !== null) {
                return true;
              }

              el = el.parentElement;
            }

            return false;
          }.bind(this)
        });
      }
    },
    unlockScroll: function unlockScroll() {
      if (!this.disableScrollLock) {
        bodyScrollLock.enableBodyScroll(this.$el);
      }
    }
  },
  mounted: function mounted() {
    this.transport(this.$el, 'modals');
    this.toggleScroll(this.opened);
  },
  beforeDestroy: function beforeDestroy() {
    this.unlockScroll();
    this.removeTransportedElement(this.$el, 'modals');
  },
  render: function render(h) {
    return h('div', {
      staticClass: createStyle('overlay')(),
      class: {
        '-opened': this.opened
      }
    }, this.$slots.default);
  }
};

var uiOverlay = generatePlugin(uiOverlay$1);

var style$R = createStyle('modal');
var uiModal$1 = {
  name: 'ui-modal',
  mixins: [provide$1('overlay'), provide(200)],
  directives: {
    clickOutside: ClickOutside
  },
  model: {
    prop: 'opened',
    event: 'toggle'
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    breakpoints: {
      type: [String, Object],
      default: null
    },
    disableClosing: {
      type: Boolean,
      default: false
    },
    innerScroll: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.width ? "".concat(this.width, "px") : null
      };
    },
    directives: function directives() {
      var _this = this;

      return [{
        name: 'click-outside',
        value: function value() {
          _newArrowCheck(this, _this);

          return this.close();
        }.bind(this),
        args: {
          /**
           * @param {HTMLDivElement} target
           * @return {boolean}
           */
          closeConditional: function closeConditional(_ref) {
            var _this2 = this;

            var target = _ref.target;

            _newArrowCheck(this, _this);

            if (this.disableClosing || !this.opened) {
              return false;
            }

            if (this.$el === target && target.scrollHeight > target.clientHeight) {
              return false;
            } // eslint-disable-next-line max-len


            return [this.$refs.window].concat(_toConsumableArray(this.$_relatedElements)).every(function (el) {
              _newArrowCheck(this, _this2);

              return !el || !el.contains(target);
            }.bind(this)) && this.$el.contains(target);
          }.bind(this)
        }
      }];
    },
    isInnerScroll: function isInnerScroll() {
      return this.innerScroll || !this.$isServer && mediaMax('sm');
    }
  },
  watch: {
    opened: function opened(v) {
      if (v && this.isInnerScroll) {
        this.$refs.content.scrollTop = 0;
      }

      this.toggleScroll(v);
    }
  },
  methods: {
    register: function register(item) {
      this.$_relatedElements.push(item.$el);
    },
    unregister: function unregister(item) {
      var _this3 = this;

      this.$_relatedElements = this.$_relatedElements.filter(function (el) {
        _newArrowCheck(this, _this3);

        return el !== item.$el;
      }.bind(this));
    },
    close: function close() {
      var _this4 = this;

      this.$emit('toggle', false);
      setTimeout(function () {
        _newArrowCheck(this, _this4);

        return this.$emit('close');
      }.bind(this), 400);
    },
    toggleScroll: function toggleScroll(opened) {
      opened ? this.lockScroll() : this.unlockScroll();
    },
    lockScroll: function lockScroll() {
      if (!this.isInnerScroll) {
        return;
      }

      bodyScrollLock.disableBodyScroll(this.$refs.content);
    },
    unlockScroll: function unlockScroll() {
      if (!this.isInnerScroll) {
        return;
      }

      bodyScrollLock.enableBodyScroll(this.$refs.content);
    },
    genOverlay: function genOverlay(content) {
      var _this5 = this;

      return this.$createElement(uiOverlay, {
        props: {
          opened: this.opened
        },
        on: {
          toggle: function toggle(value) {
            _newArrowCheck(this, _this5);

            return this.$emit('toggle', value);
          }.bind(this)
        }
      }, content);
    },
    genContainer: function genContainer(content) {
      return this.$createElement('div', {
        staticClass: style$R(),
        class: {
          '-outer-scroll': !this.innerScroll,
          '-full-height': this.fullHeight
        }
      }, content);
    },
    genWindow: function genWindow(content) {
      var _this6 = this;

      var breakpoints = parseBreakpoints(this.breakpoints);
      return this.$createElement('div', {
        ref: 'window',
        staticClass: style$R('window')(),
        class: Object.entries(breakpoints).reduce(function (acc, _ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              k = _ref3[0],
              v = _ref3[1];

          _newArrowCheck(this, _this6);

          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "-".concat(k, "-").concat(v), true));
        }.bind(this), {
          '-opened': this.opened,
          '-outer-scroll': !this.innerScroll,
          '-full-height': this.fullHeight
        }),
        style: this.styles,
        directives: this.directives
      }, content);
    },
    genCaption: function genCaption(content) {
      return this.$createElement('div', {
        staticClass: style$R('caption')()
      }, content);
    },
    genTitle: function genTitle() {
      var content = this.title || this.$slots.title || null;

      if (!content) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$R('title')()
      }, [content]);
    },
    genClose: function genClose() {
      var _this7 = this;

      if (this.disableClosing) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$R('close')(),
        on: {
          click: function click() {
            _newArrowCheck(this, _this7);

            return this.close();
          }.bind(this)
        }
      }, [this.$createElement(uiIcon, {
        props: {
          name: 'cross'
        }
      })]);
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        ref: 'content',
        staticClass: style$R('content')(),
        class: {
          '-full-height': this.fullHeight
        }
      }, this.$slots.default);
    },
    genFooter: function genFooter() {
      return this.$slots.footer ? this.$createElement('div', {
        staticClass: style$R('footer')()
      }, this.$slots.footer) : null;
    }
  },
  created: function created() {
    this.$_relatedElements = [];
  },
  mounted: function mounted() {
    this.toggleScroll(this.opened);
  },
  beforeDestroy: function beforeDestroy() {
    this.unlockScroll();
  },
  render: function render() {
    return this.genOverlay([this.genContainer([this.genWindow([this.genCaption([this.genTitle(), this.genClose()]), this.genContent(), this.genFooter()])])]);
  }
};

var uiModal = generatePlugin(uiModal$1);

var _excluded$4 = ["content"];

var _this$U = null;
var uiApp = {
  name: 'ui-app',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    name: {
      type: String,
      default: 'app'
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$U);

    return {
      currentTheme: null
    };
  }.bind(null),
  computed: {
    notifications: function notifications() {
      if (this.$ui) {
        return {
          max: this.$ui.$notifications.max,
          position: this.$ui.$notifications.position,
          offset: this.$ui.$notifications.offset,
          items: this.$ui.$notifications.items
        };
      }

      return null;
    },
    modals: function modals() {
      var _this$$ui;

      if ((_this$$ui = this.$ui) !== null && _this$$ui !== void 0 && _this$$ui.$modals) {
        return {
          items: this.$ui.$modals.items
        };
      }

      return null;
    }
  },
  watch: {
    theme: {
      handler: 'setTheme',
      immediate: true
    }
  },
  methods: {
    setTheme: function setTheme(theme) {
      this.currentTheme = theme;
    },
    genContainers: function genContainers() {
      var _this2 = this;

      return Object.entries(containers).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            id = _ref2[1];

        _newArrowCheck(this, _this2);

        return this.genContainer(name, id);
      }.bind(this));
    },
    genContainer: function genContainer(name, id) {
      var _attrs;

      return this.$createElement('div', {
        key: name,
        attrs: (_attrs = {}, _defineProperty(_attrs, "data-".concat(name, "-container"), ''), _defineProperty(_attrs, "id", id), _attrs)
      });
    },
    genNotifications: function genNotifications() {
      var _this3 = this;

      if (this.$ui) {
        return this.$createElement(uiNotificationsContainer, {
          props: {
            position: this.notifications.position,
            options: this.notifications.items,
            offsetTop: this.notifications.offset
          },
          on: {
            close: function close(key) {
              _newArrowCheck(this, _this3);

              return this.$ui.$notifications.destroy(key);
            }.bind(this)
          }
        });
      }

      return null;
    },
    genModals: function genModals() {
      var _this4 = this;

      if (this.$ui) {
        return this.modals.items.map(function (item) {
          var _this5 = this;

          _newArrowCheck(this, _this4);

          /* eslint-disable prefer-const */
          var content = item.content,
              props = _objectWithoutProperties(item, _excluded$4);

          content = typeof content === 'function' ? content(this.$createElement) : content;
          return this.$createElement(uiModal, {
            props: props,
            on: {
              close: function close() {
                _newArrowCheck(this, _this5);

                return this.$ui.$modals.close(item.id);
              }.bind(this)
            }
          }, [content]);
        }.bind(this));
      }

      return null;
    }
  },
  created: function created() {
    if (this.$ui) {
      this.$ui.setAppContainer(this);
    }
  },
  render: function render(h) {
    return h(this.tag, {
      staticClass: [createStyle('framework')(), "-ui-theme-".concat(this.currentTheme)].join(' '),
      attrs: {
        id: this.name
      }
    }, [this.$slots.default, this.genNotifications(), this.genModals(), this.genContainers()]);
  }
};

var index$B = generatePlugin(uiApp);

var _this$T = null;
var style$Q = createStyle('container');
var uiContainer$1 = {
  name: 'ui-container',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
      validator: function validator(value) {
        _newArrowCheck(this, _this$T);

        return ['div', 'section'].includes(value);
      }.bind(null)
    },
    fluid: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, a(data, {
      staticClass: style$Q(),
      class: {
        '-default': !props.fluid
      }
    }), children);
  }
};

var uiContainer = generatePlugin(uiContainer$1);

var _this$S = null;
var breakpoints$3 = Object.keys(gridBreakpoints);
var flexPositions = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between', 'first', 'last'];
breakpoints$3.splice(0, 1);
var Flexible = {
  props: flexPositions.reduce(function (acc, key) {
    var _this2 = this;

    _newArrowCheck(this, _this$S);

    return Object.assign(acc, _defineProperty({}, key, {
      type: [Boolean, String],
      default: false,
      validator: function validator(v) {
        _newArrowCheck(this, _this2);

        return typeof v === 'boolean' || breakpoints$3.includes(v);
      }.bind(this)
    }));
  }.bind(null), {})
};
function classes(context) {
  var _this3 = this;

  return flexPositions.reduce(function (acc, key) {
    _newArrowCheck(this, _this3);

    var value = context[key];
    return Object.assign(acc, typeof value === 'boolean' ? _defineProperty({}, "f-".concat(key), value) : _defineProperty({}, "f-".concat(key, "-").concat(value), !!value));
  }.bind(this), {});
}

var _this$R = null;
var style$P = createStyle('row');
var uiRow$1 = {
  name: 'ui-row',
  functional: true,
  mixins: [Flexible],
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gutter: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$R);

        return !Number.isNaN(parseInt(v, 10)) && v > -1 && v < 5;
      }.bind(null)
    },
    gutters: {
      type: [String, Object],
      default: function _default() {
        _newArrowCheck(this, _this$R);

        return {};
      }.bind(null)
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, _ref) {
    var _this2 = this;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var gutters = parseBreakpoints(props.gutters);
    var guttersClasses = Object.keys(gridBreakpoints).reduce(function (acc, k) {
      _newArrowCheck(this, _this2);

      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "-".concat(k, "-").concat(gutters[k]), !Number.isNaN(Number(gutters[k]))));
    }.bind(this), {});
    return h(props.tag, a(data, {
      staticClass: style$P(),
      class: _objectSpread2(_objectSpread2(_defineProperty({
        '-reverse': props.reverse
      }, "-xs-".concat(props.gutter), props.gutter !== null), guttersClasses), classes(props))
    }), children);
  }
};

var uiRow = generatePlugin(uiRow$1);

var _this4 = null;
/**
 * @type {(function(string)) | string}
 */

var style$O = createStyle('col');
/**
 * @type {string[]}
 */

var breakpoints$2 = Object.keys(gridBreakpoints);
/**
 * @param {Object} context
 * @return {Object}
 */

function parseBreakpointClasses(context) {
  var _this = this;

  var parsedBreakpoints = parseBreakpoints(context.breakpoints);
  return breakpoints$2.reduce(function (classes, k) {
    _newArrowCheck(this, _this);

    var value = parsedBreakpoints[k] || context[k];
    var key = typeof value === 'boolean' ? "-".concat(k) : "-".concat(k, "-").concat(value);
    return _objectSpread2(_objectSpread2({}, classes), {}, _defineProperty({}, key, !!value));
  }.bind(this), {});
}
/**
 * @param {Object} context
 * @return {Object}
 */


function parseOffsetClasses(context) {
  var _this2 = this;

  var parsedOffsets = parseBreakpoints(context.offsets);
  return breakpoints$2.reduce(function (classes, k) {
    _newArrowCheck(this, _this2);

    var value = parsedOffsets[k] || context["".concat(k, "Offset")];
    return _objectSpread2(_objectSpread2({}, classes), {}, _defineProperty({}, "-".concat(k, "-").concat(value, "-offset-left"), !!value));
  }.bind(this), {});
}
/**
 * @param {Object} context
 * @return {Object}
 */


function parseOffsetRightClasses(context) {
  var _this3 = this;

  var parsedOffsets = parseBreakpoints(context.offsetsRight);
  return breakpoints$2.reduce(function (classes, k) {
    _newArrowCheck(this, _this3);

    var value = parsedOffsets[k] || context["".concat(k, "OffsetRight")];
    return _objectSpread2(_objectSpread2({}, classes), {}, _defineProperty({}, "-".concat(k, "-").concat(value, "-offset-right"), !!value));
  }.bind(this), {});
}
/**
 * @type {object}
 */


var breakpointProps = breakpoints$2.reduce(function (acc, breakpoint) {
  var _objectSpread5;

  _newArrowCheck(this, _this4);

  return _objectSpread2(_objectSpread2({}, acc), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, breakpoint, {
    type: [Boolean, String, Number],
    default: false
  }), _defineProperty(_objectSpread5, "".concat(breakpoint, "Offset"), {
    type: [String, Number],
    default: null
  }), _defineProperty(_objectSpread5, "".concat(breakpoint, "OffsetRight"), {
    type: [String, Number],
    default: null
  }), _objectSpread5));
}.bind(null), {});
var uiCol$1 = {
  name: 'ui-col',
  functional: true,
  mixins: [Flexible],
  props: _objectSpread2({
    tag: {
      type: String,
      default: 'div'
    },
    reverse: {
      type: Boolean,
      default: false
    },
    breakpoints: {
      type: [String, Object],
      default: null
    },
    offsets: {
      type: [String, Object],
      default: null
    },
    offsetsRight: {
      type: [String, Object],
      default: null
    }
  }, breakpointProps),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, a(data, {
      staticClass: style$O(),
      class: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        '-reverse': props.reverse
      }, parseBreakpointClasses(props)), parseOffsetClasses(props)), parseOffsetRightClasses(props)), classes(props)),
      attrs: {
        'data-column': ''
      }
    }), children);
  }
};

var uiCol = generatePlugin(uiCol$1);

// https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-a-leap-year
function leapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}

function checkFalsePositiveDates() {
  var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (dateString.length === 10) {
    // massage input to use yyyy-mm-dd format
    // we support yyyy/mm/dd or yyyy.mm.dd
    var normalizedDate = dateString.replace('.', '-').replace('/', '-');
    var parts = normalizedDate.split('-');

    if (parts.length === 3) {
      if (parts[0].length === 4) {
        // yyyy-mm-dd format
        var y = parseInt(parts[0]);
        var m = parseInt(parts[1]);
        var d = parseInt(parts[2]);

        if (m === 2) {
          // return leapYear(y) ? d <= 29 : d <= 28;
          if (leapYear(y)) {
            if (d > 29) {
              return false;
            }
          } else {
            if (d > 28) {
              return false;
            }
          }
        }

        if (m === 4 || m === 6 || m === 9 || m === 11) {
          if (d > 30) {
            return false;
          }
        }
      }
    }

    return true; // we are not in feburary, proceed
  }

  return true; // we are not testing formatted date, proceed to rest of validation
}

function isValidDate(dateString) {
  var testDate;

  if (typeof dateString === 'number') {
    testDate = new Date(dateString);

    if (_typeof(testDate) === 'object') {
      return true;
    }
  } // first convert incoming string to date object and see if it correct date and format


  testDate = new Date(dateString);

  if (_typeof(testDate) === 'object') {
    if (testDate.toString() === 'Invalid Date') {
      return false;
    }
    /**
     * Check for false positive dates
     * perform special check on february as JS `new Date` incorrectly returns valid date
     * Eg.  let newDate = new Date('2020-02-29')  // returns as March 02 2020
     * Eg.  let newDate = new Date('2019-02-29')  // returns as March 01 2020
     * Eg.  let newDate = new Date('2019-04-31')  // returns as April 30 2020
     */


    if (!checkFalsePositiveDates(dateString)) {
      return false;
    } // valid date object and not a february date


    return true;
  } // First check for the pattern


  var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

  if (!regex_date.test(dateString)) {
    return false;
  } // Parse the date parts to integers


  var parts = dateString.split("-");
  var day = parseInt(parts[2], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[0], 10); // Check the ranges of month and year

  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
    return false;
  }

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
    monthLength[1] = 29;
  } // Check the range of the day


  return day > 0 && day <= monthLength[month - 1];
}

var rules$1 = {
  required: function required(val) {
    var str;

    if (val === undefined || val === null) {
      return false;
    }

    str = String(val).replace(/\s/g, "");
    return str.length > 0 ? true : false;
  },
  required_if: function required_if(val, req, attribute) {
    req = this.getParameters();

    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
      return this.validator.getRule("required").validate(val);
    }

    return true;
  },
  required_unless: function required_unless(val, req, attribute) {
    req = this.getParameters();

    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
      return this.validator.getRule("required").validate(val);
    }

    return true;
  },
  required_with: function required_with(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return this.validator.getRule("required").validate(val);
    }

    return true;
  },
  required_with_all: function required_with_all(val, req, attribute) {
    req = this.getParameters();

    for (var i = 0; i < req.length; i++) {
      if (!this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule("required").validate(val);
  },
  required_without: function required_without(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return true;
    }

    return this.validator.getRule("required").validate(val);
  },
  required_without_all: function required_without_all(val, req, attribute) {
    req = this.getParameters();

    for (var i = 0; i < req.length; i++) {
      if (this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule("required").validate(val);
  },
  boolean: function boolean(val) {
    return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
  },
  // compares the size of strings
  // with numbers, compares the value
  size: function size(val, req, attribute) {
    if (val) {
      req = parseFloat(req);
      var size = this.getSize();
      return size === req;
    }

    return true;
  },
  string: function string(val, req, attribute) {
    return typeof val === "string";
  },
  sometimes: function sometimes(val) {
    return true;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  min: function min(val, req, attribute) {
    var size = this.getSize();
    return size >= req;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  max: function max(val, req, attribute) {
    var size = this.getSize();
    return size <= req;
  },
  between: function between(val, req, attribute) {
    req = this.getParameters();
    var size = this.getSize();
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);
    return size >= min && size <= max;
  },
  email: function email(val) {
    // Added umlaut support https://github.com/skaterdav85/validatorjs/issues/308
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(val)) {
      // added support domain 3-n level https://github.com/skaterdav85/validatorjs/issues/384
      re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
    }

    return re.test(val);
  },
  numeric: function numeric(val) {
    var num;
    num = Number(val); // tries to convert value to a number. useful if value is coming from form element

    if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
      return true;
    } else {
      return false;
    }
  },
  array: function array(val) {
    return val instanceof Array;
  },
  url: function url(_url) {
    return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(_url);
  },
  alpha: function alpha(val) {
    return /^[a-zA-Z]+$/.test(val);
  },
  alpha_dash: function alpha_dash(val) {
    return /^[a-zA-Z0-9_\-]+$/.test(val);
  },
  alpha_num: function alpha_num(val) {
    return /^[a-zA-Z0-9]+$/.test(val);
  },
  same: function same(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];

    var val2 = val;

    if (val1 === val2) {
      return true;
    }

    return false;
  },
  different: function different(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];

    var val2 = val;

    if (val1 !== val2) {
      return true;
    }

    return false;
  },
  in: function _in(val, req) {
    var list, i;

    if (val) {
      list = this.getParameters();
    }

    if (val && !(val instanceof Array)) {
      var localValue = val;

      for (i = 0; i < list.length; i++) {
        if (typeof list[i] === "string") {
          localValue = String(val);
        }

        if (localValue === list[i]) {
          return true;
        }
      }

      return false;
    }

    if (val && val instanceof Array) {
      for (i = 0; i < val.length; i++) {
        if (list.indexOf(val[i]) < 0) {
          return false;
        }
      }
    }

    return true;
  },
  not_in: function not_in(val, req) {
    var list = this.getParameters();
    var len = list.length;
    var returnVal = true;

    for (var i = 0; i < len; i++) {
      var localValue = val;

      if (typeof list[i] === "string") {
        localValue = String(val);
      }

      if (localValue === list[i]) {
        returnVal = false;
        break;
      }
    }

    return returnVal;
  },
  accepted: function accepted(val) {
    if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
      return true;
    }

    return false;
  },
  confirmed: function confirmed(val, req, key) {
    var confirmedKey = key + "_confirmation";

    if (this.validator.input[confirmedKey] === val) {
      return true;
    }

    return false;
  },
  integer: function integer(val) {
    return String(parseInt(val, 10)) === String(val);
  },
  digits: function digits(val, req) {
    var numericRule = this.validator.getRule('numeric');

    if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
      return true;
    }

    return false;
  },
  digits_between: function digits_between(val) {
    var numericRule = this.validator.getRule("numeric");
    var req = this.getParameters();
    var valueDigitsCount = String(val).length;
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);

    if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
      return true;
    }

    return false;
  },
  regex: function regex(val, req) {
    var mod = /[g|i|m]{1,3}$/;
    var flag = req.match(mod);
    flag = flag ? flag[0] : "";
    req = req.replace(mod, "").slice(1, -1);
    req = new RegExp(req, flag);
    return !!req.test(val);
  },
  date: function date(val, format) {
    return isValidDate(val);
  },
  present: function present(val) {
    return typeof val !== "undefined";
  },
  after: function after(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;

    if (!isValidDate(val1)) {
      return false;
    }

    if (!isValidDate(val2)) {
      return false;
    }

    if (new Date(val1).getTime() < new Date(val2).getTime()) {
      return true;
    }

    return false;
  },
  after_or_equal: function after_or_equal(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;

    if (!isValidDate(val1)) {
      return false;
    }

    if (!isValidDate(val2)) {
      return false;
    }

    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
      return true;
    }

    return false;
  },
  before: function before(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;

    if (!isValidDate(val1)) {
      return false;
    }

    if (!isValidDate(val2)) {
      return false;
    }

    if (new Date(val1).getTime() > new Date(val2).getTime()) {
      return true;
    }

    return false;
  },
  before_or_equal: function before_or_equal(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;

    if (!isValidDate(val1)) {
      return false;
    }

    if (!isValidDate(val2)) {
      return false;
    }

    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
      return true;
    }

    return false;
  },
  hex: function hex(val) {
    return /^[0-9a-f]+$/i.test(val);
  },
  ipv4: function ipv4(val, req, attribute) {
    if (typeof val != 'string') return false; // regex to check that each octet is valid

    var er = /^[0-9]+$/; // ipv4 octets are delimited by dot

    octets = val.split('.'); // check 1: ipv4 address should contains 4 octets

    if (octets.length != 4) return false;

    for (var i = 0; i < octets.length; i++) {
      var element = octets[i]; // check 2: each octet should be integer bigger than 0

      if (!er.test(element)) return false; // check 3: each octet value should be less than 256

      var octetValue = parseInt(element);
      if (octetValue >= 256) return false;
    } // if all checks passed, we know it's valid IPv4 address!


    return true;
  },
  ipv6: function ipv6(val, req, attribute) {
    if (typeof val != 'string') return false; // regex to check that each hextet is valid

    var er = /^[0-9a-f]+$/; // ipv6 hextets are delimited by colon

    hextets = val.split(':'); // check 1: ipv6 should contain only one consecutive colons

    colons = val.match(/::/);
    if (colons != null && val.match(/::/g).length > 1) return false; // check 2: ipv6 should not be ending or starting with colon
    //          edge case: not with consecutive colons

    if (val[0] == ':' && (colons == null || colons != null && colons.index != 0)) return false;
    if (val[val.length - 1] == ':' && (colons == null || colons != null && colons.index != val.length - 2)) return false; // check 3: ipv6 should contain no less than 3 sector
    //         minimum ipv6 addres - ::1

    if (3 > hextets.length) return false; // check 4: ipv6 should contain no more than 8 sectors
    //         only 1 edge case: when first or last sector is ommited

    var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
    if (hextets.length > 8 && !isEdgeCase) return false; // check 5: ipv6 should contain exactly one consecutive colons if it has less than 8 sectors

    if (hextets.length != 8 && colons == null) return false;

    for (var i = 0; i < hextets.length; i++) {
      var element = hextets[i];
      if (element.length == 0) continue; // check 6: all of hextets should contain numbers from 0 to f (in hexadecimal)

      if (!er.test(element)) return false; // check 7: all of hextet values should be less then ffff (in hexadeimal)
      //          checking using length of hextet. lowest invalid value's length is 5.
      //          so all valid hextets are length of 4 or less

      if (element.length > 4) return false;
    }

    return true;
  },
  ip: function ip(val, req, attribute) {
    return rules$1['ipv4'](val, req, attribute) || rules$1['ipv6'](val, req, attribute);
  }
};

var missedRuleValidator = function missedRuleValidator() {
  throw new Error("Validator `" + this.name + "` is not defined!");
};

var missedRuleMessage;

function Rule(name, fn, async) {
  this.name = name;
  this.fn = fn;
  this.passes = null;
  this._customMessage = undefined;
  this.async = async;
}

Rule.prototype = {
  /**
   * Validate rule
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  validate: function validate(inputValue, ruleValue, attribute, callback) {
    var _this = this;

    this._setValidatingData(attribute, inputValue, ruleValue);

    if (typeof callback === "function") {
      this.callback = callback;

      var handleResponse = function handleResponse(passes, message) {
        _this.response(passes, message);
      };

      if (this.async) {
        return this._apply(inputValue, ruleValue, attribute, handleResponse);
      } else {
        return handleResponse(this._apply(inputValue, ruleValue, attribute));
      }
    }

    return this._apply(inputValue, ruleValue, attribute);
  },

  /**
   * Apply validation function
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  _apply: function _apply(inputValue, ruleValue, attribute, callback) {
    var fn = this.isMissed() ? missedRuleValidator : this.fn;
    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
  },

  /**
   * Set validating data
   *
   * @param {string} attribute
   * @param {mixed} inputValue
   * @param {mixed} ruleValue
   * @return {void}
   */
  _setValidatingData: function _setValidatingData(attribute, inputValue, ruleValue) {
    this.attribute = attribute;
    this.inputValue = inputValue;
    this.ruleValue = ruleValue;
  },

  /**
   * Get parameters
   *
   * @return {array}
   */
  getParameters: function getParameters() {
    var value = [];

    if (typeof this.ruleValue === "string") {
      value = this.ruleValue.split(",");
    }

    if (typeof this.ruleValue === "number") {
      value.push(this.ruleValue);
    }

    if (this.ruleValue instanceof Array) {
      value = this.ruleValue;
    }

    return value;
  },

  /**
   * Get true size of value
   *
   * @return {integer|float}
   */
  getSize: function getSize() {
    var value = this.inputValue;

    if (value instanceof Array) {
      return value.length;
    }

    if (typeof value === "number") {
      return value;
    }

    if (this.validator._hasNumericRule(this.attribute)) {
      return parseFloat(value, 10);
    }

    return value.length;
  },

  /**
   * Get the type of value being checked; numeric or string.
   *
   * @return {string}
   */
  _getValueType: function _getValueType() {
    if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
      return "numeric";
    }

    return "string";
  },

  /**
   * Set the async callback response
   *
   * @param  {boolean|undefined} passes  Whether validation passed
   * @param  {string|undefined} message Custom error message
   * @return {void}
   */
  response: function response(passes, message) {
    this.passes = passes === undefined || passes === true;
    this._customMessage = message;
    this.callback(this.passes, message);
  },

  /**
   * Set validator instance
   *
   * @param {Validator} validator
   * @return {void}
   */
  setValidator: function setValidator(validator) {
    this.validator = validator;
  },

  /**
   * Check if rule is missed
   *
   * @return {boolean}
   */
  isMissed: function isMissed() {
    return typeof this.fn !== "function";
  },

  get customMessage() {
    return this.isMissed() ? missedRuleMessage : this._customMessage;
  }

};
var manager = {
  /**
   * List of async rule names
   *
   * @type {Array}
   */
  asyncRules: [],

  /**
   * Implicit rules (rules to always validate)
   *
   * @type {Array}
   */
  implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],

  /**
   * Get rule by name
   *
   * @param  {string} name
   * @param {Validator}
   * @return {Rule}
   */
  make: function make(name, validator) {
    var async = this.isAsync(name);
    var rule = new Rule(name, rules$1[name], async);
    rule.setValidator(validator);
    return rule;
  },

  /**
   * Determine if given rule is async
   *
   * @param  {string}  name
   * @return {boolean}
   */
  isAsync: function isAsync(name) {
    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
      if (this.asyncRules[i] === name) {
        return true;
      }
    }

    return false;
  },

  /**
   * Determine if rule is implicit (should always validate)
   *
   * @param {string} name
   * @return {boolean}
   */
  isImplicit: function isImplicit(name) {
    return this.implicitRules.indexOf(name) > -1;
  },

  /**
   * Register new rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  register: function register(name, fn) {
    rules$1[name] = fn;
  },

  /**
   * Register new implicit rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerImplicit: function registerImplicit(name, fn) {
    this.register(name, fn);
    this.implicitRules.push(name);
  },

  /**
   * Register async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsync: function registerAsync(name, fn) {
    this.register(name, fn);
    this.asyncRules.push(name);
  },

  /**
   * Register implicit async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsyncImplicit: function registerAsyncImplicit(name, fn) {
    this.registerImplicit(name, fn);
    this.asyncRules.push(name);
  },
  registerMissedRuleValidator: function registerMissedRuleValidator(fn, message) {
    missedRuleValidator = fn;
    missedRuleMessage = message;
  }
};
var rules_1 = manager;

var replacements = {
  /**
   * Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  between: function between(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },

  /**
   * Digits-Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  digits_between: function digits_between(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },

  /**
   * Required_if replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_if: function required_if(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },

  /**
   * Required_unless replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_unless: function required_unless(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },

  /**
   * Required_with replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with: function required_with(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Required_with_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with_all: function required_with_all(template, rule) {
    var parameters = rule.getParameters();

    var getAttributeName = this._getAttributeName.bind(this);

    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(', ')
    });
  },

  /**
   * Required_without replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without: function required_without(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Required_without_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without_all: function required_without_all(template, rule) {
    var parameters = rule.getParameters();

    var getAttributeName = this._getAttributeName.bind(this);

    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(', ')
    });
  },

  /**
   * After replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after: function after(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before: function before(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before: this._getAttributeName(parameters[0])
    });
  },

  /**
   * After_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after_or_equal: function after_or_equal(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before_or_equal: function before_or_equal(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Same replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  same: function same(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      same: this._getAttributeName(parameters[0])
    });
  }
};

function formatter(attribute) {
  return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
}

var attributes = {
  replacements: replacements,
  formatter: formatter
};

var Messages = function Messages(lang, messages) {
  this.lang = lang;
  this.messages = messages;
  this.customMessages = {};
  this.attributeNames = {};
};

Messages.prototype = {
  constructor: Messages,

  /**
   * Set custom messages
   *
   * @param {object} customMessages
   * @return {void}
   */
  _setCustom: function _setCustom(customMessages) {
    this.customMessages = customMessages || {};
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   */
  _setAttributeNames: function _setAttributeNames(attributes) {
    this.attributeNames = attributes;
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  _setAttributeFormatter: function _setAttributeFormatter(func) {
    this.attributeFormatter = func;
  },

  /**
   * Get attribute name to display.
   *
   * @param  {string} attribute
   * @return {string}
   */
  _getAttributeName: function _getAttributeName(attribute) {
    var name = attribute;

    if (this.attributeNames.hasOwnProperty(attribute)) {
      return this.attributeNames[attribute];
    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
      name = this.messages.attributes[attribute];
    }

    if (this.attributeFormatter) {
      name = this.attributeFormatter(name);
    }

    return name;
  },

  /**
   * Get all messages
   *
   * @return {object}
   */
  all: function all() {
    return this.messages;
  },

  /**
   * Render message
   *
   * @param  {Rule} rule
   * @return {string}
   */
  render: function render(rule) {
    if (rule.customMessage) {
      return rule.customMessage;
    }

    var template = this._getTemplate(rule);

    var message;

    if (attributes.replacements[rule.name]) {
      message = attributes.replacements[rule.name].apply(this, [template, rule]);
    } else {
      message = this._replacePlaceholders(rule, template, {});
    }

    return message;
  },

  /**
   * Get the template to use for given rule
   *
   * @param  {Rule} rule
   * @return {string}
   */
  _getTemplate: function _getTemplate(rule) {
    var messages = this.messages;
    var template = messages.def;
    var customMessages = this.customMessages;
    var formats = [rule.name + '.' + rule.attribute, rule.name];

    for (var i = 0, format; i < formats.length; i++) {
      format = formats[i];

      if (customMessages.hasOwnProperty(format)) {
        template = customMessages[format];
        break;
      } else if (messages.hasOwnProperty(format)) {
        template = messages[format];
        break;
      }
    }

    if (_typeof(template) === 'object') {
      template = template[rule._getValueType()];
    }

    return template;
  },

  /**
   * Replace placeholders in the template using the data object
   *
   * @param  {Rule} rule
   * @param  {string} template
   * @param  {object} data
   * @return {string}
   */
  _replacePlaceholders: function _replacePlaceholders(rule, template, data) {
    var message, attribute;
    data.attribute = this._getAttributeName(rule.attribute);
    data[rule.name] = data[rule.name] || rule.getParameters().join(',');

    if (typeof template === 'string' && _typeof(data) === 'object') {
      message = template;

      for (attribute in data) {
        message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
      }
    }

    return message;
  }
};
var messages$1 = Messages;

var require_method = commonjsRequire;
var container = {
  messages: {},

  /**
   * Set messages for language
   *
   * @param {string} lang
   * @param {object} rawMessages
   * @return {void}
   */
  _set: function _set(lang, rawMessages) {
    this.messages[lang] = rawMessages;
  },

  /**
   * Set message for given language's rule.
   *
   * @param {string} lang
   * @param {string} attribute
   * @param {string|object} message
   * @return {void}
   */
  _setRuleMessage: function _setRuleMessage(lang, attribute, message) {
    this._load(lang);

    if (message === undefined) {
      message = this.messages[lang].def;
    }

    this.messages[lang][attribute] = message;
  },

  /**
   * Load messages (if not already loaded)
   *
   * @param  {string} lang
   * @return {void}
   */
  _load: function _load(lang) {
    if (!this.messages[lang]) {
      try {
        var rawMessages = require_method('./lang/' + lang);

        this._set(lang, rawMessages);
      } catch (e) {}
    }
  },

  /**
   * Get raw messages for language
   *
   * @param  {string} lang
   * @return {object}
   */
  _get: function _get(lang) {
    this._load(lang);

    return this.messages[lang];
  },

  /**
   * Make messages for given language
   *
   * @param  {string} lang
   * @return {Messages}
   */
  _make: function _make(lang) {
    this._load(lang);

    return new messages$1(lang, this.messages[lang]);
  }
};
var lang = container;

var Errors = function Errors() {
  this.errors = {};
};

Errors.prototype = {
  constructor: Errors,

  /**
   * Add new error message for given attribute
   *
   * @param  {string} attribute
   * @param  {string} message
   * @return {void}
   */
  add: function add(attribute, message) {
    if (!this.has(attribute)) {
      this.errors[attribute] = [];
    }

    if (this.errors[attribute].indexOf(message) === -1) {
      this.errors[attribute].push(message);
    }
  },

  /**
   * Returns an array of error messages for an attribute, or an empty array
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {array} An array of error messages
   */
  get: function get(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute];
    }

    return [];
  },

  /**
   * Returns the first error message for an attribute, false otherwise
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {string|false} First error message or false
   */
  first: function first(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute][0];
    }

    return false;
  },

  /**
   * Get all error messages from all failing attributes
   *
   * @return {Object} Failed attribute names for keys and an array of messages for values
   */
  all: function all() {
    return this.errors;
  },

  /**
   * Determine if there are any error messages for an attribute
   *
   * @param  {string}  attribute A key in the data object being validated
   * @return {boolean}
   */
  has: function has(attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return true;
    }

    return false;
  }
};
var errors = Errors;

function AsyncResolvers(onFailedOne, onResolvedAll) {
  this.onResolvedAll = onResolvedAll;
  this.onFailedOne = onFailedOne;
  this.resolvers = {};
  this.resolversCount = 0;
  this.passed = [];
  this.failed = [];
  this.firing = false;
}

AsyncResolvers.prototype = {
  /**
   * Add resolver
   *
   * @param {Rule} rule
   * @return {integer}
   */
  add: function add(rule) {
    var index = this.resolversCount;
    this.resolvers[index] = rule;
    this.resolversCount++;
    return index;
  },

  /**
   * Resolve given index
   *
   * @param  {integer} index
   * @return {void}
   */
  resolve: function resolve(index) {
    var rule = this.resolvers[index];

    if (rule.passes === true) {
      this.passed.push(rule);
    } else if (rule.passes === false) {
      this.failed.push(rule);
      this.onFailedOne(rule);
    }

    this.fire();
  },

  /**
   * Determine if all have been resolved
   *
   * @return {boolean}
   */
  isAllResolved: function isAllResolved() {
    return this.passed.length + this.failed.length === this.resolversCount;
  },

  /**
   * Attempt to fire final all resolved callback if completed
   *
   * @return {void}
   */
  fire: function fire() {
    if (!this.firing) {
      return;
    }

    if (this.isAllResolved()) {
      this.onResolvedAll(this.failed.length === 0);
    }
  },

  /**
   * Enable firing
   *
   * @return {void}
   */
  enableFiring: function enableFiring() {
    this.firing = true;
  }
};
var async = AsyncResolvers;

var Validator = function Validator(input, rules, customMessages) {
  var lang$1 = Validator.getDefaultLang();
  this.input = input || {};
  this.messages = lang._make(lang$1);

  this.messages._setCustom(customMessages);

  this.setAttributeFormatter(Validator.prototype.attributeFormatter);
  this.errors = new errors();
  this.errorCount = 0;
  this.hasAsync = false;
  this.rules = this._parseRules(rules);
};

Validator.prototype = {
  constructor: Validator,

  /**
   * Default language
   *
   * @type {string}
   */
  lang: 'en',

  /**
   * Numeric based rules
   *
   * @type {array}
   */
  numericRules: ['integer', 'numeric'],

  /**
   * Attribute formatter.
   *
   * @type {function}
   */
  attributeFormatter: attributes.formatter,

  /**
   * Run validator
   *
   * @return {boolean} Whether it passes; true = passes, false = fails
   */
  check: function check() {

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];

      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);

        if (!rulePassed) {
          this._addFailure(rule);
        }

        if (this._shouldStopValidating(attribute, rulePassed)) {
          break;
        }
      }
    }

    return this.errorCount === 0;
  },

  /**
   * Run async validator
   *
   * @param {function} passes
   * @param {function} fails
   * @return {void}
   */
  checkAsync: function checkAsync(passes, fails) {
    var _this = this;

    passes = passes || function () {};

    fails = fails || function () {};

    var failsOne = function failsOne(rule, message) {
      _this._addFailure(rule, message);
    };

    var resolvedAll = function resolvedAll(allPassed) {
      if (allPassed) {
        passes();
      } else {
        fails();
      }
    };

    var asyncResolvers = new async(failsOne, resolvedAll);

    var validateRule = function validateRule(inputValue, ruleOptions, attribute, rule) {
      return function () {
        var resolverIndex = asyncResolvers.add(rule);
        rule.validate(inputValue, ruleOptions.value, attribute, function () {
          asyncResolvers.resolve(resolverIndex);
        });
      };
    };

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];

      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        validateRule(inputValue, ruleOptions, attribute, rule)();
      }
    }

    asyncResolvers.enableFiring();
    asyncResolvers.fire();
  },

  /**
   * Add failure and error message for given rule
   *
   * @param {Rule} rule
   */
  _addFailure: function _addFailure(rule) {
    var msg = this.messages.render(rule);
    this.errors.add(rule.attribute, msg);
    this.errorCount++;
  },

  /**
   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
   *
   * @param  {object} nested object
   * @return {object} flattened object
   */
  _flattenObject: function _flattenObject(obj) {
    var flattened = {};

    function recurse(current, property) {
      if (!property && Object.getOwnPropertyNames(current).length === 0) {
        return;
      }

      if (Object(current) !== current || Array.isArray(current)) {
        flattened[property] = current;
      } else {
        var isEmpty = true;

        for (var p in current) {
          isEmpty = false;
          recurse(current[p], property ? property + '.' + p : p);
        }

        if (isEmpty) {
          flattened[property] = {};
        }
      }
    }

    if (obj) {
      recurse(obj);
    }

    return flattened;
  },

  /**
   * Extract value from nested object using string path with dot notation
   *
   * @param  {object} object to search in
   * @param  {string} path inside object
   * @return {any|void} value under the path
   */
  _objectPath: function _objectPath(obj, path) {
    if (Object.prototype.hasOwnProperty.call(obj, path)) {
      return obj[path];
    }

    var keys = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
    var copy = {};

    for (var attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
        copy[attr] = obj[attr];
      }
    }

    for (var i = 0, l = keys.length; i < l; i++) {
      if (_typeof(copy) === 'object' && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
        copy = copy[keys[i]];
      } else {
        return;
      }
    }

    return copy;
  },

  /**
   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
   *
   * @param  {object} rules
   * @return {object}
   */
  _parseRules: function _parseRules(rules) {
    var parsedRules = {};
    rules = this._flattenObject(rules);

    for (var attribute in rules) {
      var rulesArray = rules[attribute];

      this._parseRulesCheck(attribute, rulesArray, parsedRules);
    }

    return parsedRules;
  },
  _parseRulesCheck: function _parseRulesCheck(attribute, rulesArray, parsedRules, wildCardValues) {
    if (attribute.indexOf('*') > -1) {
      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
    } else {
      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
    }
  },
  _parsedRulesRecurse: function _parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues) {
    var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);

    var propertyValue = this._objectPath(this.input, parentPath);

    if (propertyValue) {
      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
        var workingValues = wildCardValues ? wildCardValues.slice() : [];
        workingValues.push(propertyNumber);

        this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
      }
    }
  },
  _parseRulesDefault: function _parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues) {
    var attributeRules = [];

    if (rulesArray instanceof Array) {
      rulesArray = this._prepareRulesArray(rulesArray);
    }

    if (typeof rulesArray === 'string') {
      rulesArray = rulesArray.split('|');
    }

    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
      rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];

      if (rule.value) {
        rule.value = this._replaceWildCards(rule.value, wildCardValues);

        this._replaceWildCardsMessages(wildCardValues);
      }

      if (rules_1.isAsync(rule.name)) {
        this.hasAsync = true;
      }

      attributeRules.push(rule);
    }

    parsedRules[attribute] = attributeRules;
  },
  _replaceWildCards: function _replaceWildCards(path, nums) {
    if (!nums) {
      return path;
    }

    var path2 = path;
    nums.forEach(function (value) {
      if (Array.isArray(path2)) {
        path2 = path2[0];
      }

      var pos = path2.indexOf('*');

      if (pos === -1) {
        return path2;
      }

      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
    });

    if (Array.isArray(path)) {
      path[0] = path2;
      path2 = path;
    }

    return path2;
  },
  _replaceWildCardsMessages: function _replaceWildCardsMessages(nums) {
    var customMessages = this.messages.customMessages;
    var self = this;
    Object.keys(customMessages).forEach(function (key) {
      if (nums) {
        var newKey = self._replaceWildCards(key, nums);

        customMessages[newKey] = customMessages[key];
      }
    });

    this.messages._setCustom(customMessages);
  },

  /**
   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
   *
   * @param  {array} rulesArray
   * @return {array}
   */
  _prepareRulesArray: function _prepareRulesArray(rulesArray) {
    var rules = [];

    for (var i = 0, len = rulesArray.length; i < len; i++) {
      if (_typeof(rulesArray[i]) === 'object') {
        for (var rule in rulesArray[i]) {
          rules.push({
            name: rule,
            value: rulesArray[i][rule]
          });
        }
      } else {
        rules.push(rulesArray[i]);
      }
    }

    return rules;
  },

  /**
   * Determines if the attribute is supplied with the original data object.
   *
   * @param  {array} attribute
   * @return {boolean}
   */
  _suppliedWithData: function _suppliedWithData(attribute) {
    return this.input.hasOwnProperty(attribute);
  },

  /**
   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
   *
   * @param  {string} ruleString min:3
   * @return {object} object containing the name of the rule and value
   */
  _extractRuleAndRuleValue: function _extractRuleAndRuleValue(ruleString) {
    var rule = {},
        ruleArray;
    rule.name = ruleString;

    if (ruleString.indexOf(':') >= 0) {
      ruleArray = ruleString.split(':');
      rule.name = ruleArray[0];
      rule.value = ruleArray.slice(1).join(':');
    }

    return rule;
  },

  /**
   * Determine if attribute has any of the given rules
   *
   * @param  {string}  attribute
   * @param  {array}   findRules
   * @return {boolean}
   */
  _hasRule: function _hasRule(attribute, findRules) {
    var rules = this.rules[attribute] || [];

    for (var i = 0, len = rules.length; i < len; i++) {
      if (findRules.indexOf(rules[i].name) > -1) {
        return true;
      }
    }

    return false;
  },

  /**
   * Determine if attribute has any numeric-based rules.
   *
   * @param  {string}  attribute
   * @return {Boolean}
   */
  _hasNumericRule: function _hasNumericRule(attribute) {
    return this._hasRule(attribute, this.numericRules);
  },

  /**
   * Determine if rule is validatable
   *
   * @param  {Rule}   rule
   * @param  {mixed}  value
   * @return {boolean}
   */
  _isValidatable: function _isValidatable(rule, value) {
    if (Array.isArray(value)) {
      return true;
    }

    if (rules_1.isImplicit(rule.name)) {
      return true;
    }

    return this.getRule('required').validate(value);
  },

  /**
   * Determine if we should stop validating.
   *
   * @param  {string} attribute
   * @param  {boolean} rulePassed
   * @return {boolean}
   */
  _shouldStopValidating: function _shouldStopValidating(attribute, rulePassed) {
    var stopOnAttributes = this.stopOnAttributes;

    if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
      return false;
    }

    if (stopOnAttributes instanceof Array) {
      return stopOnAttributes.indexOf(attribute) > -1;
    }

    return true;
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   * @return {void}
   */
  setAttributeNames: function setAttributeNames(attributes) {
    this.messages._setAttributeNames(attributes);
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  setAttributeFormatter: function setAttributeFormatter(func) {
    this.messages._setAttributeFormatter(func);
  },

  /**
   * Get validation rule
   *
   * @param  {string} name
   * @return {Rule}
   */
  getRule: function getRule(name) {
    return rules_1.make(name, this);
  },

  /**
   * Stop on first error.
   *
   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
   * @return {void}
   */
  stopOnError: function stopOnError(attributes) {
    this.stopOnAttributes = attributes;
  },

  /**
   * Determine if validation passes
   *
   * @param {function} passes
   * @return {boolean|undefined}
   */
  passes: function passes(_passes) {
    var async = this._checkAsync('passes', _passes);

    if (async) {
      return this.checkAsync(_passes);
    }

    return this.check();
  },

  /**
   * Determine if validation fails
   *
   * @param {function} fails
   * @return {boolean|undefined}
   */
  fails: function fails(_fails) {
    var async = this._checkAsync('fails', _fails);

    if (async) {
      return this.checkAsync(function () {}, _fails);
    }

    return !this.check();
  },

  /**
   * Check if validation should be called asynchronously
   *
   * @param  {string}   funcName Name of the caller
   * @param  {function} callback
   * @return {boolean}
   */
  _checkAsync: function _checkAsync(funcName, callback) {
    var hasCallback = typeof callback === 'function';

    if (this.hasAsync && !hasCallback) {
      throw funcName + ' expects a callback when async rules are being tested.';
    }

    return this.hasAsync || hasCallback;
  }
};
/**
 * Set messages for language
 *
 * @param {string} lang
 * @param {object} messages
 * @return {this}
 */

Validator.setMessages = function (lang$1, messages) {
  lang._set(lang$1, messages);

  return this;
};
/**
 * Get messages for given language
 *
 * @param  {string} lang
 * @return {Messages}
 */


Validator.getMessages = function (lang$1) {
  return lang._get(lang$1);
};
/**
 * Set default language to use
 *
 * @param {string} lang
 * @return {void}
 */


Validator.useLang = function (lang) {
  this.prototype.lang = lang;
};
/**
 * Get default language
 *
 * @return {string}
 */


Validator.getDefaultLang = function () {
  return this.prototype.lang;
};
/**
 * Set the attribute formatter.
 *
 * @param {fuction} func
 * @return {void}
 */


Validator.setAttributeFormatter = function (func) {
  this.prototype.attributeFormatter = func;
};
/**
 * Stop on first error.
 *
 * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
 * @return {void}
 */


Validator.stopOnError = function (attributes) {
  this.prototype.stopOnAttributes = attributes;
};
/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */


Validator.register = function (name, fn, message, fnReplacement) {
  var lang$1 = Validator.getDefaultLang();
  rules_1.register(name, fn);

  lang._setRuleMessage(lang$1, name, message);
};
/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @param  {function} fnReplacement
 * @return {void}
 */


Validator.registerImplicit = function (name, fn, message, fnReplacement) {
  var lang$1 = Validator.getDefaultLang();
  rules_1.registerImplicit(name, fn);

  lang._setRuleMessage(lang$1, name, message);
};
/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */


Validator.registerAsync = function (name, fn, message, fnReplacement) {
  var lang$1 = Validator.getDefaultLang();
  rules_1.registerAsync(name, fn);

  lang._setRuleMessage(lang$1, name, message);
};
/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */


Validator.registerAsyncImplicit = function (name, fn, message) {
  var lang$1 = Validator.getDefaultLang();
  rules_1.registerAsyncImplicit(name, fn);

  lang._setRuleMessage(lang$1, name, message);
};
/**
 * Register validator for missed validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */


Validator.registerMissedRuleValidator = function (fn, message) {
  rules_1.registerMissedRuleValidator(fn, message);
};

var validator$1 = Validator;

var customRules = {
  cyrillic: 'Поле должно содержать только кириллицу',
  phone: 'Некорректный номер телефона',
  name: 'Фамилия, имя и отчество должны начинаться с большой буквы',
  number: 'Поле должно содержать число',
  date: 'Поле должно содержать дату',
  dateRange: 'Поле должно содержать период дат',
  dateBetween: 'Дата должна быть указана в заданном промежутке',
  dateBetweenOrEqual: 'Дата должна быть указана в заданном промежутке',
  money: 'Некорректный формат',
  confirmed: 'Поля не совпадают'
};
var messages = _objectSpread2({
  attributes: {},
  accepted: 'Вы должны поставить галочку',
  alpha: 'Поле может содержать только буквы',
  alpha_dash: 'Поле может содержать только буквы, цифры, дефисы и символы подчеркивания',
  alpha_num: 'Поле может содержать только буквы и цифры',
  between: 'Поле должно быть между :min и :max',
  def: 'Поле содержит ошибки',
  different: 'Поле должно отличаться от :different',
  digits: 'Длина значения должна быть :digits',
  digits_between: 'Длина значения должна быть от :min до :max',
  email: 'Поле должно содержать адрес электронной почты',
  hex: 'Поле должно должно иметь шестнадцатиречный формат',
  in: 'Выбрано неверное значение',
  not_in: 'Выбрано неверное значение',
  integer: 'Поле должно быть целым числом',
  min: {
    numeric: 'Значение поля должно быть больше или равно :min',
    string: 'Количество символов в поле не может быть менее :min'
  },
  max: {
    numeric: 'Значение поля должно быть меньше или равно :max',
    string: 'Количество символов в поле не может превышать :max'
  },
  numeric: 'Поле должно быть числом',
  present: 'Поле должно присутствовать (но может быть пустым)',
  regex: 'Неверный формат поля',
  required: 'Поле обязательно для заполнения',
  required_if: 'Поле обязательно для заполнения',
  same: 'Значение поля должно совпадать с :same',
  size: {
    numeric: 'Значение поля должно быть равным :size',
    string: 'Количество символов в поле должно быть равно :size'
  },
  url: 'Значение поля должно содержать валидный URL'
}, customRules);

function cyrillic(v) {
  return String(v).match(/[а-яё]/i);
}

function phone(value) {
  return /^([78]+\d{10})$/.test(String(value));
}

var _this$Q = null;
/**
 * @param {string?} repeat
 * @returns {string}
 */
// eslint-disable-next-line max-len

var rule = function rule(repeat) {
  _newArrowCheck(this, _this$Q);

  return "^([\u0410-\u042F\u0401][\u0430-\u044F\u0451]+(-[\u0410-\u042F\u0401][\u0430-\u044F\u0451]+)?)(\\s[\u0410-\u042F\u0401][\u0430-\u044F\u0451]+(-[\u0410-\u042F\u0401][\u0430-\u044F\u0451]+)?)".concat(repeat || '', "$");
}.bind(null);
/**
 * @type {{optional: string, partial: string, full: string}}
 */


var options = {
  /**
   * Полное ФИО
   *
   * @type {string}
   */
  full: rule('{2,}'),

  /**
   * Имя и фамилия обязательны, отчество необязательно
   *
   * @type {string}
   */
  optional: rule('+'),

  /**
   * Только имя и фамилия
   *
   * @type {string}
   */
  partial: rule()
};
/**
 * @type {string[] | Array<string>}
 */

var optionsNames = Object.keys(options);
/**
 * @param {*} v
 * @param {'optional' | 'full' | 'partial'} option
 * @returns {boolean}
 */

function name$1(v) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'optional';

  if (!optionsNames.includes(option)) {
    // eslint-disable-next-line max-len
    throw new ValidatorError("Invalid option \"".concat(option, "\" given for rule \"name\", allowed values: ").concat(optionsNames.join(', ')));
  }

  return new RegExp(options[option]).test(String(v));
}

function number(v) {
  return typeof v === 'number';
}

function money(v) {
  return /^\d+([,.]\d{1,2})?$/.test(String(v).replace(' ', ''));
}

function confirmed(v, field) {
  if (!field) {
    throw new ValidatorError('The signature of confirmed rule must be like - confirmed:your_field');
  }

  var value = this.validator.input[field];

  if (typeof value === 'string') {
    value = value.toLocaleLowerCase();
  }

  if (typeof v === 'string') {
    // eslint-disable-next-line no-param-reassign
    v = v.toLocaleLowerCase();
  }

  return value === v;
}

function email(v) {
  // eslint-disable-next-line
  return /^(?!\.)(?:[\"!#$%&'*+\-\/=?^_`{|}~A-Яa-я0-9ёЁ]|\.(?![\.@]))+@[\[]?([^@\s\\\"<>)(\[\]+:;,.-]+(([.+-][^@\s\\\"<>)(\[\]+:;,.-]+)+?|)([.][^0-9@\s\\\"<>)(\[\]+:;,.-]+)+?|(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?\]?))$/.test(String(v));
}

/**
 * @type {string}
 */

var nativeDateFormat = 'native';
/**
 * @param {string | undefined} format
 * @return {function(Date | string | number): boolean}
 */

function parseDate(format) {
  var _this = this;

  var now = new Date();
  var newFormat = format || nativeDateFormat;
  return function (date) {
    _newArrowCheck(this, _this);

    return newFormat === nativeDateFormat ? date : parse(date, newFormat, now, {
      locale: ru
    });
  }.bind(this);
}

function date(v) {
  var _this = this;

  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nativeDateFormat;
  var parse = parseDate(format);

  var check = function check(value) {
    _newArrowCheck(this, _this);

    var formattedDate = format === nativeDateFormat ? value : parse(value);

    if (!isValid(formattedDate)) {
      return false;
    }

    return isExists(formattedDate.getFullYear(), formattedDate.getMonth(), formattedDate.getDate());
  }.bind(this);

  return Array.isArray(v) ? v.every(check) : check(v);
}

function dateBetween(v) {
  var _this = this;

  // eslint-disable-next-line prefer-const
  var _this$getParameters = this.getParameters(),
      _this$getParameters2 = _slicedToArray(_this$getParameters, 3),
      start = _this$getParameters2[0],
      end = _this$getParameters2[1],
      format = _this$getParameters2[2];

  if (!start || !end) {
    throw new ValidatorError('Invalid range of dates given for rule "dateBetween"');
  }

  var parse = parseDate(format);
  var dates = Array.isArray(v) ? v.map(parse) : [parse(v)];
  start = parse(start);
  end = parse(end); // eslint-disable-next-line max-len

  return [start, end].concat(_toConsumableArray(dates)).every(isValid) && dates.every(function (date) {
    _newArrowCheck(this, _this);

    return isAfter(date, start);
  }.bind(this)) && dates.every(function (date) {
    _newArrowCheck(this, _this);

    return isBefore(date, end);
  }.bind(this));
}

function dateBetweenOrEqual(v) {
  var _this = this;

  // eslint-disable-next-line prefer-const
  var _this$getParameters = this.getParameters(),
      _this$getParameters2 = _slicedToArray(_this$getParameters, 3),
      start = _this$getParameters2[0],
      end = _this$getParameters2[1],
      format = _this$getParameters2[2];

  if (!start || !end) {
    throw new ValidatorError('Invalid range of dates given for rule "dateBetweenOrEquals"');
  }

  var prepare = parseDate(format);
  var dates = Array.isArray(v) ? v.map(prepare) : [prepare(v)];
  start = prepare(start);
  end = prepare(end);

  if ([start, end].concat(_toConsumableArray(dates)).some(function (item) {
    _newArrowCheck(this, _this);

    return !isValid(item);
  }.bind(this))) {
    return false;
  } // eslint-disable-next-line max-len


  return dates.every(function (date) {
    _newArrowCheck(this, _this);

    return isAfter(date, start) && isBefore(date, end) || isEqual(date, start) || isEqual(date, end);
  }.bind(this));
}

function dateRange(v) {
  var _this = this;

  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nativeDateFormat;

  if (!Array.isArray(v)) {
    return false;
  }

  if (v.length < 2) {
    return false;
  }

  var parse = parseDate(format);
  return v.every(function (date) {
    _newArrowCheck(this, _this);

    return format === nativeDateFormat ? date instanceof Date : isValid(parse(date));
  }.bind(this));
}

var rules = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cyrillic: cyrillic,
  phone: phone,
  name: name$1,
  number: number,
  money: money,
  confirmed: confirmed,
  email: email,
  date: date,
  dateBetween: dateBetween,
  dateBetweenOrEqual: dateBetweenOrEqual,
  dateRange: dateRange
});

var _this$P = null;
validator$1.useLang('ru');
validator$1.setMessages('ru', messages);
Object.entries(rules).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      executor = _ref2[1];

  _newArrowCheck(this, _this$P);

  validator$1.register(name, executor, messages[name]);
}.bind(null));
function extend(name, validator) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var async = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  validator$1[async ? 'registerAsync' : 'register'](name, validator, message);
}

var _this$O = null;
var uiForm = {
  name: 'ui-form',
  provide: function provide() {
    return {
      /**
       * Namespace for injected components
       */
      formGroup: {
        register: this.register,
        unregister: this.unregister,
        update: this.controlHandler
      }
    };
  },
  props: {
    /**
     * Component mount tag
     */
    tag: {
      type: String,
      default: 'form'
    },

    /**
     * Validation rules
     */
    rules: {
      type: Object,
      default: null
    },

    /**
     * Validation external data
     */
    data: {
      type: Object,
      default: function _default() {
        _newArrowCheck(this, _this$O);

        return {};
      }.bind(null)
    },

    /**
     * Custom validation messages
     */
    messages: {
      type: Object,
      default: function _default() {
        _newArrowCheck(this, _this$O);

        return {};
      }.bind(null)
    },

    /**
     * Включает скроллинг до первого поля, в котором произошла ошибка валидации
     */
    scrollOnError: {
      type: Boolean,
      default: false
    },

    /**
     * Задает смещение по оси Y для скрола
     */
    scrollOffset: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$O);

        return v >= 0;
      }.bind(null)
    }
  },
  data: function data() {
    var _this2 = this;

    _newArrowCheck(this, _this$O);

    return {
      /**
       * Form controls
       *
       * @type {Object}
       */
      controls: {},

      /**
       * Controls' data
       *
       * @type {Object<string, *>}
       */
      input: {},

      /**
       * Validation errors bag
       *
       * @type {{ has: (function(string): boolean), first: (function(string): string | null), all: (function(string): string[]) }}
       */
      errors: {
        has: function has() {
          _newArrowCheck(this, _this2);

          return false;
        }.bind(this),
        first: function first() {
          _newArrowCheck(this, _this2);

          return null;
        }.bind(this),
        all: function all() {
          _newArrowCheck(this, _this2);

          return [];
        }.bind(this)
      },

      /**
       * Validation state
       *
       * @type {boolean}
       */
      valid: false,

      /**
       * Validator instance
       *
       * @type {Validator | null}
       */
      validator: null
    };
  }.bind(null),
  computed: {
    /**
     * Allow to validate form data
     *
     * @returns {boolean}
     */
    needValidate: function needValidate() {
      return this.rules !== null && !!Object.keys(this.rules).length;
    },

    /**
     * Validation result for scoped slot and event "validate"
     *
     * @returns {{ all: (function(string): string[]), isValid: boolean, get: (function(string): Array<string>), has: (function(string): boolean), errors: Object }}
     */
    validationState: function validationState() {
      var _this3 = this;

      return {
        errors: this.errors,
        isValid: this.valid,
        has: function has(field) {
          _newArrowCheck(this, _this3);

          return this.hasError(field);
        }.bind(this),
        get: function get(field) {
          _newArrowCheck(this, _this3);

          return this.getError(field);
        }.bind(this),
        all: function all(field) {
          _newArrowCheck(this, _this3);

          return this.getAllErrors(field);
        }.bind(this),
        show: function show(field) {
          _newArrowCheck(this, _this3);

          return this.showControlError(field);
        }.bind(this),
        hide: function hide(field) {
          _newArrowCheck(this, _this3);

          return this.hideControlError(field);
        }.bind(this),
        reset: function reset() {
          _newArrowCheck(this, _this3);

          return this.resetShowErrorState();
        }.bind(this)
      };
    },

    /**
     * Form HTML attributes
     *
     * @return {Object}
     */
    attributes: function attributes() {
      return {
        novalidate: this.tag === 'form' ? '' : null
      };
    },

    /**
     * Form event handlers
     *
     * @returns {{ submit: function(Event) }}
     */
    handlers: function handlers() {
      var _this4 = this;

      return {
        reset: function reset(e) {
          _newArrowCheck(this, _this4);

          return this.resetHandler(e);
        }.bind(this),
        submit: function submit(e) {
          _newArrowCheck(this, _this4);

          return this.submitHandler(e);
        }.bind(this)
      };
    }
  },
  watch: {
    rules: {
      deep: true,
      handler: 'validate'
    },
    data: {
      deep: true,
      handler: 'validate'
    },
    messages: {
      deep: true,
      handler: 'validate'
    }
  },
  methods: {
    /**
     * Form reset event handler
     *
     * @param {Event} e
     */
    resetHandler: function resetHandler(e) {
      this.resetShowErrorState();
      this.$emit('reset', e);
    },

    /**
     * Form submit event handler
     *
     * @param {SubmitEvent | Event} e
     */
    submitHandler: function submitHandler(e) {
      var _this5 = this;

      e.preventDefault();

      var submit = function submit() {
        _newArrowCheck(this, _this5);

        return this.$emit('submit', e);
      }.bind(this);

      if (!this.needValidate) {
        submit();
        return;
      }

      this.validate();

      if (this.valid) {
        submit();
        return;
      }

      this.updateShowErrorState();

      if (this.scrollOnError) {
        var _Object$values$filter = Object.values(this.controls).filter(function (v) {
          _newArrowCheck(this, _this5);

          return this.hasError(v.name) && v.$el.offsetParent;
        }.bind(this)).sort(function (a, b) {
          _newArrowCheck(this, _this5);

          return a.$el.offsetTop - b.$el.offsetTop;
        }.bind(this)),
            _Object$values$filter2 = _slicedToArray(_Object$values$filter, 1),
            control = _Object$values$filter2[0];

        if (control) {
          control.$el.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }
      }
    },

    /**
     * Updates show error state for all injected controls
     */
    updateShowErrorState: function updateShowErrorState() {
      var _this6 = this;

      Object.values(this.controls).forEach(function (control) {
        _newArrowCheck(this, _this6);

        return control.showValidationError();
      }.bind(this));
    },

    /**
     * Reset error state for all injected controls
     */
    resetShowErrorState: function resetShowErrorState() {
      var _this7 = this;

      Object.values(this.controls).forEach(function (control) {
        _newArrowCheck(this, _this7);

        return control.hideValidationError();
      }.bind(this));
    },

    /**
     * Finding control by name
     *
     * @param {string} name
     * @return {Object | Vue | null}
     */
    findControl: function findControl(name) {
      return this.controls[name] || null;
    },

    /**
     * Shows validation error of control
     *
     * @param {string} name
     */
    showControlError: function showControlError(name) {
      var control = this.findControl(name);

      if (control) {
        control.showValidationError();
      }
    },

    /**
     * Hides validation error of control
     *
     * @param {string} name
     */
    hideControlError: function hideControlError(name) {
      var control = this.findControl(name);

      if (control) {
        control.hideValidationError();
      }
    },

    /**
     * Updates control data for all injected components
     */
    updateInput: function updateInput() {
      var _this8 = this;

      Object.values(this.controls).forEach(function (control) {
        _newArrowCheck(this, _this8);

        return this.updateControlInput(control);
      }.bind(this));
    },

    /**
     * Updates control's data
     *
     * @param {Vue} control
     * @param {*} value
     */
    updateControlInput: function updateControlInput(control) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var v = value === undefined ? control[control.$options.model.prop] : value;
      this.$set(this.input, control.name, v);
    },

    /**
     * Updates control's validation state
     *
     * @param {Vue} control
     */
    updateControlValidationState: function updateControlValidationState(control) {
      var error = this.validator ? this.validator.errors.first(control.name) || null : null; // eslint-disable-next-line no-param-reassign

      control.validation.error = error; // eslint-disable-next-line no-param-reassign

      control.validation.valid = !error;
    },

    /**
     * Updates validation state for all injected controls
     */
    updateValidationState: function updateValidationState() {
      var _this9 = this;

      Object.values(this.controls).forEach(function (control) {
        _newArrowCheck(this, _this9);

        return this.updateControlValidationState(control);
      }.bind(this));
    },

    /**
     * Creates Validator instance and validates all controls' data
     */
    validate: function validate() {
      var _this10 = this;

      this.validator = new validator$1(_objectSpread2(_objectSpread2({}, this.input), this.data), this.rules, this.messages);

      if (this.needValidate) {
        var handler = function handler() {
          _newArrowCheck(this, _this10);

          this.errors = this.validator.errors;
          this.valid = this.validator.errorCount === 0;
          this.updateValidationState();
          this.$emit('validate', this.validationState);
        }.bind(this);

        if (this.validator.hasAsync) {
          this.validator.checkAsync(handler, handler);
        } else {
          this.validator.check();
          handler();
        }
      }
    },

    /**
     * Control's data update handler
     *
     * @param {Vue} control
     * @param {*} value
     */
    controlHandler: function controlHandler(control, value) {
      this.updateControlInput(control, value);
      this.validate();
    },

    /**
     * Helper for checking errors
     *
     * @param {string | Array<string>} field
     * @returns {boolean}
     */
    hasError: function hasError(field) {
      var _this11 = this;

      if (!Array.isArray(field) && typeof field !== 'string') {
        throw new FrameworkError('Invalid field name given');
      }

      var has = function has(f) {
        _newArrowCheck(this, _this11);

        return this.errors ? this.errors.has(f) : false;
      }.bind(this);

      if (typeof field === 'string') {
        return has(field);
      }

      return field.some(function (v) {
        _newArrowCheck(this, _this11);

        return has(v);
      }.bind(this));
    },

    /**
     * Helper for getting first error of control
     *
     * @param {string} field
     * @returns {string | Array<string>}
     */
    getError: function getError(field) {
      if (typeof field !== 'string') {
        throw new FrameworkError('Invalid field name given');
      }

      return this.errors && this.errors.first ? this.errors.first(field) || null : null;
    },

    /**
     * Helper for getting all errors of control
     *
     * @param {string} field
     * @returns {string[]}
     */
    getAllErrors: function getAllErrors(field) {
      if (typeof field !== 'string') {
        throw new FrameworkError('Invalid field name given');
      }

      return this.errors && this.errors.get ? this.errors.get(field) : null;
    },

    /**
     * Register control component into form via inject/provide
     *
     * @see https://ru.vuejs.org/v2/api/index.html#provide-inject
     *
     * @param {Vue} control
     */
    register: function register(control) {
      if (!control.$options.model) {
        throw new FrameworkError(["Can't register ".concat(kebabToCamel(control.$options.name), " in uiForm component"), 'Model options are unreachable']);
      }

      this.controls[control.name] = control;
      this.updateControlInput(control);
      this.updateControlValidationState(control);
    },

    /**
     * Unregister control component from form via inject/provide
     *
     * @see https://ru.vuejs.org/v2/api/index.html#provide-inject
     *
     * @param {Vue} control
     */
    unregister: function unregister(control) {
      if (this.$_isDestroying) {
        return;
      }

      if (this.controls[control.name]) {
        this.$delete(this.input, control.name);

        var _this$controls = this.controls,
            _control$name = control.name;
            _this$controls[_control$name];
            var controls = _objectWithoutProperties(_this$controls, [_control$name].map(_toPropertyKey));

        this.controls = controls;
      }
    }
  },
  mounted: function mounted() {
    this.updateInput();
    this.validate();
  },
  beforeDestroy: function beforeDestroy() {
    this.$_isDestroying = true;
  },

  /**
   * Template render function
   *
   * @param {function} h
   * @returns {VNode}
   */
  render: function render(h) {
    var content = this.$slots.default || this.$scopedSlots.default;

    if (typeof content === 'function') {
      content = content(this.validationState);
    }

    return h(this.tag, {
      attrs: this.attributes,
      on: this.handlers
    }, content);
  }
};

var index$A = generatePlugin(uiForm);

var _this$N = null;

/**
 * Form control factory function
 *
 * @param {{ validateOn?: string | null }?} options
 * @return {Object}
 */
var factory$2 = function factory() {
  var _this2 = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$validateOn = _ref.validateOn,
      validateOn = _ref$validateOn === void 0 ? 'input' : _ref$validateOn;

  _newArrowCheck(this, _this$N);

  return {
    inject: {
      formGroup: {
        default: null
      }
    },
    props: _objectSpread2(_objectSpread2({
      /**
       * Control name which will be used for validation
       */
      name: {
        type: String,
        default: null
      }
    }, validateOn && {
      validationEvent: {
        type: String,
        default: validateOn
      }
    }), {}, {
      /**
       * Mode which changes error showing
       *
       * event - show validation error on control event which passes into "validationEvent" property
       * immediate - show validation error on control mount
       */
      validationMode: {
        type: String,
        default: 'event',
        validator: function validator(v) {
          _newArrowCheck(this, _this2);

          return ['event', 'immediate'].includes(v);
        }.bind(this)
      }
    }),
    data: function data() {
      _newArrowCheck(this, _this2);

      return {
        /**
         * Validation state
         */
        validation: {
          /**
           * Validation error message
           */
          error: null,

          /**
           * If field's value validation passes
           */
          valid: true,

          /**
           * Show validation error message
           */
          show: false
        }
      };
    }.bind(this),
    computed: {
      /**
       * Tells if control need to be registered inside form
       *
       * @return {boolean}
       */
      needRegisterInFormGroup: function needRegisterInFormGroup() {
        return Boolean(this.formGroup && this.name);
      },

      /**
       * Validation error message
       *
       * @return {string | null}
       */
      validationError: function validationError() {
        var _this$validation = this.validation,
            show = _this$validation.show,
            valid = _this$validation.valid,
            error = _this$validation.error;
        return show && !valid ? error : null;
      }
    },
    watch: _objectSpread2({
      name: function name(v) {
        if (v !== null && v !== undefined) {
          this.formGroupRegister();
          this.registerModelWatcher();
          this.registerValidationEventHandler();
        }
      }
    }, validateOn && {
      validationEvent: function validationEvent(value, old) {
        this.unregisterValidationEventHandler(old);
        this.registerValidationEventHandler(value);
      }
    }),
    methods: {
      /**
       * Register control into form
       */
      formGroupRegister: function formGroupRegister() {
        if (this.needRegisterInFormGroup) {
          this.formGroup.register(this);
        }
      },

      /**
       * Unregister control into form
       */
      formGroupUnregister: function formGroupUnregister() {
        if (this.needRegisterInFormGroup) {
          this.formGroup.unregister(this);
        }
      },

      /**
       * Create listener for show error message event
       *
       * @param {string | null} event
       */
      registerValidationEventHandler: function registerValidationEventHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (this.needRegisterInFormGroup && validateOn) {
          this.$on(event || this.validationEvent, this.showValidationError);
        }
      },

      /**
       * Destroy listener for show error message event
       *
       * @param {string | null} event
       */
      unregisterValidationEventHandler: function unregisterValidationEventHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (this.needRegisterInFormGroup && validateOn) {
          this.$off(event || this.validationEvent, this.showValidationError);
        }
      },

      /**
       * Enable watcher for control model
       */
      registerModelWatcher: function registerModelWatcher() {
        var _this3 = this;

        if (this.needRegisterInFormGroup) {
          this.$_modelWatcher = this.$watch(this.$options.model.prop, function (v) {
            _newArrowCheck(this, _this3);

            return this.formGroup.update(this, v);
          }.bind(this));
        }
      },

      /**
       * Disable watcher for control model
       */
      unregisterModelWatcher: function unregisterModelWatcher() {
        if (this.needRegisterInFormGroup && this.$_modelWatcher) {
          this.$_modelWatcher();
        }
      },

      /**
       * Show error message
       */
      showValidationError: function showValidationError() {
        this.validation.show = true;
      },

      /**
       * Hide error message
       */
      hideValidationError: function hideValidationError() {
        this.validation.show = false;
      }
    },
    mounted: function mounted() {
      this.formGroupRegister();
      this.registerModelWatcher();
      this.registerValidationEventHandler();

      if (this.validationMode === 'immediate') {
        this.showValidationError();
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.unregisterModelWatcher();
      this.formGroupUnregister();
    }
  };
}.bind(null);
factory$2();

var uiFormControl = {
  name: 'ui-form-control',
  mixins: [factory$2({
    validateOn: null
  })],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    tag: {
      type: String,
      default: null
    }
  },
  render: function render(h) {
    var _this = this;

    var content = this.$scopedSlots.default({
      isValid: this.validation.valid,
      state: this.validationError ? 'error' : null,
      error: this.validationError,
      handler: function handler() {
        _newArrowCheck(this, _this);

        return this.showValidationError();
      }.bind(this)
    });
    return this.tag ? h(this.tag, {
      attrs: {
        'data-form-control': ''
      }
    }, [content]) : content;
  }
};

var index$z = generatePlugin(uiFormControl);

var _this$M = null;

var factory$1 = function factory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'message' : _ref$prop,
      _ref$slot = _ref.slot,
      slot = _ref$slot === void 0 ? 'message' : _ref$slot;

  _newArrowCheck(this, _this$M);

  return {
    props: _defineProperty({}, prop, {
      type: String,
      default: null
    }),
    computed: {
      hasMessage: function hasMessage() {
        return this[prop] || this.$slots[slot];
      },
      messageOptions: function messageOptions() {
        return {};
      }
    },
    methods: {
      genMessage: function genMessage() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var content = message || this[prop] || this.$slots[slot] || null;
        return this.$createElement(tag, this.messageOptions, [content]);
      }
    }
  };
}.bind(null);
var Messageable = factory$1();

var _this$L = null;

/**
 * @param {Array<string>} allowedStates
 */
var factory = function factory(allowedStates) {
  var _this2 = this;

  _newArrowCheck(this, _this$L);

  return {
    props: {
      state: {
        type: String,
        default: null,
        validator: function validator(v) {
          _newArrowCheck(this, _this2);

          return allowedStates.includes(v);
        }.bind(this)
      }
    },
    computed: allowedStates.reduce(function (acc, value) {
      _newArrowCheck(this, _this2);

      var state = value.substr(0, 1).toLocaleUpperCase() + value.substr(1).toLocaleLowerCase();
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "is".concat(state, "State"), function isState() {
        return this.state === value;
      }));
    }.bind(this), {})
  };
}.bind(null);
var Stateable = factory(['error', 'success', 'warning']);

var vueInputFacade_umd_min = createCommonjsModule(function (module, exports) {
  (function (t, e) {
    module.exports = e() ;
  })("undefined" !== typeof self ? self : commonjsGlobal, function () {
    return function (t) {
      var e = {};

      function n(r) {
        if (e[r]) return e[r].exports;
        var o = e[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = t, n.c = e, n.d = function (t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (t) {
        "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, n.t = function (t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" === _typeof(t) && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var o in t) {
          n.d(r, o, function (e) {
            return t[e];
          }.bind(null, o));
        }
        return r;
      }, n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t["default"];
        } : function () {
          return t;
        };
        return n.d(e, "a", e), e;
      }, n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.p = "", n(n.s = "fb15");
    }({
      "06cf": function cf(t, e, n) {
        var r = n("83ab"),
            o = n("d1e7"),
            i = n("5c6c"),
            a = n("fc6a"),
            u = n("c04e"),
            c = n("5135"),
            f = n("0cfb"),
            s = Object.getOwnPropertyDescriptor;
        e.f = r ? s : function (t, e) {
          if (t = a(t), e = u(e, !0), f) try {
            return s(t, e);
          } catch (n) {}
          if (c(t, e)) return i(!o.f.call(t, e), t[e]);
        };
      },
      "0cfb": function cfb(t, e, n) {
        var r = n("83ab"),
            o = n("d039"),
            i = n("cc12");
        t.exports = !r && !o(function () {
          return 7 != Object.defineProperty(i("div"), "a", {
            get: function get() {
              return 7;
            }
          }).a;
        });
      },
      "1d80": function d80(t, e) {
        t.exports = function (t) {
          if (void 0 == t) throw TypeError("Can't call method on " + t);
          return t;
        };
      },
      "23cb": function cb(t, e, n) {
        var r = n("a691"),
            o = Math.max,
            i = Math.min;

        t.exports = function (t, e) {
          var n = r(t);
          return n < 0 ? o(n + e, 0) : i(n, e);
        };
      },
      "23e7": function e7(t, e, n) {
        var r = n("da84"),
            o = n("06cf").f,
            i = n("9112"),
            a = n("6eeb"),
            u = n("ce4e"),
            c = n("e893"),
            f = n("94ca");

        t.exports = function (t, e) {
          var n,
              s,
              l,
              p,
              d,
              m,
              v = t.target,
              h = t.global,
              b = t.stat;
          if (s = h ? r : b ? r[v] || u(v, {}) : (r[v] || {}).prototype, s) for (l in e) {
            if (d = e[l], t.noTargetGet ? (m = o(s, l), p = m && m.value) : p = s[l], n = f(h ? l : v + (b ? "." : "#") + l, t.forced), !n && void 0 !== p) {
              if (_typeof(d) === _typeof(p)) continue;
              c(d, p);
            }

            (t.sham || p && p.sham) && i(d, "sham", !0), a(s, l, d, t);
          }
        };
      },
      "241c": function c(t, e, n) {
        var r = n("ca84"),
            o = n("7839"),
            i = o.concat("length", "prototype");

        e.f = Object.getOwnPropertyNames || function (t) {
          return r(t, i);
        };
      },
      "25f0": function f0(t, e, n) {

        var r = n("6eeb"),
            o = n("825a"),
            i = n("d039"),
            a = n("ad6d"),
            u = "toString",
            c = RegExp.prototype,
            f = c[u],
            s = i(function () {
          return "/a/b" != f.call({
            source: "a",
            flags: "b"
          });
        }),
            l = f.name != u;
        (s || l) && r(RegExp.prototype, u, function () {
          var t = o(this),
              e = String(t.source),
              n = t.flags,
              r = String(void 0 === n && t instanceof RegExp && !("flags" in c) ? a.call(t) : n);
          return "/" + e + "/" + r;
        }, {
          unsafe: !0
        });
      },
      "428f": function f(t, e, n) {
        var r = n("da84");
        t.exports = r;
      },
      "44ad": function ad(t, e, n) {
        var r = n("d039"),
            o = n("c6b6"),
            i = "".split;
        t.exports = r(function () {
          return !Object("z").propertyIsEnumerable(0);
        }) ? function (t) {
          return "String" == o(t) ? i.call(t, "") : Object(t);
        } : Object;
      },
      "4d64": function d64(t, e, n) {
        var r = n("fc6a"),
            o = n("50c4"),
            i = n("23cb"),
            a = function a(t) {
          return function (e, n, a) {
            var u,
                c = r(e),
                f = o(c.length),
                s = i(a, f);

            if (t && n != n) {
              while (f > s) {
                if (u = c[s++], u != u) return !0;
              }
            } else for (; f > s; s++) {
              if ((t || s in c) && c[s] === n) return t || s || 0;
            }

            return !t && -1;
          };
        };

        t.exports = {
          includes: a(!0),
          indexOf: a(!1)
        };
      },
      "50c4": function c4(t, e, n) {
        var r = n("a691"),
            o = Math.min;

        t.exports = function (t) {
          return t > 0 ? o(r(t), 9007199254740991) : 0;
        };
      },
      5135: function _(t, e) {
        var n = {}.hasOwnProperty;

        t.exports = function (t, e) {
          return n.call(t, e);
        };
      },
      5692: function _(t, e, n) {
        var r = n("c430"),
            o = n("c6cd");
        (t.exports = function (t, e) {
          return o[t] || (o[t] = void 0 !== e ? e : {});
        })("versions", []).push({
          version: "3.6.5",
          mode: r ? "pure" : "global",
          copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
        });
      },
      "56ef": function ef(t, e, n) {
        var r = n("d066"),
            o = n("241c"),
            i = n("7418"),
            a = n("825a");

        t.exports = r("Reflect", "ownKeys") || function (t) {
          var e = o.f(a(t)),
              n = i.f;
          return n ? e.concat(n(t)) : e;
        };
      },
      "5c6c": function c6c(t, e) {
        t.exports = function (t, e) {
          return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
          };
        };
      },
      "60da": function da(t, e, n) {

        var r = n("83ab"),
            o = n("d039"),
            i = n("df75"),
            a = n("7418"),
            u = n("d1e7"),
            c = n("7b0b"),
            f = n("44ad"),
            s = Object.assign,
            l = Object.defineProperty;
        t.exports = !s || o(function () {
          if (r && 1 !== s({
            b: 1
          }, s(l({}, "a", {
            enumerable: !0,
            get: function get() {
              l(this, "b", {
                value: 3,
                enumerable: !1
              });
            }
          }), {
            b: 2
          })).b) return !0;
          var t = {},
              e = {},
              n = Symbol(),
              o = "abcdefghijklmnopqrst";
          return t[n] = 7, o.split("").forEach(function (t) {
            e[t] = t;
          }), 7 != s({}, t)[n] || i(s({}, e)).join("") != o;
        }) ? function (t, e) {
          var n = c(t),
              o = arguments.length,
              s = 1,
              l = a.f,
              p = u.f;

          while (o > s) {
            var d,
                m = f(arguments[s++]),
                v = l ? i(m).concat(l(m)) : i(m),
                h = v.length,
                b = 0;

            while (h > b) {
              d = v[b++], r && !p.call(m, d) || (n[d] = m[d]);
            }
          }

          return n;
        } : s;
      },
      "69f3": function f3(t, e, n) {
        var r,
            o,
            i,
            a = n("7f9a"),
            u = n("da84"),
            c = n("861d"),
            f = n("9112"),
            s = n("5135"),
            l = n("f772"),
            p = n("d012"),
            d = u.WeakMap,
            m = function m(t) {
          return i(t) ? o(t) : r(t, {});
        },
            v = function v(t) {
          return function (e) {
            var n;
            if (!c(e) || (n = o(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
            return n;
          };
        };

        if (a) {
          var h = new d(),
              b = h.get,
              g = h.has,
              y = h.set;
          r = function r(t, e) {
            return y.call(h, t, e), e;
          }, o = function o(t) {
            return b.call(h, t) || {};
          }, i = function i(t) {
            return g.call(h, t);
          };
        } else {
          var x = l("state");
          p[x] = !0, r = function r(t, e) {
            return f(t, x, e), e;
          }, o = function o(t) {
            return s(t, x) ? t[x] : {};
          }, i = function i(t) {
            return s(t, x);
          };
        }

        t.exports = {
          set: r,
          get: o,
          has: i,
          enforce: m,
          getterFor: v
        };
      },
      "6eeb": function eeb(t, e, n) {
        var r = n("da84"),
            o = n("9112"),
            i = n("5135"),
            a = n("ce4e"),
            u = n("8925"),
            c = n("69f3"),
            f = c.get,
            s = c.enforce,
            l = String(String).split("String");
        (t.exports = function (t, e, n, u) {
          var c = !!u && !!u.unsafe,
              f = !!u && !!u.enumerable,
              p = !!u && !!u.noTargetGet;
          "function" == typeof n && ("string" != typeof e || i(n, "name") || o(n, "name", e), s(n).source = l.join("string" == typeof e ? e : "")), t !== r ? (c ? !p && t[e] && (f = !0) : delete t[e], f ? t[e] = n : o(t, e, n)) : f ? t[e] = n : a(e, n);
        })(Function.prototype, "toString", function () {
          return "function" == typeof this && f(this).source || u(this);
        });
      },
      7418: function _(t, e) {
        e.f = Object.getOwnPropertySymbols;
      },
      7839: function _(t, e) {
        t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
      },
      "7b0b": function b0b(t, e, n) {
        var r = n("1d80");

        t.exports = function (t) {
          return Object(r(t));
        };
      },
      "7f9a": function f9a(t, e, n) {
        var r = n("da84"),
            o = n("8925"),
            i = r.WeakMap;
        t.exports = "function" === typeof i && /native code/.test(o(i));
      },
      "825a": function a(t, e, n) {
        var r = n("861d");

        t.exports = function (t) {
          if (!r(t)) throw TypeError(String(t) + " is not an object");
          return t;
        };
      },
      "83ab": function ab(t, e, n) {
        var r = n("d039");
        t.exports = !r(function () {
          return 7 != Object.defineProperty({}, 1, {
            get: function get() {
              return 7;
            }
          })[1];
        });
      },
      "861d": function d(t, e) {
        t.exports = function (t) {
          return "object" === _typeof(t) ? null !== t : "function" === typeof t;
        };
      },
      8925: function _(t, e, n) {
        var r = n("c6cd"),
            o = Function.toString;
        "function" != typeof r.inspectSource && (r.inspectSource = function (t) {
          return o.call(t);
        }), t.exports = r.inspectSource;
      },
      "90e3": function e3(t, e) {
        var n = 0,
            r = Math.random();

        t.exports = function (t) {
          return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++n + r).toString(36);
        };
      },
      9112: function _(t, e, n) {
        var r = n("83ab"),
            o = n("9bf2"),
            i = n("5c6c");
        t.exports = r ? function (t, e, n) {
          return o.f(t, e, i(1, n));
        } : function (t, e, n) {
          return t[e] = n, t;
        };
      },
      "94ca": function ca(t, e, n) {
        var r = n("d039"),
            o = /#|\.prototype\./,
            i = function i(t, e) {
          var n = u[a(t)];
          return n == f || n != c && ("function" == typeof e ? r(e) : !!e);
        },
            a = i.normalize = function (t) {
          return String(t).replace(o, ".").toLowerCase();
        },
            u = i.data = {},
            c = i.NATIVE = "N",
            f = i.POLYFILL = "P";

        t.exports = i;
      },
      "9bf2": function bf2(t, e, n) {
        var r = n("83ab"),
            o = n("0cfb"),
            i = n("825a"),
            a = n("c04e"),
            u = Object.defineProperty;
        e.f = r ? u : function (t, e, n) {
          if (i(t), e = a(e, !0), i(n), o) try {
            return u(t, e, n);
          } catch (r) {}
          if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
          return "value" in n && (t[e] = n.value), t;
        };
      },
      a691: function a691(t, e) {
        var n = Math.ceil,
            r = Math.floor;

        t.exports = function (t) {
          return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
        };
      },
      ad6d: function ad6d(t, e, n) {

        var r = n("825a");

        t.exports = function () {
          var t = r(this),
              e = "";
          return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
        };
      },
      c04e: function c04e(t, e, n) {
        var r = n("861d");

        t.exports = function (t, e) {
          if (!r(t)) return t;
          var n, o;
          if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
          if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
          if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
          throw TypeError("Can't convert object to primitive value");
        };
      },
      c430: function c430(t, e) {
        t.exports = !1;
      },
      c6b6: function c6b6(t, e) {
        var n = {}.toString;

        t.exports = function (t) {
          return n.call(t).slice(8, -1);
        };
      },
      c6cd: function c6cd(t, e, n) {
        var r = n("da84"),
            o = n("ce4e"),
            i = "__core-js_shared__",
            a = r[i] || o(i, {});
        t.exports = a;
      },
      c8ba: function c8ba(t, e) {
        var n;

        n = function () {
          return this;
        }();

        try {
          n = n || new Function("return this")();
        } catch (r) {
          "object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
        }

        t.exports = n;
      },
      ca84: function ca84(t, e, n) {
        var r = n("5135"),
            o = n("fc6a"),
            i = n("4d64").indexOf,
            a = n("d012");

        t.exports = function (t, e) {
          var n,
              u = o(t),
              c = 0,
              f = [];

          for (n in u) {
            !r(a, n) && r(u, n) && f.push(n);
          }

          while (e.length > c) {
            r(u, n = e[c++]) && (~i(f, n) || f.push(n));
          }

          return f;
        };
      },
      cc12: function cc12(t, e, n) {
        var r = n("da84"),
            o = n("861d"),
            i = r.document,
            a = o(i) && o(i.createElement);

        t.exports = function (t) {
          return a ? i.createElement(t) : {};
        };
      },
      cca6: function cca6(t, e, n) {
        var r = n("23e7"),
            o = n("60da");
        r({
          target: "Object",
          stat: !0,
          forced: Object.assign !== o
        }, {
          assign: o
        });
      },
      ce4e: function ce4e(t, e, n) {
        var r = n("da84"),
            o = n("9112");

        t.exports = function (t, e) {
          try {
            o(r, t, e);
          } catch (n) {
            r[t] = e;
          }

          return e;
        };
      },
      d012: function d012(t, e) {
        t.exports = {};
      },
      d039: function d039(t, e) {
        t.exports = function (t) {
          try {
            return !!t();
          } catch (e) {
            return !0;
          }
        };
      },
      d066: function d066(t, e, n) {
        var r = n("428f"),
            o = n("da84"),
            i = function i(t) {
          return "function" == typeof t ? t : void 0;
        };

        t.exports = function (t, e) {
          return arguments.length < 2 ? i(r[t]) || i(o[t]) : r[t] && r[t][e] || o[t] && o[t][e];
        };
      },
      d1e7: function d1e7(t, e, n) {

        var r = {}.propertyIsEnumerable,
            o = Object.getOwnPropertyDescriptor,
            i = o && !r.call({
          1: 2
        }, 1);
        e.f = i ? function (t) {
          var e = o(this, t);
          return !!e && e.enumerable;
        } : r;
      },
      da84: function da84(t, e, n) {
        (function (e) {
          var n = function n(t) {
            return t && t.Math == Math && t;
          };

          t.exports = n("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || n("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || n("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || n("object" == _typeof(e) && e) || Function("return this")();
        }).call(this, n("c8ba"));
      },
      df75: function df75(t, e, n) {
        var r = n("ca84"),
            o = n("7839");

        t.exports = Object.keys || function (t) {
          return r(t, o);
        };
      },
      e893: function e893(t, e, n) {
        var r = n("5135"),
            o = n("56ef"),
            i = n("06cf"),
            a = n("9bf2");

        t.exports = function (t, e) {
          for (var n = o(e), u = a.f, c = i.f, f = 0; f < n.length; f++) {
            var s = n[f];
            r(t, s) || u(t, s, c(e, s));
          }
        };
      },
      f772: function f772(t, e, n) {
        var r = n("5692"),
            o = n("90e3"),
            i = r("keys");

        t.exports = function (t) {
          return i[t] || (i[t] = o(t));
        };
      },
      fb15: function fb15(t, e, n) {

        var _this = this;

        if (n.r(e), n.d(e, "InputFacade", function () {
          return E;
        }), n.d(e, "facade", function () {
          return x;
        }), n.d(e, "tokens", function () {
          return i;
        }), n.d(e, "masker", function () {
          return g;
        }), n.d(e, "filter", function () {
          return T;
        }), "undefined" !== typeof window) {
          var r = window.document.currentScript,
              o = r && r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
          o && (n.p = o[1]);
        }

        var i = {
          "#": {
            pattern: /\d/
          },
          X: {
            pattern: /[0-9a-z]/i
          },
          S: {
            pattern: /[a-z]/i
          },
          A: {
            pattern: /[a-z]/i,
            transform: function transform(t) {
              _newArrowCheck(this, _this);

              return t.toLocaleUpperCase();
            }.bind(this)
          },
          a: {
            pattern: /[a-z]/i,
            transform: function transform(t) {
              _newArrowCheck(this, _this);

              return t.toLocaleLowerCase();
            }.bind(this)
          },
          "\\": {
            escape: !0
          }
        };
        n("cca6"), n("25f0");
        var a = "__input-facade__";

        function u(t) {
          this.masked = this.unmasked = t || "";
        }

        function c() {
          return new CustomEvent("input", {
            bubbles: !0,
            cancelable: !0,
            detail: {
              facade: !0
            }
          });
        }

        function f(t, e) {
          return (Array.isArray(t) || "string" === typeof t) && (t = {
            mask: t
          }), Object.assign(t || {}, e);
        }

        function s(t) {
          var e = t instanceof HTMLInputElement ? t : t.querySelector("input");
          if (!e) throw new Error("facade directive requires an input element");
          return e;
        }

        function l(t) {
          var e = t.target,
              n = t.detail;
          if (n && n.facade || "insertCompositionText" === t.inputType) return !1;
          t.stopPropagation();
          var r = e.value,
              o = e.selectionEnd,
              i = e[a].oldValue;
          d(e, null, {
            emit: !1
          }, t), p(t, r, o), i !== e.value && e.dispatchEvent(c());
        }

        function p(t, e, n) {
          var r = t.target,
              o = ["text", "tel", "search", null].includes(r.getAttribute("type")),
              i = r[a] && r[a].config;
          if (r !== document.activeElement || !o || !i.mask) return;
          var u = t.inputType || "insertText",
              c = ["insertText", "insertFromPaste"].includes(u),
              f = c && n == e.length;
          var s = c && e[n - 1];
          var l = r.value.toLocaleLowerCase();
          var p = n;
          if (f) p = l.length;else if (s) {
            s = s.toLocaleLowerCase();
            var _t = p;

            while (_t <= l.length && l.charAt(_t - 1) !== s) {
              _t++;
            }

            p = _t <= l.length ? _t : p - 1;
          }
          r.setSelectionRange(p, p), setTimeout(function () {
            r.setSelectionRange(p, p);
          }, 0);
        }

        function d(t, e) {
          var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
              _ref$emit = _ref.emit,
              n = _ref$emit === void 0 ? !0 : _ref$emit,
              _ref$force = _ref.force,
              r = _ref$force === void 0 ? !1 : _ref$force;

          var o = arguments.length > 3 ? arguments[3] : undefined;
          var _t$a = t[a],
              i = _t$a.config,
              u = _t$a.oldValue,
              f = e && e.data.model ? e.data.model.value : t.value;

          if (u = u || "", f = f || "", r || u !== f) {
            var _e = g(f, i);

            if (o && "function" === typeof i.formatter) {
              var _n = i.formatter(_e, o);

              if ("string" === typeof _n) _e = g(_n, i);else if (!1 === _n) return void (t.value = u);
            }

            t[a].oldValue = _e.masked, t.unmaskedValue = _e.unmasked, t.value !== _e.masked && (t.value = _e.masked), n && t.dispatchEvent(c());
          }
        }

        var m = i;

        function v(t) {
          t && (m = t);
        }

        function h(t, e) {
          var _this2 = this;

          var n = e.masks.slice().sort(function (t, e) {
            _newArrowCheck(this, _this2);

            return t.length - e.length;
          }.bind(this)),
              r = function r(t) {
            _newArrowCheck(this, _this2);

            return Object.assign({}, e, t);
          }.bind(this),
              o = function o(e, n) {
            _newArrowCheck(this, _this2);

            var o = b(t, r({
              mask: n
            })),
                i = e.unmasked.length,
                a = o.unmasked.length;
            return a > i ? o : e;
          }.bind(this);

          if (!n.length) return new u();
          var i = n.shift();
          var a = b(t, r({
            mask: i
          }));

          while (n.length) {
            var _t2 = n.shift();

            a = o(a, _t2);
          }

          return a;
        }

        function b(t, e) {
          var _e$mask = e.mask,
              n = _e$mask === void 0 ? "" : _e$mask,
              r = e.tokens,
              _e$prefill = e.prefill,
              o = _e$prefill === void 0 ? !1 : _e$prefill,
              _e$short = e.short,
              i = _e$short === void 0 ? !1 : _e$short;
          r = r ? Object.assign({}, m, r) : m;
          var a = new u(),
              c = !1,
              f = 0,
              s = 0,
              l = "";

          while (s < n.length) {
            var _e2 = n[s],
                _o = r[_e2];
            var _i = t[f];
            if (!_i && _o) break;

            if (_o && !c) {
              if (_o.escape) {
                c = !0, s++;
                continue;
              }

              _o.pattern.test(_i) && (_i = _o.transform ? _o.transform(_i) : _i, a.unmasked += _i, a.masked += l + _i, l = "", s++), f++;
            } else l += _e2, (_i && _i.toLocaleLowerCase()) === (_e2 && _e2.toLocaleLowerCase()) && (f++, _o && !c || (a.masked += l, l = "")), c = !1, s++;
          }

          return (o && !a.unmasked || !i && a.unmasked) && (a.masked += l), a;
        }

        function g(t, e) {
          return t = (t || "").toString(), e = f(e), e.mask ? Array.isArray(e.mask) ? h(t, Object.assign({}, e, {
            masks: e.mask
          })) : b(t, e) : new u(t);
        }

        var y = a;

        var x = {
          bind: function bind(t, _ref2, r) {
            var e = _ref2.value,
                n = _ref2.modifiers;

            _newArrowCheck(this, _this);

            t = s(t);
            var o = f(e, n);
            t[y] = {
              config: o
            }, d(t, r, {
              force: o.prefill
            });
          }.bind(this),
          inserted: function inserted(t) {
            var _this3 = this;

            _newArrowCheck(this, _this);

            t = s(t);

            var e = t[y],
                n = t.parentElement || t,
                r = function r(e) {
              _newArrowCheck(this, _this3);

              e.target === t && l(e);
            }.bind(this);

            n.addEventListener("input", r, !0), e.cleanup = function () {
              _newArrowCheck(this, _this3);

              return n.removeEventListener("input", r, !0);
            }.bind(this);
          }.bind(this),
          update: function update(t, _ref3, o) {
            var e = _ref3.value,
                n = _ref3.oldValue,
                r = _ref3.modifiers;

            _newArrowCheck(this, _this);

            t = s(t), e !== n ? (t[y].config = f(e, r), d(t, o, {
              force: !0
            })) : d(t, o);
          }.bind(this),
          unbind: function unbind(t) {
            _newArrowCheck(this, _this);

            s(t)[y].cleanup();
          }.bind(this)
        },
            k = function k() {
          var t = this,
              e = t.$createElement,
              n = t._self._c || e;
          return n("input", {
            directives: [{
              name: "facade",
              rawName: "v-facade",
              value: t.config,
              expression: "config"
            }],
            attrs: {
              type: "text"
            },
            domProps: {
              value: t.maskedValue
            },
            on: {
              input: t.onInput,
              change: t.onChange,
              blur: function blur(e) {
                return t.$emit("blur");
              },
              focus: function focus(e) {
                return t.$emit("focus");
              }
            }
          });
        },
            w = [],
            j = {
          name: "InputFacade",
          props: {
            formatter: Function,
            lazy: {
              type: Boolean,
              default: !1
            },
            mask: [String, Array],
            masked: {
              type: Boolean,
              default: !1
            },
            prefill: {
              type: Boolean,
              default: !1
            },
            short: {
              type: Boolean,
              default: !1
            },
            tokens: Object,
            value: [String, Number]
          },
          directives: {
            facade: x
          },
          data: function data() {
            return {
              maskedValue: this.value,
              unmaskedValue: null
            };
          },
          watch: {
            value: function value(t) {
              t !== this.emittedValue && (this.maskedValue = t);
            },
            mask: function mask(t) {
              t || (this.maskedValue = this.unmaskedValue);
            },
            masked: function masked() {
              this.emitInput();
            }
          },
          computed: {
            config: function config() {
              return {
                mask: this.mask,
                tokens: this.tokens,
                formatter: this.formatter,
                prefill: this.prefill,
                short: this.short
              };
            },
            emittedValue: function emittedValue() {
              return this.mask && this.masked ? this.maskedValue : this.unmaskedValue;
            }
          },
          methods: {
            onInput: function onInput(_ref4) {
              var t = _ref4.target;
              this.maskedValue = t.value, this.unmaskedValue = t.unmaskedValue, this.lazy || this.emitInput();
            },
            onChange: function onChange() {
              this.$emit("change", this.emittedValue), this.lazy && this.emitInput();
            },
            emitInput: function emitInput() {
              this.$emit("input", this.emittedValue);
            }
          }
        },
            O = j;

        function S(t, e, n, r, o, i, a, u) {
          var c,
              f = "function" === typeof t ? t.options : t;
          if (e && (f.render = e, f.staticRenderFns = n, f._compiled = !0), r && (f.functional = !0), i && (f._scopeId = "data-v-" + i), a ? (c = function c(t) {
            t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" === typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(a);
          }, f._ssrRegister = c) : o && (c = u ? function () {
            o.call(this, (f.functional ? this.parent : this).$root.$options.shadowRoot);
          } : o), c) if (f.functional) {
            f._injectStyles = c;
            var s = f.render;

            f.render = function (t, e) {
              return c.call(e), s(t, e);
            };
          } else {
            var l = f.beforeCreate;
            f.beforeCreate = l ? [].concat(l, c) : [c];
          }
          return {
            exports: t,
            options: f
          };
        }

        var _ = S(O, k, w, !1, null, null, null),
            E = _.exports;

        function V(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.tokens && v(e.tokens), t.component(E.name, E), t.directive(e.name || "facade", x), t.filter(e.name || "facade", T);
        }

        function T(t, e) {
          return g(t, e).masked;
        }

        var C = V;
        "undefined" !== typeof window && window.Vue && window.Vue.use(V);
        e["default"] = C;
      },
      fc6a: function fc6a(t, e, n) {
        var r = n("44ad"),
            o = n("1d80");

        t.exports = function (t) {
          return r(o(t));
        };
      }
    });
  });
});

var _this$K = null;
/**
 * Default mask tokens
 *
 * @type {object}
 */

var defaultMaskTokens = {
  '#': {
    pattern: /\d/
  },
  X: {
    pattern: /[0-9a-zA-Z]/
  },
  S: {
    pattern: /[a-zA-Z]/
  },
  A: {
    pattern: /[a-zA-Z]/,
    transform: function transform(v) {
      _newArrowCheck(this, _this$K);

      return v.toLocaleUpperCase();
    }.bind(null)
  },
  a: {
    pattern: /[a-zA-Z]/,
    transform: function transform(v) {
      _newArrowCheck(this, _this$K);

      return v.toLocaleLowerCase();
    }.bind(null)
  },
  '!': {
    escape: true
  }
};
/**
 * Merge mask tokens
 *
 * @param {object} tokens
 * @returns {object}
 */

var mergeTokens = function mergeTokens(tokens) {
  var _this2 = this;

  _newArrowCheck(this, _this$K);

  var defaults = _objectSpread2({}, defaultMaskTokens);

  return Object.entries(tokens).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        token = _ref2[0],
        options = _ref2[1];

    _newArrowCheck(this, _this2);

    return [token, options instanceof RegExp ? {
      pattern: options
    } : options];
  }.bind(this)).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        token = _ref4[0],
        options = _ref4[1];

    _newArrowCheck(this, _this2);

    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, token, options));
  }.bind(this), defaults);
}.bind(null);

var _this$J = null;
var style$N = createStyle('group-item');
var breakpoints$1 = Object.keys(gridBreakpoints);
var uiGroupItem = {
  name: 'ui-group-item',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    stretch: {
      type: [Boolean, String],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$J);

        return typeof v === 'boolean' || breakpoints$1.includes(v);
      }.bind(null)
    }
  },
  render: function render(h, _ref) {
    var _this2 = this;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, a(data, {
      staticClass: style$N(),
      class: _objectSpread2({
        '-stretch': props.stretch === true
      }, breakpoints$1.reduce(function (acc, key) {
        _newArrowCheck(this, _this2);

        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "-stretch-".concat(key), props.stretch === key));
      }.bind(this), {})),
      attrs: {
        'data-group-item': ''
      }
    }), children);
  }
};

var _excluded$3 = ["input"];

var _this$I = null;
var uiInputMasked = {
  name: 'ui-input-masked',
  directives: {
    facade: vueInputFacade_umd_min.facade
  },
  props: {
    value: [String, Number],
    mask: {
      type: [String, Array],
      required: true
    },
    masked: {
      type: Boolean,
      default: false
    },
    tokens: {
      type: Object,
      default: function _default() {
        _newArrowCheck(this, _this$I);

        return _objectSpread2({}, defaultMaskTokens);
      }.bind(null)
    }
  },
  data: function data() {
    return {
      lastValue: null,
      display: this.value
    };
  },
  computed: {
    config: function config() {
      return {
        mask: this.mask,
        tokens: this.tokens,
        masked: this.masked
      };
    }
  },
  watch: {
    value: function value(newValue) {
      if (newValue !== this.lastValue) {
        this.display = newValue;
      }
    },
    masked: function masked() {
      this.refresh(this.display);
    },
    display: {
      immediate: true,
      handler: function handler(v) {
        this.$emit('formatted-input', v);
      }
    }
  },
  methods: {
    onInput: function onInput(e) {
      if (!e.isTrusted) {
        this.refresh(e.target.value);
      }
    },
    refresh: function refresh(v) {
      this.display = v;
      var value = vueInputFacade_umd_min.masker(v, this.config)[this.masked ? 'masked' : 'unmasked'];

      if (value !== this.lastValue) {
        this.lastValue = value;
        this.$emit('input', value);
      }
    }
  },
  render: function render(h) {
    var _this2 = this;

    var _this$$listeners = this.$listeners;
        _this$$listeners.input;
        var listeners = _objectWithoutProperties(_this$$listeners, _excluded$3);

    return h('input', {
      directives: [{
        name: 'facade',
        value: this.config
      }],
      attrs: this.$attrs,
      domProps: {
        value: this.display
      },
      on: _objectSpread2({
        input: function input(e) {
          _newArrowCheck(this, _this2);

          return this.onInput(e);
        }.bind(this)
      }, listeners)
    });
  }
};

var style$L = createStyle('input');
var style$M = {
  value: style$L(),
  focused: '-focused',
  large: '-large',
  disabled: '-disabled',
  error: '-error',
  warning: '-warning',
  field: style$L('field')(),
  wrapper: {
    value: style$L('wrapper')(),
    readonly: '-read-only'
  },
  label: {
    value: style$L('label')(),
    active: '-active'
  },
  message: style$L('message')(),
  messageWrapper: style$L('message-wrapper')(),
  placeholder: {
    value: style$L('placeholder')(),
    hidden: style$L('hidden')()
  },
  icon: {
    value: style$L('icon')(),
    hidden: '-hidden',
    loading: '-loading'
  },
  range: {
    value: style$L('range')()
  },
  progress: {
    value: style$L('range-progress')(),
    disabled: '-disabled'
  }
};

var _this$H = null;
/**
 * @todo Refactoring
 */

var uiInput$1 = {
  name: 'ui-input',
  mixins: [Labelable, Messageable, Stateable, Testable, factory$2({
    validateOn: 'blur'
  })],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator: function validator(value) {
        _newArrowCheck(this, _this$H);

        return ['text', 'number', 'email', 'password', 'tel', 'url', 'search' // 'range',
        ].includes(value);
      }.bind(null)
    },
    mode: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$H);

        return ['text', 'numeric', 'decimal', 'tel', 'search', 'email', 'url'].includes(v);
      }.bind(null)
    },
    placeholder: {
      type: String,
      default: null
    },
    large: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: [String, Number],
      default: null
    },
    max: {
      type: [String, Number],
      default: null
    },
    step: {
      type: [String, Number],
      default: null
    },
    size: {
      type: [String, Number],
      default: null
    },
    maxSize: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$H);

        return !Number.isNaN(parseInt(v, 10)) && v > 0;
      }.bind(null)
    },
    maxLength: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$H);

        return !Number.isNaN(parseInt(v, 10)) && v > 0;
      }.bind(null)
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconCb: {
      type: Function,
      default: null
    },
    mask: {
      type: [String, Array],
      default: null,
      validator: function validator(value) {
        var _this2 = this;

        _newArrowCheck(this, _this$H);

        return Array.isArray(value) ? value.every(function (mask) {
          _newArrowCheck(this, _this2);

          return typeof mask === 'string';
        }.bind(this)) : true;
      }.bind(null)
    },
    maskTokens: {
      type: Object,
      default: function _default() {
        _newArrowCheck(this, _this$H);

        return {};
      }.bind(null)
    },
    maskPlaceholder: {
      type: [Boolean, String],
      default: false
    },
    returnMaskedValue: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    role: {
      type: String,
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$H);

    return {
      innerValue: '',
      isFocused: false // range: 0,

    };
  }.bind(null),
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$M.value, true), _defineProperty(_ref, style$M.focused, this.isFocused), _defineProperty(_ref, style$M.large, this.large), _defineProperty(_ref, style$M.disabled, this.disabled), _defineProperty(_ref, style$M.error, this.isErrorState || this.validationError), _defineProperty(_ref, style$M.warning, this.isWarningState), _ref;
    },
    directives: function directives() {
      return [];
    },
    inputClasses: function inputClasses() {
      return _defineProperty({}, style$M.field, true);
    },
    contentClasses: function contentClasses() {
      var _ref3;

      return _ref3 = {}, _defineProperty(_ref3, style$M.wrapper.value, true), _defineProperty(_ref3, style$M.wrapper.readonly, this.readOnly), _ref3;
    },
    iconClasses: function iconClasses() {
      return {};
    },
    maskPlaceholderClasses: function maskPlaceholderClasses() {
      return {};
    },
    inputElement: function inputElement() {
      var input = this.$refs.input;
      return input ? input.$el || input : null;
    },
    inputDOMProps: function inputDOMProps() {
      return {
        value: this.value
      };
    },
    isInputTypeEmail: function isInputTypeEmail() {
      return this.type === 'email';
    },
    isInputTypeNumber: function isInputTypeNumber() {
      return this.type === 'number';
    },
    // isInputTypeRange() {
    //   return this.type === 'range';
    // },
    isInputFilled: function isInputFilled() {
      if (this.value === null || this.value === undefined) {
        return false;
      }

      return !!String(this.inputDOMProps.value).length;
    },
    inputSize: function inputSize() {
      if (this.isInputTypeNumber) {
        return null;
      }

      var size = this.size;

      if (size && this.maxSize) {
        var length = this.value ? String(this.value).length : 0;
        size = Math.min(Math.max(size, length), this.maxSize);
      }

      return size;
    },
    computedType: function computedType() {
      if (this.isInputTypeEmail) {
        return 'text';
      } // if (this.isInputTypeRange) {
      //   return 'number';
      // }


      return this.type;
    },
    inputAttributes: function inputAttributes() {
      return _objectSpread2({
        id: this.id || this.labelHash,
        type: this.computedType,
        name: this.name,
        inputmode: this.isInputTypeEmail ? 'email' : this.mode,
        placeholder: this.placeholder,
        size: this.inputSize,
        maxLength: this.maxLength,
        min: this.isInputTypeNumber ? this.min : null,
        max: this.isInputTypeNumber ? this.max : null,
        step: this.isInputTypeNumber ? this.step : null,
        autocomplete: this.autocomplete,
        disabled: this.disabled,
        readonly: this.readOnly,
        role: this.role
      }, this.qaAttributes);
    },
    inputHandlers: function inputHandlers() {
      var _this3 = this;

      return {
        input: function input(e) {
          _newArrowCheck(this, _this3);

          return this.inputHandler(e);
        }.bind(this),
        'formatted-input': function formattedInput(e) {
          _newArrowCheck(this, _this3);

          return this.formattedInputHandler(e);
        }.bind(this),
        change: function change(e) {
          _newArrowCheck(this, _this3);

          return this.changeHandler(e);
        }.bind(this),
        focus: function focus(e) {
          _newArrowCheck(this, _this3);

          return this.focusHandler(e);
        }.bind(this),
        blur: function blur(e) {
          _newArrowCheck(this, _this3);

          return this.blurHandler(e);
        }.bind(this),
        keyup: function keyup(e) {
          _newArrowCheck(this, _this3);

          return this.keyUpHandler(e);
        }.bind(this),
        keydown: function keydown(e) {
          _newArrowCheck(this, _this3);

          return this.keyDownHandler(e);
        }.bind(this),
        keypress: function keypress(e) {
          _newArrowCheck(this, _this3);

          return this.keyPressHandler(e);
        }.bind(this),
        paste: function paste(e) {
          _newArrowCheck(this, _this3);

          return this.pasteHandler(e);
        }.bind(this)
      };
    },

    /**
     * Could be implemented in extended component
     *
     * @protected
     */
    maskedInputProps: function maskedInputProps() {
      return {
        value: this.inputDOMProps.value,
        mask: this.mask,
        tokens: this.tokens,
        masked: this.returnMaskedValue
      };
    },
    tokens: function tokens() {
      return mergeTokens(this.maskTokens);
    },
    computedMaskPlaceholder: function computedMaskPlaceholder() {
      if (!this.mask || !this.maskPlaceholder) {
        return null;
      }

      return typeof this.maskPlaceholder === 'string' ? this.maskPlaceholder : this.placeholder || '';
    },

    /**
     * Could be implemented in extended component
     *
     * @protected
     */
    maskPlaceholderValue: function maskPlaceholderValue() {
      var _this$innerValue;

      if (!this.computedMaskPlaceholder) {
        return null;
      }

      var v = String((_this$innerValue = this.innerValue) !== null && _this$innerValue !== void 0 ? _this$innerValue : '');
      return this.computedMaskPlaceholder.length === v.length ? null : {
        hidden: v,
        visible: this.computedMaskPlaceholder.substr(v.length)
      };
    },

    /**
     * Could be implemented in extended component
     *
     * @protected
     */
    showMaskPlaceholder: function showMaskPlaceholder() {
      return this.computedMaskPlaceholder && (this.isInputFilled || this.isFocused && !this.placeholder);
    },
    inputDirectives: function inputDirectives() {
      return [];
    },
    isLabelActive: function isLabelActive() {
      return this.isInputFilled || !!this.placeholder || this.isFocused;
    },
    labelOptions: function labelOptions() {
      var _class;

      return {
        ref: 'label',
        class: (_class = {}, _defineProperty(_class, style$M.label.value, true), _defineProperty(_class, style$M.label.active, this.isLabelActive), _class),
        attrs: {
          for: this.id || this.labelHash
        }
      };
    },
    messageOptions: function messageOptions() {
      return {
        key: 'message',
        staticClass: style$M.message
      };
    }
  },
  methods: {
    fireModelUpdate: function fireModelUpdate(v) {
      this.$emit('input', v);
    },

    /**
     * Проверяет не поменял ли браузер внутреннее значение инпута при загрузке страницы.
     * Если поменял, то восстанавливает модель компонента, основываясь на значении в инпуте.
     *
     * @protected Может быть переопределено в компонентах, которые наследуют uiInput
     */
    restoreModel: function restoreModel() {
      if (this.inputElement.value !== this.value) {
        this.inputHandler({
          target: this.inputElement
        });
      }
    },

    /**
     * Модифицирует полученное значение перед тем как обновить модель
     *
     * @param {Event | *} e
     * @return {*}
     */
    modifyModel: function modifyModel(e) {
      return this.mask ? e : e.target.value;
    },

    /**
     * @param {Event | string | number} e
     */
    inputHandler: function inputHandler(e) {
      this.fireModelUpdate(this.modifyModel(e));
    },
    formattedInputHandler: function formattedInputHandler(v) {
      this.innerValue = v;
    },
    changeHandler: function changeHandler(e) {
      this.$emit('change', e.target.value);
    },
    focus: function focus() {
      if (this.inputElement instanceof HTMLInputElement) {
        this.inputElement.focus();
      }
    },
    focusHandler: function focusHandler(e) {
      if (this.readOnly) {
        e.preventDefault();
        return;
      }

      this.isFocused = true;
      this.$emit('focus', e);
    },
    blur: function blur() {
      if (this.inputElement) {
        this.inputElement.blur();
      }
    },
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },

    /**
     * @param {KeyboardEvent} e
     */
    keyUpHandler: function keyUpHandler(e) {
      this.$emit('keyup', e); // eslint-disable-next-line default-case

      switch (e.keyCode) {
        case keyCodes.esc:
          {
            this.escapeHandler();
            break;
          }

        case keyCodes.up:
          {
            this.arrowUpHandler(e);
            break;
          }

        case keyCodes.down:
          {
            this.arrowDownHandler(e);
            break;
          }

        case keyCodes.enter:
          {
            this.submitHandler(e);
            break;
          }
      }
    },

    /**
     * @param {KeyboardEvent} e
     */
    keyPressHandler: function keyPressHandler(e) {
      var contentSelected = window.getSelection().toString();

      if (this.isInputTypeNumber) {
        if (!/(\d|,|\.|-|e)/.test(e.key)) {
          e.preventDefault(); // eslint-disable-next-line max-len
        } else if (this.maxLength && parseInt(this.maxLength, 10) === String(e.target.value).length && !contentSelected) {
          e.preventDefault();
        }
      }

      this.$emit('keypress', e);
    },

    /**
     * @param {KeyboardEvent} e
     */
    keyDownHandler: function keyDownHandler(e) {
      this.$emit('keydown', e);
    },
    clearModel: function clearModel() {
      this.fireModelUpdate('');
    },
    escapeHandler: function escapeHandler() {
      this.clearModel();
      this.$emit('clear');
    },
    arrowUpHandler: function arrowUpHandler() {},
    arrowDownHandler: function arrowDownHandler() {},
    submitHandler: function submitHandler() {
      this.$emit('submit');
    },

    /**
     * @param {ClipboardEvent} e
     */
    pasteHandler: function pasteHandler(e) {
      if (this.isInputTypeNumber) {
        e.preventDefault();
        var value = e.clipboardData.getData('text').replace(/[^0-9\-.,]/gi, '');
        this.fireModelUpdate(value);
      }
    },

    /**
     * @protected Could be implemented in child component
     */
    iconClickHandler: function iconClickHandler() {},
    // checkRequiredPropsForTypeRange() {
    //   if (this.isInputTypeRange) {
    //     if (typeof this.min !== 'number') {
    //       throw new FrameworkError('Missing required property "min"');
    //     }
    //
    //     if (typeof this.max !== 'number') {
    //       throw new FrameworkError('Missing required property "max"');
    //     }
    //   }
    // },
    genInputWrapper: function genInputWrapper(content) {
      return this.$createElement(uiGroupItem, {
        class: this.classes,
        directives: this.directives
      }, content);
    },

    /**
     * @param content
     * @return {VNode}
     */
    genContentWrapper: function genContentWrapper(content) {
      return this.$createElement('div', {
        class: this.contentClasses,
        ref: 'contentWrapper'
      }, content);
    },

    /**
     * @protected
     * @return {null | VNode}
     */
    genInputPrefix: function genInputPrefix() {
      return null;
    },
    genInput: function genInput() {
      return this.$createElement('input', {
        key: 'input',
        ref: 'input',
        class: this.inputClasses,
        domProps: this.inputDOMProps,
        attrs: this.inputAttributes,
        on: this.inputHandlers,
        directives: this.inputDirectives
      });
    },
    genMaskedInput: function genMaskedInput() {
      return this.$createElement(uiInputMasked, {
        key: 'input',
        ref: 'input',
        class: this.inputClasses,
        props: this.maskedInputProps,
        attrs: this.inputAttributes,
        on: this.inputHandlers,
        directives: this.inputDirectives
      });
    },
    genMaskPlaceholder: function genMaskPlaceholder() {
      if (!this.showMaskPlaceholder || !this.maskPlaceholderValue) {
        return null;
      }

      return this.$createElement('div', {
        key: 'placeholder',
        ref: 'placeholder',
        staticClass: style$M.placeholder.value,
        class: this.maskPlaceholderClasses
      }, [this.genMaskPlaceholderHiddenPart(), this.maskPlaceholderValue.visible]);
    },
    genMaskPlaceholderHiddenPart: function genMaskPlaceholderHiddenPart() {
      var hidden = this.maskPlaceholderValue.hidden;
      return hidden ? this.$createElement('i', {
        staticClass: style$M.placeholder.hidden
      }, [hidden]) : null;
    },
    // genRangeSelector() {
    //   if (!this.isInputTypeRange) {
    //     return null;
    //   }
    //
    //   return this.$createElement('input', {
    //     staticClass: style.range.value,
    //     class: {
    //       [style.focused]: this.isFocused,
    //     },
    //     domProps: {
    //       value: this.range,
    //     },
    //     attrs: {
    //       type: 'range',
    //       min: this.min ?? 0,
    //       max: this.max,
    //       step: this.step ?? 1,
    //     },
    //     on: {
    //       input: (e) => {
    //         this.range = e.target.value;
    //       },
    //     },
    //   });
    // },
    // genRangeProgress() {
    //   if (!this.isInputTypeRange) {
    //     return null;
    //   }
    //
    //   return this.$createElement('div', {
    //     staticClass: style.range.progress,
    //     style: {},
    //   });
    // },
    genIconWrapper: function genIconWrapper(content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.$createElement('span', _objectSpread2({
        key: 'icon',
        staticClass: style$M.icon.value
      }, options), [content]);
    },
    genClearIcon: function genClearIcon() {
      var _this4 = this;

      if (!this.clearable || this.disabled) {
        return null;
      }

      return this.genIconWrapper([this.$createElement(uiIcon, {
        props: {
          name: 'cross',
          interactive: true
        }
      })], {
        class: _defineProperty({}, style$M.icon.hidden, !this.isInputFilled),
        on: {
          click: function click() {
            _newArrowCheck(this, _this4);

            return this.escapeHandler();
          }.bind(this)
        }
      });
    },
    genLoadingIcon: function genLoadingIcon() {
      return this.genIconWrapper([this.$createElement(uiIcon, {
        props: {
          name: 'spinner'
        }
      })], {
        class: _defineProperty({}, style$M.icon.loading, true)
      });
    },
    genIcon: function genIcon() {
      var _this5 = this;

      if (this.$slots.icon) {
        return this.genIconWrapper([this.$slots.icon], {
          class: this.iconClasses
        });
      }

      if (this.icon) {
        var hasCallback = typeof this.iconCb === 'function';
        return this.genIconWrapper([this.$createElement(uiIcon, {
          props: {
            name: this.icon,
            interactive: hasCallback,
            disabled: this.disabled
          }
        })], {
          class: this.iconClasses,
          on: {
            click: function click(e) {
              _newArrowCheck(this, _this5);

              if (hasCallback) {
                this.iconCb(e);
              }

              this.iconClickHandler(e);
            }.bind(this)
          }
        });
      }

      return null;
    },
    genIconSlot: function genIconSlot() {
      if (this.loading) {
        return this.genLoadingIcon();
      }

      if (this.clearable) {
        return this.genClearIcon();
      }

      return this.genIcon();
    }
  },
  created: function created() {// this.checkRequiredPropsForTypeRange();
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.autofocus) {
      this.$nextTick(function () {
        _newArrowCheck(this, _this6);

        return this.focus();
      }.bind(this));
    }

    if (this.autocomplete !== 'off') {
      onBrowserReady(function () {
        _newArrowCheck(this, _this6);

        return this.restoreModel();
      }.bind(this));
    }
  },
  render: function render() {
    return this.genInputWrapper([this.genLabel(), this.genContentWrapper([this.genMaskPlaceholder(), this.genInputPrefix(), this.maskedInputProps.mask ? this.genMaskedInput() : this.genInput(), this.genIconSlot() // this.genRangeSelector(),
    // this.genRangeProgress(),
    ]), this.genMessage(this.validationError)]);
  }
};

var uiInput = generatePlugin(uiInput$1);

var defaultValue = '+7 (';
var uiInputPhone = {
  name: 'ui-input-phone',
  extends: uiInput,
  props: {
    type: {
      type: String,
      default: 'tel'
    },
    mode: {
      type: String,
      default: 'tel'
    },
    mask: {
      type: [String, Array],
      default: '+# (###) ###-##-##'
    }
  },
  methods: {
    formattedInputHandler: function formattedInputHandler() {},
    focusHandler: function focusHandler(e) {
      uiInput.methods.focusHandler.call(this, e);

      if (!e.target.value) {
        e.target.value = defaultValue;
      }
    },
    blurHandler: function blurHandler(e) {
      uiInput.methods.blurHandler.call(this, e);

      if (e.target.value === defaultValue) {
        e.target.value = '';

        if (this.value) {
          this.$emit('input', '');
        }
      }
    }
  }
};

var index$y = generatePlugin(uiInputPhone);

/**
 * Vue Currency Input 1.22.6
 * (c) 2018-2021 Matthias Stiller
 * @license MIT
 */
var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

var removeLeadingZeros = function removeLeadingZeros(str) {
  return str.replace(/^0+(0$|[^0])/, '$1');
};

var count = function count(str, search) {
  return (str.match(new RegExp(escapeRegExp(search), 'g')) || []).length;
};

var startsWith = function startsWith(str, search) {
  return str.substring(0, search.length) === search;
};

var substringBefore = function substringBefore(str, search) {
  return str.substring(0, str.indexOf(search));
};

var DECIMAL_SYMBOLS = [',', '.', '٫'];
var INTEGER_PATTERN = '(0|[1-9]\\d*)';

var NumberFormat = function NumberFormat(options) {
  var currency = options.currency;
  var locale = options.locale;
  var precision = options.precision;
  var autoDecimalMode = options.autoDecimalMode;
  var valueAsInteger = options.valueAsInteger;
  var numberFormat = new Intl.NumberFormat(locale, typeof currency === 'string' ? {
    currency: currency,
    style: 'currency'
  } : {
    minimumFractionDigits: 1
  });
  var ps = numberFormat.format(123456);
  this.locale = locale;
  this.currency = currency;
  this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (i) {
    return i.toLocaleString(locale);
  });
  this.decimalSymbol = count(ps, this.digits[0]) ? ps.substr(ps.indexOf(this.digits[6]) + 1, 1) : undefined;
  this.groupingSymbol = ps.substr(ps.indexOf(this.digits[3]) + 1, 1);
  this.minusSymbol = substringBefore(Number(-1).toLocaleString(locale), this.digits[1]);

  if (this.decimalSymbol === undefined) {
    this.minimumFractionDigits = this.maximumFractionDigits = 0;
  } else if (typeof precision === 'number') {
    this.minimumFractionDigits = this.maximumFractionDigits = precision;
  } else if (_typeof(precision) === 'object' && !autoDecimalMode && !valueAsInteger) {
    this.minimumFractionDigits = precision.min || 0;
    this.maximumFractionDigits = precision.max !== undefined ? precision.max : 20;
  } else if (typeof currency === 'string') {
    this.minimumFractionDigits = numberFormat.resolvedOptions().minimumFractionDigits;
    this.maximumFractionDigits = numberFormat.resolvedOptions().maximumFractionDigits;
  } else {
    this.minimumFractionDigits = this.maximumFractionDigits = 2;
  }

  if (typeof currency === 'string') {
    this.prefix = substringBefore(ps, this.digits[1]);
    this.negativePrefix = substringBefore(numberFormat.format(-1), this.digits[1]);
    this.suffix = ps.substring(ps.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[6]) + 1);
  } else {
    this.prefix = (currency || {}).prefix || '';
    this.negativePrefix = "" + this.minusSymbol + this.prefix;
    this.suffix = (currency || {}).suffix || '';
  }
};

NumberFormat.prototype.parse = function parse(str, valueAsInteger) {
  if (valueAsInteger === void 0) valueAsInteger = false;

  if (str) {
    var negative = this.isNegative(str);
    str = this.normalizeDigits(str);
    str = this.stripCurrencySymbol(str);
    str = this.stripMinusSymbol(str);
    var fraction = this.decimalSymbol ? "(?:" + escapeRegExp(this.decimalSymbol) + "(\\d*))?" : '';
    var match = this.stripGroupingSymbol(str).match(new RegExp("^" + INTEGER_PATTERN + fraction + "$"));

    if (match && this.isValidIntegerFormat(str.split(this.decimalSymbol)[0], Number(match[1]))) {
      var number = Number("" + (negative ? '-' : '') + match[1] + "." + (match[2] || ''));
      return valueAsInteger ? Number(number.toFixed(this.maximumFractionDigits).split('.').join('')) : number;
    }
  }

  return null;
};

NumberFormat.prototype.isValidIntegerFormat = function isValidIntegerFormat(str, integerNumber) {
  var options = typeof this.currency === 'string' ? {
    style: 'currency',
    currency: this.currency,
    minimumFractionDigits: 0
  } : {};
  return [this.stripCurrencySymbol(this.normalizeDigits(integerNumber.toLocaleString(this.locale, Object.assign({}, options, {
    useGrouping: true
  })))), this.stripCurrencySymbol(this.normalizeDigits(integerNumber.toLocaleString(this.locale, Object.assign({}, options, {
    useGrouping: false
  }))))].includes(str);
};

NumberFormat.prototype.format = function format(number, options) {
  if (options === void 0) options = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  };

  if (typeof this.currency === 'string') {
    return number.toLocaleString(this.locale, Object.assign({}, {
      style: 'currency',
      currency: this.currency
    }, options));
  } else {
    return this.insertCurrencySymbol(Math.abs(number).toLocaleString(this.locale, options), number < 0 || number === 0 && 1 / number < 0);
  }
};

NumberFormat.prototype.toFraction = function toFraction(str) {
  return "" + this.digits[0] + this.decimalSymbol + this.onlyLocaleDigits(str.substr(1)).substr(0, this.maximumFractionDigits);
};

NumberFormat.prototype.isFractionIncomplete = function isFractionIncomplete(str) {
  return !!this.normalizeDigits(this.stripGroupingSymbol(str)).match(new RegExp("^" + INTEGER_PATTERN + escapeRegExp(this.decimalSymbol) + "$"));
};

NumberFormat.prototype.isNegative = function isNegative(str) {
  return startsWith(str, this.negativePrefix) || startsWith(str.replace('-', this.minusSymbol), this.minusSymbol);
};

NumberFormat.prototype.insertCurrencySymbol = function insertCurrencySymbol(str, negative) {
  return "" + (negative ? this.negativePrefix : this.prefix) + str + this.suffix;
};

NumberFormat.prototype.stripGroupingSymbol = function stripGroupingSymbol(str) {
  return str.replace(new RegExp(escapeRegExp(this.groupingSymbol), 'g'), '');
};

NumberFormat.prototype.stripMinusSymbol = function stripMinusSymbol(str) {
  return str.replace('-', this.minusSymbol).replace(this.minusSymbol, '');
};

NumberFormat.prototype.stripCurrencySymbol = function stripCurrencySymbol(str) {
  return str.replace(this.negativePrefix, '').replace(this.prefix, '').replace(this.suffix, '');
};

NumberFormat.prototype.normalizeDecimalSymbol = function normalizeDecimalSymbol(str, from) {
  var this$1$1 = this;
  DECIMAL_SYMBOLS.forEach(function (s) {
    str = str.substr(0, from) + str.substr(from).replace(s, this$1$1.decimalSymbol);
  });
  return str;
};

NumberFormat.prototype.normalizeDigits = function normalizeDigits(str) {
  if (this.digits[0] !== '0') {
    this.digits.forEach(function (digit, index) {
      str = str.replace(new RegExp(digit, 'g'), index);
    });
  }

  return str;
};

NumberFormat.prototype.onlyDigits = function onlyDigits(str) {
  return this.normalizeDigits(str).replace(/\D+/g, '');
};

NumberFormat.prototype.onlyLocaleDigits = function onlyLocaleDigits(str) {
  return str.replace(new RegExp("[^" + this.digits.join('') + "]*", 'g'), '');
};

var DEFAULT_OPTIONS = {
  locale: undefined,
  currency: 'EUR',
  valueAsInteger: false,
  distractionFree: true,
  precision: undefined,
  autoDecimalMode: false,
  valueRange: undefined,
  allowNegative: true
};

var _parse = function parse(formattedValue, options) {
  var mergedOptions = Object.assign({}, DEFAULT_OPTIONS, options);
  return new NumberFormat(mergedOptions).parse(formattedValue, mergedOptions.valueAsInteger);
};

var getValue$1 = function getValue(ref) {
  return (ref.$el || ref).$ci.getValue();
};

var setValue = function setValue(ref, value) {
  (ref.$el || ref).$ci.setValue(value);
};

var equal = function equal(a, b) {
  if (a === b) {
    return true;
  }

  if (!a || !b || _typeof(a) !== 'object' || _typeof(b) !== 'object') {
    return false;
  }

  var keys = Object.keys(a);

  if (keys.length !== Object.keys(b).length) {
    return false;
  }

  if (!keys.every(Object.prototype.hasOwnProperty.bind(b))) {
    return false;
  }

  return keys.every(function (key) {
    return equal(a[key], b[key]);
  });
};

var DefaultNumberMask = function DefaultNumberMask(numberFormat) {
  this.numberFormat = numberFormat;
};

DefaultNumberMask.prototype.conformToMask = function conformToMask(str, previousConformedValue) {
  var this$1$1 = this;
  if (previousConformedValue === void 0) previousConformedValue = '';
  var negative = this.numberFormat.isNegative(str);

  var checkIncompleteValue = function checkIncompleteValue(str) {
    if (str === '' && negative && previousConformedValue !== this$1$1.numberFormat.negativePrefix) {
      return '';
    } else if (this$1$1.numberFormat.maximumFractionDigits > 0) {
      if (this$1$1.numberFormat.isFractionIncomplete(str)) {
        return str;
      } else if (startsWith(str, this$1$1.numberFormat.decimalSymbol)) {
        return this$1$1.numberFormat.toFraction(str);
      }
    }

    return null;
  };

  var value = str;
  value = this.numberFormat.stripCurrencySymbol(value);
  value = this.numberFormat.stripMinusSymbol(value);
  var incompleteValue = checkIncompleteValue(value);

  if (incompleteValue != null) {
    return this.numberFormat.insertCurrencySymbol(incompleteValue, negative);
  }

  var ref = value.split(this.numberFormat.decimalSymbol);
  var integer = ref[0];
  var fraction = ref.slice(1);
  var integerDigits = removeLeadingZeros(this.numberFormat.onlyDigits(integer));
  var fractionDigits = this.numberFormat.onlyDigits(fraction.join('')).substr(0, this.numberFormat.maximumFractionDigits);
  var invalidFraction = fraction.length > 0 && fractionDigits.length === 0;
  var invalidNegativeValue = integerDigits === '' && negative && (previousConformedValue === str.slice(0, -1) || previousConformedValue !== this.numberFormat.negativePrefix);

  if (invalidFraction || invalidNegativeValue) {
    return previousConformedValue;
  } else if (integerDigits.match(/\d+/)) {
    return {
      numberValue: Number("" + (negative ? '-' : '') + integerDigits + "." + fractionDigits),
      fractionDigits: fractionDigits
    };
  } else {
    return '';
  }
};

var AutoDecimalModeNumberMask = function AutoDecimalModeNumberMask(numberFormat) {
  this.numberFormat = numberFormat;
};

AutoDecimalModeNumberMask.prototype.conformToMask = function conformToMask(str) {
  if (str === '') {
    return '';
  }

  var negative = this.numberFormat.isNegative(str);
  var numberValue = this.numberFormat.stripMinusSymbol(str) === '' ? -0 : Number("" + (negative ? '-' : '') + removeLeadingZeros(this.numberFormat.onlyDigits(str))) / Math.pow(10, this.numberFormat.minimumFractionDigits);
  return {
    numberValue: numberValue,
    fractionDigits: numberValue.toFixed(this.numberFormat.minimumFractionDigits).slice(-this.numberFormat.minimumFractionDigits)
  };
};

var getCaretPositionAfterFormat = function getCaretPositionAfterFormat(newValue, inputtedValue, caretPosition, numberFormat, options) {
  var prefix = numberFormat.prefix;
  var suffix = numberFormat.suffix;
  var decimalSymbol = numberFormat.decimalSymbol;
  var maximumFractionDigits = numberFormat.maximumFractionDigits;
  var groupingSymbol = numberFormat.groupingSymbol;
  var decimalSymbolPosition = inputtedValue.indexOf(decimalSymbol) + 1;
  var caretPositionFromLeft = inputtedValue.length - caretPosition;

  if (Math.abs(newValue.length - inputtedValue.length) > 1 && caretPosition <= decimalSymbolPosition) {
    return newValue.indexOf(decimalSymbol) + 1;
  } else if (newValue.substr(caretPosition, 1) === groupingSymbol && count(newValue, groupingSymbol) === count(inputtedValue, groupingSymbol) + 1) {
    return newValue.length - caretPositionFromLeft - 1;
  } else {
    if (!options.autoDecimalMode && decimalSymbolPosition !== 0 && caretPosition > decimalSymbolPosition) {
      if (numberFormat.onlyDigits(inputtedValue.substr(decimalSymbolPosition)).length - 1 === maximumFractionDigits) {
        caretPositionFromLeft -= 1;
      }
    }

    return options.distractionFree.hideCurrencySymbol ? newValue.length - caretPositionFromLeft : Math.max(newValue.length - Math.max(caretPositionFromLeft, suffix.length), prefix.length === 0 ? 0 : prefix.length + 1);
  }
};

var getDistractionFreeCaretPosition = function getDistractionFreeCaretPosition(numberFormat, options, value, caretPosition) {
  var result = caretPosition;

  if (options.distractionFree.hideCurrencySymbol) {
    result -= numberFormat.prefix.length;
  }

  if (options.distractionFree.hideGroupingSymbol) {
    result -= count(value.substring(0, caretPosition), numberFormat.groupingSymbol);
  }

  return Math.max(0, result);
};

var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

var NumberInput = function NumberInput(el, options, callbackFns) {
  this.el = el;
  this.callbackFns = callbackFns;
  this.numberValue = null;
  this.addEventListener();
  this.init(options);
  this.setValue(this.currencyFormat.parse(this.el.value));
};

NumberInput.prototype.init = function init(newOptions) {
  var options = Object.assign({}, newOptions);
  var distractionFree = options.distractionFree;
  var autoDecimalMode = options.autoDecimalMode;
  var valueRange = options.valueRange;

  if (typeof distractionFree === 'boolean') {
    options.distractionFree = {
      hideCurrencySymbol: distractionFree,
      hideNegligibleDecimalDigits: distractionFree,
      hideGroupingSymbol: distractionFree
    };
  }

  if (valueRange) {
    options.valueRange = {
      min: valueRange.min !== undefined ? Math.max(valueRange.min, -MAX_SAFE_INTEGER) : -MAX_SAFE_INTEGER,
      max: valueRange.max !== undefined ? Math.min(valueRange.max, MAX_SAFE_INTEGER) : MAX_SAFE_INTEGER
    };
  } else {
    options.valueRange = {
      min: -MAX_SAFE_INTEGER,
      max: MAX_SAFE_INTEGER
    };
  }

  if (autoDecimalMode) {
    options.distractionFree.hideNegligibleDecimalDigits = false;
    this.el.setAttribute('inputmode', 'numeric');
  } else {
    this.el.setAttribute('inputmode', 'decimal');
  }

  this.options = options;
  this.currencyFormat = new NumberFormat(this.options);
  this.numberMask = options.autoDecimalMode ? new AutoDecimalModeNumberMask(this.currencyFormat) : new DefaultNumberMask(this.currencyFormat);
};

NumberInput.prototype.setOptions = function setOptions(options) {
  this.init(options);
  this.applyFixedFractionFormat(this.numberValue, true);
};

NumberInput.prototype.applyFixedFractionFormat = function applyFixedFractionFormat(number, forcedChange) {
  this.format(number != null ? this.currencyFormat.format(this.validateValueRange(number)) : null);

  if (number !== this.numberValue || forcedChange) {
    this.callbackFns.onChange(this.getValue());
  }
};

NumberInput.prototype.getValue = function getValue() {
  return this.currencyFormat.parse(this.formattedValue, this.options.valueAsInteger);
};

NumberInput.prototype.setValue = function setValue(value) {
  var newValue = this.options.valueAsInteger && value != null ? value / Math.pow(10, this.currencyFormat.maximumFractionDigits) : value;

  if (newValue !== this.numberValue) {
    this.applyFixedFractionFormat(newValue);
  }
};

NumberInput.prototype.validateValueRange = function validateValueRange(value) {
  var ref = this.options.valueRange;
  var min = ref.min;
  var max = ref.max;
  return Math.min(Math.max(value, min), max);
};

NumberInput.prototype.updateInputValue = function updateInputValue(value, hideNegligibleDecimalDigits) {
  if (hideNegligibleDecimalDigits === void 0) hideNegligibleDecimalDigits = false;

  if (value != null) {
    if (this.decimalSymbolInsertedAt !== undefined) {
      value = this.currencyFormat.normalizeDecimalSymbol(value, this.decimalSymbolInsertedAt);
      this.decimalSymbolInsertedAt = undefined;
    }

    var conformedValue = this.numberMask.conformToMask(value, this.formattedValue);
    var formattedValue;

    if (_typeof(conformedValue) === 'object') {
      var numberValue = conformedValue.numberValue;
      var fractionDigits = conformedValue.fractionDigits;
      var ref = this.currencyFormat;
      var maximumFractionDigits = ref.maximumFractionDigits;
      var minimumFractionDigits = ref.minimumFractionDigits;

      if (this.focus) {
        minimumFractionDigits = maximumFractionDigits;
      }

      minimumFractionDigits = hideNegligibleDecimalDigits ? fractionDigits.replace(/0+$/, '').length : Math.min(minimumFractionDigits, fractionDigits.length);
      formattedValue = numberValue > MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(numberValue, {
        useGrouping: !(this.focus && this.options.distractionFree.hideGroupingSymbol),
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
      });
    } else {
      formattedValue = conformedValue;
    }

    if (!this.options.allowNegative) {
      formattedValue = formattedValue.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix);
    }

    if (this.focus && this.options.distractionFree.hideCurrencySymbol) {
      formattedValue = formattedValue.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSymbol).replace(this.currencyFormat.prefix, '').replace(this.currencyFormat.suffix, '');
    }

    this.el.value = formattedValue;
    this.numberValue = this.currencyFormat.parse(formattedValue);
  } else {
    this.el.value = this.numberValue = null;
  }

  this.formattedValue = this.el.value;
};

NumberInput.prototype.format = function format(value) {
  this.updateInputValue(value);
  this.callbackFns.onInput(this.getValue());
};

NumberInput.prototype.addEventListener = function addEventListener() {
  var this$1$1 = this;
  this.el.addEventListener('input', function () {
    var ref = this$1$1.el;
    var value = ref.value;
    var selectionStart = ref.selectionStart;
    this$1$1.format(value);

    if (this$1$1.focus) {
      this$1$1.setCaretPosition(getCaretPositionAfterFormat(this$1$1.formattedValue, value, selectionStart, this$1$1.currencyFormat, this$1$1.options));
    }
  }, {
    capture: true
  });
  this.el.addEventListener('focus', function () {
    this$1$1.focus = true;
    var ref = this$1$1.options.distractionFree;
    var hideCurrencySymbol = ref.hideCurrencySymbol;
    var hideGroupingSymbol = ref.hideGroupingSymbol;
    var hideNegligibleDecimalDigits = ref.hideNegligibleDecimalDigits;

    if (hideCurrencySymbol || hideGroupingSymbol || hideNegligibleDecimalDigits) {
      setTimeout(function () {
        var ref = this$1$1.el;
        var value = ref.value;
        var selectionStart = ref.selectionStart;
        var selectionEnd = ref.selectionEnd;

        if (value) {
          this$1$1.updateInputValue(this$1$1.el.value, hideNegligibleDecimalDigits);
        }

        if (Math.abs(selectionStart - selectionEnd) > 0) {
          this$1$1.setCaretPosition(0, this$1$1.el.value.length);
        } else {
          this$1$1.setCaretPosition(getDistractionFreeCaretPosition(this$1$1.currencyFormat, this$1$1.options, value, selectionStart));
        }
      });
    }
  });
  this.el.addEventListener('keypress', function (e) {
    if (DECIMAL_SYMBOLS.includes(e.key)) {
      this$1$1.decimalSymbolInsertedAt = this$1$1.el.selectionStart;
    }
  });
  this.el.addEventListener('blur', function () {
    this$1$1.focus = false;

    if (this$1$1.numberValue != null) {
      this$1$1.applyFixedFractionFormat(this$1$1.numberValue);
    }
  });
  this.el.addEventListener('change', function () {
    this$1$1.callbackFns.onChange(this$1$1.getValue());
  });
};

NumberInput.prototype.setCaretPosition = function setCaretPosition(start, end) {
  if (end === void 0) end = start;
  this.el.setSelectionRange(start, end);
};

var directive = {
  bind: function bind(el, ref, vnode) {
    var optionsFromBinding = ref.value;
    var inputElement = el.tagName.toLowerCase() === 'input' ? el : el.querySelector('input');

    if (!inputElement) {
      throw new Error('No input element found');
    }

    var options = Object.assign({}, DEFAULT_OPTIONS, (vnode.context.$ci || {}).globalOptions, optionsFromBinding);
    var listeners = vnode.data && vnode.data.on || vnode.componentOptions && vnode.componentOptions.listeners || {};

    var emit = function emit(event, data) {
      if (listeners[event]) {
        listeners[event](vnode.componentOptions ? data : {
          target: {
            value: data
          }
        });
      }
    };

    el.$ci = new NumberInput(inputElement, options, {
      onChange: function onChange() {
        emit('change', inputElement.value);
      },
      onInput: function onInput() {
        emit('input', inputElement.value);
      }
    });
  },
  componentUpdated: function componentUpdated(el, ref) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    if (!equal(value, oldValue)) {
      el.$ci.setOptions(value);
    }
  }
};
var component = {
  render: function render(h) {
    var this$1$1 = this;
    return h('input', {
      directives: [{
        name: 'currency',
        value: this.options
      }],
      on: Object.assign({}, this.$listeners, {
        change: function change() {
          this$1$1.$emit('change', getValue$1(this$1$1.$el));
        },
        input: function input() {
          var numberValue = getValue$1(this$1$1.$el);

          if (this$1$1.value !== numberValue) {
            this$1$1.$emit('input', numberValue);
          }
        }
      })
    });
  },
  directives: {
    currency: directive
  },
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: null
    },
    locale: {
      type: String,
      default: undefined
    },
    currency: {
      type: [String, Object],
      default: undefined
    },
    distractionFree: {
      type: [Boolean, Object],
      default: undefined
    },
    precision: {
      type: [Number, Object],
      default: undefined
    },
    autoDecimalMode: {
      type: Boolean,
      default: undefined
    },
    valueAsInteger: {
      type: Boolean,
      default: undefined
    },
    valueRange: {
      type: Object,
      default: undefined
    },
    allowNegative: {
      type: Boolean,
      default: undefined
    }
  },
  mounted: function mounted() {
    this.setValue(this.value);
  },
  computed: {
    options: function options() {
      var this$1$1 = this;
      var options = Object.assign({}, DEFAULT_OPTIONS, (this.$ci || {}).globalOptions);
      Object.keys(DEFAULT_OPTIONS).forEach(function (key) {
        if (this$1$1[key] !== undefined) {
          options[key] = this$1$1[key];
        }
      });
      return options;
    }
  },
  watch: {
    value: 'setValue'
  },
  methods: {
    setValue: function setValue$1(value) {
      setValue(this.$el, value);
    }
  }
};
var plugin$3 = {
  install: function install(Vue, ref) {
    if (ref === void 0) ref = {};
    var componentName = ref.componentName;
    if (componentName === void 0) componentName = component.name;
    var directiveName = ref.directiveName;
    if (directiveName === void 0) directiveName = 'currency';
    var globalOptions = ref.globalOptions;
    if (globalOptions === void 0) globalOptions = {};
    Vue.component(componentName, component);
    Vue.directive(directiveName, directive);
    Vue.prototype.$ci = {
      parse: function parse(formattedValue, options) {
        return _parse(formattedValue, Object.assign({}, globalOptions, options));
      },
      getValue: getValue$1,
      setValue: setValue,
      globalOptions: globalOptions
    };
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin$3);
}

var _this$G = null;
/**
 * @type {Readonly<{prefix: string[], suffix: string[]}>}
 */

var symbolSides = Object.freeze({
  prefix: ['usd', 'eur'],
  suffix: ['rub']
});
/**
 * @param {string} alias
 * @returns {string}
 */

var getCurrencySymbol = function getCurrencySymbol(alias) {
  _newArrowCheck(this, _this$G);

  return currencies[alias] || '';
}.bind(null);
/**
 * @param {string} alias
 * @returns {string | null}
 */


var getCurrencyPrefix = function getCurrencyPrefix(alias) {
  _newArrowCheck(this, _this$G);

  return symbolSides.prefix.includes(alias) ? getCurrencySymbol(alias) : null;
}.bind(null);
/**
 * @param {string} alias
 * @returns {string | null}
 */

var getCurrencySuffix = function getCurrencySuffix(alias) {
  _newArrowCheck(this, _this$G);

  return symbolSides.suffix.includes(alias) ? getCurrencySymbol(alias) : null;
}.bind(null);

var _this$F = null;
var style$K = createStyle('input-money');
/**
 * Money input
 *
 * @extends uiInput
 * @todo Переверстать префикс
 */

var uiInputMoney = {
  name: 'ui-input-money',
  extends: uiInput,
  directives: {
    currency: directive
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    mode: {
      type: String,
      default: 'decimals'
    },
    currency: {
      type: String,
      default: 'rub'
    },
    decimals: {
      type: String,
      default: 'auto',
      validator: function validator(v) {
        _newArrowCheck(this, _this$F);

        return ['auto', 'never', 'always'].includes(v);
      }.bind(null)
    },
    allowNegative: {
      type: Boolean,
      default: false
    },

    /**
     * @deprecated Use decimals="never"
     */
    withoutDecimals: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$F);

    return {
      formattedValue: ''
    };
  }.bind(null),
  watch: {
    value: function value(v) {
      if (!this.isFocused) {
        this.initModel(v);
      }
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, uiInput.computed.classes.call(this)), {}, _defineProperty({}, style$K(), true));
    },
    inputClasses: function inputClasses() {
      return _objectSpread2(_objectSpread2({}, uiInput.computed.inputClasses.call(this)), {}, _defineProperty({}, style$K('offset')(), this.hasPrefix));
    },
    inputDOMProps: function inputDOMProps() {
      return {
        value: this.formattedValue
      };
    },
    currencyDirectiveOptions: function currencyDirectiveOptions() {
      return {
        locale: 'sv-SE',
        currency: null,
        distractionFree: false,
        precision: this.withoutDecimals || this.decimals === 'never' ? 0 : this.decimals === 'auto' ? {
          min: 0,
          max: 2
        } : 2,
        allowNegative: this.allowNegative
      };
    },
    inputDirectives: function inputDirectives() {
      return [{
        name: 'currency',
        value: this.currencyDirectiveOptions
      }];
    },
    prefix: function prefix() {
      var prefix = getCurrencyPrefix(this.currency);
      return prefix ? "".concat(prefix, " ") : '';
    },
    hasPrefix: function hasPrefix() {
      return !!this.prefix;
    },
    suffix: function suffix() {
      var suffix = getCurrencySuffix(this.currency);
      return suffix ? " ".concat(suffix) : '';
    },
    showMaskPlaceholder: function showMaskPlaceholder() {
      return this.isFocused && !this.placeholder || this.isInputFilled;
    },
    maskPlaceholderValue: function maskPlaceholderValue() {
      var value = this.formattedValue;

      if (value.includes('.')) {
        value = value.replace('.', ',');
      } // eslint-disable-next-line max-len


      var disabled = this.decimals === 'never' || this.withoutDecimals || this.decimals === 'auto' && !value.includes(','); // eslint-disable-next-line max-len

      var enabled = this.decimals === 'always' || this.decimals === 'auto' && value.includes(',');

      if (value.length === 0) {
        return [this.prefix, '0', enabled ? ',00' : '', this.suffix].join('');
      }

      var decimals = enabled ? ',00' : '';
      var digits = value;

      if (value.includes(',')) {
        var parts = value.split(',');
        decimals = parts[1].padEnd(2, '0');
        digits = "".concat(parts[0], ",");
      } // eslint-disable-next-line max-len


      var placeholder = "".concat(digits).concat(disabled ? '' : decimals).concat(this.suffix);
      return {
        hidden: value,
        visible: placeholder.substr(value.length)
      };
    },
    maskPlaceholderClasses: function maskPlaceholderClasses() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$K('placeholder')(), this.isInputFilled && !this.isFocused), _defineProperty(_ref, '-disabled', this.disabled), _ref;
    }
  },
  methods: {
    initModel: function initModel(v) {
      if (v === null || v === undefined || v === '') {
        this.formattedValue = '';
        return;
      }

      if (this.returnMaskedValue) {
        this.formattedValue = v;
        return;
      }

      setValue(this.inputElement, this.value);
    },
    restoreModel: function restoreModel() {
      if (this.formattedValue !== this.inputElement.value) {
        this.inputHandler({
          target: this.inputElement
        });
      }
    },
    modifyModel: function modifyModel(e) {
      var value = e.target.value;
      var model = this.returnMaskedValue ? value : _parse(value, this.currencyDirectiveOptions);
      return {
        value: value,
        model: model
      };
    },
    inputHandler: function inputHandler(e) {
      var _this$modifyModel = this.modifyModel(e),
          value = _this$modifyModel.value,
          model = _this$modifyModel.model;

      this.formattedValue = value;
      this.fireModelUpdate(model);
    },
    formattedInputHandler: function formattedInputHandler() {},
    genMaskPlaceholderPrefix: function genMaskPlaceholderPrefix() {
      var _class;

      if (!this.hasPrefix) {
        return null;
      }

      return this.$createElement('span', {
        class: (_class = {}, _defineProperty(_class, style$K('prefix')(), true), _defineProperty(_class, '-disabled', this.disabled), _class)
      }, this.prefix);
    }
  },
  mounted: function mounted() {
    this.initModel(this.value);
    uiInput.mounted.call(this);
  }
};

var index$x = generatePlugin(uiInputMoney);

var _this$E = null;
/**
 * @type {number}
 */

var ACTIVE_INDEX_INITIAL_VALUE = -1;
/**
 * @param {*} value
 * @param {* | undefined | null} fallback
 * @return {* | null}
 */

var getValue = function getValue(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  _newArrowCheck(this, _this$E);

  return typeof value === 'undefined' ? fallback : value;
}.bind(null);

var Optionable = {
  props: {
    options: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$E);

        return [];
      }.bind(null)
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    optionName: {
      type: String,
      default: 'name'
    },
    optionDisabled: {
      type: String,
      default: 'disabled'
    },
    optionGroup: {
      type: String,
      default: 'group'
    },
    groups: {
      type: Object,
      default: function _default() {
        _newArrowCheck(this, _this$E);

        return {};
      }.bind(null)
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$E);

    return {
      activeIndex: ACTIVE_INDEX_INITIAL_VALUE
    };
  }.bind(null),
  computed: {
    /**
     * @return {boolean}
     */
    hasOptions: function hasOptions() {
      return !!this.options.length;
    },

    /**
     * @return {boolean}
     */
    hasGroupedOptions: function hasGroupedOptions() {
      return !!Object.keys(this.groups).length;
    },

    /**
     * @return {boolean}
     */
    hasActiveOption: function hasActiveOption() {
      return this.activeIndex > -1;
    },

    /**
     * @return {Object}
     */
    activeOption: function activeOption() {
      return this.findOption(this.activeIndex);
    },

    /**
     * Options
     *
     * @returns {Object[] | Array<Object>}
     */
    computedOptions: function computedOptions() {
      return this.options;
    }
  },
  methods: {
    /**
     * Finds option by index
     *
     * @param {number} index
     * @return {Object}
     */
    findOption: function findOption(index) {
      return this.computedOptions[index];
    },

    /**
     * Returns option's unique key if exists
     *
     * @param {Object} option
     * @return {string | number | null}
     */
    getOptionKeyField: function getOptionKeyField(option) {
      return getValue(option[this.optionKey]);
    },

    /**
     * Returns option's name if exists
     *
     * @param {Object} option
     * @return {string | null}
     */
    getOptionNameField: function getOptionNameField(option) {
      return getValue(option[this.optionName], '');
    },

    /**
     * Returns option's disabled state if given
     *
     * @param {Object} option
     * @return {boolean}
     */
    getOptionDisabledField: function getOptionDisabledField(option) {
      return getValue(option[this.optionDisabled], false);
    },

    /**
     * Returns option's group key if given
     *
     * @param {Object} option
     * @return {string | number | boolean | null}
     */
    getOptionGroupKeyField: function getOptionGroupKeyField(option) {
      var key = getValue(option[this.optionGroup]);
      return key ? String(key) : null;
    },

    /**
     * Returns group's title if exists
     *
     * @param {string | number} key
     * @return {string}
     */
    getGroupTitle: function getGroupTitle(key) {
      return getValue(this.groups[key], '');
    },

    /**
     * Returns option's index
     *
     * @param {Object} option
     * @return {number}
     */
    getOptionIndex: function getOptionIndex(option) {
      return this.computedOptions.indexOf(option);
    },

    /**
     * Returns group's options
     *
     * @param {string | number} key
     * @return {Array<Object>}
     */
    getGroupOptions: function getGroupOptions(key) {
      var _this2 = this;

      return [].concat(this.computedOptions).filter(function (option) {
        _newArrowCheck(this, _this2);

        return this.getOptionGroupKeyField(option) === key;
      }.bind(this));
    },

    /**
     * Returns option's $ref key
     *
     * @param {number | string} suffix
     * @returns {string}
     */
    getOptionReferenceKey: function getOptionReferenceKey(suffix) {
      return "option-".concat(suffix);
    },

    /**
     * Increment activeIndex
     */
    incrementIndex: function incrementIndex() {
      if (this.activeIndex === this.computedOptions.length - 1) {
        this.activeIndex = 0;
      } else {
        this.activeIndex += 1;

        if (this.getOptionDisabledField(this.activeOption)) {
          this.incrementIndex();
        }
      }
    },

    /**
     * Decrement activeIndex
     */
    decrementIndex: function decrementIndex() {
      if ([ACTIVE_INDEX_INITIAL_VALUE, 0].includes(this.activeIndex)) {
        this.activeIndex = this.computedOptions.length - 1;
      } else {
        this.activeIndex -= 1;

        if (this.getOptionDisabledField(this.activeOption)) {
          this.decrementIndex();
        }
      }
    },

    /**
     * Reset activeIndex to initial value
     */
    resetIndex: function resetIndex() {
      this.activeIndex = ACTIVE_INDEX_INITIAL_VALUE;
    },

    /**
     * Checks if option's index and activeIndex are same
     *
     * @param {Object} option
     * @return {boolean}
     */
    isOptionActive: function isOptionActive(option) {
      return this.getOptionIndex(option) === this.activeIndex;
    },

    /**
     * Scroll to active option
     *
     * @param {Element | HTMLElement} container
     */
    scrollToActiveOption: function scrollToActiveOption(container) {
      var key = this.getOptionReferenceKey(this.activeIndex);
      var option = this.$refs[key] ? this.$refs[key].$el : null;

      if (!container || !option) {
        return;
      }

      var _viewArea = viewArea(container),
          _viewArea$y = _viewArea.y,
          start = _viewArea$y.start,
          end = _viewArea$y.end;

      var optionBottom = option.offsetTop + option.getBoundingClientRect().height;

      if (option.offsetTop < start) {
        scrollTop(container, option.offsetTop);
      } else if (optionBottom > end) {
        scrollTop(container, start + (optionBottom - end));
      }
    }
  }
};

var _this$D = null;
var style$J = createStyle('dropdown');

var validateNumber$3 = function validateNumber(v) {
  _newArrowCheck(this, _this$D);

  return !Number.isNaN(parseInt(v, 10)) || v === 'auto';
}.bind(null);

var formatSize$1 = function formatSize(value) {
  _newArrowCheck(this, _this$D);

  switch (true) {
    case value === 'auto':
      return value;

    case !Number.isNaN(Number(value)):
      return "".concat(value, "px");

    default:
      return null;
  }
}.bind(null);

var uiDropdown$1 = {
  name: 'ui-dropdown',
  mixins: [inject$1('overlay'), factory$3('opened', 'toggle'), Transportable, Testable],
  props: {
    width: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$D);

        return validateNumber$3(v) || v === 'auto';
      }.bind(null)
    },
    height: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$D);

        return validateNumber$3(v) || v === 'auto';
      }.bind(null)
    },
    zIndex: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    classes: function classes() {
      return {
        '-opened': this.isOpened
      };
    },
    styles: function styles() {
      return {
        width: formatSize$1(this.width),
        'max-height': formatSize$1(this.height),
        'z-index': this.zIndex
      };
    },
    attributes: function attributes() {
      return _objectSpread2(_objectSpread2({}, this.qaAttributes), {}, {
        'aria-hidden': !this.isOpened
      });
    }
  },
  mounted: function mounted() {
    this.transport(this.$el, 'dropdowns');

    if (this.overlay) {
      this.overlay.register(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.overlay) {
      this.overlay.unregister(this);
    }

    this.removeTransportedElement(this.$el, 'dropdowns');
  },
  render: function render(h) {
    return h('div', {
      staticClass: style$J(),
      class: this.classes,
      style: this.styles,
      attrs: this.attributes
    }, this.$slots.default);
  }
};

var uiDropdown = generatePlugin(uiDropdown$1);

var style$I = createStyle('dropdown-group');
var uiDropdownGroup$1 = {
  name: 'ui-dropdown-group',
  functional: true,
  props: _objectSpread2({
    title: {
      type: String,
      required: true
    }
  }, qaProperty),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h('div', a(data, {
      staticClass: style$I(),
      attrs: _defineProperty({}, qaAttributeName, props.qa)
    }), [h('div', {
      staticClass: style$I('title')()
    }, [props.title]), children]);
  }
};

var uiDropdownGroup = generatePlugin(uiDropdownGroup$1);

var uiDropdownOption$1 = {
  name: 'ui-dropdown-option',
  mixins: [Testable],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      return {
        '-active': this.active,
        '-disabled': this.disabled
      };
    },
    attributes: function attributes() {
      return this.qaAttributes;
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      if (!this.disabled) {
        this.$emit('click', e);
      }
    },
    genContent: function genContent() {
      return this.$slots.default;
    }
  },
  render: function render(h) {
    var _this = this;

    return h('div', {
      staticClass: createStyle('dropdown-option')(),
      class: this.classes,
      attrs: this.attributes,
      on: {
        click: function click(e) {
          _newArrowCheck(this, _this);

          return this.clickHandler(e);
        }.bind(this)
      }
    }, [this.genContent()]);
  }
};

var uiDropdownOption = generatePlugin(uiDropdownOption$1);

var _this$C = null;
/**
 * @todo Refactoring
 */

var Dropdownable = {
  mixins: [inject],
  props: {
    /**
     * Dropdown initial position
     */
    position: {
      type: String,
      default: 'bottom'
    },

    /**
     * Dropdown position mode
     */
    positionMode: {
      type: String,
      default: 'absolute',
      validator: function validator(v) {
        _newArrowCheck(this, _this$C);

        return ['absolute', 'fixed'].includes(v);
      }.bind(null)
    },

    /**
     * Custom dropdown class
     */
    dropdownClass: {
      type: [String, Object],
      default: null
    },

    /**
     * Custom z-index for dropdown
     */
    zIndex: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$C);

    return {
      /**
       * Dropdown width in pixels
       *
       * @type {string | null}
       */
      dropdownWidth: null
    };
  }.bind(null),
  computed: {
    /**
     * HTML атрибуты выпадающего окна
     *
     * @return {{}}
     */
    dropdownAttributes: function dropdownAttributes() {
      return {};
    },

    /**
     * Titles of all groups
     *
     * @return {Array<string> | string[]}
     */
    groupsTitles: function groupsTitles() {
      return Object.values(this.groups || {});
    }
  },
  watch: {
    positionMode: 'calculatePosition'
  },
  methods: {
    /**
     * Reference element for dropdown
     *
     * @protected
     * @return {HTMLElement | Element}
     * @throws MethodNotImplemented
     */
    getDropdownReferenceElement: function getDropdownReferenceElement() {
      // eslint-disable-next-line max-len
      throw new MethodNotImplemented('getDropdownReferenceElement', kebabToCamel(this.$options.name));
    },

    /**
     * Calculate dropdown position
     */
    calculatePosition: function calculatePosition() {
      if (!this.$isServer) {
        var dropdown = this.$refs.dropdown ? this.$refs.dropdown.$el : null;
        var el = this.getDropdownReferenceElement();

        if (el && dropdown) {
          this.calculateDropdownWidth();
          this.$_popper = createPopper(el, dropdown, this.position, {
            strategy: this.positionMode
          });
        }
      }
    },

    /**
     * Calculates dropdown width in px
     */
    calculateDropdownWidth: function calculateDropdownWidth() {
      if (!this.$isServer) {
        var el = this.getDropdownReferenceElement();
        this.dropdownWidth = Math.ceil(el.getBoundingClientRect().width);
      }
    },

    /**
     * Set dropdown scroll position to initial
     */
    resetDropdownScroll: function resetDropdownScroll() {
      if (!this.$isServer) {
        scrollTo(this.$refs.dropdown.$el, 0, 0);
      }
    },

    /**
     * Generates dropdown template
     *
     * @param {boolean} opened
     * @param {VNode[]} content?
     * @return {VNode[]}
     */
    genDropdown: function genDropdown(opened) {
      var _this2 = this;

      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.$createElement(uiDropdown, {
        key: 'dropdown',
        ref: 'dropdown',
        staticClass: typeof this.dropdownClass === 'string' ? this.dropdownClass : null,
        class: _typeof(this.dropdownClass) === 'object' ? this.dropdownClass : null,
        props: {
          opened: opened,
          width: this.dropdownWidth,
          zIndex: this.zIndex || this.layer,
          qa: this.qa ? "".concat(this.qa, "-dropdown") : null
        },
        attrs: this.dropdownAttributes,
        on: {
          toggle: function toggle(v) {
            _newArrowCheck(this, _this2);

            return this.$emit('toggle', v);
          }.bind(this)
        }
      }, [this.$slots.dropdown || content]);
    },

    /**
     * Generates group template
     *
     * @param {string} title
     * @param {VNode[]} content
     * @param {*?} key
     * @return {VNode}
     */
    genGroup: function genGroup(title, content) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.$createElement(uiDropdownGroup, {
        key: key || this.groupsTitles.indexOf(title),
        props: {
          title: title,
          qa: this.qa && key ? "".concat(this.qa, "-dropdown-group-").concat(key) : null
        }
      }, content);
    },

    /**
     * Generates option template
     *
     * @param {Object} data
     * @param {VNode[]} content?
     * @return {VNode}
     */
    genOption: function genOption(data) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.$createElement(uiDropdownOption, data, content);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$_resizeCallback = throttle(this.calculateDropdownWidth, 100);
    requestAnimationFrame(function () {
      _newArrowCheck(this, _this3);

      return this.calculatePosition();
    }.bind(this));
    window.addEventListener('resize', this.$_resizeCallback, true);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$_popper) {
      this.$_popper.destroy();
    }

    window.removeEventListener('resize', this.$_resizeCallback, true);
  }
};

var uiHighlightText$1 = {
  name: 'ui-highlight-text',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    value: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: ''
    }
  },
  render: function render(h, _ref) {
    var _props$value,
        _this = this;

    var props = _ref.props,
        data = _ref.data;

    if (!props.value) {
      return h(props.tag, [props.text]);
    }

    var regex = new RegExp(escapeRegExp$1((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : ''), 'gim');
    var matches = props.text.match(regex);
    var result = props.text;

    if (Array.isArray(matches)) {
      matches.forEach(function (part) {
        _newArrowCheck(this, _this);

        result = result.replace(part, "<b>".concat(part, "</b>"));
      }.bind(this));
    }

    return h(props.tag, a(data, {
      domProps: {
        innerHTML: result
      }
    }));
  }
};

var uiHighlightText = generatePlugin(uiHighlightText$1);

var _this$B = null;
var uiInputSuggest = {
  name: 'ui-input-suggest',
  extends: uiInput,
  mixins: [Optionable, Dropdownable],
  directives: {
    ClickOutside: ClickOutside
  },
  props: {
    keepFocus: {
      type: Boolean,
      default: false
    },
    validationEvent: {
      type: String,
      default: 'select'
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$B);

    return {
      isOpened: false
    };
  }.bind(null),
  computed: {
    directives: function directives() {
      var _this2 = this;

      return [{
        name: 'click-outside',
        value: function value() {
          _newArrowCheck(this, _this2);

          this.isOpened = false;
        }.bind(this),
        args: {
          closeConditional: function closeConditional(_ref) {
            var target = _ref.target;

            _newArrowCheck(this, _this2);

            if (!this.isOpened) {
              return false;
            }

            var content = this.$refs.dropdown.$el;

            if (content.contains(target) || content === target) {
              return false;
            }

            return !!this.$el && !this.$el.contains(target) && target !== this.$el;
          }.bind(this)
        }
      }];
    },
    isDropdownOpened: function isDropdownOpened() {
      return this.isOpened && (this.hasOptions || !!this.$slots.options);
    }
  },
  methods: {
    arrowDownHandler: function arrowDownHandler() {
      this.incrementIndex();
      this.scrollToActiveOption(this.$refs.dropdown.$el);
    },
    arrowUpHandler: function arrowUpHandler() {
      this.decrementIndex();
      this.scrollToActiveOption(this.$refs.dropdown.$el);
    },
    focusHandler: function focusHandler(e) {
      var _this3 = this;

      if (this.readOnly) {
        e.preventDefault();
        return;
      }

      this.isFocused = true;
      this.isOpened = true;
      this.$nextTick(function () {
        _newArrowCheck(this, _this3);

        return this.calculatePosition();
      }.bind(this));
      this.$emit('focus', e);
    },
    keyDownHandler: function keyDownHandler(e) {
      if (e.keyCode === keyCodes.tab) {
        this.isFocused = false;
        this.isOpened = false;
      }

      this.$emit('keydown', e);
    },
    submitHandler: function submitHandler() {
      if (this.hasActiveOption) {
        this.select(this.activeOption);
        this.resetIndex();
      } else {
        this.$emit('submit');
      }
    },
    select: function select(option) {
      if (this.keepFocus) {
        this.focus();
      } else {
        this.isOpened = false;
      }

      this.$emit('select', option);
      this.resetDropdownScroll();
    },
    getDropdownReferenceElement: function getDropdownReferenceElement() {
      return this.$refs.contentWrapper;
    },
    genDropdownContent: function genDropdownContent() {
      return this.$slots.options || (this.hasGroupedOptions ? this.genGroups() : this.genOptions(this.computedOptions));
    },
    genGroups: function genGroups() {
      var _this4 = this;

      return Object.entries(this.groups).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            title = _ref3[1];

        _newArrowCheck(this, _this4);

        var content = this.$slots.group || this.$scopedSlots.group || null;

        if (typeof content === 'function') {
          content = content({
            key: key,
            title: title,
            options: this.getGroupOptions(key)
          });
        }

        return this.genGroup(title, content || this.genOptions(this.getGroupOptions(key)), key);
      }.bind(this));
    },
    genOptions: function genOptions(options) {
      var _this5 = this;

      return options.map(function (option) {
        var _this6 = this;

        _newArrowCheck(this, _this5);

        var content = this.$slots.option || this.$scopedSlots.option || null;

        if (typeof content === 'function') {
          content = content(option);
        }

        content = content || [this.$createElement(uiHighlightText, {
          props: {
            text: this.getOptionNameField(option),
            value: String(this.inputDOMProps.value)
          }
        })];
        var index = this.getOptionIndex(option);
        var key = this.getOptionKeyField(option);
        return this.genOption({
          ref: this.getOptionReferenceKey(index),
          key: key ? "".concat(key, "-").concat(index) : index,
          props: {
            disabled: this.getOptionDisabledField(option),
            active: this.isOptionActive(option),
            qa: this.qa ? "".concat(this.qa, "-dropdown-option-").concat(key) : null
          },
          on: {
            click: function click() {
              _newArrowCheck(this, _this6);

              return this.select(option);
            }.bind(this)
          }
        }, content);
      }.bind(this));
    },
    genInputWrapper: function genInputWrapper(content) {
      return this.$createElement(uiGroupItem, {
        class: this.classes,
        directives: this.directives
      }, [this.genDropdown(this.isDropdownOpened, this.genDropdownContent())].concat(_toConsumableArray(content)));
    }
  }
};

var index$w = generatePlugin(uiInputSuggest);

var _this$A = null;
/**
 * @type {string}
 */

var rangeSeparator = ' - ';
/**
 * @type {string}
 */

var defaultPlaceholder$1 = 'дд.мм.гггг';
/**
 * @return {Date}
 */

var cleanDate = function cleanDate() {
  _newArrowCheck(this, _this$A);

  return set(new Date(), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });
}.bind(null);

var _this$z = null;
/**
 * Namespace for inject/provide
 *
 * @type {string}
 */

var defaultNamespace = 'selectableGroup';
/**
 * Model types for different
 *
 * @type {Readonly<Object<string, Array>>}
 */

var modelTypes = Object.freeze({
  single: [String, Number, Boolean, Object],
  multiple: Array,
  manual: [String, Number, Boolean, Object, Array]
});
/**
 * Default provider factory options
 *
 * @type {{prop?: string, event?: string, selectionType?: string, itemValueProp?: string, itemSelectedState?: string, itemSelectEvent?: string}} options
 */

var defaultProviderOptions = {
  /**
   * Namespace
   *
   * @type {string}
   */
  namespace: defaultNamespace,

  /**
   * Value property for v-model
   */
  prop: 'value',

  /**
   * Value update event for v-model
   */
  event: 'change',

  /**
   * Selection type. Types:
   * - single - only single value can be selected
   * - multiple - one or many values can be selected
   * - manual - switch selection type by property
   */
  selectionType: 'manual',

  /**
   * Mandatory mode types:
   * - allow
   * - disallow
   * - manual
   */
  mandatoryMode: 'manual',

  /**
   * Property name for value of child component
   */
  itemValueProp: 'value',

  /**
   * Data property name for selected state of child component
   */
  itemSelectedState: 'isSelected',

  /**
   * Name for event, which will be dispatched by child component on selection
   */
  itemSelectEvent: 'select'
};
/**
 * Allowed values for option "selectionType"
 *
 * @type {string[]}
 */

var selectionTypeAllowedValues = ['single', 'multiple', 'manual'];
/**
 * Allowed values for option "mandatoryMode"
 *
 * @type {string[]}
 */

var mandatoryModeAllowedValues = ['allow', 'disallow', 'manual'];
/**
 * Generate selectable mixin for provider
 *
 * @param {{namespace?: string, prop?: string, event?: string, selectionType?: string, mandatoryMode?: string, itemValueProp?: string, itemSelectedState?: string, itemSelectEvent?: string}} options
 * @returns {object}
 *
 * @todo Add auto select first child
 */

var providerFactory = function providerFactory() {
  var _this2 = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _newArrowCheck(this, _this$z);

  var _defaultProviderOptio = _objectSpread2(_objectSpread2({}, defaultProviderOptions), options),
      namespace = _defaultProviderOptio.namespace,
      prop = _defaultProviderOptio.prop,
      event = _defaultProviderOptio.event,
      selectionType = _defaultProviderOptio.selectionType,
      mandatoryMode = _defaultProviderOptio.mandatoryMode,
      itemValueProp = _defaultProviderOptio.itemValueProp,
      itemSelectedState = _defaultProviderOptio.itemSelectedState,
      itemSelectEvent = _defaultProviderOptio.itemSelectEvent;

  if (!selectionTypeAllowedValues.includes(selectionType)) {
    throw new InvalidOptionValueError('selectionType', selectionTypeAllowedValues);
  }

  var multipleProp = {
    type: Boolean,
    default: false
  };

  if (!mandatoryModeAllowedValues.includes(mandatoryMode)) {
    throw new InvalidOptionValueError('mandatoryMode', mandatoryModeAllowedValues);
  }

  var mandatoryProp = {
    type: Boolean,
    default: false
  };
  return {
    mixins: [provide$1(namespace)],
    model: {
      prop: prop,
      event: event
    },
    props: _objectSpread2(_objectSpread2(_defineProperty({}, prop, {
      type: modelTypes[selectionType],
      default: null
    }), selectionType === 'manual' && {
      multiple: multipleProp
    }), mandatoryMode === 'manual' && selectionType === 'single' && {
      mandatory: mandatoryProp
    }),
    data: function data() {
      _newArrowCheck(this, _this2);

      return {
        /**
         * Array of child components
         */
        items: [],

        /**
         * Array of listeners for each child component
         */
        listeners: [],

        /**
         * Destroying state
         */
        isDestroying: false
      };
    }.bind(this),
    watch: _defineProperty({}, prop, {
      handler: 'update',
      deep: true
    }),
    computed: {
      /**
       * Model value
       *
       * @returns {array | string | number}
       */
      model: function model() {
        return this[prop];
      },

      /**
       * Allow multiple values
       *
       * @returns {boolean}
       */
      isMultiple: function isMultiple() {
        return selectionType === 'manual' ? this.multiple : selectionType === 'multiple';
      },

      /**
       * Allow reset selected value
       *
       * @returns {boolean}
       */
      allowMandatory: function allowMandatory() {
        if (this.isMultiple) {
          return false;
        }

        return mandatoryMode === 'manual' ? this.mandatory : mandatoryMode === 'disallow';
      },

      /**
       * Is model value not passed
       *
       * @returns {boolean}
       */
      isModelEmpty: function isModelEmpty() {
        return this.isMultiple ? !this.model.length : this.model === null || this.model === undefined;
      }
    },
    methods: {
      /**
       * Emit model change event
       *
       * @param {Array | *} value
       */
      fireModelUpdate: function fireModelUpdate(value) {
        this.$emit(event, this.isMultiple ? this.getUpdatedMultipleValue(value) : this.getUpdatedValue(value));
      },

      /**
       * Emit value of selected child component
       *
       * @param {Vue} item Child item
       */
      updateValue: function updateValue(item) {
        this.fireModelUpdate(item[itemValueProp]);
      },

      /**
       * Checks has item already selected or not
       *
       * @param {string | number} value
       * @returns {boolean}
       */
      isItemSelected: function isItemSelected(value) {
        return this.isMultiple ? this.model.includes(value) : this.model === value;
      },

      /**
       * Returns updated model value
       *
       * @param {string | number} value
       * @returns {array}
       */
      getUpdatedMultipleValue: function getUpdatedMultipleValue(value) {
        return this.isItemSelected(value) ? this.removeItem(value) : this.addItem(value);
      },

      /**
       * Remove item value from model
       *
       * @param {string | number} value
       * @returns {array}
       */
      removeItem: function removeItem(value) {
        var model = _toConsumableArray(this.model);

        model.splice(model.indexOf(value), 1);
        return model;
      },

      /**
       * Add item value to model
       *
       * @param {string | number} value
       * @returns {array}
       */
      addItem: function addItem(value) {
        var model = _toConsumableArray(this.model);

        model.push(value);
        return model;
      },

      /**
       * Returns updated model value
       *
       * @param {string | number} value
       * @returns {null | string | number}
       */
      getUpdatedValue: function getUpdatedValue(value) {
        return this.model === value && !this.allowMandatory ? null : value;
      },

      /**
       * Refresh selection state for each child component
       */
      update: function update() {
        for (var i = 0; i < this.items.length; i += 1) {
          var item = this.items[i];

          if (item[itemSelectedState]) {
            item[itemSelectedState] = false;
          }

          if (this.isItemSelected(item[itemValueProp])) {
            item[itemSelectedState] = true;
          }
        }
      },

      /**
       * Register child component
       *
       * @param {Vue} item VueComponent
       */
      register: function register(item) {
        var _this3 = this;

        var index = this.items.length;
        this.items.push(item);
        this.listeners.push(function () {
          _newArrowCheck(this, _this3);

          return this.updateValue(item);
        }.bind(this));
        item.$on(itemSelectEvent, this.listeners[index]);
        this.update();
        this.afterRegister(item);
      },

      /**
       * After child component register hook
       */
      afterRegister: function afterRegister() {},

      /**
       * Unregister child component
       *
       * @param {Vue} item VueComponent
       */
      unregister: function unregister(item) {
        if (this.isDestroying) {
          return;
        }

        var index = this.items.indexOf(item);

        if (index > -1) {
          item.$off(itemSelectEvent, this.listeners[index]);
          this.items.splice(index, 1);
          this.listeners.splice(index, 1);
        }
      }
    },

    /**
     * Refresh selection state for each child component on provider mount
     */
    mounted: function mounted() {
      this.update(this[prop]);
    },

    /**
     * Update destroying state before component will be destroyed
     */
    beforeDestroy: function beforeDestroy() {
      this.isDestroying = true;
    }
  };
}.bind(null);
/**
 * Selectable mixin for provider with default settings
 *
 * @type {Object}
 */

providerFactory();
/**
 * Default child factory options
 *
 * @type {{prop: string, event: string, selectionState: string, child: string | null, provider: string | null}}
 */

var defaultChildOptions = {
  /**
   * Namespace
   *
   * @type {string}
   */
  namespace: defaultNamespace,

  /**
   * Child value property name
   */
  prop: 'value',

  /**
   * Child select event name
   */
  event: 'select',

  /**
   * Child unselect event name
   */
  removeEvent: 'remove',

  /**
   * Child selection state property name
   */
  selectionState: 'isSelected',

  /**
   * Child component name
   */
  child: null,

  /**
   * Provider component name
   */
  provider: null
};
/**
 * Generate selectable mixin for provider's child
 *
 * @param {{namespace?: string, prop?: string, event?: string, removeEvent?: string, selectionState?: string, child?: string, provider?: string}} options
 * @returns {object}
 */

var childFactory = function childFactory() {
  var _this4 = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _newArrowCheck(this, _this$z);

  var _defaultChildOptions$ = _objectSpread2(_objectSpread2({}, defaultChildOptions), options),
      namespace = _defaultChildOptions$.namespace,
      prop = _defaultChildOptions$.prop,
      event = _defaultChildOptions$.event,
      removeEvent = _defaultChildOptions$.removeEvent,
      selectionState = _defaultChildOptions$.selectionState,
      childProvider = _defaultChildOptions$.provider,
      child = _defaultChildOptions$.child;

  return {
    mixins: [inject$1(namespace, child, childProvider)],
    props: _defineProperty({}, prop, {
      type: [String, Number, Boolean, Object],
      default: null
    }),
    data: function data() {
      _newArrowCheck(this, _this4);

      return _defineProperty({}, selectionState, false);
    }.bind(this),
    watch: _defineProperty({}, selectionState, function (selected) {
      if (!selected) {
        this.remove();
      }
    }),
    methods: {
      /**
       * Emit event on selection
       */
      select: function select() {
        this.$emit(event);
      },

      /**
       * Emit event on selection reset
       */
      remove: function remove() {
        this.$emit(removeEvent);
      }
    },

    /**
     * Register child on component instance create
     */
    mounted: function mounted() {
      if (this[namespace]) {
        this[namespace].register(this);
      }
    },

    /**
     * Unregister child before component instance destroy
     */
    beforeDestroy: function beforeDestroy() {
      if (this[namespace]) {
        this[namespace].unregister(this);
      }
    }
  };
}.bind(null);
/**
 * Selectable mixin for provider's child with default settings
 *
 * @type {Object}
 */

childFactory();

var style$H = createStyle('select-option');
var uiSelectOption$1 = {
  name: 'ui-select-option',
  extends: uiDropdownOption,
  mixins: [childFactory({
    namespace: 'optionsGroup',
    provider: 'uiSelect',
    child: 'uiSelectOption'
  })],
  props: {
    icon: {
      type: String,
      default: 'check'
    }
  },
  computed: {
    attributes: function attributes() {
      return _objectSpread2(_objectSpread2({
        'aria-role': 'option'
      }, !this.disabled && {
        'aria-selected': this.isSelected
      }), this.qaAttributes);
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      if (!this.disabled) {
        this.$emit('click', e);
        this.select();
      }
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: style$H()
      }, [this.$createElement('div', {
        staticClass: style$H('content')()
      }, this.$slots.default), this.genIcon()]);
    },
    genIcon: function genIcon() {
      if (!this.icon) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$H('icon')()
      }, [this.isSelected ? this.$createElement(uiIcon, {
        props: {
          name: this.icon
        }
      }) : null]);
    }
  }
};

var uiSelectOption = generatePlugin(uiSelectOption$1);

var _this$y = null;
var style$G = createStyle('select'); // eslint-disable-next-line no-confusing-arrow

var defaultPlaceholder = function defaultPlaceholder(searchable) {
  _newArrowCheck(this, _this$y);

  return searchable ? 'Выберите или начните ввод' : 'Выберите из списка';
}.bind(null);

var uiSelect$1 = {
  name: 'ui-select',
  mixins: [providerFactory({
    namespace: 'optionsGroup',
    event: 'change',
    mandatoryMode: 'disallow'
  }), Labelable, Stateable, Messageable, Optionable, Dropdownable, Testable, factory$2({
    validateOn: 'change'
  })],
  directives: {
    ClickOutside: ClickOutside
  },
  props: {
    placeholder: {
      type: String,
      default: null
    },
    withoutAutoclose: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoSelect: {
      type: Boolean,
      default: false
    },
    returnValue: {
      type: String,
      default: 'key',
      validator: function validator(v) {
        _newArrowCheck(this, _this$y);

        return ['key', 'name', 'option'].includes(v);
      }.bind(null)
    },
    selectedIcon: {
      type: String,
      default: 'check'
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$y);

    return {
      isOpened: false,
      search: null,
      filter: false
    };
  }.bind(null),
  computed: {
    classes: function classes() {
      return {
        '-disabled': this.disabled,
        '-error': this.isErrorState || this.validationError,
        '-warning': this.isWarningState,
        '-readonly': this.readOnly,
        '-active': this.isOpened,
        '-large': this.large
      };
    },
    directives: function directives() {
      var _this2 = this;

      return [{
        name: 'click-outside',
        value: function value() {
          _newArrowCheck(this, _this2);

          return this.close();
        }.bind(this),
        args: {
          closeConditional: function closeConditional(_ref) {
            var _this3 = this;

            var target = _ref.target;

            _newArrowCheck(this, _this2);

            if (!this.isOpened) {
              return false;
            }

            var check = function check(el) {
              _newArrowCheck(this, _this3);

              return !!el && !el.contains(target) && target !== el;
            }.bind(this);

            return check(this.$el) && check(this.$refs.dropdown.$el);
          }.bind(this)
        }
      }];
    },
    inputHandlers: function inputHandlers() {
      var _this4 = this;

      return {
        click: function click(e) {
          _newArrowCheck(this, _this4);

          return e.stopPropagation();
        }.bind(this),
        focus: function focus(e) {
          _newArrowCheck(this, _this4);

          return e.stopPropagation();
        }.bind(this),
        blur: function blur(e) {
          _newArrowCheck(this, _this4);

          return e.stopPropagation();
        }.bind(this),
        input: function input(_ref2) {
          var _this5 = this;

          var target = _ref2.target;

          _newArrowCheck(this, _this4);

          var value = target.value;
          this.search = value;
          this.filter = !!value;
          this.$emit('input', value);
          this.$nextTick(function () {
            _newArrowCheck(this, _this5);

            return this.calculatePosition();
          }.bind(this));
        }.bind(this),
        keydown: function keydown(e) {
          _newArrowCheck(this, _this4);

          if (e.keyCode === keyCodes.tab) {
            this.close();
          }
        }.bind(this)
      };
    },
    computedOptions: function computedOptions() {
      return this.searchable && this.filter ? search(this.search, this.options, this.optionName) : this.options;
    },
    selectedOptions: function selectedOptions() {
      var _this6 = this;

      if (this.isModelEmpty) {
        return [];
      }

      return this.options.filter(function (option) {
        _newArrowCheck(this, _this6);

        return this.isItemSelected(this.getOptionValue(option));
      }.bind(this));
    },
    selectedOptionNames: function selectedOptionNames() {
      var _this7 = this;

      return this.selectedOptions.map(function (option) {
        _newArrowCheck(this, _this7);

        return this.getOptionNameField(option);
      }.bind(this)).join(', ');
    },
    labelOptions: function labelOptions() {
      return {
        staticClass: style$G('label')(),
        attrs: {
          for: this.labelHash
        }
      };
    },
    messageOptions: function messageOptions() {
      return {
        staticClass: style$G('message')()
      };
    },
    dropdownAttributes: function dropdownAttributes() {
      return _objectSpread2({
        id: this.labelHash,
        'aria-role': 'listbox'
      }, this.isMultiple && {
        'aria-multiselectable': 'true'
      });
    }
  },
  watch: {
    isOpened: function isOpened(value) {
      var _this8 = this;

      if (this.searchable) {
        value ? this.$nextTick(function () {
          _newArrowCheck(this, _this8);

          return this.$refs.input.focus();
        }.bind(this)) : this.resetSearch();
      }
    },
    model: 'resetSearch'
  },
  methods: {
    close: function close() {
      this.isOpened = false;
      this.$emit('close');
    },
    toggle: function toggle() {
      this.isOpened = !this.isOpened;
    },
    clickHandler: function clickHandler() {
      if (this.disabled || this.readOnly) {
        return;
      }

      this.toggle();

      if (this.isOpened) {
        this.calculatePosition();
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    },
    selectHandler: function selectHandler(option) {
      var _this9 = this;

      this.$emit('select', option);
      this.$nextTick(function () {
        _newArrowCheck(this, _this9);

        if (!this.withoutAutoclose && !this.multiple) {
          this.close();
        }
      }.bind(this));
    },
    removeHandler: function removeHandler(option) {
      this.$emit('remove', option);
    },
    resetSearch: function resetSearch() {
      if (this.searchable) {
        this.search = this.selectedOptionNames || null;
        this.filter = false;
      }
    },
    getDropdownReferenceElement: function getDropdownReferenceElement() {
      return this.$refs.activator;
    },
    getOptionValue: function getOptionValue(option) {
      if (this.returnValue === 'key') {
        return this.getOptionKeyField(option);
      }

      if (this.returnValue === 'name') {
        return this.getOptionNameField(option);
      }

      return option;
    },
    isOptionHidden: function isOptionHidden(option) {
      if (!this.searchable) {
        return false;
      }

      return !this.computedOptions.includes(option);
    },
    genWrapper: function genWrapper() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.$createElement(uiGroupItem, {
        staticClass: style$G(),
        class: this.classes,
        directives: this.directives
      }, content);
    },
    genActivator: function genActivator() {
      var _this10 = this;

      if ((this.multiple || this.withoutAutoclose) && !this.$isServer) {
        this.$nextTick(function () {
          _newArrowCheck(this, _this10);

          this.calculateDropdownWidth();
          this.calculatePosition();
        }.bind(this));
      }

      var selected = this.selectedOptions.length || this.searchable && this.search;
      return this.$createElement('div', {
        ref: 'activator',
        staticClass: style$G('activator')(),
        class: {
          '-searchable': this.searchable,
          '-selected': selected
        },
        attrs: _objectSpread2({}, this.qaAttributes),
        on: {
          click: function click() {
            _newArrowCheck(this, _this10);

            return this.clickHandler();
          }.bind(this)
        }
      }, [selected ? this.genSelected() : this.genPlaceholder(), this.genInput(), this.genClearIcon(), this.loading ? this.genLoading() : this.genArrow()]);
    },
    genPlaceholder: function genPlaceholder() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.$createElement('div', {
        staticClass: style$G('placeholder')(),
        class: {
          '-hidden': this.searchable && this.isOpened
        }
      }, [// eslint-disable-next-line max-len
      content || this.placeholder || this.$slots.placeholder || defaultPlaceholder(this.searchable)]);
    },
    genSelected: function genSelected() {
      // eslint-disable-next-line max-len
      var content = this.$slots.selected || this.$scopedSlots.selected || this.selectedOptionNames || (this.filter ? this.search : null);

      if (typeof content === 'function') {
        content = content({
          selected: this.multiple ? this.selectedOptions : this.selectedOptions[0] || null
        });
      }

      return this.genPlaceholder(content);
    },
    genIcon: function genIcon(name) {
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.$createElement(uiIcon, _objectSpread2({
        staticClass: style$G('icon')(),
        class: classes,
        props: {
          name: name,
          interactive: !!handler
        }
      }, handler && {
        on: {
          click: handler
        }
      }));
    },
    genClearIcon: function genClearIcon() {
      var _this11 = this;

      if (!this.clearable) {
        return null;
      }

      return this.genIcon('cross', {
        '-clear': true,
        '-hidden': this.isModelEmpty
      }, function (e) {
        _newArrowCheck(this, _this11);

        e.stopPropagation();
        this.fireModelUpdate(this.isMultiline ? [] : null);
        this.$emit('clear');
      }.bind(this));
    },
    genLoading: function genLoading() {
      return this.genIcon('spinner', {
        '-loader': true,
        '-hidden': !this.loading
      });
    },
    genArrow: function genArrow() {
      if (this.readOnly) {
        return null;
      }

      return this.genIcon('arrow', {
        '-arrow': true,
        '-hidden': this.loading
      });
    },
    genInput: function genInput() {
      if (!this.searchable) {
        return null;
      }

      return this.$createElement('input', {
        ref: 'input',
        staticClass: style$G('input')(),
        attrs: {
          placeholder: this.placeholder || defaultPlaceholder(this.searchable),
          autocomplete: 'off',
          role: 'presentation'
        },
        domProps: {
          value: this.search
        },
        on: this.inputHandlers
      });
    },
    genDropdownContent: function genDropdownContent() {
      return this.$slots.options || (this.hasGroupedOptions ? this.genGroups() : this.genOptions(this.options));
    },
    genGroups: function genGroups() {
      var _this12 = this;

      return Object.entries(this.groups).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            title = _ref4[1];

        _newArrowCheck(this, _this12);

        var content = this.$slots.group || this.$scopedSlots.group || null;

        if (typeof content === 'function') {
          content = content({
            key: key,
            title: title,
            options: this.getGroupOptions(key)
          });
        }

        return this.genGroup(title, content || this.genOptions(this.getGroupOptions(key)));
      }.bind(this));
    },
    genOptions: function genOptions(options) {
      var _this13 = this;

      return options.map(function (option) {
        _newArrowCheck(this, _this13);

        var content = this.$slots.option || this.$scopedSlots.option || null;

        if (typeof content === 'function') {
          content = content(option);
        }

        return this.genOption(option, content, this.options.indexOf(option));
      }.bind(this));
    },
    genOption: function genOption(option, content, index) {
      var _this14 = this;

      var key = this.getOptionKeyField(option);
      return this.$createElement(uiSelectOption, {
        ref: this.getOptionReferenceKey(this.getOptionIndex(option)),
        key: key ? "".concat(key, "-").concat(index) : index,
        class: {
          'd-none': this.isOptionHidden(option)
        },
        props: {
          value: this.getOptionValue(option),
          disabled: this.getOptionDisabledField(option),
          icon: this.selectedIcon,
          qa: typeof this.qa === 'string' ? "".concat(this.qa, "-option-").concat(index) : null
        },
        on: {
          select: function select() {
            _newArrowCheck(this, _this14);

            return this.selectHandler(option);
          }.bind(this),
          remove: function remove() {
            _newArrowCheck(this, _this14);

            return this.removeHandler(option);
          }.bind(this)
        }
      }, content || this.genOptionLabel(option));
    },
    genOptionLabel: function genOptionLabel(option) {
      var text = this.getOptionNameField(option);
      return [this.filter ? this.$createElement(uiHighlightText, {
        props: {
          value: this.search || '',
          text: text
        }
      }) : text];
    }
  },
  created: function created() {
    if (this.multiple && this.searchable) {
      throw new FrameworkError('Multiple selects with search has not supported yet');
    }

    if (this.autoSelect && this.isModelEmpty && this.options.length) {
      this.fireModelUpdate(this.getOptionValue(this.options[0]));
    }
  },
  render: function render() {
    return this.genWrapper([!this.readOnly && this.genDropdown(this.isOpened, this.genDropdownContent()), this.genLabel(), this.genActivator(), this.genMessage(this.validationError)]);
  }
};

var uiSelect = generatePlugin(uiSelect$1);

var _this$x = null;
/**
 * @type {string[]}
 */

var weekDays = Object.values(weekDays$1).map(function (_ref) {
  var short = _ref.short;

  _newArrowCheck(this, _this$x);

  return short;
}.bind(null));
/**
 * @type {{ id: number, name: string }[]}
 */

var months = Object.entries(months$1).reduce(function (acc, _ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
      k = _ref3[0],
      v = _ref3[1];

  _newArrowCheck(this, _this$x);

  return [].concat(_toConsumableArray(acc), [{
    id: parseInt(k, 10),
    name: "".concat(k.padStart(2, '0'), " - ").concat(v)
  }]);
}.bind(null), []);
/**
 * @param {string | number} v
 * @returns {boolean}
 */

var yearValidator = function yearValidator(v) {
  _newArrowCheck(this, _this$x);

  return !Number.isNaN(parseInt(v, 10)) && v >= 1900;
}.bind(null);
/**
 * @param {number} min
 * @param {number} max
 * @returns {number[]}
 */

var getAvailableYears = function getAvailableYears(min, max) {
  _newArrowCheck(this, _this$x);

  var result = [];

  for (var i = max; i >= min; i -= 1) {
    result.push(i);
  }

  return result;
}.bind(null);

var style$E = createStyle('calendar');
/**
 * @type {Object | string}
 */

var style$F = {
  value: style$E(),
  activator: {
    value: style$E('activator')(),
    inline: '-inline'
  },
  dropdown: style$E('dropdown')(),
  controls: style$E('controls')(),
  select: style$E('select')(),
  cell: {
    value: style$E('cell')(),
    week: '-week',
    day: '-day',
    selected: '-selected',
    reselect: '-reselect',
    range: '-in-range',
    left: '-left',
    right: '-right',
    disabled: '-disabled'
  }
};

var _this$w = null;
var uiCalendar$1 = {
  name: 'ui-calendar',
  mixins: [Dropdownable, Testable],
  directives: {
    ClickOutside: ClickOutside
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    /**
     * Выбранная дата / период дат / список дат
     */
    value: {
      type: [String, Date, Array],
      default: null
    },

    /**
     * Формат даты, в котором она будет храниться в модели
     */
    format: {
      type: String,
      default: 'native'
    },

    /**
     * Выходной формат для активатора
     */
    humanFormat: {
      type: String,
      default: dateFormat,
      validator: function validator(v) {
        _newArrowCheck(this, _this$w);

        return v !== 'native';
      }.bind(null)
    },

    /**
     * Selection type
     */
    selectionType: {
      type: String,
      default: 'single',
      validator: function validator(v) {
        _newArrowCheck(this, _this$w);

        return ['single', 'range'].includes(v);
      }.bind(null)
    },

    /**
     * Minimum date which allowed to select
     */
    min: {
      type: [Date, String],
      default: null
    },

    /**
     * Maximum date which allowed to select
     */
    max: {
      type: [Date, String],
      default: null
    },

    /**
     * Minimum year which allowed to select
     */
    minYear: {
      type: [String, Number],
      default: 1900,
      validator: function validator(v) {
        _newArrowCheck(this, _this$w);

        return yearValidator(v);
      }.bind(null)
    },

    /**
     * Maximum year which allowed to select
     */
    maxYear: {
      type: [String, Number],
      default: new Date().getFullYear(),
      validator: function validator(v) {
        _newArrowCheck(this, _this$w);

        return yearValidator(v);
      }.bind(null)
    },

    /**
     * Default calendar dropdown position
     */
    position: {
      type: String,
      default: 'bottom-start'
    },

    /**
     *
     */
    dropdownClass: {
      type: String,
      default: style$F.value
    },

    /**
     *
     */
    trigger: {
      type: String,
      default: 'click',
      validator: function validator(v) {
        _newArrowCheck(this, _this$w);

        return ['click', 'manual'].includes(v);
      }.bind(null)
    },

    /**
     *
     */
    opened: {
      type: Boolean,
      default: false
    },

    /**
     *
     */
    inline: {
      type: Boolean,
      default: false
    },

    /**
     *
     */
    reselectAvailable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$w);

    return {
      /**
       * Состояние показа календаря
       */
      isOpened: false,

      /**
       * Current date
       */
      date: set(new Date(), {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      }),

      /**
       * Name list of each week day
       */
      weekDays: weekDays,

      /**
       * List of months
       */
      months: months
    };
  }.bind(null),
  computed: {
    /**
     * Разрешен выбор только одной даты
     *
     * @return {boolean}
     */
    isSingle: function isSingle() {
      return this.selectionType === 'single';
    },

    /**
     * Разрешен выбор только промежутка дат
     *
     * @return {boolean}
     */
    isRange: function isRange() {
      return this.selectionType === 'range';
    },

    /**
     * Использовать нативный объект Date в качестве представления для дат
     *
     * @return {boolean}
     */
    isNative: function isNative() {
      return this.format === 'native';
    },

    /**
     * Ручное управление показом календаря через пропс "opened"
     *
     * @return {boolean}
     */
    isManualOpen: function isManualOpen() {
      return this.trigger === 'manual';
    },

    /**
     * Указывает на отсутствие заданного значения
     *
     * @return {boolean}
     */
    isEmpty: function isEmpty() {
      return this.isSingle ? !this.value : !Array.isArray(this.value) || this.value.filter(Boolean).length === 0;
    },

    /**
     * @return {Date | Date[]}
     */
    model: function model() {
      var _this2 = this;

      if (this.isEmpty) {
        return this.isRange ? [] : null;
      }

      if (this.isNative) {
        return this.value;
      }

      if (this.isSingle) {
        return parse(this.value, this.format, this.date);
      }

      return this.value.map(function (v) {
        _newArrowCheck(this, _this2);

        return parse(v, this.format, this.date);
      }.bind(this)).filter(isValid).sort(function (a, b) {
        _newArrowCheck(this, _this2);

        return a.getTime() - b.getTime();
      }.bind(this));
    },

    /**
     * Понятная для человека дата
     *
     * @return {string | null}
     */
    humanValue: function humanValue() {
      var _this3 = this;

      if (this.isEmpty) {
        return null;
      }

      var condition = this.isRange ? this.model.every(isValid) : isValid(this.model);

      if (condition) {
        return this.isRange ? this.model.map(function (v) {
          _newArrowCheck(this, _this3);

          return format$2(v, this.humanFormat);
        }.bind(this)) : format$2(this.model, this.humanFormat);
      }

      return null;
    },

    /**
     * Список доступных годов для переключателя
     *
     * @return {{ name: number, id: number }[]}
     */
    years: function years() {
      var _this4 = this;

      return getAvailableYears(this.minYear, this.maxYear).map(function (v) {
        _newArrowCheck(this, _this4);

        return {
          id: v,
          name: v,
          // eslint-disable-next-line max-len
          disabled: this.minDate && this.minDate.getFullYear() > v || this.maxDate && this.maxDate.getFullYear() < v
        };
      }.bind(this));
    },

    /**
     * Текущий выбранный месяц
     */
    month: {
      get: function get() {
        return this.date.getMonth() + 1;
      },
      set: function set(value) {
        this.date = setMonth(this.date, value - 1);
      }
    },

    /**
     * Текущий выбранный год
     */
    year: {
      get: function get() {
        return this.date.getFullYear();
      },
      set: function set(value) {
        this.date = setYear(this.date, value);
      }
    },

    /**
     * Минимально возможная для выбора дата
     *
     * @return {Date | null}
     */
    minDate: function minDate() {
      if (!this.min) {
        return null;
      }

      return this.isNative ? this.min : parse(this.min, this.format, this.date);
    },

    /**
     * Максимально возможная для выбора дата
     *
     * @return {Date | null}
     */
    maxDate: function maxDate() {
      if (!this.max) {
        return null;
      }

      return this.isNative ? this.max : parse(this.max, this.format, this.date);
    },

    /**
     * Кол-во дней в текущем выбранном месяце
     *
     * @return {number}
     */
    daysCount: function daysCount() {
      return getDaysInMonth(this.date);
    },

    /**
     * Кол-во дней в последней неделе предыдущего месяца
     *
     * @return {number}
     */
    daysOffset: function daysOffset() {
      var month = startOfMonth(this.date);
      var week = startOfWeek(month, {
        weekStartsOn: 1
      });
      return differenceInCalendarDays(month, week);
    },
    directives: function directives() {
      var _this5 = this;

      return this.isManualOpen ? [] : [{
        name: 'click-outside',
        value: function value() {
          _newArrowCheck(this, _this5);

          this.isOpened = false;
        }.bind(this),
        args: {
          closeConditional: function closeConditional(_ref) {
            var _this6 = this;

            var target = _ref.target;

            _newArrowCheck(this, _this5);

            return this.isOpened && [this.$el, this.$refs.dropdown.$el, this.$refs.monthSelect.$refs.dropdown.$el, this.$refs.yearSelect.$refs.dropdown.$el].every(function (el) {
              _newArrowCheck(this, _this6);

              return target !== el && !el.contains(target);
            }.bind(this));
          }.bind(this)
        }
      }];
    }
  },
  watch: {
    value: {
      deep: true,
      handler: function handler(v) {
        this.changeDate(v);
        this.calculatePosition();
      }
    },
    opened: function opened(v) {
      if (this.isManualOpen) {
        this.isOpened = v;
      }
    },
    isOpened: function isOpened(v) {
      var _this7 = this;

      if (v) {
        this.$nextTick(function () {
          _newArrowCheck(this, _this7);

          return this.calculatePosition();
        }.bind(this));
      }

      this.$emit('toggle', v);
    }
  },
  methods: {
    calculateDropdownWidth: function calculateDropdownWidth() {},
    getDropdownReferenceElement: function getDropdownReferenceElement() {
      return this.$el;
    },

    /**
     * @param {string} value
     */
    changeDate: function changeDate(value) {
      if (!value || this.isRange && this.model.length > 1) {
        return;
      }

      var date = this.isRange ? this.model[0] : this.model;

      if (!isValid(date)) {
        return;
      }

      var year = date.getFullYear();

      if (year < this.minYear || year > this.maxYear) {
        return;
      }

      this.date = new Date(date.getTime());
    },
    isSelected: function isSelected(date) {
      var _this8 = this;

      if (this.isSingle) {
        return isSameDay(date, this.model);
      }

      if (this.model.length === 0) {
        return false;
      }

      return this.model.some(function (v) {
        _newArrowCheck(this, _this8);

        return isSameDay(date, v);
      }.bind(this));
    },
    isInRange: function isInRange(date) {
      if (!this.isRange || !Array.isArray(this.model) || this.model.length < 2) {
        return false;
      }

      var _this$model = _slicedToArray(this.model, 2),
          start = _this$model[0],
          end = _this$model[1];

      return !isBefore(date, start) && !isAfter(date, end);
    },
    isLeft: function isLeft(date) {
      return isSameDay(date, this.model[0]);
    },
    isRight: function isRight(date) {
      return isSameDay(date, this.model[1]);
    },
    isDisabled: function isDisabled(date) {
      return isBefore(date, this.minDate) || isAfter(date, this.maxDate);
    },
    clickHandler: function clickHandler(date, isSelected) {
      if (this.isSingle) {
        if (isSelected) {
          if (this.reselectAvailable) {
            this.isOpened = false;
          }
        } else {
          this.update(date);
        }

        return;
      }

      isSelected ? this.remove(date) : this.select(date);
    },
    select: function select(date) {
      var _this9 = this;

      var value = _toConsumableArray(this.model);

      if (value.length === 2) {
        value = [];
      }

      value.push(date);
      value.sort(function (a, b) {
        _newArrowCheck(this, _this9);

        return a.getTime() - b.getTime();
      }.bind(this));
      this.$emit('select', date);
      this.update(value);
    },
    remove: function remove(date) {
      var _this10 = this;

      this.$emit('remove', date);
      this.update(this.model.filter(function (v) {
        _newArrowCheck(this, _this10);

        return !isSameDay(v, date);
      }.bind(this)));
    },
    update: function update(model) {
      var _this11 = this;

      var prepare = function prepare(date) {
        _newArrowCheck(this, _this11);

        return this.isNative ? date : format$2(date, this.format);
      }.bind(this);

      this.isOpened = this.isSingle ? !model : model.length < 2;
      return this.$emit('change', this.isSingle ? prepare(model) : model.map(prepare));
    },
    genActivator: function genActivator(content) {
      var _this12 = this;

      return this.$createElement('div', {
        staticClass: style$F.activator.value,
        class: _defineProperty({}, style$F.activator.inline, this.inline),
        on: {
          click: function click() {
            _newArrowCheck(this, _this12);

            if (!this.isManualOpen) {
              this.isOpened = !this.isOpened;
            }
          }.bind(this)
        }
      }, content);
    },
    genContent: function genContent() {
      var content = this.$scopedSlots.default || this.$slots.default;

      if (typeof content === 'function') {
        content = content({
          value: this.humanValue
        });
      }

      return content;
    },
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: style$F.controls
      }, [this.genMonthSelect(), this.genYearSelect()]);
    },
    genSelect: function genSelect(_ref2) {
      var ref = _ref2.ref,
          value = _ref2.value,
          options = _ref2.options,
          change = _ref2.change;
      return this.$createElement(uiSelect, {
        ref: ref,
        staticClass: style$F.select,
        props: {
          value: value,
          options: options,
          selectedIcon: null,
          positionMode: this.positionMode,
          zIndex: this.layer ? this.layer + 1 : this.zIndex,
          dropdownClass: style$F.dropdown
        },
        on: {
          change: change
        }
      });
    },
    genMonthSelect: function genMonthSelect() {
      var _this13 = this;

      return this.genSelect({
        ref: 'monthSelect',
        value: this.month,
        options: this.months,
        change: function change(v) {
          _newArrowCheck(this, _this13);

          this.month = v;
        }.bind(this)
      });
    },
    genYearSelect: function genYearSelect() {
      var _this14 = this;

      return this.genSelect({
        ref: 'yearSelect',
        value: this.year,
        options: this.years,
        change: function change(v) {
          _newArrowCheck(this, _this14);

          this.year = v;
        }.bind(this)
      });
    },
    genGroup: function genGroup() {
      var _this15 = this;

      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var daysInWeek = 7;
      var length = Math.ceil(content.length / daysInWeek);
      var rows = Array.from({
        length: length
      }).map(function (_, index) {
        _newArrowCheck(this, _this15);

        return this.$createElement('div', content.slice(index * daysInWeek, (index + 1) * daysInWeek));
      }.bind(this));
      return this.$createElement('div', {
        staticClass: style$F.group
      }, rows);
    },
    genCell: function genCell(content) {
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handlers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.$createElement('div', {
        staticClass: style$F.cell.value,
        class: classes,
        on: handlers
      }, content);
    },
    genWeekDays: function genWeekDays() {
      var _this16 = this;

      return this.genGroup(this.weekDays.map(function (v) {
        _newArrowCheck(this, _this16);

        return this.genCell(v, _defineProperty({}, style$F.cell.week, true));
      }.bind(this)));
    },
    genDates: function genDates() {
      var _this17 = this;

      var content = [];

      for (var i = 0; i < this.daysOffset; i += 1) {
        content.push(this.genCell());
      }

      var _loop = function _loop(_i) {
        var _this17$genCell,
            _this18 = this;

        var date = setDate(_this17.date, _i);

        var isSelected = _this17.isSelected(date);

        var isDisabled = _this17.isDisabled(date);

        var inRange = _this17.isInRange(date);

        content.push(_this17.genCell([_i], (_this17$genCell = {}, _defineProperty(_this17$genCell, style$F.cell.day, true), _defineProperty(_this17$genCell, style$F.cell.selected, isSelected), _defineProperty(_this17$genCell, style$F.cell.reselect, isSelected && _this17.reselectAvailable), _defineProperty(_this17$genCell, style$F.cell.disabled, isDisabled), _defineProperty(_this17$genCell, style$F.cell.range, inRange), _defineProperty(_this17$genCell, style$F.cell.left, inRange && _this17.isLeft(date)), _defineProperty(_this17$genCell, style$F.cell.right, inRange && _this17.isRight(date)), _this17$genCell), {
          click: function click() {
            _newArrowCheck(this, _this18);

            return !isDisabled && _this17.clickHandler(date, isSelected);
          }.bind(this)
        }));
      };

      for (var _i = 1; _i <= this.daysCount; _i += 1) {
        _loop(_i);
      }

      return this.genGroup(content);
    }
  },
  created: function created() {
    if (this.isEmpty) {
      this.date = isBefore(this.date, this.minDate) ? this.minDate : isAfter(this.date, this.maxDate) ? this.maxDate : this.date;
    } else {
      this.changeDate(this.value);
    }
  },
  render: function render() {
    return this.genActivator([this.genContent(), this.genDropdown(this.isOpened, [this.genControls(), this.genWeekDays(), this.genDates()])]);
  }
};

var uiCalendar = generatePlugin(uiCalendar$1);

var style$C = createStyle('input-calendar');
var style$D = {
  value: style$C(),
  icon: {
    value: style$C('icon')(),
    active: '-active'
  }
};

var _this$v = null;

var _uiCalendar$props = uiCalendar.props;
    _uiCalendar$props.humanFormat;
    _uiCalendar$props.trigger;
    _uiCalendar$props.opened;
    _uiCalendar$props.inline;
    var props = _objectWithoutProperties(_uiCalendar$props, ["humanFormat", "trigger", "opened", "inline"]);

var _Dropdownable$props = Dropdownable.props;
    _Dropdownable$props.dropdownClass;
    _Dropdownable$props.position;
    var dropdownProps = _objectWithoutProperties(_Dropdownable$props, ["dropdownClass", "position"]);

var uiInputCalendar = {
  name: 'ui-input-calendar',
  extends: uiInput,
  directives: {
    ClickOutside: ClickOutside
  },
  props: _objectSpread2(_objectSpread2(_objectSpread2({}, props), dropdownProps), {}, {
    /**
     * Default input mask
     */
    mask: {
      type: String,
      default: '##.##.####'
    },

    /**
     * Placeholder for mask
     */
    maskPlaceholder: {
      type: Boolean,
      default: true
    },

    /**
     * Return masked value by default
     */
    returnMaskedValue: {
      type: Boolean,
      default: true
    },

    /**
     * Input placeholder
     */
    placeholder: {
      type: String,
      default: defaultPlaceholder$1
    },

    /**
     * Input icon
     */
    icon: {
      type: String,
      default: 'calendar'
    },
    autocomplete: {
      type: String,
      default: 'off'
    },

    /**
     * Allow reselection of entered date
     */
    reselectAvailable: {
      type: Boolean,
      default: false
    }
  }),
  data: function data() {
    _newArrowCheck(this, _this$v);

    return {
      /**
       * @type {boolean}
       */
      isOpened: false,

      /**
       * @type {string}
       */
      inputValue: ''
    };
  }.bind(null),
  computed: {
    inputAttributes: function inputAttributes() {
      return _objectSpread2(_objectSpread2({}, uiInput.computed.inputAttributes.call(this)), {}, {
        placeholder: this.formattedPlaceholder
      });
    },
    inputDOMProps: function inputDOMProps() {
      return {
        value: this.inputValue
      };
    },
    maskedInputProps: function maskedInputProps() {
      return _objectSpread2(_objectSpread2({}, uiInput.computed.maskedInputProps.call(this)), {}, {
        mask: this.formattedMask
      });
    },
    iconClasses: function iconClasses() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$D.icon.value, true), _defineProperty(_ref, style$D.icon.active, this.isOpened), _ref;
    },
    isRange: function isRange() {
      return this.selectionType === 'range';
    },
    isInputFilled: function isInputFilled() {
      return !!(this.inputValue || '').length;
    },
    formattedPlaceholder: function formattedPlaceholder() {
      if (!this.placeholder) {
        return null;
      }

      return this.isRange ? [this.placeholder, this.placeholder].join(rangeSeparator) : this.placeholder;
    },
    formattedMask: function formattedMask() {
      if (!this.mask) {
        return null;
      }

      return this.isRange ? [this.mask, this.mask].join(rangeSeparator) : this.mask;
    },
    showMaskPlaceholder: function showMaskPlaceholder() {
      return this.isInputFilled;
    },
    maskPlaceholderValue: function maskPlaceholderValue() {
      if (!this.formattedPlaceholder) {
        return null;
      }

      var v = this.inputValue || '';
      return {
        hidden: v,
        visible: this.formattedPlaceholder.substr(v.length)
      };
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function handler(v) {
        if (!this.isFocused) {
          this.inputValue = this.prepareInputValue(v);
        }
      }
    }
  },
  methods: {
    clearModel: function clearModel() {
      this.fireModelUpdate(this.isRange ? [] : null);
    },
    modifyModel: function modifyModel(e) {
      var _this2 = this;

      var input = (this.mask ? e : e.target.value) || '';
      var date = input.split(rangeSeparator).map(function (value) {
        _newArrowCheck(this, _this2);

        return parse(value, dateFormat, cleanDate(), {
          locale: ru
        });
      }.bind(this)).filter(isValid);
      date = this.format === 'native' ? date : date.map(function (value) {
        _newArrowCheck(this, _this2);

        return format$2(value, this.format, {
          locale: ru
        });
      }.bind(this));
      return {
        input: input,
        model: this.isRange ? date : date[0] || new Date(undefined)
      };
    },
    restoreModel: function restoreModel() {
      if (this.inputValue !== this.inputElement.value) {
        this.inputHandler({
          target: this.inputElement
        });
      }
    },
    focusHandler: function focusHandler(e) {
      this.isOpened = true;
      uiInput.methods.focusHandler.call(this, e);
    },
    blurHandler: function blurHandler(e) {
      e.preventDefault();
      uiInput.methods.blurHandler.call(this, e);
    },
    keyDownHandler: function keyDownHandler(e) {
      if (e.keyCode === keyCodes.tab) {
        this.isOpened = false;
      }

      uiInput.methods.keyDownHandler.call(this, e);
    },
    iconClickHandler: function iconClickHandler() {
      if (this.reselectAvailable && this.isOpened && this.isInputFilled) {
        this.isOpened = false;
      } else {
        this.focus();
      }
    },
    inputHandler: function inputHandler(e) {
      var _this$modifyModel = this.modifyModel(e),
          input = _this$modifyModel.input,
          model = _this$modifyModel.model;

      this.inputValue = input;
      this.fireModelUpdate(model);
    },
    formattedInputHandler: function formattedInputHandler() {},
    prepareInputValue: function prepareInputValue(v) {
      var _this3 = this;

      var prepare = function prepare(date) {
        _newArrowCheck(this, _this3);

        return this.format === 'native' ? date : parse(date, this.format, cleanDate(), {
          local: ru
        });
      }.bind(this);

      var date = (this.isRange ? v : [v]).map(prepare).filter(isValid);
      return date.map(function (value) {
        _newArrowCheck(this, _this3);

        return format$2(value, dateFormat, {
          locale: ru
        });
      }.bind(this)).join(rangeSeparator);
    },
    onToggle: function onToggle(e) {
      this.isOpened = e;
      this.$emit('toggle', e);
    },
    genContentWrapper: function genContentWrapper(content) {
      var _this4 = this;

      return this.$createElement(uiCalendar, {
        ref: 'calendar',
        class: this.contentClasses,
        directives: [{
          name: 'click-outside',
          value: function value() {
            _newArrowCheck(this, _this4);

            this.isOpened = false;
          }.bind(this),
          args: {
            closeConditional: function closeConditional(_ref2) {
              var _this5 = this;

              var target = _ref2.target;

              _newArrowCheck(this, _this4);

              return this.isOpened && [this.$refs.calendar.$el, this.$refs.calendar.$refs.dropdown.$el, this.$refs.calendar.$refs.monthSelect.$refs.dropdown.$el, this.$refs.calendar.$refs.yearSelect.$refs.dropdown.$el].every(function (el) {
                _newArrowCheck(this, _this5);

                return target !== el && !el.contains(target);
              }.bind(this));
            }.bind(this)
          }
        }],
        props: {
          value: this.value,
          format: this.format,
          min: this.min,
          max: this.max,
          selectionType: this.selectionType,
          minYear: this.minYear,
          maxYear: this.maxYear,
          position: this.position,
          positionMode: this.positionMode,
          zIndex: this.zIndex,
          opened: this.isOpened,
          trigger: 'manual',
          reselectAvailable: this.reselectAvailable
        },
        on: {
          change: function change(v) {
            _newArrowCheck(this, _this4);

            this.inputValue = this.prepareInputValue(v);
            this.fireModelUpdate(v);
          }.bind(this),
          select: function select(e) {
            _newArrowCheck(this, _this4);

            return this.$emit('select', e);
          }.bind(this),
          remove: function remove(e) {
            _newArrowCheck(this, _this4);

            return this.$emit('remove', e);
          }.bind(this),
          toggle: function toggle(e) {
            _newArrowCheck(this, _this4);

            return this.onToggle(e);
          }.bind(this)
        }
      }, content);
    }
  }
};

var index$v = generatePlugin(uiInputCalendar);

var _this$u = null;
var style$B = createStyle('input-plural');

var format = function format(v) {
  _newArrowCheck(this, _this$u);

  return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}.bind(null);

var unformat = function unformat(v) {
  _newArrowCheck(this, _this$u);

  return Number(v.toString().replace(/ /g, ''));
}.bind(null);

var uiInputPlural = {
  name: 'ui-input-plural',
  extends: uiInput,
  props: {
    value: {
      type: Number,
      default: null
    },
    mode: {
      type: String,
      default: 'numeric'
    },
    plurals: {
      type: Array,
      required: true
    }
  },
  computed: {
    classes: function classes() {
      return _objectSpread2(_objectSpread2({}, uiInput.computed.classes.call(this)), {}, _defineProperty({}, style$B(), true));
    },
    inputDOMProps: function inputDOMProps() {
      return {
        value: this.maskedValue
      };
    },
    maskedValue: function maskedValue() {
      return this.value === null ? '' : format(this.value);
    },
    showMaskPlaceholder: function showMaskPlaceholder() {
      return this.isFocused || this.isInputFilled;
    },
    maskPlaceholderClasses: function maskPlaceholderClasses() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$B('active')(), this.isInputFilled && !this.isFocused), _defineProperty(_ref, style$B('disabled')(), this.disabled), _ref;
    },
    maskPlaceholderValue: function maskPlaceholderValue() {
      var v = this.maskedValue;
      var pluralized = pluralize(this.value || 0, this.plurals);
      return {
        hidden: v,
        visible: "".concat(v.length ? '' : 0, " ").concat(pluralized)
      };
    }
  },
  methods: {
    restoreModel: function restoreModel() {
      if (this.maskedValue !== this.inputElement.value) {
        this.inputHandler({
          target: this.inputElement
        });
      }
    },
    modifyModel: function modifyModel(_ref2) {
      var target = _ref2.target;
      var value = target.value.length ? unformat(target.value) : null;

      if (value !== null && Number.MAX_SAFE_INTEGER < value) {
        value = Number.MAX_SAFE_INTEGER;
      }

      return value;
    },
    formattedInputHandler: function formattedInputHandler() {},

    /**
     * @param {KeyboardEvent | { target: HTMLInputElement }} e
     * @todo Вынести в хелпер
     */
    keyPressHandler: function keyPressHandler(e) {
      this.$emit('keypress', e);
      var v = this.maskedValue;
      var isNumber = !Number.isNaN(parseInt(e.key, 10));

      if (!isNumber) {
        e.preventDefault();
      }

      var caret = e.target.selectionEnd;

      if (v === '0' && caret === 1) {
        e.preventDefault();
      }

      if (v.length && !v.startsWith('0') && caret === 0 && e.key === '0') {
        e.preventDefault();
      }
    }
  }
};

var index$u = generatePlugin(uiInputPlural);

var _this$t = null;
var style$A = createStyle('textarea');

var numberValidator = function numberValidator(v) {
  _newArrowCheck(this, _this$t);

  return !Number.isNaN(parseInt(v, 10)) && v > 0;
}.bind(null);

var parseStyle = function parseStyle(styles, field) {
  _newArrowCheck(this, _this$t);

  return parseInt(styles[field], 10);
}.bind(null);

var uiTextarea = {
  name: 'ui-textarea',
  mixins: [Labelable, Messageable, Stateable, Testable, factory$2({
    validateOn: 'blur'
  })],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    rows: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$t);

        return numberValidator(v);
      }.bind(null)
    },
    placeholder: {
      type: String,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: [String, Number],
      default: 5000,
      validator: function validator(v) {
        _newArrowCheck(this, _this$t);

        return numberValidator(v);
      }.bind(null)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$t);

    return {
      isFocused: false,
      hiddenAreaWidth: null,
      hiddenAreaFields: 12,
      hiddenAreaLineHeight: 20,
      calculatedRows: 1
    };
  }.bind(null),
  computed: {
    classes: function classes() {
      return {
        '-disabled': this.disabled,
        '-error': this.isErrorState || this.validationError,
        '-warning': this.isWarningState
      };
    },
    attributes: function attributes() {
      return _objectSpread2({
        id: this.id || this.labelHash,
        name: this.name,
        rows: this.calculatedRows,
        placeholder: this.placeholder,
        disabled: this.disabled,
        readonly: this.readOnly,
        maxlength: this.maxLength,
        autocomplete: this.autocomplete
      }, this.qaAttributes);
    },
    handlers: function handlers() {
      var _this2 = this;

      return {
        input: function input(e) {
          _newArrowCheck(this, _this2);

          return this.inputHandler(e);
        }.bind(this),
        focus: function focus(e) {
          _newArrowCheck(this, _this2);

          return this.focusHandler(e);
        }.bind(this),
        blur: function blur(e) {
          _newArrowCheck(this, _this2);

          return this.blurHandler(e);
        }.bind(this)
      };
    },
    hasValue: function hasValue() {
      return String(this.value).length > 0;
    },
    labelOptions: function labelOptions() {
      return {
        staticClass: style$A('label')(),
        class: {
          '-active': this.isFocused || this.hasValue || !!this.placeholder
        },
        attrs: {
          for: this.id || this.labelHash
        }
      };
    },
    messageOptions: function messageOptions() {
      return {
        staticClass: style$A('message')()
      };
    }
  },
  watch: {
    value: 'calculateRows',
    hiddenAreaWidth: 'calculateRows'
  },
  methods: {
    calculateHiddenAreaStyles: function calculateHiddenAreaStyles() {
      var hiddenArea = this.$refs.hiddenArea;
      var styles = window.getComputedStyle(hiddenArea);
      var padding = parseStyle(styles, 'paddingTop') + parseStyle(styles, 'paddingBottom');
      var border = parseStyle(styles, 'borderBottomWidth');
      this.hiddenAreaFields = padding + border;
      this.hiddenAreaLineHeight = parseStyle(styles, 'lineHeight');
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      this.$nextTick(function () {
        _newArrowCheck(this, _this3);

        var hiddenArea = this.$refs.hiddenArea;
        var height = hiddenArea.clientHeight - this.hiddenAreaFields;
        var result = Math.ceil(height / this.hiddenAreaLineHeight);
        this.calculatedRows = this.rows ? result > this.rows ? this.rows : result : result;
      }.bind(this));
    },
    inputHandler: function inputHandler(_ref) {
      var target = _ref.target;
      this.$emit('input', target.value);
    },
    focusHandler: function focusHandler(e) {
      if (!this.readOnly) {
        this.isFocused = true;
      }

      this.$emit('focus', e);
    },
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement(uiGroupItem, {
        staticClass: style$A(),
        class: this.classes
      }, content);
    },
    genTextarea: function genTextarea() {
      return this.$createElement('textarea', {
        ref: 'textarea',
        staticClass: style$A('field')(),
        domProps: {
          value: this.value
        },
        attrs: this.attributes,
        on: this.handlers
      });
    },
    genHiddenArea: function genHiddenArea() {
      var _this4 = this;

      var content = (this.value || '').split('\n');
      return this.$createElement('div', {
        ref: 'hiddenArea',
        staticClass: style$A('field')(),
        class: {
          '-hidden': true
        },
        style: {
          width: this.hiddenAreaWidth
        }
      }, content.map(function (v) {
        _newArrowCheck(this, _this4);

        return this.$createElement('div', [v]);
      }.bind(this)));
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$_resizeCallback = function () {
      _newArrowCheck(this, _this5);

      this.hiddenAreaWidth = "".concat(this.$refs.textarea.clientWidth, "px");
    }.bind(this);

    this.$_resizeCallback();
    this.calculateHiddenAreaStyles();

    if (String(this.value).length > 0) {
      this.calculateRows();
    }

    window.addEventListener('resize', this.$_resizeCallback, true);

    if (this.autocomplete !== 'off') {
      onBrowserReady(function () {
        _newArrowCheck(this, _this5);

        var target = this.$refs.textarea;

        if (target.value !== this.value) {
          this.inputHandler({
            target: target
          });
        }
      }.bind(this));
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeCallback, true);
  },
  render: function render() {
    return this.genWrapper([this.genLabel(), this.genTextarea(), this.genMessage(this.validationError), this.genHiddenArea()]);
  }
};

var index$t = generatePlugin(uiTextarea);

var style$y = createStyle('radio-group');
var style$z = {
  row: '-row',
  wrapper: {
    value: style$y('wrapper')(),
    messageable: '-messageable'
  },
  message: {
    value: style$y('message')(),
    error: '-error'
  }
};

var _this$s = null;
var style$x = createStyle('group');
var uiGroup = {
  name: 'ui-group',
  mixins: [Flexible],
  props: {
    gutters: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$s);

        return !Number.isNaN(+v) && v > -1;
      }.bind(null)
    },
    wrap: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h) {
    var _objectSpread2$1;

    return h('div', {
      staticClass: style$x(),
      class: _objectSpread2((_objectSpread2$1 = {
        '-wrap': this.wrap
      }, _defineProperty(_objectSpread2$1, "-gutter-".concat(this.gutters), this.gutters !== null), _defineProperty(_objectSpread2$1, '-controls', this.controls), _defineProperty(_objectSpread2$1, '-vertical', this.vertical), _objectSpread2$1), classes(this)),
      attrs: {
        role: 'group'
      }
    }, this.$slots.default);
  }
};

var uiRadioGroup = {
  name: 'ui-radio-group',
  mixins: [providerFactory({
    namespace: 'radioGroup',
    selectionType: 'single',
    mandatoryMode: 'disallow'
  }), factory$2({
    validateOn: 'change'
  }), Stateable, Messageable, Flexible, Testable],
  props: {
    row: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messageOptions: function messageOptions() {
      var _class;

      return {
        staticClass: style$z.message.value,
        class: (_class = {}, _defineProperty(_class, style$z.message.error, this.isErrorState || !!this.validationError), _defineProperty(_class, style$z.message.warning, this.isWarningState), _class)
      };
    }
  },
  methods: {
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$z.wrapper.value,
        class: _defineProperty({}, style$z.wrapper.messageable, this.hasMessage || !!this.validationError),
        attrs: this.qaAttributes
      }, content);
    },
    genGroup: function genGroup(content) {
      return this.$createElement(uiGroup, {
        props: {
          wrap: this.wrap,
          vertical: !this.row,
          controls: true
        }
      }, content);
    }
  },
  render: function render() {
    return this.genWrapper([this.genGroup(this.$slots.default), this.genMessage(this.validationError)]);
  }
};

var index$s = generatePlugin(uiRadioGroup);

var _this$r = null;
var style$w = createStyle('radio');
var uiRadio = {
  name: 'ui-radio',
  mixins: [childFactory({
    namespace: 'radioGroup',
    provider: 'uiRadioGroup',
    child: 'uiRadio'
  }), factory$4({
    tag: 'span'
  }), Messageable, Testable],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    markerColor: {
      type: String,
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$r);

    return {
      isFocused: false
    };
  }.bind(null),
  computed: {
    classes: function classes() {
      return {
        '-focused': this.isFocused,
        '-selected': this.isSelected,
        '-disabled': this.disabled
      };
    },
    attributes: function attributes() {
      return _objectSpread2({
        type: 'radio',
        id: this.id,
        value: this.value,
        name: this.$attrs.name || null,
        disabled: this.disabled,
        'aria-label': this.labelText,
        'aria-checked': this.isSelected
      }, this.qaAttributes);
    },
    handlers: function handlers() {
      var _this2 = this;

      return {
        change: function change() {
          _newArrowCheck(this, _this2);

          return this.select();
        }.bind(this),
        click: function click(e) {
          _newArrowCheck(this, _this2);

          return this.clickHandler(e);
        }.bind(this),
        focus: function focus(e) {
          _newArrowCheck(this, _this2);

          return this.focusHandler(e);
        }.bind(this),
        blur: function blur(e) {
          _newArrowCheck(this, _this2);

          return this.blurHandler(e);
        }.bind(this)
      };
    },
    labelOptions: function labelOptions() {
      return {
        staticClass: style$w('label')()
      };
    },
    messageOptions: function messageOptions() {
      return {
        staticClass: style$w('message')()
      };
    }
  },
  methods: {
    changeHandler: function changeHandler() {
      this.select();
    },
    clickHandler: function clickHandler(e) {
      this.$emit('click', e);
    },
    focusHandler: function focusHandler(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement(uiGroupItem, {
        props: {
          tag: 'label'
        },
        staticClass: style$w(),
        class: this.classes,
        attrs: {
          'data-radio': ''
        }
      }, content);
    },
    genInput: function genInput() {
      return this.$createElement('input', {
        ref: 'input',
        domProps: {
          checked: this.isSelected
        },
        attrs: this.attributes,
        on: this.handlers
      });
    },
    genMarker: function genMarker() {
      var _this3 = this;

      var markerStyle = function () {
        _newArrowCheck(this, _this3);

        if (!this.isSelected || !this.markerColor) {
          return undefined;
        }

        return {
          border: "1px solid ".concat(this.markerColor),
          backgroundColor: this.markerColor,
          boxShadow: "0 0 0 3px ".concat(this.markerColor, "20")
        };
      }.bind(this)();

      return this.$createElement('span', {
        staticClass: style$w('marker')(),
        style: markerStyle
      });
    },
    genContent: function genContent(content) {
      return this.$createElement('div', {
        staticClass: style$w('content')()
      }, content);
    },
    genMessageWrapper: function genMessageWrapper() {
      var content = this.message || this.$slots.message || null;
      return content ? this.genMessage() : null;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    onBrowserReady(function () {
      _newArrowCheck(this, _this4);

      if (this.$refs.input.checked && !this.isSelected) {
        this.select();
      }
    }.bind(this));
  },
  render: function render() {
    return this.genWrapper([this.genInput(), this.genMarker(), this.genContent([this.genLabel(), this.genMessageWrapper()])]);
  }
};

var index$r = generatePlugin(uiRadio);

var uiCheckboxGroup = {
  name: 'ui-checkbox-group',
  mixins: [Testable, providerFactory({
    namespace: 'checkboxGroup',
    selectionType: 'multiple',
    mandatory: 'disallow'
  }), factory$2({
    validateOn: 'input'
  }), Messageable],
  props: {
    row: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messageOptions: function messageOptions() {
      var _class;

      return {
        staticClass: style$z.message.value,
        class: (_class = {}, _defineProperty(_class, style$z.message.error, this.isErrorState || !!this.validationError), _defineProperty(_class, style$z.message.warning, this.isWarningState), _class)
      };
    }
  },
  methods: {
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$z.wrapper.value,
        class: _defineProperty({}, style$z.wrapper.messageable, this.hasMessage || !!this.validationError),
        attrs: this.qaAttributes
      }, content);
    },
    genGroup: function genGroup(content) {
      return this.$createElement(uiGroup, {
        props: {
          wrap: this.wrap,
          vertical: !this.row,
          controls: true
        }
      }, content);
    }
  },
  render: function render() {
    return this.genWrapper([this.genGroup(this.$slots.default), this.genMessage(this.validationError)]);
  }
};

var index$q = generatePlugin(uiCheckboxGroup);

var _this$q = null;
var style$v = createStyle('checkbox');
var uiCheckbox = {
  name: 'ui-checkbox',
  mixins: [childFactory({
    namespace: 'checkboxGroup'
  }), factory$2({
    validateOn: 'change'
  }), factory$4({
    tag: 'span'
  }), factory$1({
    tag: 'span'
  }), Stateable, Testable],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(v) {
        _newArrowCheck(this, _this$q);

        return ['default', 'small', 'large'].includes(v);
      }.bind(null)
    },
    theme: {
      type: String,
      validator: function validator(v) {
        _newArrowCheck(this, _this$q);

        return ['partner'].includes(v);
      }.bind(null),
      default: null
    },
    unknown: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$q);

    return {
      isFocused: false
    };
  }.bind(null),
  computed: {
    isInGroup: function isInGroup() {
      return !!this.checkboxGroup;
    },
    isChecked: function isChecked() {
      return this.isInGroup ? this.isSelected : this.value;
    },
    classes: function classes() {
      return {
        '-focused': this.isFocused,
        '-selected': this.isChecked,
        '-unknown': this.value === null && this.unknown,
        '-error': this.isErrorState || !!this.validationError,
        '-warning': this.isWarningState,
        '-disabled': this.disabled,
        '-size-default': this.size === 'default',
        '-size-small': this.size === 'small',
        '-size-large': this.size === 'large',
        '-partner': this.theme === 'partner'
      };
    },
    attributes: function attributes() {
      return _objectSpread2({
        type: 'checkbox',
        id: this.id,
        checked: this.isChecked,
        disabled: this.disabled,
        name: this.name,
        'aria-label': this.labelText,
        'aria-checked': this.isChecked === null ? 'mixed' : this.isChecked
      }, this.qaAttributes);
    },
    handlers: function handlers() {
      var _this2 = this;

      return {
        change: function change(e) {
          _newArrowCheck(this, _this2);

          return this.changeHandler(e);
        }.bind(this),
        click: function click(e) {
          _newArrowCheck(this, _this2);

          return this.clickHandler(e);
        }.bind(this),
        focus: function focus(e) {
          _newArrowCheck(this, _this2);

          return this.focusHandler(e);
        }.bind(this),
        blur: function blur(e) {
          _newArrowCheck(this, _this2);

          return this.blurHandler(e);
        }.bind(this)
      };
    },
    needRegisterInFormGroup: function needRegisterInFormGroup() {
      return Boolean(this.formGroup && this.name && !this.isInGroup);
    },
    labelOptions: function labelOptions() {
      return {
        staticClass: style$v('label')()
      };
    },
    messageOptions: function messageOptions() {
      return {
        staticClass: style$v('message')()
      };
    }
  },
  methods: {
    modelUpdate: function modelUpdate(v) {
      this.$emit('change', v);
    },
    changeHandler: function changeHandler() {
      var v = this.value === null ? false : !this.value;
      this.isInGroup ? this.select() : this.$emit('change', v);
    },
    clickHandler: function clickHandler(e) {
      this.$emit('click', e);
    },
    focusHandler: function focusHandler(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement(uiGroupItem, {
        props: {
          tag: 'label'
        },
        staticClass: style$v(),
        class: this.classes,
        attrs: {
          'data-checkbox': ''
        }
      }, content);
    },
    genInput: function genInput() {
      return this.$createElement('input', {
        ref: 'input',
        domProps: {
          checked: this.isChecked,
          disabled: this.disabled
        },
        attrs: this.attributes,
        on: this.handlers
      });
    },
    genMarker: function genMarker() {
      return this.$createElement('span', {
        staticClass: style$v('marker')()
      });
    },
    genContent: function genContent() {
      if (!this.hasLabel) {
        return null;
      }

      var hasMessage = this.hasMessage || this.validationError;
      return this.$createElement('span', {
        staticClass: style$v('content')()
      }, [this.genLabel(), hasMessage && this.genMessage(this.validationError)]);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    onBrowserReady(function () {
      _newArrowCheck(this, _this3);

      var checked = this.$refs.input.checked;

      if (!this.isInGroup && checked !== this.value) {
        this.modelUpdate(checked);
        return;
      }

      if (checked && !this.isChecked) {
        this.select();
      } else if (!checked && this.isChecked) {
        this.remove();
      }
    }.bind(this));
  },
  render: function render() {
    return this.genWrapper([this.genMarker(), this.genInput(), this.genContent()]);
  }
};

var index$p = generatePlugin(uiCheckbox);

var _this$p = null;
var breakpoints = Object.keys(gridBreakpoints);
var styleBuilder = createStyle('switcher');
var style$u = {
  value: styleBuilder(),
  wrapper: styleBuilder('wrapper')(),
  message: styleBuilder('message')(),
  error: '-error',
  warning: '-warning'
};
var uiSwitcher = {
  name: 'ui-switcher',
  mixins: [providerFactory({
    namespace: 'switcher',
    selectionType: 'single',
    mandatoryMode: 'disallow'
  }), Messageable, Stateable, factory$2({
    validateOn: 'change'
  })],
  props: {
    vertical: {
      type: [Boolean, String],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$p);

        return typeof v === 'boolean' || breakpoints.includes(v);
      }.bind(null)
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$u.value, true), _defineProperty(_ref, style$u.error, this.isErrorState || this.validationError), _defineProperty(_ref, style$u.warning, this.isWarningState), _ref;
    },
    messageOptions: function messageOptions() {
      return {
        key: 'message',
        staticClass: style$u.message
      };
    }
  },
  methods: {
    genWrapper: function genWrapper() {
      var _this2 = this;

      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.$createElement('div', {
        class: this.classes
      }, [this.$createElement('div', {
        staticClass: style$u.wrapper,
        class: _objectSpread2({
          '-vertical': this.vertical === true
        }, breakpoints.reduce(function (acc, key) {
          _newArrowCheck(this, _this2);

          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "-vertical-".concat(key), this.vertical === key));
        }.bind(this), {}))
      }, content), this.genMessage(this.validationError)]);
    }
  },
  render: function render() {
    return this.genWrapper(this.$slots.default);
  }
};

var index$o = generatePlugin(uiSwitcher);

var _this$o = null;
var style$t = createStyle('switcher-button');
var uiSwitcherButton = {
  name: 'ui-switcher-button',
  mixins: [childFactory({
    namespace: 'switcher',
    provider: 'uiSwitcher',
    child: 'uiSwitcherButton'
  }), factory$4({
    tag: 'span'
  })],
  props: {
    icon: {
      type: String,
      default: null
    },
    large: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'left',
      validator: function validator(value) {
        _newArrowCheck(this, _this$o);

        return ['left', 'center'].includes(value);
      }.bind(null)
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$t(), true), _defineProperty(_ref, '-active', this.isSelected), _defineProperty(_ref, '-with-icon', this.hasIcon), _defineProperty(_ref, '-with-label', this.hasLabel), _defineProperty(_ref, '-large', this.large), _defineProperty(_ref, '-center', this.align === 'center'), _ref;
    },
    handlers: function handlers() {
      var _this2 = this;

      return {
        click: function click(e) {
          _newArrowCheck(this, _this2);

          this.$emit('click', e);
          this.select();
        }.bind(this)
      };
    },
    labelOptions: function labelOptions() {
      return {
        staticClass: style$t('label')()
      };
    },
    hasIcon: function hasIcon() {
      return this.$slots.icon || this.$scopedSlots.icon || this.icon;
    }
  },
  methods: {
    genWrapper: function genWrapper() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.$createElement('div', {
        class: this.classes,
        on: this.handlers
      }, content);
    },
    genIcon: function genIcon() {
      if (!this.icon) {
        return null;
      }

      return this.$createElement(uiIcon, {
        props: {
          name: this.icon
        }
      });
    },
    genIconSlot: function genIconSlot() {
      return this.$slots.icon || this.genIcon();
    }
  },
  render: function render() {
    return this.genWrapper([this.genIconSlot(), this.genLabel()]);
  }
};

var index$n = generatePlugin(uiSwitcherButton);

var uiToggleGroup = {
  name: 'ui-toggle-group',
  mixins: [Testable, providerFactory({
    namespace: 'toggleGroup',
    selectionType: 'multiple',
    mandatory: 'disallow'
  }), factory$2({
    validateOn: 'change'
  })],
  props: {
    row: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h) {
    return h(uiGroup, {
      props: {
        wrap: this.wrap,
        vertical: !this.row,
        controls: true
      },
      attrs: this.qaAttributes
    }, this.$slots.default);
  }
};

var index$m = generatePlugin(uiToggleGroup);

var style$r = createStyle('toggle');
/**
 * @type {Object | string}
 */

var style$s = {
  value: style$r(),
  marker: style$r('marker')(),
  content: style$r('content')(),
  label: style$r('label')(),
  message: style$r('message')()
};

var _this$n = null;
var uiToggle = {
  name: 'ui-toggle',
  mixins: [childFactory({
    namespace: 'toggleGroup'
  }), factory$4({
    tag: 'span'
  }), factory$1({
    tag: 'span'
  }), factory$2({
    validateOn: 'change'
  }), Testable],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$n);

    return {
      isFocused: false,
      isActive: false
    };
  }.bind(null),
  computed: {
    isInGroup: function isInGroup() {
      return !!this.toggleGroup;
    },
    isChecked: function isChecked() {
      return this.isInGroup ? this.isSelected : this.value;
    },
    classes: function classes() {
      return {
        '-focused': this.isFocused,
        '-selected': this.isChecked,
        '-error': this.isErrorState || !!this.validationError,
        '-disabled': this.disabled,
        '-active': this.isActive
      };
    },
    attributes: function attributes() {
      return _objectSpread2({
        type: 'checkbox',
        id: this.id,
        checked: this.isChecked,
        disabled: this.disabled,
        name: this.name,
        'aria-label': this.labelText,
        'aria-checked': this.isChecked === null ? 'mixed' : this.isChecked
      }, this.qaAttributes);
    },
    wrapperHandlers: function wrapperHandlers() {
      var _this2 = this;

      return {
        mousedown: function mousedown() {
          _newArrowCheck(this, _this2);

          return this.mouseDownHandler();
        }.bind(this),
        mouseup: function mouseup() {
          _newArrowCheck(this, _this2);

          return this.mouseLeaveHandler();
        }.bind(this),
        mouseleave: function mouseleave() {
          _newArrowCheck(this, _this2);

          return this.mouseLeaveHandler();
        }.bind(this)
      };
    },
    inputHandlers: function inputHandlers() {
      var _this3 = this;

      return {
        change: function change(e) {
          _newArrowCheck(this, _this3);

          return this.changeHandler(e);
        }.bind(this),
        click: function click(e) {
          _newArrowCheck(this, _this3);

          return this.clickHandler(e);
        }.bind(this),
        focus: function focus(e) {
          _newArrowCheck(this, _this3);

          return this.focusHandler(e);
        }.bind(this),
        blur: function blur(e) {
          _newArrowCheck(this, _this3);

          return this.blurHandler(e);
        }.bind(this)
      };
    },
    labelOptions: function labelOptions() {
      return {
        staticClass: style$s.label
      };
    },
    messageOptions: function messageOptions() {
      return {
        staticClass: style$s.message
      };
    }
  },
  methods: {
    changeHandler: function changeHandler() {
      var v = this.value === null ? false : !this.value;
      this.isInGroup ? this.select() : this.$emit('change', v);
    },
    clickHandler: function clickHandler(e) {
      this.$emit('click', e);
    },
    focusHandler: function focusHandler(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    mouseDownHandler: function mouseDownHandler() {
      if (this.disabled) {
        return;
      }

      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler() {
      if (this.disabled) {
        return;
      }

      this.isActive = false;
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement(uiGroupItem, {
        props: {
          tag: 'label'
        },
        staticClass: style$s.value,
        class: this.classes,
        on: this.wrapperHandlers
      }, content);
    },
    genInput: function genInput() {
      return this.$createElement('input', {
        ref: 'input',
        domProps: {
          checked: this.isChecked,
          disabled: this.disabled
        },
        attrs: this.attributes,
        on: this.inputHandlers
      });
    },
    genMarker: function genMarker() {
      return this.$createElement('span', {
        staticClass: style$s.marker
      });
    },
    genContent: function genContent() {
      if (!this.hasLabel) {
        return null;
      }

      return this.$createElement('span', {
        staticClass: style$s.content
      }, [this.genLabel(), this.genMessage(this.validationError)]);
    }
  },
  render: function render() {
    return this.genWrapper([this.genMarker(), this.genInput(), this.genContent()]);
  }
};

var index$l = generatePlugin(uiToggle);

var _this$m = null;
var style$q = createStyle('table-col');
var uiTableColumn$1 = {
  name: 'ui-table-column',
  props: {
    /**
     * Content alignment inside wrapper
     */
    align: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$m);

        return ['left', 'right', 'center', null].includes(v);
      }.bind(null)
    },

    /**
     * Shows sort icon and make column sortable
     */
    sortable: {
      type: Boolean,
      default: false
    },

    /**
     * Columns attribute "rowspan"
     */
    rows: {
      type: [String, Number],
      default: null
    },

    /**
     * Columns attribute "colspan"
     */
    cols: {
      type: [String, Number],
      default: null
    },

    /**
     * Sort direction
     */
    direction: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$m);

        return ['asc', 'desc'].includes(v);
      }.bind(null)
    },

    /**
     *
     */
    highlighted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Click event handler
     *
     * @param {MouseEvent} e
     */
    clickHandler: function clickHandler(e) {
      this.$emit('click', e);

      if (this.sortable) {
        var v = this.direction === null ? 'desc' : this.direction === 'desc' ? 'asc' : null;
        this.$emit('toggle', v);
      }
    },

    /**
     * Generates column template
     *
     * @param {Array<VNode>} content
     * @return {VNode}
     */
    genColumn: function genColumn(content) {
      var _this2 = this;

      return this.$createElement('th', {
        staticClass: style$q(),
        class: {
          '-sortable': this.sortable,
          '-highlighted': this.highlighted
        },
        attrs: {
          rowspan: this.rows,
          colspan: this.cols
        },
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this2);

            return this.clickHandler(e);
          }.bind(this)
        }
      }, content);
    },

    /**
     * Generates title's wrapper template
     *
     * @param {Array<VNode>} content
     * @return {VNode}
     */
    genWrapper: function genWrapper(content) {
      return this.$createElement('span', {
        staticClass: style$q('content')(),
        class: {
          '-right': this.align === 'right',
          '-center': this.align === 'center'
        }
      }, content);
    },

    /**
     * Generates title template
     *
     * @return {VNode}
     */
    genTitle: function genTitle() {
      return this.$createElement('span', {
        staticClass: style$q('title')()
      }, this.$slots.default);
    },

    /**
     * Generates sort icon template
     *
     * @return {VNode | null}
     */
    genIcon: function genIcon() {
      if (!this.sortable) {
        return null;
      }

      return this.$createElement(uiIcon, {
        staticClass: style$q('icon')(),
        class: {
          '-asc': this.direction === 'asc',
          '-desc': this.direction === 'desc'
        },
        props: {
          name: 'sort',
          interactive: true
        }
      });
    }
  },
  render: function render() {
    return this.genColumn([this.genWrapper([this.genTitle(), this.genIcon()])]);
  }
};

var uiTableColumn = generatePlugin(uiTableColumn$1);

var uiTableRow$1 = {
  name: 'ui-table-row',
  props: {
    expandable: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    related: {
      type: Boolean,
      default: false
    },
    interactive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      this.$emit('click', e);

      if (this.expandable) {
        this.$emit('toggle');
      }
    },
    dblclickHandler: function dblclickHandler(e) {
      this.$emit('dblclick', e);
    }
  },
  render: function render(h) {
    var _this = this;

    return h('tr', {
      staticClass: createStyle('table-row')(),
      class: {
        '-related': this.related,
        '-expandable': this.expandable,
        '-expanded': this.expanded,
        '-interactive': this.interactive
      },
      on: {
        click: function click(e) {
          _newArrowCheck(this, _this);

          return this.clickHandler(e);
        }.bind(this),
        dblclick: function dblclick(e) {
          _newArrowCheck(this, _this);

          return this.dblclickHandler(e);
        }.bind(this)
      }
    }, this.$slots.default);
  }
};

var uiTableRow = generatePlugin(uiTableRow$1);

var _this$l = null;
var uiTableCell$1 = {
  name: 'ui-table-cell',
  functional: true,
  props: {
    cols: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$l);

        return !Number.isNaN(parseInt(v, 10)) && v > 0;
      }.bind(null)
    },
    rows: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$l);

        return !Number.isNaN(parseInt(v, 10)) && v > 0;
      }.bind(null)
    },
    highlighted: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        listeners = _ref.listeners,
        children = _ref.children,
        data = _ref.data;
    return h('td', a(data, {
      staticClass: createStyle('table-cell')(),
      class: {
        '-highlighted': props.highlighted
      },
      attrs: {
        colspan: props.cols,
        rowspan: props.rows
      },
      on: listeners
    }), children);
  }
};

var uiTableCell = generatePlugin(uiTableCell$1);

var _excluded$2 = ["class", "style"];

var _this$k = null;
var style$p = createStyle('table');
/**
 * @type {{ column: string, indexedColumn: (function(*): string), row: string, indexedRow: (function(*): string) }}
 */

var defaultSlots = {
  column: 'column',
  indexedColumn: function indexedColumn(index) {
    _newArrowCheck(this, _this$k);

    return "column-".concat(index);
  }.bind(null),
  row: 'row',
  indexedRow: function indexedRow(index) {
    _newArrowCheck(this, _this$k);

    return "row-".concat(index);
  }.bind(null),
  related: 'related',
  indexedRelated: function indexedRelated(index) {
    _newArrowCheck(this, _this$k);

    return "related-".concat(index);
  }.bind(null),
  relatedRow: 'related-row',
  indexedRelatedRow: function indexedRelatedRow(index) {
    _newArrowCheck(this, _this$k);

    return "related-row-".concat(index);
  }.bind(null)
};
var uiTable = {
  name: 'ui-table',
  model: {
    prop: 'sort',
    event: 'change'
  },
  props: {
    /**
     * Sort options. Uses for v-model.
     */
    sort: {
      type: Object,
      default: null,
      // eslint-disable-next-line max-len
      validator: function validator(v) {
        _newArrowCheck(this, _this$k);

        return v === null || typeof v.column === 'string' && ['asc', 'desc'].includes(v.direction);
      }.bind(null)
    },

    /**
     * Table columns which will be rendered in head
     */
    columns: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$k);

        return [];
      }.bind(null)
    },

    /**
     * Table rows which will be rendered in body
     */
    rows: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$k);

        return [];
      }.bind(null)
    },

    /**
     * Название поля, в котором будут храниться настройки строки
     */
    rowOptions: {
      type: String,
      default: 'options'
    },

    /**
     * Related rows field name
     */
    relatedRows: {
      type: String,
      default: null
    },

    /**
     * Custom names of slots
     */
    slots: {
      type: Object,
      default: function _default() {
        _newArrowCheck(this, _this$k);

        return _objectSpread2({}, defaultSlots);
      }.bind(null)
    },

    /**
     * Disable native inner table scroll
     */
    disableScroll: {
      type: Boolean,
      default: false
    },

    /**
     * Applies inline scss to table
     */
    inline: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$k);

    return {
      /**
       * Current sort column
       *
       * @type {string | null}
       */
      column: null,

      /**
       * Current sort direction
       *
       * @type {'asc' | 'desc' | null}
       */
      direction: null,

      /**
       * Current expanded row
       *
       * @type {number | null}
       */
      expandedRow: null,

      /**
       * Shadows visibility state
       *
       * @type {{ left: boolean, right: boolean }}
       */
      shadows: {
        left: false,
        right: false
      }
    };
  }.bind(null),
  computed: {
    /**
     * All columns' keys
     *
     * @returns {Array<string>}
     */
    keys: function keys() {
      var _this2 = this;

      return this.columns.map(function (_ref) {
        var key = _ref.key;

        _newArrowCheck(this, _this2);

        return key;
      }.bind(this));
    },

    /**
     * @return {*[]}
     */
    highlightedCols: function highlightedCols() {
      var _this3 = this;

      return this.columns.filter(function (_ref2) {
        var highlighted = _ref2.highlighted;

        _newArrowCheck(this, _this3);

        return highlighted;
      }.bind(this)).map(function (_ref3) {
        var key = _ref3.key;

        _newArrowCheck(this, _this3);

        return key;
      }.bind(this));
    },

    /**
     * All rows in sort order
     *
     * @returns {Array<Object>}
     */
    sortedRows: function sortedRows() {
      return this.column && this.direction ? orderBy(this.rows, [this.column], [this.direction]) : this.rows;
    },

    /**
     * Sort direction for each column
     *
     * @returns {Object<string, 'asc' | 'desc' | null>}
     */
    columnsDirection: function columnsDirection() {
      var _this4 = this;

      return this.columns.reduce(function (acc, _ref4) {
        var key = _ref4.key;

        _newArrowCheck(this, _this4);

        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, this.column === key ? this.direction : null));
      }.bind(this), {});
    },

    /**
     * Rows' indexes which could be expanded
     *
     * @returns {Array<number>}
     */
    expandableRows: function expandableRows() {
      var _this5 = this;

      if (typeof this.relatedRows !== 'string') {
        return [];
      }

      return this.rows.map(function (row, index) {
        _newArrowCheck(this, _this5);

        var rows = row[this.relatedRows];
        var isExpandable = Array.isArray(rows) ? rows.length > 0 : !!rows;
        return isExpandable ? index : null;
      }.bind(this)).filter(function (v) {
        _newArrowCheck(this, _this5);

        return v !== null;
      }.bind(this));
    }
  },
  watch: {
    sort: {
      immediate: true,
      deep: true,
      handler: function handler(v) {
        this.column = v !== null ? v.column : null;
        this.direction = v !== null ? v.direction : null;
      }
    }
  },
  methods: {
    /**
     * Width resize handler
     */
    calculateShadowsVisibility: function calculateShadowsVisibility() {
      var _this$$refs$container = this.$refs.container,
          scrollLeft = _this$$refs$container.scrollLeft,
          scrollWidth = _this$$refs$container.scrollWidth,
          clientWidth = _this$$refs$container.clientWidth;
      this.shadows.left = scrollLeft > 0;
      this.shadows.right = scrollLeft + clientWidth < scrollWidth;
    },
    // handleContainerScroll() {
    //   const { head, container } = this.$refs;
    //
    //   head.style.setProperty('transform', `translate3d(-${container.scrollLeft}px, 0, 0)`);
    // },

    /**
     * Column sort change event handler
     *
     * @param {string} column Column key
     * @param {'asc' | 'desc' | null} direction Sort direction
     */
    handleSortChange: function handleSortChange(column, direction) {
      this.column = column;
      this.direction = direction;
      this.$emit('change', direction === null ? null : {
        column: column,
        direction: direction
      });
    },

    /**
     * @param {number} index
     */
    handleExpandedRowChange: function handleExpandedRowChange(index) {
      this.expandedRow = this.expandedRow === index ? null : index;
      this.$emit('row-toggle', {
        index: index,
        isExpanded: this.expandedRow === index
      });
    },

    /**
     * @param {Event} e
     * @param {string | number} key
     */
    handleColumnClick: function handleColumnClick(e, key) {
      this.$emit('column-click', e, key);
    },

    /**
     * @param {Event} e
     * @param {string | number} index
     */
    handleRowClick: function handleRowClick(e, index) {
      this.$emit('row-click', e, index);
    },

    /**
     * @param {Event} e
     * @param {string | number} index
     */
    handleRowDblClick: function handleRowDblClick(e, index) {
      this.$emit('row-dbl-click', e, index);
    },

    /**
     * @param {Event} e
     * @param {string | number} rowIndex
     * @param {string | number} columnKey
     */
    handleCellClick: function handleCellClick(e, rowIndex, columnKey) {
      this.$emit('cell-click', e, rowIndex, columnKey);
    },

    /**
     * @param {Object} row
     * @return {{ highlighted: boolean }}
     */
    getRowOptions: function getRowOptions(row) {
      return row[this.rowOptions] || {
        highlighted: false
      };
    },

    /**
     * Get content from slot with priority
     *
     * @param {string | number} key
     * @param {string | number} indexedKey
     * @return {function(props: *): VNode[] | VNode[] | undefined}
     */
    getSlotContent: function getSlotContent(key, indexedKey) {
      // eslint-disable-next-line max-len
      return this.$scopedSlots[indexedKey] || this.$slots[indexedKey] || this.$scopedSlots[key] || this.$slots[key];
    },

    /**
     * Get content for cols and cells
     *
     * @param {*} value
     * @return {*}
     */
    getContent: function getContent(value) {
      return value === null || value === undefined ? '' : value;
    },

    /**
     * Generates wrapper template
     *
     * @param {Array<VNode>} content
     * @returns {VNode}
     */
    genWrapper: function genWrapper() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.$createElement('div', {
        staticClass: style$p()
      }, [this.genLeftShadow(), this.genRightShadow(), this.$createElement('div', {
        ref: 'container',
        staticClass: style$p('container')()
      }, [// this.genStickyHead(),
      this.genTable(content)])]);
    },

    /**
     * Generates shadow template
     *
     * @param {boolean} show
     * @param {string} type
     * @return {VNode}
     */
    genShadow: function genShadow(show, type) {
      var _class;

      return this.$createElement('div', {
        staticClass: style$p('shadow')(),
        class: (_class = {}, _defineProperty(_class, "-".concat(type), true), _defineProperty(_class, '-hidden', !show), _class),
        attrs: {
          'data-shadow': type
        }
      });
    },

    /**
     * Generates left shadow template
     *
     * @return {VNode}
     */
    genLeftShadow: function genLeftShadow() {
      return this.genShadow(this.shadows.left, 'left');
    },

    /**
     * Generates right shadow template
     *
     * @return {VNode}
     */
    genRightShadow: function genRightShadow() {
      return this.genShadow(this.shadows.right, 'right');
    },

    /**
     * Generates sticky table header template
     *
     * @return {VNode}
     */
    // genStickyHead() {
    //   return this.genTable([this.genHead()], {
    //     ref: 'head',
    //     class: {
    //       [$style.sticky]: true,
    //     },
    //   });
    // },

    /**
     * Generates table template
     *
     * @param {Array<VNode>} content
     * @param {Object?} data
     * @returns {VNode}
     */
    genTable: function genTable(content) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.$createElement('table', data, content);
    },

    /**
     * Generates header template
     *
     * @param {Object?} options
     * @returns {VNode}
     */
    genHead: function genHead() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.$createElement('thead', _objectSpread2(_objectSpread2({}, options), {}, {
        staticClass: style$p('head')()
      }), this.$slots.head || [this.$createElement('tr', this.genColumns())]);
    },

    /**
     * Generates columns templates
     *
     * @returns {Array<VNode>}
     */
    genColumns: function genColumns() {
      var _this6 = this;

      return this.columns.map(function (col) {
        _newArrowCheck(this, _this6);

        return this.genColumn(col);
      }.bind(this));
    },

    /**
     * Generates column template
     *
     * @param {{ key: string, title?: string, class?: string | Array<string> | Object, style?: string | Array<string> | Object, sortable?: boolean }} col
     * @returns {VNode}
     */
    genColumn: function genColumn(col) {
      var _this7 = this;

      if (!('key' in col)) {
        throw new FrameworkError('Column key missing');
      } // eslint-disable-next-line max-len


      var content = this.getSlotContent(this.slots.column, this.slots.indexedColumn(col.key, col)) || this.getContent(col.title);

      var _col$class = col.class,
          classes = _col$class === void 0 ? null : _col$class,
          _col$style = col.style,
          styles = _col$style === void 0 ? null : _col$style,
          props = _objectWithoutProperties(col, _excluded$2);

      return this.$createElement(uiTableColumn, {
        class: classes,
        style: styles,
        props: _objectSpread2(_objectSpread2({}, props), {}, {
          direction: this.columnsDirection[col.key]
        }),
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this7);

            return this.handleColumnClick(e, col.key);
          }.bind(this),
          toggle: function toggle(direction) {
            _newArrowCheck(this, _this7);

            return this.handleSortChange(col.key, direction);
          }.bind(this)
        }
      }, [typeof content === 'function' ? content(col) : content]);
    },

    /**
     * Generates body template
     *
     * @returns {VNode}
     */
    genBody: function genBody() {
      return this.sortedRows.length ? this.$createElement('tbody', this.$slots.body || this.genRows(this.sortedRows)) : '';
    },

    /**
     * Generates rows templates
     *
     * @todo refactoring
     *
     * @param {Array<Object>} rows
     * @returns {Array<Array<VNode>>}
     */
    genRows: function genRows(rows) {
      var _this8 = this;

      return rows.map(function (row) {
        _newArrowCheck(this, _this8);

        var index = this.rows.indexOf(row);
        var expandable = this.expandableRows.includes(index);
        return [this.genRow(row, index, {
          expandable: expandable
        })].concat(_toConsumableArray(expandable && this.expandedRow === index ? this.genRelatedRows(row[this.relatedRows], row, index) : []));
      }.bind(this));
    },

    /**
     * Generates related rows templates
     *
     * @param {*} rows
     * @param {Object} parent
     * @param {number} parentIndex
     * @returns {Array<VNode>}
     */
    genRelatedRows: function genRelatedRows(rows, parent, parentIndex) {
      var _this9 = this;

      var content = this.getSlotContent(this.slots.related, this.slots.indexedRelated(parentIndex));

      if (content) {
        return typeof content === 'function' ? content({
          rows: rows,
          parent: parent,
          parentIndex: parentIndex
        }) : content;
      }

      if (Array.isArray(rows) && rows.length > 0) {
        return rows.map(function (row, index) {
          _newArrowCheck(this, _this9);

          return this.genRow(row, index, {
            related: true,
            parent: parent,
            parentIndex: parentIndex
          });
        }.bind(this));
      }

      return [this.genRow({}, 0, {
        related: true,
        parent: parent,
        parentIndex: parentIndex
      })];
    },

    /**
     * Generates row template
     *
     * @todo refactoring
     *
     * @param {Object} row
     * @param {number} index
     * @param {{ related?: boolean, expandable?: boolean, parent?: Object, parentIndex?: number | null }} options
     * @returns {VNode}
     */
    // eslint-disable-next-line
    genRow: function genRow(row, index, _ref5) {
      var _this10 = this;

      var _ref5$related = _ref5.related,
          related = _ref5$related === void 0 ? false : _ref5$related,
          _ref5$expandable = _ref5.expandable,
          expandable = _ref5$expandable === void 0 ? false : _ref5$expandable,
          _ref5$parent = _ref5.parent,
          parent = _ref5$parent === void 0 ? null : _ref5$parent,
          _ref5$parentIndex = _ref5.parentIndex,
          parentIndex = _ref5$parentIndex === void 0 ? null : _ref5$parentIndex;
      var relatedIndex = related ? "".concat(parentIndex, "-").concat(index) : null;

      var _this$getRowOptions = this.getRowOptions(row),
          highlighted = _this$getRowOptions.highlighted;

      var indexedSlot = related ? this.slots.indexedRelatedRow(relatedIndex) : this.slots.indexedRow(index);
      var slot = related ? this.slots.relatedRow : this.slots.row; // eslint-disable-next-line max-len

      var content = this.$scopedSlots[indexedSlot] || this.$slots[indexedSlot] || this.$scopedSlots[slot] || this.$slots[slot] || this.genCells(row, related ? relatedIndex : index);

      if (typeof content === 'function') {
        content = content({
          row: row,
          parent: parent,
          expandedRowIndex: this.expandedRow
        });
      }

      return this.$createElement(uiTableRow, {
        key: related ? relatedIndex : index,
        props: {
          related: related,
          expandable: expandable,
          interactive: !highlighted,
          expanded: related ? false : this.expandedRow === index
        },
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this10);

            return this.handleRowClick(e, index);
          }.bind(this),
          dblclick: function dblclick(e) {
            _newArrowCheck(this, _this10);

            return this.handleRowDblClick(e, index);
          }.bind(this),
          toggle: function toggle() {
            _newArrowCheck(this, _this10);

            return this.handleExpandedRowChange(index);
          }.bind(this)
        }
      }, [content]);
    },

    /**
     * Generates cells templates
     *
     * @param {Object} row
     * @param {number} index
     * @returns {Array<VNode>}
     */
    genCells: function genCells(row, index) {
      var _this11 = this;

      return this.keys.map(function (key) {
        _newArrowCheck(this, _this11);

        return this.genCell(key, row, index);
      }.bind(this));
    },

    /**
     * Generates cell template
     *
     * @param {string} key
     * @param {Object} row
     * @param {number} index
     * @returns {VNode}
     */
    genCell: function genCell(key, row, index) {
      var _this12 = this;

      var value = row[key]; // eslint-disable-next-line max-len

      var _this$getRowOptions2 = this.getRowOptions(row),
          highlighted = _this$getRowOptions2.highlighted;

      var content = this.getSlotContent(key, "".concat(key, "-").concat(index)) || this.getContent(value);
      return this.$createElement(uiTableCell, {
        key: key,
        props: {
          highlighted: highlighted || this.highlightedCols.includes(key)
        },
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this12);

            return this.handleCellClick(e, index, key);
          }.bind(this)
        }
      }, [typeof content === 'function' ? content({
        value: value,
        row: row
      }) : content]);
    },

    /**
     * Generate footer template
     *
     * @returns {null | VNode}
     */
    genFoot: function genFoot() {
      var content = this.$slots.foot;

      if (!content) {
        return null;
      }

      return this.$createElement('tfoot', content);
    }
  },
  created: function created() {
    if (typeof this.slots.indexedRow !== 'function') {
      // eslint-disable-next-line max-len
      throw new FrameworkError('"indexedRow" must be a function, which returns name of slot as string');
    }

    if (typeof this.slots.indexedRelatedRow !== 'function') {
      // eslint-disable-next-line max-len
      throw new FrameworkError('"indexedRelatedRow" must be a function, which returns name of slot as string');
    }

    if (typeof this.slots.indexedColumn !== 'function') {
      // eslint-disable-next-line max-len
      throw new FrameworkError('"indexedColumn" must be a function, which returns name of slot as string');
    }
  },
  mounted: function mounted() {
    this.$_resizeHandler = throttle(this.calculateShadowsVisibility, 200);
    this.$_resizeHandler();
    window.addEventListener('resize', this.$_resizeHandler);
    this.$refs.container.addEventListener('scroll', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
    this.$refs.container.removeEventListener('scroll', this.$_resizeHandler);
  },
  render: function render() {
    return this.genWrapper([this.genHead(), this.genBody(), this.genFoot()]);
  }
};

var index$k = generatePlugin(uiTable);

var _this$j = null;
var style$o = createStyle('tab');
var uiTab$1 = {
  name: 'ui-tab',
  mixins: [childFactory({
    namespace: 'tabsGroup',
    prop: 'name'
  }), Routable, Testable],
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    name: {
      type: [String, Number],
      default: null
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(v) {
        _newArrowCheck(this, _this$j);

        return ['default', 'small'].includes(v);
      }.bind(null)
    },
    label: {
      type: String,
      default: null
    },
    activeClass: {
      type: String,
      default: '-active'
    },
    exactActiveClass: {
      type: String,
      default: '-active'
    },
    exact: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    click: function click(e) {
      this.$emit('click', e);

      if (!this.isLink) {
        this.select();
      }
    },
    genWrapper: function genWrapper(content) {
      var _this$generateRouterL2;

      var _this$generateRouterL = this.generateRouterLink((_this$generateRouterL2 = {}, _defineProperty(_this$generateRouterL2, style$o(), true), _defineProperty(_this$generateRouterL2, this.activeClass, this.isSelected && !this.isLink), _defineProperty(_this$generateRouterL2, '-small', this.size === 'small'), _this$generateRouterL2)),
          tag = _this$generateRouterL.tag,
          data = _this$generateRouterL.data;

      Object.assign(data.attrs, {
        'data-tab': ''
      }, this.qaAttributes);
      return this.$createElement(tag, data, content);
    },
    genTitle: function genTitle() {
      return this.$createElement('span', [this.label || this.$slots.default]);
    }
  },
  created: function created() {
    if (!this.isLink && !this.name) {
      throw new FrameworkError('Missing required property "name"');
    }
  },
  render: function render() {
    return this.genWrapper([this.genTitle()]);
  }
};

var uiTab = generatePlugin(uiTab$1);

var _excluded$1 = ["title"];

var _this$i = null;
var style$n = createStyle('tabs');
/**
 * Default tab options
 *
 * @type {Readonly<Object>}
 */

var defaultOptionProps = Object.freeze({
  title: null,
  name: undefined,
  to: undefined,
  href: undefined,
  native: undefined,
  qa: null
});
var uiTabs = {
  name: 'ui-tabs',
  mixins: [providerFactory({
    namespace: 'tabsGroup',
    selectionType: 'single',
    itemValueProp: 'name'
  })],
  props: {
    /**
     * Array of tabs
     */
    options: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$i);

        return [];
      }.bind(null)
    },

    /**
     * Draws tabs inside uiContainer
     */
    container: {
      type: Boolean,
      default: false
    },

    /**
     * Hide tabs underline
     */
    withoutUnderline: {
      type: Boolean,
      default: false
    },

    /**
     * Shows control buttons on non-touch devices
     */
    controls: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$i);

    return {
      /**
       * Shows left shadow inside tabs' container
       *
       * @type {boolean}
       */
      left: false,

      /**
       * Shows right shadow inside tabs' container
       *
       * @type {boolean}
       */
      right: false
    };
  }.bind(null),
  computed: {
    /**
     * Is tabs options passed
     *
     * @return {boolean}
     */
    hasOptions: function hasOptions() {
      return !!this.options.length;
    }
  },
  methods: {
    /**
     * Watch scroll position inside wrapper element and calculates shadows visibility
     */
    calculateScrollOffset: function calculateScrollOffset() {
      var _this$$refs$wrapper = this.$refs.wrapper,
          scrollLeft = _this$$refs$wrapper.scrollLeft,
          scrollWidth = _this$$refs$wrapper.scrollWidth,
          clientWidth = _this$$refs$wrapper.clientWidth;
      this.left = scrollLeft > 0;
      this.right = scrollLeft + clientWidth < scrollWidth;
    },

    /**
     * After child component register hook
     *
     * @param {Vue} tab
     */
    afterRegister: function afterRegister(tab) {
      var _this2 = this;

      tab.$on('click', function () {
        _newArrowCheck(this, _this2);

        return this.scrollToTab(tab.$el);
      }.bind(this));
    },

    /**
     * Scroll to given tab element
     *
     * @param {Element | HTMLElement} el
     * @param {boolean?} useAnimation
     */
    scrollToTab: function scrollToTab(el) {
      var useAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var wrapper = this.$refs.wrapper; // eslint-disable-next-line max-len

      var predictablePosition = wrapper.clientWidth / 2 - el.clientWidth / 4 + wrapper.scrollLeft;
      var offset = wrapper.scrollLeft + (el.offsetLeft - predictablePosition);

      if (useAnimation) {
        animate(wrapper, 'scrollLeft', offset, {
          duration: 200
        });
      } else {
        wrapper.scrollLeft = offset;
      }
    },

    /**
     * Generates tabs container template
     *
     * @param {Array<VNode>} content
     * @return {VNode}
     */
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$n()
      }, content);
    },

    /**
     * @param {string} type
     * @param {boolean} hidden
     * @param {Array<VNode> | VNode[]} content
     * @return {VNode}
     */
    genControl: function genControl(type, hidden, content) {
      return this.$createElement('div', {
        staticClass: style$n('control')(),
        class: {
          '-left': type === 'left',
          '-right': type === 'right',
          '-hidden': hidden
        }
      }, content);
    },

    /**
     * @return {VNode}
     */
    genLeftControl: function genLeftControl() {
      return this.genControl('left', !this.left, [this.genButton('left'), this.genShadow('left')]);
    },

    /**
     * @return {VNode}
     */
    genRightControl: function genRightControl() {
      return this.genControl('right', !this.right, [this.genShadow('right'), this.genButton('right')]);
    },

    /**
     * @param {string} type
     * @return {VNode}
     */
    genButton: function genButton(type) {
      var _this3 = this;

      if (isTouchDevice() || !this.controls) {
        return null;
      }

      return this.$createElement(uiButton, {
        staticClass: style$n('button')(),
        class: {
          '-left': type === 'left',
          '-right': type === 'right'
        },
        props: {
          theme: 'secondary',
          icon: 'arrowhead'
        },
        on: {
          click: function click() {
            _newArrowCheck(this, _this3);

            var wrapper = this.$refs.wrapper;
            var offset = type === 'left' ? -1 : 1; // eslint-disable-next-line max-len

            animate(wrapper, 'scrollLeft', wrapper.scrollLeft + wrapper.clientWidth * offset, {
              duration: 250
            });
          }.bind(this)
        }
      });
    },

    /**
     * Generates shadow template
     *
     * @param {string} type
     * @return {VNode}
     */
    genShadow: function genShadow(type) {
      return this.$createElement('div', {
        staticClass: style$n('shadow')(),
        class: {
          '-left': type === 'left',
          '-right': type === 'right'
        }
      });
    },

    /**
     * Generates container template
     *
     * @param {Array<VNode>} content
     * @return {VNode}
     */
    genContainer: function genContainer(content) {
      return this.container ? this.$createElement(uiContainer, {
        staticClass: style$n('container')()
      }, content) : content;
    },

    /**
     * Generates scrollable wrapper template
     *
     * @param {Array<VNode>} content
     * @return {VNode}
     */
    genContent: function genContent(content) {
      return this.$createElement('div', {
        ref: 'wrapper',
        staticClass: style$n('wrapper')()
      }, content);
    },

    /**
     * Generates tabs which passed through options property
     *
     * @return {Array<VNode>}
     */
    genTabs: function genTabs() {
      var _this4 = this;

      return this.options.map(function (tab) {
        _newArrowCheck(this, _this4);

        var _defaultOptionProps$t = _objectSpread2(_objectSpread2({}, defaultOptionProps), tab),
            title = _defaultOptionProps$t.title,
            props = _objectWithoutProperties(_defaultOptionProps$t, _excluded$1);

        return this.$createElement(uiTab, {
          props: props
        }, [title]);
      }.bind(this));
    },

    /**
     * Generates tabs wrapper's underline
     *
     * @return {VNode | null}
     */
    genUnderline: function genUnderline() {
      if (this.withoutUnderline) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$n('underline')()
      });
    },

    /**
     * Generates tab's content slot
     *
     * @return {Array<VNode> | null}
     */
    genTabSlot: function genTabSlot() {
      if (this.value === null) {
        return null;
      }

      return this.$slots[this.value] || null;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$_scrollHandler = throttle(this.calculateScrollOffset, 200);
    this.$_scrollHandler();
    /**
     * Watch window resize and wrapper scroll and recalculate shadows visibility
     */

    this.$refs.wrapper.addEventListener('scroll', this.$_scrollHandler);
    window.addEventListener('resize', this.$_scrollHandler);
    /**
     * Defers execution to 3 drawing frames (very important)
     */

    requestAnimationFrame(function () {
      var _this6 = this;

      _newArrowCheck(this, _this5);

      requestAnimationFrame(function () {
        var _this7 = this;

        _newArrowCheck(this, _this6);

        requestAnimationFrame(function () {
          var _this8 = this;

          _newArrowCheck(this, _this7);

          requestAnimationFrame(function () {
            var _this9 = this;

            _newArrowCheck(this, _this8);

            /**
             * Finding first active tab and scrolling view into it
             */
            // eslint-disable-next-line max-len
            var item = this.items.find(function (_ref) {
              var _this10 = this;

              var $el = _ref.$el,
                  activeClass = _ref.activeClass,
                  exactActiveClass = _ref.exactActiveClass;

              _newArrowCheck(this, _this9);

              return [activeClass, exactActiveClass].some(function (v) {
                _newArrowCheck(this, _this10);

                return $el.classList.contains(v);
              }.bind(this));
            }.bind(this));

            if (item) {
              this.scrollToTab(item.$el, false);
            }
          }.bind(this));
        }.bind(this));
      }.bind(this));
    }.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    /**
     * Remove all watchers
     */
    this.$refs.wrapper.removeEventListener('scroll', this.$_scrollHandler);
    window.removeEventListener('resize', this.$_scrollHandler);
  },

  /**
   * Build and render template
   *
   * @return {VNode}
   */
  render: function render() {
    return this.genWrapper([this.genContainer([this.genLeftControl(), this.genRightControl(), this.genContent([this.hasOptions ? this.genTabs() : this.$slots.default])]), this.genUnderline(), this.genTabSlot()]);
  }
};

var index$j = generatePlugin(uiTabs);

var _this$h = null;
var style$m = createStyle('tile');
var uiTile = {
  name: 'ui-tile',
  mixins: [Testable],
  props: {
    title: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    large: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'left',
      validator: function validator(value) {
        _newArrowCheck(this, _this$h);

        return ['left', 'right', 'center'].includes(value);
      }.bind(null)
    }
  },
  computed: {
    classes: function classes() {
      return {
        '-left': this.align === 'left',
        '-right': this.align === 'right',
        '-center': this.align === 'center',
        '-large': this.large,
        '-with-hint': this.hasHint
      };
    },
    hasHint: function hasHint() {
      return !!(this.hint || this.$slots.hint);
    }
  },
  methods: {
    genElement: function genElement(content, staticClass) {
      if (!content) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: staticClass
      }, content);
    },
    genTitle: function genTitle() {
      return this.genElement(this.title || this.$slots.title, style$m('label')());
    },
    genHint: function genHint() {
      return this.genElement(this.hint || this.$slots.hint, style$m('hint')());
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: style$m('content')()
      }, this.$slots.default);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: style$m(),
      class: this.classes,
      attrs: this.qaAttributes
    }, [this.genTitle(), this.genContent(), this.genHint()]);
  }
};

var index$i = generatePlugin(uiTile);

var index$h = generatePlugin(uiGroup, [uiGroupItem]);

var _this$g = null;
var style$l = createStyle('text');

var name = function name(v) {
  _newArrowCheck(this, _this$g);

  return style$l() + (v === 'text' ? '' : "-".concat(v));
}.bind(null);

var tagsForTypes = Object.freeze({
  hero: 'h1',
  'accident-large': 'h1',
  'accident-small': 'h3',
  accident: 'h1',
  h0: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  text: 'span'
});
var uiText$1 = {
  name: 'ui-text',
  functional: true,
  props: _objectSpread2({
    tag: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator: function validator(v) {
        _newArrowCheck(this, _this$g);

        return Object.keys(tagsForTypes).includes(v);
      }.bind(null)
    },
    breakpoints: {
      type: [Object, String],
      default: function _default() {
        _newArrowCheck(this, _this$g);

        return {};
      }.bind(null)
    },
    text: {
      type: String,
      default: null
    },
    weight: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$g);

        return ['bold', 'medium', 'regular', 'light', 'thin'].includes(v);
      }.bind(null)
    }
  }, qaProperty),
  render: function render(h, _ref) {
    var _this2 = this,
        _Object$entries$reduc;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag || tagsForTypes[props.type], a(data, {
      class: Object.entries(parseBreakpoints(props.breakpoints)).reduce(function (acc, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        _newArrowCheck(this, _this2);

        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "".concat(name(v), "-").concat(k), true));
      }.bind(this), (_Object$entries$reduc = {}, _defineProperty(_Object$entries$reduc, style$l(), true), _defineProperty(_Object$entries$reduc, name('hero'), props.type === 'hero'), _defineProperty(_Object$entries$reduc, name('accident-large'), props.type === 'accident-large'), _defineProperty(_Object$entries$reduc, name('accident'), props.type === 'accident'), _defineProperty(_Object$entries$reduc, name('accident-small'), props.type === 'accident-small'), _defineProperty(_Object$entries$reduc, name('h0'), props.type === 'h0'), _defineProperty(_Object$entries$reduc, name('h1'), props.type === 'h1'), _defineProperty(_Object$entries$reduc, name('h2'), props.type === 'h2'), _defineProperty(_Object$entries$reduc, name('h3'), props.type === 'h3'), _defineProperty(_Object$entries$reduc, 't-thin', props.weight === 'thin'), _defineProperty(_Object$entries$reduc, 't-light', props.weight === 'light'), _defineProperty(_Object$entries$reduc, 't-regular', props.weight === 'regular'), _defineProperty(_Object$entries$reduc, 't-medium', props.weight === 'medium'), _defineProperty(_Object$entries$reduc, 't-bold', props.weight === 'bold'), _Object$entries$reduc)),
      attrs: _defineProperty({}, qaAttributeName, props.qa)
    }), [props.text || children]);
  }
};

var uiText = generatePlugin(uiText$1);

var _this$f = null;
var style$k = createStyle('spinner'); // eslint-disable-next-line

var validator = function validator(v) {
  _newArrowCheck(this, _this$f);

  return !isNaN(parseInt(v)) && v > 0;
}.bind(null);

var uiSpinner$1 = {
  name: 'ui-spinner',
  functional: true,
  props: {
    theme: {
      type: String,
      validator: function validator(v) {
        _newArrowCheck(this, _this$f);

        return ['primary', 'secondary', 'partner'].includes(v);
      }.bind(null),
      default: null
    },
    size: {
      type: [String, Number],
      default: 40,
      validator: validator
    },
    border: {
      type: [String, Number],
      default: 2,
      validator: validator
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    return h('div', a(data, {
      staticClass: style$k(),
      class: {
        '-primary': props.theme === 'primary',
        '-secondary': props.theme === 'secondary',
        '-partner': props.theme === 'partner'
      },
      style: {
        width: "".concat(props.size, "px"),
        height: "".concat(props.size, "px"),
        'border-width': "".concat(props.border, "px")
      }
    }));
  }
};

var uiSpinner = generatePlugin(uiSpinner$1);

var _this$e = null;
var style$j = createStyle('preloader');
var uiPreloader = {
  name: 'ui-preloader',
  model: {
    prop: 'loading',
    event: 'toggle'
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$e);

        return ['primary', 'secondary', 'partner'].includes(v);
      }.bind(null)
    },
    size: {
      type: [String, Number],
      default: 40
    },
    border: {
      type: [String, Number],
      default: 2
    },
    overlayColor: {
      type: String,
      default: null
    }
  },
  methods: {
    genOverlay: function genOverlay() {
      return this.$createElement('div', {
        staticClass: style$j('overlay')(),
        class: {
          '-hidden': !this.loading
        },
        style: {
          'background-color': this.overlayColor
        }
      }, [this.$createElement(uiSpinner, {
        props: {
          theme: this.theme,
          size: this.size,
          border: this.border
        }
      })]);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: style$j()
    }, [this.genOverlay(), this.$slots.default]);
  }
};

var index$g = generatePlugin(uiPreloader);

var style$i = createStyle('badge');
var uiBadge = {
  name: 'ui-badge',
  mixins: [Testable],
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    genBadge: function genBadge() {
      if (!this.value) {
        return null;
      }

      return this.$createElement('span', {
        staticClass: style$i(),
        attrs: this.qaAttributes
      }, [this.value]);
    }
  },
  render: function render(h) {
    return h(this.tag, {
      staticClass: style$i('wrapper')()
    }, [this.genBadge(), this.$slots.default]);
  }
};

var index$f = generatePlugin(uiBadge);

var _this$d = null;
var uiLink = {
  name: 'ui-link',
  mixins: [Testable, Routable],
  props: {
    label: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$d);

        return v === 'secondary' || v === null;
      }.bind(null)
    },
    pseudo: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: '-active'
    },
    exactActiveClass: {
      type: String,
      default: '-active'
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, createStyle('link')(), true), _defineProperty(_ref, '-secondary', this.theme === 'secondary'), _defineProperty(_ref, '-pseudo', this.pseudo), _defineProperty(_ref, this.activeClass, this.active), _ref;
    }
  },
  render: function render(h) {
    var _this$generateRouterL = this.generateRouterLink(this.classes),
        tag = _this$generateRouterL.tag,
        data = _this$generateRouterL.data;

    if (!data.attrs) {
      data.attrs = {};
    }

    Object.assign(data.attrs, this.qaAttributes);
    return h(tag, data, [this.$slots.default || this.label]);
  }
};

var index$e = generatePlugin(uiLink);

var _this$c = null;
var style$h = createStyle('stepper');

var _validator = function validator(v) {
  _newArrowCheck(this, _this$c);

  return !Number.isNaN(parseInt(v, 10));
}.bind(null);

var uiStepper = {
  name: 'ui-stepper',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: 0,
      validator: function validator(v) {
        _newArrowCheck(this, _this$c);

        return _validator(v) && v > -1;
      }.bind(null)
    },
    total: {
      type: [String, Number],
      default: 100,
      validator: function validator(v) {
        _newArrowCheck(this, _this$c);

        return _validator(v) && v > 0;
      }.bind(null)
    },
    size: {
      type: [String, Number],
      default: 44,
      validator: function validator(v) {
        _newArrowCheck(this, _this$c);

        return _validator(v) && v > 0;
      }.bind(null)
    },
    border: {
      type: [String, Number],
      default: 3,
      validator: function validator(v) {
        _newArrowCheck(this, _this$c);

        return _validator(v) && v > 0;
      }.bind(null)
    },
    disableCounter: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    radius: function radius() {
      return (this.size - this.border) / 2;
    },
    length: function length() {
      return Math.PI * 2 * this.radius;
    },
    center: function center() {
      return this.size / 2;
    },
    offset: function offset() {
      return this.length / 360 * 90;
    },
    fill: function fill() {
      return this.length * (Math.max(this.value, 0) / this.total);
    },
    rest: function rest() {
      return this.length - this.fill;
    },
    hasLabel: function hasLabel() {
      return this.label || this.$slots.default;
    },
    counter: function counter() {
      var value = Math.min(this.value, this.total);
      return "".concat(value, "/").concat(this.total);
    }
  },
  methods: {
    genSvg: function genSvg() {
      return this.$createElement('div', {
        staticClass: style$h('svg')(),
        style: {
          width: "".concat(this.size, "px"),
          height: "".concat(this.size, "px")
        }
      }, [this.$createElement('svg', {
        attrs: {
          width: this.size,
          height: this.size,
          viewBox: "0 0 ".concat(this.size, " ").concat(this.size)
        }
      }, [this.genBackgroundCircle(), this.genForegroundCircle()]), this.genCounter()]);
    },
    genCircle: function genCircle(className) {
      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.$createElement('circle', {
        staticClass: className,
        attrs: _objectSpread2({
          cx: this.center,
          cy: this.center,
          r: this.radius,
          'stroke-width': this.border
        }, attrs)
      });
    },
    genBackgroundCircle: function genBackgroundCircle() {
      return this.genCircle(style$h('background')());
    },
    genForegroundCircle: function genForegroundCircle() {
      return this.genCircle(style$h('foreground')(), {
        'stroke-dasharray': "".concat(this.fill, " ").concat(this.rest),
        'stroke-dashoffset': this.offset
      });
    },
    genCounter: function genCounter() {
      if (this.disableCounter) {
        return null;
      }

      var content = this.$slots.counter || this.$scopedSlots.counter || this.counter;

      if (typeof content === 'function') {
        content = content({
          value: this.value,
          total: this.total
        });
      }

      return this.$createElement('div', {
        staticClass: style$h('counter')(),
        style: {
          width: "".concat(this.size, "px"),
          'max-width': "".concat(this.size, "px"),
          height: "".concat(this.size, "px")
        }
      }, content);
    },
    genLabel: function genLabel() {
      if (!this.hasLabel) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$h('label')()
      }, [this.label || this.$slots.default]);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: style$h()
    }, [this.genSvg(), this.genLabel()]);
  }
};

var index$d = generatePlugin(uiStepper);

var _this$b = null;
var style$g = createStyle('popover');

var validate = function validate(v) {
  _newArrowCheck(this, _this$b);

  return !Number.isNaN(parseInt(v, 10));
}.bind(null);

var uiPopover$1 = {
  name: 'ui-popover',
  mixins: [factory$3('opened', 'toggle'), inject, Transportable, Testable],
  directives: {
    ClickOutside: ClickOutside
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    position: {
      type: String,
      default: 'bottom'
    },
    positionMode: {
      type: String,
      default: 'absolute',
      validator: function validator(v) {
        _newArrowCheck(this, _this$b);

        return ['absolute', 'fixed'].includes(v);
      }.bind(null)
    },
    trigger: {
      type: String,
      default: 'click',
      validator: function validator(v) {
        _newArrowCheck(this, _this$b);

        return ['click', 'hover'].includes(v);
      }.bind(null)
    },
    manual: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$b);

        return validate(v) && v > 0 || v === 'auto' || v === null;
      }.bind(null)
    },
    zIndex: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$b);

        return validate(v) || v === null;
      }.bind(null)
    },
    closeDelay: {
      type: [String, Number],
      default: 1000,
      validator: function validator(v) {
        _newArrowCheck(this, _this$b);

        return validate(v) && v >= 100;
      }.bind(null)
    },
    hideArrow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$b);

    return {
      /**
       * Is Popper.js created
       *
       * @type {boolean}
       */
      popperCreated: false,

      /**
       * Popover bottom style property when is's open
       */
      openedPopoverBottom: -10
    };
  }.bind(null),
  computed: {
    /**
     * Allow open popover on activator click event
     *
     * @return {boolean}
     */
    allowOpenOnClick: function allowOpenOnClick() {
      return !this.manual && this.trigger === 'click';
    },

    /**
     * Popover css classes
     *
     * @return {Object}
     */
    classes: function classes() {
      return {
        '-opened': this.isOpened
      };
    },

    /**
     * Popover css properties
     *
     * @return {Object}
     */
    styles: function styles() {
      var width = !this.width ? null : this.width === 'auto' ? this.width : "".concat(this.width, "px");
      return {
        width: width,
        'z-index': this.zIndex || this.layer
      };
    },

    /**
     * Popover directives
     *
     * @return {Array}
     */
    directives: function directives() {
      var _this2 = this;

      return [{
        name: 'click-outside',
        value: function value() {
          _newArrowCheck(this, _this2);

          return this.close();
        }.bind(this),
        args: {
          closeConditional: function closeConditional(_ref) {
            var target = _ref.target;

            _newArrowCheck(this, _this2);

            if (!this.isOpened || this.trigger === 'hover' && !mediaMax('sm')) {
              return false;
            }

            var popover = this.$refs.popover;

            if (popover && popover.contains(target)) {
              return false;
            }

            return !!this.$el && !this.$el.contains(target) && target !== this.$el;
          }.bind(this)
        }
      }];
    },

    /**
     * Activator event handlers
     *
     * @return {Object}
     */
    handlers: function handlers() {
      var _this3 = this;

      if (this.manual) {
        return {};
      }

      if (this.trigger === 'hover') {
        return {
          mouseover: function mouseover(e) {
            _newArrowCheck(this, _this3);

            return !mediaMax('sm') && this.mouseOverHandler(e);
          }.bind(this),
          mouseleave: function mouseleave(e) {
            _newArrowCheck(this, _this3);

            return !mediaMax('sm') && this.mouseLeaveHandler(e);
          }.bind(this),
          click: function click(e) {
            _newArrowCheck(this, _this3);

            return mediaMax('sm') && this.clickHandler(e);
          }.bind(this)
        };
      }

      return {
        click: function click(e) {
          _newArrowCheck(this, _this3);

          return this.clickHandler(e);
        }.bind(this)
      };
    }
  },
  watch: {
    position: 'createPopper',
    positionMode: 'createPopper',
    hideArrow: 'createPopper',
    isOpened: function isOpened(value) {
      var _this4 = this;

      if (value) {
        this.$nextTick(function () {
          _newArrowCheck(this, _this4);

          if (this.$_popper) this.$_popper.update();
        }.bind(this));
      }
    }
  },
  methods: {
    /**
     * Creates instance of Popper.js
     */
    createPopper: function createPopper$1() {
      var _this$$refs = this.$refs,
          activator = _this$$refs.activator,
          popover = _this$$refs.popover,
          arrow = _this$$refs.arrow;
      this.$_popper = createPopper(activator, popover, this.position, _objectSpread2({
        strategy: this.positionMode
      }, !this.hideArrow && {
        modifiers: [{
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'bottom', 'left', 'right']
          }
        }, {
          name: 'arrow',
          options: {
            element: arrow
          }
        }, {
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }, {
          name: 'computeStyles',
          options: {
            adaptive: false
          }
        }]
      }));
    },

    /**
     * Activator mouse over handler
     */
    mouseOverHandler: function mouseOverHandler() {
      var _this5 = this;

      if (this.$_startOpening) {
        return;
      }

      if (this.$_closeTimeout) {
        clearTimeout(this.$_closeTimeout);
        return;
      }

      if (!this.isOpened) {
        this.$_startOpening = true;
        this.open();
        setTimeout(function () {
          _newArrowCheck(this, _this5);

          this.$_startOpening = false;
        }.bind(this), 100);
      }
    },

    /**
     * Activator mouse leave handler
     */
    mouseLeaveHandler: function mouseLeaveHandler() {
      var _this6 = this;

      if (!this.isOpened || mediaMax('sm')) {
        return;
      }

      this.$_closeTimeout = setTimeout(function () {
        _newArrowCheck(this, _this6);

        this.close();
        this.$_closeTimeout = null;
      }.bind(this), this.closeDelay);
    },

    /**
     * Activator mouse click handler
     */
    clickHandler: function clickHandler(e) {
      var value = !this.isOpened;
      this.handleModelChange(value);
      this.$emit('click', e);
    },
    touchStartHandler: function touchStartHandler(event) {
      var popover = this.$refs.popover;
      var pageY = event.changedTouches[0].pageY;
      popover.style.setProperty('transition', 'none');
      this.touchStartTime = new Date().getTime();
      this.touchStartY = pageY;
    },
    touchMoveHandler: function touchMoveHandler(event) {
      var popover = this.$refs.popover;
      var pageY = event.changedTouches[0].pageY;
      this.touchMoveOffset = pageY - this.touchStartY;
      var currentBottom = this.openedPopoverBottom - this.touchMoveOffset < 0 ? this.openedPopoverBottom - this.touchMoveOffset : 0;
      popover.style.setProperty('bottom', "".concat(currentBottom, "px"));
    },
    touchEndHandler: function touchEndHandler(event) {
      var popover = this.$refs.popover;
      var pageY = event.changedTouches[0].pageY;
      popover.style.removeProperty('transition');
      popover.style.removeProperty('bottom');
      this.touchEndTime = new Date().getTime();
      this.touchEndY = pageY;
      var touchSpeed = (this.touchEndY - this.touchStartY) / (this.touchEndTime - this.touchStartTime);

      if (popover.offsetHeight / 3 <= this.touchMoveOffset || touchSpeed > 0.2) {
        this.close();
      }
    },
    lockScroll: function lockScroll() {
      bodyScrollLock.disableBodyScroll(this.$refs.content);
    },
    unlockScroll: function unlockScroll() {
      bodyScrollLock.enableBodyScroll(this.$refs.content);
    },

    /**
     * Reassign and extend open and close methods from factory
     */
    open: function open() {
      this.isClosed = false;
      this.isOpened = true;
      if (mediaMax('sm')) this.lockScroll();
    },
    close: function close() {
      this.isClosed = true;
      this.isOpened = false;
      this.unlockScroll();
    },

    /**
     * Enable or disable Popper.js depending on the screen size
     */
    switchPopperView: function switchPopperView() {
      if (mediaMax('sm')) {
        if (this.popperCreated) {
          this.$_popper.destroy();
          this.popperCreated = false;
          this.isOpened ? this.lockScroll() : this.unlockScroll();
        }
      } else if (!this.popperCreated) {
        this.createPopper();
        this.popperCreated = true;
        if (this.isOpened) this.unlockScroll();
      }
    },

    /**
     * Generates activator wrapper template
     */
    genWrapper: function genWrapper(content) {
      return this.$createElement(this.tag, {
        ref: 'activator',
        staticClass: style$g('wrapper')(),
        attrs: _objectSpread2({
          'data-activator': ''
        }, this.qaAttributes),
        directives: this.directives,
        on: this.handlers
      }, content);
    },

    /**
     * Generates popover overlay
     */
    genPopoverOverlay: function genPopoverOverlay(content) {
      return this.$createElement('div', {
        ref: 'overlay',
        staticClass: style$g('overlay')(),
        class: this.classes,
        attrs: {
          'aria-hidden': !this.isOpened
        }
      }, content);
    },

    /**
     * Generates popover template
     */
    genPopover: function genPopover(content) {
      return this.$createElement('div', {
        ref: 'popover',
        staticClass: style$g(),
        style: this.styles,
        attrs: {
          'data-popover': ''
        }
      }, content);
    },

    /**
     * Generates popover content template
     */
    genPopoverContent: function genPopoverContent(content) {
      return this.$createElement('div', {
        ref: 'content',
        staticClass: style$g('content')()
      }, content);
    },

    /**
     * Generates popover's arrow template
     */
    genArrow: function genArrow() {
      if (this.hideArrow) {
        return null;
      }

      return this.$createElement('div', {
        ref: 'arrow',
        staticClass: style$g('arrow')()
      });
    },

    /**
     * Generates popover's swiper template
     */
    genSwiper: function genSwiper() {
      var _this7 = this;

      return this.$createElement('div', {
        ref: 'swiper',
        staticClass: style$g('swiper')(),
        on: {
          touchstart: function touchstart(e) {
            _newArrowCheck(this, _this7);

            return this.touchStartHandler(e);
          }.bind(this),
          touchmove: function touchmove(e) {
            _newArrowCheck(this, _this7);

            return this.touchMoveHandler(e);
          }.bind(this),
          touchend: function touchend(e) {
            _newArrowCheck(this, _this7);

            return this.touchEndHandler(e);
          }.bind(this),
          touchcancel: function touchcancel(e) {
            _newArrowCheck(this, _this7);

            return this.touchEndHandler(e);
          }.bind(this)
        }
      });
    }
  },
  mounted: function mounted() {
    this.transport(this.$refs.overlay, 'popovers');
    this.$_resizeHandler = throttle(this.switchPopperView, 100);
    this.$_resizeHandler();
    /**
     * Watch window resize and recalculate shadows visibility
     */

    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this.removeTransportedElement(this.$refs.overlay, 'popovers');
    window.removeEventListener('resize', this.$_resizeHandler);
    this.unlockScroll();
  },
  render: function render() {
    return this.genWrapper([this.$slots.activator, this.genPopoverOverlay([this.genPopover([this.genArrow(), this.genSwiper(), this.genPopoverContent([this.$slots.default])])])]);
  }
};

var uiPopover = generatePlugin(uiPopover$1);

var _excluded = ["text", "icon", "disabled"];

var _this$a = null;
var uiInfo = {
  name: 'ui-info',
  props: _objectSpread2({
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'question-circled'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    qa: {
      type: String,
      default: null
    }
  }, uiPopover.props),
  data: function data() {
    _newArrowCheck(this, _this$a);

    return {
      opened: false
    };
  }.bind(null),
  methods: {
    toggleHandler: function toggleHandler(v) {
      this.opened = v;
      this.$emit('toggle', this.opened);
    },
    genPopover: function genPopover(content) {
      var _this2 = this;

      // eslint-disable-next-line object-curly-newline
      var _this$$props = this.$props;
          _this$$props.text;
          _this$$props.icon;
          _this$$props.disabled;
          var props = _objectWithoutProperties(_this$$props, _excluded);

      return this.$createElement(uiPopover, {
        props: props,
        on: {
          toggle: function toggle(v) {
            _newArrowCheck(this, _this2);

            return this.toggleHandler(v);
          }.bind(this)
        }
      }, content);
    },
    genIcon: function genIcon() {
      return this.$createElement(uiIcon, {
        slot: 'activator',
        props: {
          name: this.icon,
          interactive: true,
          active: this.opened,
          disabled: this.disabled
        }
      });
    },
    genText: function genText() {
      return this.$createElement('div', {
        staticClass: createStyle('info')()
      }, [this.text || this.$slots.default]);
    }
  },
  render: function render() {
    return this.genPopover([this.genIcon(), this.genText()]);
  }
};

var index$c = generatePlugin(uiInfo);

var _this$9 = null;
var style$f = createStyle('alert');
var icons = {
  success: 'check-circled',
  error: 'cross-circled',
  info: 'hourglass-circled',
  warning: null
};
var uiAlert = {
  name: 'ui-alert',
  props: {
    theme: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$9);

        return ['success', 'error', 'warning', 'info'].includes(v);
      }.bind(null)
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  },
  computed: {
    classes: function classes() {
      return {
        '-success': this.theme === 'success',
        '-error': this.theme === 'error',
        '-warning': this.theme === 'warning',
        '-info': this.theme === 'info'
      };
    }
  },
  methods: {
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$f(),
        class: this.classes
      }, [this.$createElement(uiRow, [this.$createElement(uiCol, {
        props: {
          breakpoints: 'xs-12 sm-9'
        }
      }, content)]), this.genIcon()]);
    },
    genTitle: function genTitle() {
      var content = this.$slots.title || this.title;

      if (!content) {
        return null;
      }

      return this.$createElement(uiText, {
        staticClass: style$f('title')(),
        props: {
          type: 'h2',
          tag: 'div'
        }
      }, [content]);
    },
    genContent: function genContent() {
      return this.$createElement(uiText, {
        staticClass: style$f('content')(),
        props: {
          tag: 'div'
        }
      }, this.$slots.default);
    },
    genIcon: function genIcon() {
      var name = this.icon || (this.theme ? icons[this.theme] : null);

      if (!name) {
        return null;
      }

      return this.$createElement(uiIcon, {
        staticClass: style$f('icon')(),
        props: {
          name: name
        }
      });
    },
    genActions: function genActions() {
      if (!this.$slots.actions) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$f('actions')()
      }, this.$slots.actions);
    }
  },
  render: function render() {
    return this.genWrapper([this.genTitle(), this.genContent(), this.genActions()]);
  }
};

var index$b = generatePlugin(uiAlert);

var _this$8 = null;
var uiCollapseGroup = {
  name: 'ui-collapse-group',
  mixins: [provide$1('collapseGroup')],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$8);

    return {
      openedItemName: null
    };
  }.bind(null),
  watch: {
    value: {
      immediate: true,
      handler: function handler(v) {
        this.openedItemName = v;
      }
    },
    openedItemName: {
      immediate: true,
      handler: function handler(v) {
        this.update();
        this.$emit('change', v);
      }
    }
  },
  methods: {
    change: function change(item, isOpened) {
      this.openedItemName = isOpened ? item.name : null;
    },
    update: function update() {
      var _this2 = this;

      var v = this.openedItemName;
      Object.values(this.$_items || {}).forEach(function (item) {
        _newArrowCheck(this, _this2);

        var isOpened = item.name === v && v !== null;
        (isOpened ? item.open : item.close)();
      }.bind(this));
    },
    register: function register(item) {
      var _this3 = this;

      this.$_items[item.name] = item;

      this.$_listeners[item.name] = function (v) {
        _newArrowCheck(this, _this3);

        return this.change(item, v);
      }.bind(this);

      item.$on('toggle', this.$_listeners[item.name]);
    },
    unregister: function unregister(item) {
      if (this.$_isDestroying) {
        return;
      }

      if (item.name in this.$_items) {
        item.$off('toggle', this.$_listeners[item.name]);
        delete this.$_items[item.name];
        delete this.$_listeners[item.name];

        if (this.openedItemName === item.name) {
          this.openedItemName = null;
        }
      }
    }
  },
  created: function created() {
    this.$_items = {};
    this.$_listeners = {};
  },
  beforeDestroy: function beforeDestroy() {
    this.$_isDestroying = true;
  },
  render: function render(h) {
    return h('div', {
      staticClass: createStyle('collapse-group')()
    }, this.$slots.default);
  }
};

var index$a = generatePlugin(uiCollapseGroup);

var _this$7 = null;
var style$e = createStyle('collapse');
var uiCollapse = {
  name: 'ui-collapse',
  mixins: [inject$1('collapseGroup'), Toggleable],
  props: {
    title: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$7);

        return ['secondary'].includes(v);
      }.bind(null)
    },
    name: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      var v = !this.isOpened;

      if (!this.$_registered) {
        this.handleModelChange(v);
      }

      this.$emit('toggle', v);
      this.$emit('click', e);
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$e(),
        class: {
          '-secondary': this.theme === 'secondary'
        },
        attrs: {
          'data-collapse': ''
        }
      }, content);
    },
    genHeading: function genHeading() {
      var _this2 = this;

      return this.$createElement('div', {
        staticClass: style$e('heading')(),
        class: {
          '-active': this.isOpened
        },
        on: {
          click: function click(e) {
            _newArrowCheck(this, _this2);

            return this.clickHandler(e);
          }.bind(this)
        }
      }, [this.genArrow(), this.$slots.title || this.title]);
    },
    genArrow: function genArrow() {
      return this.$createElement(uiIcon, {
        staticClass: style$e('arrow')(),
        class: {
          '-active': this.isOpened
        },
        props: {
          name: 'arrowhead'
        }
      });
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: style$e('content')(),
        class: {
          '-hidden': this.isClosed
        }
      }, this.$slots.default);
    }
  },
  mounted: function mounted() {
    if (this.collapseGroup && this.name) {
      this.collapseGroup.register(this);
      this.$_registered = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.collapseGroup && this.name) {
      this.collapseGroup.unregister(this);
    }
  },
  render: function render() {
    return this.genWrapper([this.genHeading(), this.genContent()]);
  }
};

var index$9 = generatePlugin(uiCollapse);

var style$c = createStyle('tag');
var style$d = {
  wrapper: style$c(),
  label: style$c('label')(),
  icon: style$c('icon')(),
  default: '-default',
  primary: '-primary',
  removable: '-removable'
};

var _this$6 = null;
var uiTag = {
  name: 'ui-tag',
  mixins: [factory$4({
    tag: 'span'
  }), Testable],
  props: {
    /**
     * Component style
     */
    theme: {
      type: String,
      default: 'default',
      validator: function validator(v) {
        _newArrowCheck(this, _this$6);

        return ['default', 'primary'].includes(v);
      }.bind(null)
    },

    /**
     * Shows cross icon
     */
    removable: {
      type: Boolean,
      default: false
    },

    /**
     * Tooltip text for close button
     */
    tooltip: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    /**
     * @return {Object}
     */
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$d.default, this.theme === 'default'), _defineProperty(_ref, style$d.primary, this.theme === 'primary'), _ref;
    },

    /**
     * Close icon directives
     *
     * @return {Array<Object> | Object[] | null}
     */
    directives: function directives() {
      if (!this.removable || !this.tooltip) {
        return null;
      }

      return [{
        name: 'tooltip',
        value: this.tooltip
      }];
    },

    /**
     * @return {{ staticClass: string }}
     */
    labelOptions: function labelOptions() {
      return {
        staticClass: style$d.label,
        class: this.classes
      };
    }
  },
  methods: {
    /**
     * @param {Array} content
     * @return {VNode}
     */
    genWrapper: function genWrapper(content) {
      return this.$createElement(uiGroupItem, {
        staticClass: style$d.wrapper,
        class: _objectSpread2(_objectSpread2({}, this.classes), {}, _defineProperty({}, style$d.removable, this.removable)),
        attrs: this.qaAttributes
      }, content);
    },

    /**
     * @return {null | VNode}
     */
    genIcon: function genIcon() {
      var _this2 = this;

      if (!this.removable) {
        return null;
      }

      return this.$createElement(uiIcon, {
        staticClass: style$d.icon,
        directives: this.directives,
        props: {
          name: 'cross'
        },
        on: {
          click: function click() {
            _newArrowCheck(this, _this2);

            return this.$emit('remove');
          }.bind(this)
        }
      });
    }
  },
  render: function render() {
    return this.genWrapper([this.genLabel(), this.genIcon()]);
  }
};

var index$8 = generatePlugin(uiTag);

var _this$5 = null;
var style$b = createStyle('breadcrumbs');
var uiBreadcrumbs = {
  name: 'ui-breadcrumbs',
  props: {
    rootLink: {
      type: [String, Object],
      default: '/'
    },
    rootIcon: {
      type: String,
      default: 'logo'
    },
    items: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$5);

        return [];
      }.bind(null)
    },
    backwardLabel: {
      type: String,
      default: 'К предыдущему разделу'
    }
  },
  computed: {
    link: function link() {
      return typeof this.rootLink === 'string' ? {
        to: this.rootLink
      } : this.rootLink;
    }
  },
  methods: {
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$b()
      }, content);
    },
    genRootLink: function genRootLink(content) {
      return this.genItem(this.link, 'logo', content, {
        '-logo': true
      });
    },
    genIcon: function genIcon() {
      return this.$createElement(uiIcon, {
        props: {
          name: this.rootIcon
        }
      });
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        _newArrowCheck(this, _this2);

        return this.genItem(item, index, item.title);
      }.bind(this));
    },
    genItem: function genItem(item, key, content) {
      var classes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      // eslint-disable-next-line no-nested-ternary
      var tag;
      var data = {
        key: key,
        staticClass: style$b('link')(),
        class: classes,
        props: item
      };

      if (!item.to && !item.href) {
        tag = 'span';
        data.class = _objectSpread2(_objectSpread2({}, data.class), {}, {
          '-text': true
        });
      } else if (item.to) {
        tag = item.native ? 'router-link' : 'nuxt-link';
      } else if (item.href) {
        tag = 'a';
        data.attrs = {
          href: item.href
        };
      }

      return this.$createElement(tag, data, [content]);
    },
    genBackwardButton: function genBackwardButton() {
      if (!this.backwardLabel || this.items.length === 0) {
        return null;
      }

      var link = this.items.length === 1 ? this.link : this.items[this.items.length - 2];
      return this.$createElement(uiButton, {
        staticClass: style$b('backward-button')(),
        props: _objectSpread2(_objectSpread2({}, link), {}, {
          ghost: true,
          icon: 'arrow-alt',
          label: this.backwardLabel
        })
      });
    }
  },
  render: function render() {
    return this.genWrapper([this.genRootLink([this.genIcon()]), this.genItems(), this.genBackwardButton()]);
  }
};

var index$7 = generatePlugin(uiBreadcrumbs);

var style$9 = createStyle('countdown');
/**
 * @type {Object | string}
 */

var style$a = {
  value: style$9(),
  svg: style$9('svg')(),
  foreground: style$9('foreground')(),
  content: style$9('content')(),
  timer: style$9('timer')(),
  label: style$9('label')()
};

var _this$4 = null;

var validateNumber$2 = function validateNumber(v) {
  _newArrowCheck(this, _this$4);

  return !Number.isNaN(parseInt(v, 10));
}.bind(null);

var uiCountdown = {
  name: 'ui-countdown',
  props: {
    size: {
      type: [String, Number],
      default: 122,
      validator: function validator(v) {
        _newArrowCheck(this, _this$4);

        return validateNumber$2(v) && v >= 80;
      }.bind(null)
    },
    border: {
      type: [String, Number],
      default: 2,
      validator: function validator(v) {
        _newArrowCheck(this, _this$4);

        return validateNumber$2(v) && v > 0;
      }.bind(null)
    },
    time: {
      type: [String, Number],
      default: 0,
      validator: function validator(v) {
        _newArrowCheck(this, _this$4);

        return validateNumber$2(v) && v >= 0;
      }.bind(null)
    },
    startFrom: {
      type: [String, Number],
      default: 0,
      validator: function validator(v) {
        _newArrowCheck(this, _this$4);

        return validateNumber$2(v) && v >= 0;
      }.bind(null)
    },
    label: {
      type: String,
      default: null
    },
    labelFinish: {
      type: String,
      default: null
    },
    autoStart: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$4);

    return {
      currentTime: 0,
      isActive: false,
      isFinished: false
    };
  }.bind(null),
  computed: {
    withoutLabel: function withoutLabel() {
      return !this.label && !this.labelFinish;
    },
    center: function center() {
      return this.size / 2;
    },
    radius: function radius() {
      return (this.size - this.border) / 2;
    },
    length: function length() {
      return Math.PI * 2 * this.radius;
    },
    offset: function offset() {
      return this.length / 360 * 90;
    },
    fill: function fill() {
      if (this.isFinished) {
        return this.length;
      }

      return this.length * (Math.max(this.currentTime, 0) / this.time);
    },
    rest: function rest() {
      return this.length - this.fill;
    },
    classes: function classes() {
      return {
        '-active': this.isActive,
        '-finished': this.isFinished,
        '-with-label': !this.withoutLabel
      };
    }
  },
  methods: {
    setTime: function setTime(timer, startFrom) {
      this.currentTime = startFrom > 0 && startFrom < timer ? startFrom : timer;
    },
    start: function start() {
      var _this2 = this;

      if (this.isActive || this.isFinished) {
        return;
      }

      this.$_interval = setInterval(function () {
        _newArrowCheck(this, _this2);

        this.currentTime > 0 ? this.currentTime -= 1 : this.finish();
      }.bind(this), 1000);
      this.isActive = true;
      this.$emit('start');
    },
    pause: function pause() {
      if (!this.isActive) {
        return;
      }

      clearInterval(this.$_interval);
      this.isActive = false;
      this.$emit('pause');
    },
    finish: function finish() {
      var _this3 = this;

      clearInterval(this.$_interval);
      this.isFinished = true;
      this.$emit('finish');
      this.$_deactivateTimeout = setTimeout(function () {
        _newArrowCheck(this, _this3);

        this.isActive = false;
        clearTimeout(this.$_deactivateTimeout);
      }.bind(this), 1000);
    },
    restart: function restart() {
      clearInterval(this.$_interval);
      clearTimeout(this.$_deactivateTimeout);
      this.isActive = false;
      this.isFinished = false;
      this.setTime(this.time, this.startFrom);
      this.$emit('restart');
      this.start();
    },
    getFormattedTime: function getFormattedTime() {
      var hours = Math.floor(this.currentTime / 3600);
      var minutes = Math.floor(this.currentTime / 60) - hours * 60;
      var seconds = this.currentTime % 60;
      var hoursStr = hours > 0 ? "".concat(hours, ":") : '';
      var minutesStr = minutes < 10 && hours > 0 ? "0".concat(minutes) : "".concat(minutes);
      var secondsStr = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
      return "".concat(hoursStr).concat(minutesStr, ":").concat(secondsStr);
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$a.value,
        class: this.classes,
        attrs: this.qaAttributes
      }, content);
    },
    genSvg: function genSvg() {
      return this.$createElement('svg', {
        attrs: {
          width: this.size,
          height: this.size,
          viewBox: "0 0 ".concat(this.size, " ").concat(this.size)
        }
      }, [this.genForegroundCircle()]);
    },
    genCircle: function genCircle(className) {
      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.$createElement('circle', {
        staticClass: className,
        attrs: _objectSpread2({
          cx: this.center,
          cy: this.center,
          r: this.radius,
          'stroke-width': this.border
        }, attrs)
      });
    },
    genForegroundCircle: function genForegroundCircle() {
      return this.genCircle(style$a.foreground, {
        'stroke-dasharray': "".concat(this.fill, " ").concat(this.rest),
        'stroke-dashoffset': this.offset
      });
    },
    genTimer: function genTimer() {
      return this.$createElement('div', {
        ref: 'timer',
        staticClass: style$a.timer
      }, this.getFormattedTime());
    },
    genLabel: function genLabel() {
      if (this.withoutLabel) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$a.label
      }, this.isFinished ? this.labelFinish : this.label);
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: style$a.content
      }, [this.genTimer(), this.genLabel()]);
    }
  },
  mounted: function mounted() {
    if (!this.withoutLabel) {
      var timer = this.$refs.timer;
      timer.style.setProperty('height', "".concat(timer.offsetHeight, "px"));
    }

    this.setTime(this.time, this.startFrom);

    if (this.autoStart) {
      this.start();
    }

    this.$emit('initialized', {
      start: this.start,
      pause: this.pause,
      restart: this.restart,
      setTime: this.setTime
    });
  },
  render: function render() {
    return this.genWrapper([this.genSvg(), this.genContent()]);
  }
};

var index$6 = generatePlugin(uiCountdown);

var style$7 = createStyle('input-file');
/**
 * @type {Object | string}
 */

var style$8 = {
  value: style$7(),
  dragover: '-dragover',
  focused: '-focused',
  disabled: '-disabled',
  error: '-error',
  dropzone: style$7('dropzone')(),
  dropzoneCover: style$7('dropzoneCover')(),
  dropzoneLink: style$7('dropzoneLink')(),
  dropzoneText: style$7('dropzoneText')(),
  message: style$7('message')()
};

var _this$3 = null;
var uiInputFile = {
  name: 'ui-input-file',
  mixins: [Testable, Stateable, Messageable, factory$2({
    validateOn: 'change'
  })],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$3);

        return Array.isArray(v) || (typeof window !== 'undefined' ? v.constructor.name === 'File' : true);
      }.bind(null)
    },
    id: {
      type: String,
      default: null
    },
    limit: {
      type: [String, Number],
      default: null
    },
    maxSize: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: function _default() {
        _newArrowCheck(this, _this$3);

        return [];
      }.bind(null)
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$3);

    return {
      dragover: false,
      isDraggable: false,
      isFocused: false
    };
  }.bind(null),
  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('change', value);
      }
    },
    isMaxFilesCountReached: function isMaxFilesCountReached() {
      if (this.multiple) {
        return this.limit && this.files.length >= this.limit;
      }

      return !!this.files;
    },
    isDisabled: function isDisabled() {
      return this.disabled || this.isMaxFilesCountReached;
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, style$8.dragover, this.dragover), _defineProperty(_ref, style$8.focused, this.isFocused), _defineProperty(_ref, style$8.disabled, this.isDisabled), _defineProperty(_ref, style$8.error, this.isErrorState || this.validationError), _ref;
    },
    inputAttributes: function inputAttributes() {
      var _this2 = this;

      return _objectSpread2({
        id: this.id,
        type: 'file',
        name: this.name,
        disabled: this.isDisabled,
        multiple: this.multiple,
        accept: this.accept.length ? this.accept.map(function (type) {
          _newArrowCheck(this, _this2);

          return ".".concat(type);
        }.bind(this)) : null
      }, this.qaAttributes);
    },
    messageOptions: function messageOptions() {
      return {
        staticClass: style$8.message
      };
    }
  },
  methods: {
    onFocus: function onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    onDragover: function onDragover(e) {
      e.preventDefault();

      if (this.isDisabled) {
        return;
      }

      this.dragover = true;
    },
    onDragleave: function onDragleave() {
      if (this.isDisabled) {
        return;
      }

      this.dragover = false;
    },
    onDrop: function onDrop(e) {
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.attach(files);
      this.dragover = false;
    },
    onChange: function onChange(e) {
      var files = e.target.files;
      this.attach(files);
    },
    attach: function attach(files) {
      var _this3 = this;

      _toConsumableArray(files).forEach(function (file) {
        _newArrowCheck(this, _this3);

        var extension = file.name.split('.').pop().toLowerCase();

        if (this.isMaxFilesCountReached) {
          return;
        }

        if (this.accept.length && !this.accept.includes(extension)) {
          this.validation.error = 'Формат файла не соответствует требованиям';
          this.validation.valid = false;
          this.showValidationError();
          return;
        }

        if (this.maxSize && file.size > this.maxSize) {
          this.validation.error = 'Размер файла не соответствует требованиям';
          this.validation.valid = false;
          this.showValidationError();
          return;
        }

        this.multiple ? this.files.push(file) : this.files = file;
        this.$emit('select', file);
      }.bind(this));

      if (this.multiple) {
        this.$emit('change', this.files);
      }

      this.$refs.input.value = '';
    },
    genWrapper: function genWrapper(content) {
      return this.$createElement('div', {
        staticClass: style$8.value,
        class: this.classes,
        attrs: this.qaAttributes
      }, content);
    },
    genInput: function genInput() {
      var _this4 = this;

      return this.$createElement('input', {
        attrs: this.inputAttributes,
        ref: 'input',
        on: {
          change: function change(e) {
            _newArrowCheck(this, _this4);

            return this.onChange(e);
          }.bind(this),
          focus: function focus() {
            _newArrowCheck(this, _this4);

            return this.onFocus();
          }.bind(this),
          blur: function blur() {
            _newArrowCheck(this, _this4);

            return this.onBlur();
          }.bind(this)
        }
      });
    },
    genDropzoneLabel: function genDropzoneLabel() {
      var draggableLabel = [this.$createElement('span', {
        staticClass: style$8.dropzoneLink
      }, 'Выберите файлы'), this.$createElement('span', {
        staticClass: style$8.dropzoneText
      }, ' или перетащите их сюда')];
      var noDraggableLabel = [this.$createElement('span', {
        staticClass: style$8.dropzoneLink
      }, 'Нажмите сюда'), this.$createElement('span', {
        staticClass: style$8.dropzoneText
      }, ' чтобы загрузить файлы')]; // eslint-disable-next-line no-nested-ternary

      return this.$createElement('span', {}, this.isMaxFilesCountReached ? 'Загружено максимальное количество файлов' : this.isDraggable ? draggableLabel : noDraggableLabel);
    },
    genDropzoneCover: function genDropzoneCover() {
      return this.$createElement('span', {
        staticClass: style$8.dropzoneCover
      }, [this.$createElement(uiIcon, {
        props: {
          name: 'upload'
        }
      })]);
    },
    genDropzone: function genDropzone(content) {
      var _this5 = this;

      return this.$createElement('label', {
        ref: 'dropzone',
        staticClass: style$8.dropzone,
        on: {
          dragover: function dragover(e) {
            _newArrowCheck(this, _this5);

            return this.onDragover(e);
          }.bind(this),
          dragleave: function dragleave() {
            _newArrowCheck(this, _this5);

            return this.onDragleave();
          }.bind(this),
          drop: function drop(e) {
            _newArrowCheck(this, _this5);

            return this.onDrop(e);
          }.bind(this)
        }
      }, content);
    }
  },
  mounted: function mounted() {
    this.isDraggable = 'draggable' in this.$refs.dropzone;
  },
  render: function render() {
    return this.genWrapper([this.genDropzone([this.genDropzoneLabel(), this.genDropzoneCover(), this.genInput()]), this.genMessage()]);
  }
};

var index$5 = generatePlugin(uiInputFile);

var style$5 = createStyle('file');
/**
 * @type {Object | string}
 */

var style$6 = {
  value: style$5(),
  pending: '-pending',
  error: '-error',
  jpg: '-jpg',
  png: '-png',
  pdf: '-pdf',
  clickablePreview: '-clickable-preview',
  preview: style$5('preview')(),
  icon: style$5('icon')(),
  image: style$5('image')(),
  info: style$5('info')(),
  name: style$5('name')(),
  substring: style$5('substring')(),
  extension: style$5('extension')(),
  progress: style$5('progress')(),
  progressBar: style$5('progressBar')(),
  remove: style$5('remove')()
};

var _this$2 = null;

var validateNumber$1 = function validateNumber(v) {
  _newArrowCheck(this, _this$2);

  return !Number.isNaN(parseInt(v, 10));
}.bind(null);

var imageTypes = ['jpg', 'jpeg', 'png', 'avif', 'webp'];
var uiFile = {
  name: 'ui-file',
  mixins: [Testable, Stateable, Messageable],
  props: {
    value: {
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this$2);

        return v === null || (typeof window !== 'undefined' ? v.constructor.name === 'File' : true);
      }.bind(null)
    },
    name: {
      type: String,
      default: null
    },
    ext: {
      type: String,
      default: null
    },
    preview: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    pending: {
      type: [Boolean, Number],
      default: false,
      validator: function validator(v) {
        _newArrowCheck(this, _this$2);

        return typeof v === 'number' ? validateNumber$1(v) && v >= 0 && v <= 100 : true;
      }.bind(null)
    },
    removable: {
      type: Boolean,
      default: false
    },
    clickablePreview: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this$2);

    return {
      previewImage: null
    };
  }.bind(null),
  computed: {
    fileName: function fileName() {
      var _this$value;

      return this.name || ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.name.split('.').slice(0, -1).join('.')) || null;
    },
    fileExtension: function fileExtension() {
      var _this$value2;

      return (this.ext || ((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.name.split('.').pop()) || '').toLowerCase() || null;
    },
    fileSize: function fileSize() {
      return this.value ? humanFileSize(this.value.size) : null;
    },
    isImage: function isImage() {
      return imageTypes.includes(this.fileExtension);
    },
    classes: function classes() {
      var _ref;

      var isPending = typeof this.pending === 'boolean' && this.pending;
      return _ref = {}, _defineProperty(_ref, style$6.pending, isPending), _defineProperty(_ref, style$6.error, this.isErrorState), _defineProperty(_ref, style$6.jpg, this.fileExtension === 'jpg' || this.fileExtension === 'jpeg'), _defineProperty(_ref, style$6.png, this.fileExtension === 'png'), _defineProperty(_ref, style$6.pdf, this.fileExtension === 'pdf'), _defineProperty(_ref, style$6.clickablePreview, this.clickablePreview), _ref;
    }
  },
  methods: {
    delete: function _delete() {
      this.$emit('remove');
    },
    getFilePreview: function getFilePreview() {
      var _this2 = this;

      if (this.preview) {
        this.previewImage = this.preview;
        return;
      }

      if (this.value && this.isImage) {
        var reader = new FileReader();
        reader.addEventListener('load', function () {
          _newArrowCheck(this, _this2);

          this.previewImage = reader.result;
        }.bind(this));
        reader.readAsDataURL(this.value);
      }
    },
    genPreview: function genPreview() {
      var _this3 = this;

      // eslint-disable-next-line no-nested-ternary
      var icon = this.isErrorState ? 'file-error' : this.isImage ? 'file-type-image' : 'file-type-document';

      if (!this.isErrorState) {
        this.getFilePreview();
      }

      return this.$createElement('div', {
        staticClass: style$6.preview,
        on: {
          click: function click(event) {
            _newArrowCheck(this, _this3);

            if (!this.clickablePreview) {
              return;
            }

            event.stopPropagation();
            this.$emit('preview-click');
          }.bind(this)
        }
      }, [this.previewImage ? this.$createElement('img', {
        staticClass: style$6.image,
        attrs: {
          src: this.previewImage,
          alt: ''
        }
      }) : this.$createElement(uiIcon, {
        staticClass: style$6.icon,
        props: {
          name: icon
        }
      })]);
    },
    genSubstring: function genSubstring() {
      return this.$createElement('div', {
        staticClass: style$6.substring
      }, [this.hasMessage ? this.genMessage() : this.fileSize]);
    },
    genProgress: function genProgress() {
      return this.$createElement('div', {
        staticClass: style$6.progress
      }, [this.pending && this.$createElement('div', {
        staticClass: style$6.progressBar,
        style: {
          width: this.pending ? "".concat(this.pending, "%") : null
        }
      })]);
    },
    genInfo: function genInfo() {
      return this.$createElement('div', {
        staticClass: style$6.info
      }, [this.$createElement('div', {
        staticClass: style$6.name
      }, this.fileName), this.pending ? this.genProgress() : this.genSubstring()]);
    },
    genExtension: function genExtension() {
      if (!this.fileExtension) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$6.extension
      }, this.fileExtension);
    },
    genRemoveIcon: function genRemoveIcon() {
      var _this4 = this;

      if (!this.removable) {
        return null;
      }

      return this.$createElement('div', {
        staticClass: style$6.remove,
        attrs: {
          title: 'Удалить'
        },
        on: {
          click: function click(event) {
            _newArrowCheck(this, _this4);

            event.stopPropagation();
            this.delete();
          }.bind(this)
        }
      }, [this.$createElement(uiIcon, {
        props: {
          name: 'cross'
        }
      })]);
    }
  },
  render: function render(h) {
    var _this5 = this;

    return h('div', {
      staticClass: style$6.value,
      class: this.classes,
      on: {
        click: function click() {
          _newArrowCheck(this, _this5);

          return this.$emit('click');
        }.bind(this)
      }
    }, [this.genPreview(), this.genInfo(), this.genExtension(), this.genRemoveIcon()]);
  }
};

var index$4 = generatePlugin(uiFile);

var style$3 = createStyle('skeleton-item');
var style$4 = {
  value: style$3()
};

var uiSkeletonItem = {
  name: 'ui-skeleton-item',
  mixins: [provide$1('skeletonContainer')],
  props: {
    /**
     * Loading state
     */
    value: {
      type: Boolean,
      default: false
    },

    /**
     * Error state
     */
    error: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    /**
     * Calls children update on error state change
     *
     * @param {boolean} value
     */
    error: function error(value) {
      var _this = this;

      this.$nextTick(function () {
        _newArrowCheck(this, _this);

        return this.update(value);
      }.bind(this));
    }
  },
  methods: {
    /**
     * Registers child component instance
     *
     * @param {Vue} instance
     */
    register: function register(instance) {
      var id = this.$_generateId();
      Object.assign(instance, {
        $_providedId: id
      });
      this.$_items[id] = instance;
    },

    /**
     * Removes child component instance
     *
     * @param {Vue & { $_providedId: number }} instance
     */
    unregister: function unregister(instance) {
      delete this.$_items[instance.$_providedId];
    },

    /**
     * Updates registered children's value of providedStatic state
     *
     * @param {boolean} value
     */
    update: function update(value) {
      var _this2 = this;

      Object.values(this.$_items).forEach(function (instance) {
        _newArrowCheck(this, _this2);

        Object.assign(instance, {
          providedStatic: value
        });
      }.bind(this));
    }
  },
  beforeMount: function beforeMount() {
    /**
     * Generates unique id
     *
     * @type {function(): number}
     */
    this.$_generateId = counter();
    /**
     * Collection of all registered child components
     *
     * @type {{ [number]: Vue & { $_providedId: number } }}
     * @see uiSkeleton
     */

    this.$_items = {};
  },
  mounted: function mounted() {
    /**
     * Initial children update
     */
    this.update(this.error);
  },

  /**
   * Builds and renders component's template
   *
   * @return {VNode}
   */
  render: function render() {
    return this.$createElement('div', {
      staticClass: style$4.value
    }, this.value || this.error ? this.$slots.skeleton : this.$slots.default);
  }
};

var index$3 = generatePlugin(uiSkeletonItem);

var _this$1 = null;

/**
 * @param {*} v
 * @return {boolean}
 */
var validateNumber = function validateNumber(v) {
  _newArrowCheck(this, _this$1);

  return !Number.isNaN(parseInt(v, 10));
}.bind(null);
/**
 * @param {*} value
 * @return {'auto' | string | null}
 */

var formatSize = function formatSize(value) {
  _newArrowCheck(this, _this$1);

  switch (true) {
    case value === 'auto':
      return value;

    case !Number.isNaN(Number(value)):
      return "".concat(value, "px");

    default:
      return null;
  }
}.bind(null);

var style$1 = createStyle('skeleton');
var style$2 = {
  value: style$1(),
  inline: '-inline',
  rounded: '-rounded',
  static: '-static'
};

var _this = null;
var uiSkeleton = {
  name: 'ui-skeleton',
  mixins: [inject$1('skeletonContainer')],
  props: {
    /**
     * Width of skeleton indicator
     */
    width: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this);

        return validateNumber(v) && v >= 0 || v === 'auto';
      }.bind(null)
    },

    /**
     * Height of skeleton indicator
     */
    height: {
      type: [String, Number],
      default: null,
      validator: function validator(v) {
        _newArrowCheck(this, _this);

        return validateNumber(v) && v >= 0 || v === 'auto';
      }.bind(null)
    },

    /**
     * Displays as inline-block instead of block
     */
    inline: {
      type: Boolean,
      default: false
    },

    /**
     * Rounded view
     */
    rounded: {
      type: Boolean,
      default: false
    },

    /**
     * Turns off animation
     */
    static: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    _newArrowCheck(this, _this);

    return {
      /**
       * Local static state, which can be provided from uiSkeletonItem component
       *
       * @type {boolean | null}
       */
      providedStatic: null
    };
  }.bind(null),
  mounted: function mounted() {
    /**
     * Register component into skeletonContainer (uiSkeletonItem component) if exists
     *
     * @see uiSkeletonItem
     */
    if (this.skeletonContainer) {
      this.skeletonContainer.register(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    /**
     * Unregister component from skeletonContainer (uiSkeletonItem component) if exists
     *
     * @see uiSkeletonItem
     */
    if (this.skeletonContainer) {
      this.skeletonContainer.unregister(this);
    }
  },

  /**
   * Builds and renders component's template
   *
   * @return {VNode}
   */
  render: function render() {
    var _class;

    return this.$createElement('span', {
      staticClass: style$2.value,
      class: (_class = {}, _defineProperty(_class, style$2.inline, this.inline), _defineProperty(_class, style$2.rounded, this.rounded), _defineProperty(_class, style$2.static, this.providedStatic || this.static), _class),
      style: {
        width: formatSize(this.width),
        height: formatSize(this.height)
      }
    });
  }
};

var index$2 = generatePlugin(uiSkeleton);

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  uiApp: index$B,
  uiContainer: uiContainer,
  uiRow: uiRow,
  uiCol: uiCol,
  uiForm: index$A,
  uiFormControl: index$z,
  uiInput: uiInput,
  uiInputPhone: index$y,
  uiInputMoney: index$x,
  uiInputSuggest: index$w,
  uiInputCalendar: index$v,
  uiInputPlural: index$u,
  uiTextarea: index$t,
  uiRadioGroup: index$s,
  uiRadio: index$r,
  uiCheckboxGroup: index$q,
  uiCheckbox: index$p,
  uiSelect: uiSelect,
  uiSelectOption: uiSelectOption,
  uiSwitcher: index$o,
  uiSwitcherButton: index$n,
  uiCalendar: uiCalendar,
  uiToggleGroup: index$m,
  uiToggle: index$l,
  uiTable: index$k,
  uiTableColumn: uiTableColumn,
  uiTableRow: uiTableRow,
  uiTableCell: uiTableCell,
  uiButton: uiButton,
  uiTabs: index$j,
  uiTab: uiTab,
  uiTile: index$i,
  uiGroup: index$h,
  uiText: uiText,
  uiLoader: uiLoader,
  uiPreloader: index$g,
  uiIcon: uiIcon,
  uiBadge: index$f,
  uiLink: index$e,
  uiStepper: index$d,
  uiSpinner: uiSpinner,
  uiDropdown: uiDropdown,
  uiDropdownGroup: uiDropdownGroup,
  uiDropdownOption: uiDropdownOption,
  uiHighlightText: uiHighlightText,
  uiOverlay: uiOverlay,
  uiModal: uiModal,
  uiPopover: uiPopover,
  uiInfo: index$c,
  uiAlert: index$b,
  uiCollapseGroup: index$a,
  uiCollapse: index$9,
  uiNotificationContainer: uiNotificationsContainer,
  uiNotification: uiNotification,
  uiTag: index$8,
  uiBreadcrumbs: index$7,
  uiCountdown: index$6,
  uiInputFile: index$5,
  uiFile: index$4,
  uiSkeletonItem: index$3,
  uiSkeleton: index$2
});

var plugin$2 = {
  installed: false,
  install: function install(Vue) {
    var _this = this;

    if (this.installed) {
      return;
    }

    this.installed = true;
    Object.values(components).forEach(function (component) {
      _newArrowCheck(this, _this);

      Vue.use(component);
    }.bind(this));
  }
};

/**
 * @param {HTMLElement} el
 * @param {string | boolean | number} value
 * @param {Object} modifiers
 */

function setAttribute(el, value, modifiers) {
  var _this = this;

  var hasModifiers = !!Object.values(modifiers).length;

  if (!['string', 'number', 'boolean'].includes(_typeof(value)) && !hasModifiers) {
    throw new FrameworkError('Invalid value given for "qa" directive');
  }

  if (!hasModifiers) {
    el.setAttribute(qaAttributeName, value);
    return;
  }

  Object.keys(modifiers).forEach(function (key) {
    _newArrowCheck(this, _this);

    el.setAttribute("".concat(qaAttributeName, "-").concat(key), typeof value === 'undefined' ? '' : value);
  }.bind(this));
}

var index$1 = {
  name: 'qa',

  /**
   * @param {HTMLElement} el
   * @param {string | boolean | number} value
   * @param {Object} modifiers
   */
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    setAttribute(el, value, modifiers);
  },

  /**
   * @param {HTMLElement} el
   * @param {string | boolean | number} value
   * @param {Object} modifiers
   */
  update: function update(el, _ref2) {
    var value = _ref2.value,
        modifiers = _ref2.modifiers;
    setAttribute(el, value, modifiers);
  },

  /**
   * @param {HTMLElement} el
   */
  unbind: function unbind(el) {
    var _this2 = this;

    // Node type COMMENT
    if (el.nodeType === 8) {
      return;
    }

    Object.keys(el.attributes).filter(function (attr) {
      _newArrowCheck(this, _this2);

      return attr.startsWith(qaAttributeName);
    }.bind(this)).forEach(function (attr) {
      _newArrowCheck(this, _this2);

      return el.removeAttribute(attr);
    }.bind(this));
  }
};

var style = createStyle('tooltip')();
/**
 * @param {HTMLElement} el
 * @param {string} position
 */

function updatePosition(el, position) {
  var tooltip = el.$_tooltip;
  tooltip.classList.remove("-".concat(el.$_tooltipPosition));
  tooltip.classList.add("-".concat(position));
  Object.assign(el, {
    $_tooltipPosition: position
  });
}
/**
 * Creates tooltip element and appends it into container
 *
 * @param {string} text
 * @param {string} position
 * @return {HTMLElement}
 */


function create(text, position) {
  var tooltip = document.createElement('div');
  tooltip.classList.add(style);
  tooltip.classList.add("-".concat(position));
  tooltip.innerText = text;
  return tooltip;
}
/**
 * @param {string | Object} value
 * @return {{ text: string | number | null, position: 'bottom' | 'top' | 'left' | 'right' }}
 */


function prepareValue(value) {
  var text = _typeof(value) === 'object' && value !== null ? value.text : value;
  var position = _typeof(value) === 'object' && value !== null ? value.position : 'bottom';
  return {
    text: text,
    position: position
  };
}
/**
 * Replace tooltip element to the bottom side of the related element
 *
 * @param {HTMLElement} el
 * @param {HTMLElement} tooltip
 */


function replace(el, tooltip) {
  var arrowSize = 12;
  var windowScrollOffset = window.pageYOffset || window.scrollY;
  var rect = el.getBoundingClientRect();

  var _tooltip$getBoundingC = tooltip.getBoundingClientRect(),
      tooltipWidth = _tooltip$getBoundingC.width,
      tooltipHeight = _tooltip$getBoundingC.height;

  var x = 0;
  var y = 0;

  switch (el.$_tooltipPosition) {
    case 'top':
      {
        x = Math.ceil(rect.width / 2 + rect.left - tooltipWidth / 2);
        y = Math.ceil(rect.top - tooltipHeight - arrowSize + windowScrollOffset);
        break;
      }

    case 'right':
      {
        x = Math.ceil(rect.width + rect.left + arrowSize);
        y = Math.ceil(rect.height / 2 - tooltipHeight / 2 + rect.top + windowScrollOffset);
        break;
      }

    case 'left':
      {
        x = Math.ceil(rect.left - tooltipWidth - arrowSize);
        y = Math.ceil(rect.height / 2 - tooltipHeight / 2 + rect.top + windowScrollOffset);
        break;
      }

    case 'bottom':
    default:
      {
        x = Math.ceil(rect.width / 2 + rect.left - tooltipWidth / 2);
        y = Math.ceil(rect.height + rect.top + arrowSize + windowScrollOffset);
      }
  }

  tooltip.style.setProperty('transform', "translate3d(".concat(x, "px, ").concat(y, "px, 0)"));
}
/**
 * @param {HTMLElement} el
 * @param {boolean} v
 */


function hover(el, v) {
  Object.assign(el, {
    $_tooltipHovered: v
  });
}
/**
 * Open tooltip
 *
 * @param {HTMLElement | { $_tooltip: HTMLDivElement, $_tooltipEnabled: boolean }} el
 */


function _open(el) {
  hover(el, true);

  if (!el.$_tooltipEnabled) {
    return;
  }

  replace(el, el.$_tooltip);
  el.$_tooltip.classList.add('-opened');
}
/**
 * Close tooltip
 *
 * @param {HTMLElement | { $_tooltip: HTMLDivElement }} el
 * @param {boolean?} hovered
 */


function _close(el) {
  var hovered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  hover(el, hovered);
  el.$_tooltip.classList.remove('-opened');
}

var index = {
  name: 'tooltip',

  /**
   * @param {HTMLElement} el
   * @param {string | number | null} value
   */
  bind: function bind(el, _ref) {
    var _this = this;

    var value = _ref.value;

    if (!document || isTouchDevice()) {
      return;
    }

    var _prepareValue = prepareValue(value),
        text = _prepareValue.text,
        position = _prepareValue.position;

    var tooltip = create(text, position);
    Object.assign(el, {
      $_tooltip: tooltip,
      $_tooltipHovered: false,
      $_tooltipEnabled: !!text,
      $_tooltipText: text,
      $_tooltipPosition: position,
      $_tooltipCallbacks: {
        open: function open() {
          _newArrowCheck(this, _this);

          return _open(el);
        }.bind(this),
        close: function close() {
          _newArrowCheck(this, _this);

          return _close(el);
        }.bind(this)
      }
    });
    el.addEventListener('mouseover', el.$_tooltipCallbacks.open);
    el.addEventListener('mouseleave', el.$_tooltipCallbacks.close);
  },
  inserted: function inserted(el) {
    var _this2 = this;

    if (!document || isTouchDevice()) {
      return;
    }

    var parent = closesParent(el, function (v) {
      _newArrowCheck(this, _this2);

      return v.classList.contains(createStyle('overlay')());
    }.bind(this));

    if (parent) {
      el.$_tooltip.style.setProperty('z-index', '201');
    }

    transport(el.$_tooltip, 'tooltips');
  },

  /**
   * @param {HTMLElement | { $_tooltip: HTMLElement }} el
   * @param value
   */
  update: function update(el, _ref2) {
    var _this3 = this;

    var value = _ref2.value;

    if (!document || isTouchDevice()) {
      return;
    }

    var _prepareValue2 = prepareValue(value),
        text = _prepareValue2.text,
        position = _prepareValue2.position;

    Object.assign(el, {
      $_tooltipEnabled: !!text
    });
    Object.assign(el.$_tooltip, {
      innerText: text
    });
    updatePosition(el, position);

    if (el.$_tooltipHovered) {
      !text ? _close(el, true) : _open(el);
    }

    requestAnimationFrame(function () {
      _newArrowCheck(this, _this3);

      return replace(el, el.$_tooltip);
    }.bind(this));
  },

  /**
   * @param {HTMLElement | { $_tooltip: HTMLElement, $_tooltipParent: boolean $_tooltipCallbacks: Object }} el
   */
  unbind: function unbind(el) {
    var _this4 = this;

    if (!document || isTouchDevice()) {
      return;
    }

    removeTransportedElement(el.$_tooltip, 'tooltips');
    el.removeEventListener('mouseover', el.$_tooltipCallbacks.open);
    el.removeEventListener('mouseleave', el.$_tooltipCallbacks.close);
    Object.keys(el).filter(function (k) {
      _newArrowCheck(this, _this4);

      return k.startsWith('$_tooltip');
    }.bind(this)).forEach(function (k) {
      _newArrowCheck(this, _this4);

      // eslint-disable-next-line no-param-reassign
      delete el[k];
    }.bind(this));
  }
};

// eslint-disable import/prefer-default-export

var directives = /*#__PURE__*/Object.freeze({
  __proto__: null,
  QA: index$1,
  ClickOutside: ClickOutside,
  Tooltip: index
});

var plugin$1 = {
  installed: false,
  install: function install(Vue) {
    var _this = this;

    if (this.installed) {
      return;
    }

    this.installed = true;
    Object.values(directives).forEach(function (directive) {
      _newArrowCheck(this, _this);

      Vue.directive(directive.name, directive);
    }.bind(this));
  }
};

var defaultOptions = {
  plugins: ['notifications', 'breakpoints', 'modals'],
  config: {}
};
var plugin = {
  installed: false,
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.installed) {
      return;
    }

    this.installed = true;
    Vue.use(plugin$4, merge({}, defaultOptions, options));
    Vue.use(plugin$2);
    Vue.use(plugin$1);
  }
};

/*!
 * @moex/ui-framework
 *
 * Library with UI components for Vue.js/Nuxt.js
 *
 * Author - Nikita Kustov <nikita.kustov@moex.com>
 */

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

export { ClickOutside, plugin$2 as ComponentsPlugin, plugin$1 as DirectivesPlugin, plugin$4 as FrameworkPlugin, index$1 as QA, index as Tooltip, validator$1 as Validator, animate, plugin as default, index$b as uiAlert, index$B as uiApp, index$f as uiBadge, index$7 as uiBreadcrumbs, uiButton, uiCalendar, index$p as uiCheckbox, index$q as uiCheckboxGroup, uiCol, index$9 as uiCollapse, index$a as uiCollapseGroup, uiContainer, index$6 as uiCountdown, uiDropdown, uiDropdownGroup, uiDropdownOption, index$4 as uiFile, index$A as uiForm, index$z as uiFormControl, index$h as uiGroup, uiHighlightText, uiIcon, index$c as uiInfo, uiInput, index$v as uiInputCalendar, index$5 as uiInputFile, index$x as uiInputMoney, index$y as uiInputPhone, index$u as uiInputPlural, index$w as uiInputSuggest, index$e as uiLink, uiLoader, uiModal, uiNotification, uiNotificationsContainer as uiNotificationContainer, uiOverlay, uiPopover, index$g as uiPreloader, index$r as uiRadio, index$s as uiRadioGroup, uiRow, uiSelect, uiSelectOption, index$2 as uiSkeleton, index$3 as uiSkeletonItem, uiSpinner, index$d as uiStepper, index$o as uiSwitcher, index$n as uiSwitcherButton, uiTab, index$k as uiTable, uiTableCell, uiTableColumn, uiTableRow, index$j as uiTabs, index$8 as uiTag, uiText, index$t as uiTextarea, index$i as uiTile, index$l as uiToggle, index$m as uiToggleGroup, extend as validatorExtend };
//# sourceMappingURL=ui.esm.js.map
